(function(){
      var REPORT_PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-booking-proxy';
      var RETAIL_GAME_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-hair-story-checkin';
      var STAFF_OPERATIONS_PIN_STORAGE_KEY = 'hairstoriesStaffPortalUnlockedV1';
      var STAFF_OPERATIONS_STAFF_STORAGE_KEY = 'staffOperationsLoggedInStaff';
      var HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY = 'hairstoriesSharedAccessSessionV1';
      var LEGACY_SHARED_UNLOCKED_STORAGE_KEY = 'staffOperationsPinUnlocked';
      var STAFF_OPERATIONS_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
      var RETAIL_GAME_REFRESH_MS = 60000;
      var PAYROLL_PERIOD_ANCHOR_START = '2026-06-21';
      var PAYROLL_PERIOD_ANCHOR_START = '2026-06-21';
      var REQUEST_OFF_NOTIFY_PHONES = ['+16314875700', '+16318347937'];
      var KPI_REPORT_ID = 'urn:blvd:Report:6f402905-5d1b-41e1-b5a0-b90ed0ca3311';
      var STAFF_GROWTH_REPORT_ID = 'urn:blvd:Report:f0b7a373-59f0-4c7d-95f1-9b6f0595b630';
      var STAFF_GROWTH_YEARS = Array.from({ length: startOfLocalDay(new Date()).getFullYear() - 2021 + 1 }, function(_value, index){
        return 2021 + index;
      });
      var PERSONAL_LEVEL7_PERIOD_OPTIONS = [
        { key: 'all', label: 'All Years', summaryLabel: 'All years + 2026 YTD', description: 'Combined annual KPI totals from 2021 through 2025 plus current 2026 year-to-date actuals.' },
        { key: '2021', label: '2021', summaryLabel: '2021', description: 'Full calendar-year KPI view for this employee.' },
        { key: '2022', label: '2022', summaryLabel: '2022', description: 'Full calendar-year KPI view for this employee.' },
        { key: '2023', label: '2023', summaryLabel: '2023', description: 'Full calendar-year KPI view for this employee.' },
        { key: '2024', label: '2024', summaryLabel: '2024', description: 'Full calendar-year KPI view for this employee.' },
        { key: '2025', label: '2025', summaryLabel: '2025', description: 'Full calendar-year KPI view for this employee.' },
        { key: '2026_ytd', label: '2026 YTD', summaryLabel: '2026 YTD', description: 'KPI metrics are current year-to-date actuals. Attendance facts and reliability use the trailing 365-day window.' }
      ];
      var GLOBAL_KPI_REPORT_ID = 'urn:blvd:Report:1fece73f-bfe2-4767-a22f-e8090c857710';
      var SERVICE_MIX_REPORT_ID = 'urn:blvd:Report:7292d7f2-233d-4215-b762-b751deaab4f9';
      var pinGate = document.getElementById('pinGate');
      var pinCard = pinGate ? pinGate.querySelector('.pin-card') : null;
      var appPage = document.getElementById('appPage');
      var pinInput = document.getElementById('pinInput');
      var pinSubmitBtn = document.getElementById('pinSubmitBtn');
      var pinStatus = document.getElementById('pinStatus');
      var sessionIdentity = document.getElementById('sessionIdentity');
      var sessionIdentityName = document.getElementById('sessionIdentityName');
      var sessionIdentityMeta = document.getElementById('sessionIdentityMeta');
      var sessionSwitchLink = document.getElementById('sessionSwitchLink');
      var logoutBtn = document.getElementById('logoutBtn');
      var staffMobileDrawerIdentity = document.getElementById('staffMobileDrawerIdentity');
      var staffMobileDrawerIdentityName = document.getElementById('staffMobileDrawerIdentityName');
      var staffMobileDrawerIdentityMeta = document.getElementById('staffMobileDrawerIdentityMeta');
      var staffMobileDrawerManagerLink = document.getElementById('staffMobileDrawerManagerLink');
      var staffMobileDrawerLogoutBtn = document.getElementById('staffMobileDrawerLogoutBtn');
      var staffMobileNavBar = document.querySelector('.staff-mobileNavBar');
      var staffMobileNavCurrent = document.getElementById('staffMobileNavCurrent');
      var staffMobileNavTrigger = document.getElementById('staffMobileNavTrigger');
      var staffMobileNavDrawer = document.getElementById('staffMobileNavDrawer');
      var staffMobileNavCloseButtons = Array.prototype.slice.call(document.querySelectorAll('[data-mobile-nav-close]'));
      var tabButtons = Array.prototype.slice.call(document.querySelectorAll('[data-tab-target]'));
      var tabPanels = Array.prototype.slice.call(document.querySelectorAll('[data-tab-panel]'));
      var dateFrom = document.getElementById('dateFrom');
      var dateTo = document.getElementById('dateTo');
      var quickRangeButtons = Array.prototype.slice.call(document.querySelectorAll('[data-range]'));
      var copyDebugBtn = document.getElementById('copyDebugBtn');
      var requestOffStaff = document.getElementById('requestOffStaff');
      var requestOffDate = document.getElementById('requestOffDate');
      var requestOffScope = document.getElementById('requestOffScope');
      var requestOffPhoneLast4 = document.getElementById('requestOffPhoneLast4');
      var requestOffNote = document.getElementById('requestOffNote');
      var requestOffMeta = document.getElementById('requestOffMeta');
      var requestOffStatus = document.getElementById('requestOffStatus');
      var requestOffSubmitBtn = document.getElementById('requestOffSubmitBtn');
      var swapRequestDate = document.getElementById('swapRequestDate');
      var swapRequestShift = document.getElementById('swapRequestShift');
      var swapRequestTeammate = document.getElementById('swapRequestTeammate');
      var swapRequestPhoneLast4 = document.getElementById('swapRequestPhoneLast4');
      var swapRequestNote = document.getElementById('swapRequestNote');
      var swapRequestMeta = document.getElementById('swapRequestMeta');
      var swapRequestStatus = document.getElementById('swapRequestStatus');
      var swapRequestSubmitBtn = document.getElementById('swapRequestSubmitBtn');
      var personalDashboard = document.getElementById('personalDashboard');
      var dashboardHeroTitle = document.getElementById('dashboardHeroTitle');
      var personalDashboardLevelBadge = document.getElementById('personalDashboardLevelBadge');
      var attendanceDashboardStatus = document.getElementById('attendanceDashboardStatus');
      var salesDashboardSection = document.getElementById('salesDashboardSection');
      var salesDashboardStatus = document.getElementById('salesDashboardStatus');
      var salesTabYtd = document.getElementById('salesTabYtd');
      var salesTab90 = document.getElementById('salesTab90');
      var attendanceDashboardGrid = document.getElementById('attendanceDashboardGrid');
      var salesDashboardGrid = document.getElementById('salesDashboardGrid');
      var retailGameSection = document.getElementById('retailGameSection');
      var retailGameStatus = document.getElementById('retailGameStatus');
      var retailGameMount = document.getElementById('retailGameMount');
      var staffColorDisciplineStatus = document.getElementById('staffColorDisciplineStatus');
      var staffColorDisciplineMount = document.getElementById('staffColorDisciplineMount');
      var serviceMixSection = document.getElementById('serviceMixSection');
      var serviceMixTitle = document.getElementById('serviceMixTitle');
      var serviceMixStatus = document.getElementById('serviceMixStatus');
      var serviceMixTab180 = document.getElementById('serviceMixTab180');
      var serviceMixTab365 = document.getElementById('serviceMixTab365');
      var serviceMix = document.getElementById('serviceMix');
      var serviceMixPanels = document.getElementById('serviceMixPanels');
      var nextMoveSection = document.getElementById('nextMoveSection');
      var nextMoveStatus = document.getElementById('nextMoveStatus');
      var nextMoveMount = document.getElementById('nextMoveMount');
      var bonusDashboardSection = document.getElementById('bonusDashboardSection');
      var bonusDashboardStatus = document.getElementById('bonusDashboardStatus');
      var bonusDashboardMount = document.getElementById('bonusDashboardMount');
      var staffCoachingSection = document.getElementById('staffCoachingSection');
      var staffCoachingMount = document.getElementById('staffCoachingMount');
      var staffCoachingStatus = document.getElementById('staffCoachingStatus');
      var personalRequestsTabs = document.getElementById('personalRequestsTabs');
      var personalRequestsCountFuture = document.getElementById('personalRequestsCountFuture');
      var personalRequestsCountPast = document.getElementById('personalRequestsCountPast');
      var personalRequestsList = document.getElementById('personalRequestsList');
      var openShiftsStatus = document.getElementById('openShiftsStatus');
      var openShiftViewTabs = document.getElementById('openShiftViewTabs');
      var openShiftDayFilter = document.getElementById('openShiftDayFilter');
      var openShiftViewCountAvailable = document.getElementById('openShiftViewCountAvailable');
      var openShiftViewCountMine = document.getElementById('openShiftViewCountMine');
      var openShiftResultsList = document.getElementById('openShiftResultsList');
      var todoTitle = document.getElementById('todoTitle');
      var todoRecurrence = document.getElementById('todoRecurrence');
      var todoDetail = document.getElementById('todoDetail');
      var todoManagerPicker = document.getElementById('todoManagerPicker');
      var todoSubmitBtn = document.getElementById('todoSubmitBtn');
      var todoStatus = document.getElementById('todoStatus');
      var todoViewTabs = document.getElementById('todoViewTabs');
      var todoViewTabOpen = document.getElementById('todoViewTabOpen');
      var todoViewTabCompleted = document.getElementById('todoViewTabCompleted');
      var todoList = document.getElementById('todoList');
      var supplyItemName = document.getElementById('supplyItemName');
      var supplyItemSuggestions = document.getElementById('supplyItemSuggestions');
      var supplyLookupHint = document.getElementById('supplyLookupHint');
      var supplyNote = document.getElementById('supplyNote');
      var supplySubmitBtn = document.getElementById('supplySubmitBtn');
      var supplyStatus = document.getElementById('supplyStatus');
      var supplyRequestList = document.getElementById('supplyRequestList');
      var openShiftsTabCount = document.getElementById('openShiftsTabCount');
      var staffDirectoryStatus = document.getElementById('staffDirectoryStatus');
      var staffDirectoryList = document.getElementById('staffDirectoryList');
      var clientRecsStaff = document.getElementById('clientRecsStaff');
      var clientRecsWindow = document.getElementById('clientRecsWindow');
      var clientRecsSearch = document.getElementById('clientRecsSearch');
      var clientRecsRefresh = document.getElementById('clientRecsRefresh');
      var clientRecsStatus = document.getElementById('clientRecsStatus');
      var clientRecsList = document.getElementById('clientRecsList');
      var clientRecsDetail = document.getElementById('clientRecsDetail');
      var requestReviewStatus = document.getElementById('requestReviewStatus');
      var requestReviewList = document.getElementById('requestReviewList');
      var masterScheduleStatus = document.getElementById('masterScheduleStatus');
      var masterScheduleWeekMount = document.getElementById('masterScheduleWeekMount');
      var statusLine = document.getElementById('statusLine');
      var tableMount = document.getElementById('tableMount');
      var kpiTableMount = document.getElementById('kpiTableMount');
      var globalKpiQuarter = document.getElementById('globalKpiQuarter');
      var globalKpiStatus = document.getElementById('globalKpiStatus');
      var globalKpiTableMount = document.getElementById('globalKpiTableMount');
      var debugMount = document.getElementById('debugMount');
      var lastDebugPayload = null;
      var reliabilityScoreByStaff = {};
      var requestsOffByStaff = {};
      var callOutsByStaff = {};
      var lateArrivalsByStaff = {};
      var levelByStaff = {};
      var avatarByStaff = {};
      var currentLoggedInStaff = null;
      var currentLoggedInProgressionState = null;
      var currentRenderedNextMoveState = null;
      var selectedNextMoveApprovalKeys = {};
      var loggedInStaffContextRequestToken = 0;
      var personalDashboardRequestToken = 0;
      var openShiftViewFilter = 'available';
      var openShiftDayFilterValue = 'all';
      var activeTodoView = 'open';
      var activeSalesWindow = 'ytd';
      var currentAttendanceYtdRow = null;
      var currentAttendance90Row = null;
      var currentAttendanceYtdSnapshotDate = '';
      var currentAttendance90SnapshotDate = '';
      var currentSalesYtdSummary = null;
      var currentSales90Summary = null;
      var currentSalesYtdSnapshotDate = '';
      var currentSales90SnapshotDate = '';
      var currentSalesYtdWindow = null;
      var currentSales90Window = null;
      var currentSalesYtdSupplemental = null;
      var currentSales90Supplemental = null;
      var currentSalesYtdHeaders = [];
      var currentSales90Headers = [];
      var currentSalesYtdDetailRows = [];
      var currentSales90DetailRows = [];
      var personalStaffGrowthDataset = null;
      var personalLevel7ActivePeriod = '2026_ytd';
      var personalLevel7AttendanceByPeriod = {};
      var personalLevel7SupplementalByPeriod = {};
      var personalLevel7SupplementalLoading = {};
      var currentServiceMixWindows = [];
      var currentServiceMixConfig = null;
      var currentBonusPlans = [];
      var currentRetailGameCurrentWeek = null;
      var currentRetailGameLastWeek = null;
      var currentRetailGameOwnWeek = null;
      var currentColorDisciplineCurrentWeek = null;
      var currentColorDisciplineLastWeek = null;
      var currentColorDisciplinePeriods = [];
      var activeRetailGameBoardWindow = 'current';
      var activeRetailGamePayrollStart = '';
      var activeStaffColorDisciplinePayrollStart = '';
      var activeServiceMixWindow = 'service_mix_last_180_days';
      var activePersonalRequestsView = 'future';
      var appStarted = false;
      var hasLoadedStaffDirectory = false;
      var hasLoadedClientRecs = false;
      var clientRecsDashboard = null;
      var clientRecsSelectedClientId = '';
      var clientRecsSelectedAppointmentId = '';
      var clientRecsClientProfile = null;
      var currentClientRecsAllowed = false;
      var idleTimer = null;
      var hasLoadedGlobalKpis = false;
      var requestOffStaffOptions = [];
      var requestOffQueue = [];
      var shiftChangeQueue = [];
      var currentSwapTeammateOptions = [];
      var todoItems = [];
      var todoManagers = [];
      var supplyRequests = [];
      var supplySuggestions = [];
      var activeSupplyAutocompleteSuggestion = '';
      var masterScheduleAssignments = {};
      var activeController = null;
      var retailGameRefreshTimer = null;
      var retailGameLoadPromise = null;
      var REQUEST_TIMEOUT_MS = 180000;
      var MASTER_SCHEDULE_DAYS = [
        { key: 'monday', label: 'Monday', options: ['OFF', '12-9:30p', 'CUSTOM'] },
        { key: 'tuesday', label: 'Tuesday', options: ['OFF', '8-3pm', '12-9:30p', '3-9:30p', 'CUSTOM'] },
        { key: 'wednesday', label: 'Wednesday', options: ['OFF', '12-9:30p', 'CUSTOM'] },
        { key: 'thursday', label: 'Thursday', options: ['OFF', '8-3pm', '12-9:30p', '3-9:30p', 'CUSTOM'] },
        { key: 'friday', label: 'Friday', options: ['OFF', '11-6p', 'CUSTOM'] }
      ];

      function setStatus(text){
        if (!statusLine) return;
        statusLine.textContent = text;
      }

      function setGlobalKpiStatus(text, tone){
        if (!globalKpiStatus) return;
        globalKpiStatus.textContent = String(text || '');
        globalKpiStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setActiveTab(tabKey){
        var targetKey = String(tabKey || 'dashboard').trim() || 'dashboard';
        var activeLabel = '';
        tabButtons.forEach(function(button){
          var isActive = String(button.getAttribute('data-tab-target') || '') === targetKey;
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive && !activeLabel) {
            activeLabel = String(button.textContent || '').trim();
          }
        });
        tabPanels.forEach(function(panel){
          var isActive = String(panel.getAttribute('data-tab-panel') || '') === targetKey;
          panel.hidden = !isActive;
        });
        if (staffMobileNavCurrent) {
          staffMobileNavCurrent.textContent = activeLabel || 'Dashboard';
        }
        if (targetKey === 'staff-directory' && !hasLoadedStaffDirectory) {
          ensureStaffDirectoryLoaded();
        }
        if (targetKey === 'client-recs' && !hasLoadedClientRecs) {
          ensureClientRecsLoaded();
        }
      }

      function setMobileNavOpen(isOpen){
        if (!staffMobileNavDrawer || !staffMobileNavTrigger || typeof document === 'undefined') return;
        var open = isOpen === true;
        staffMobileNavDrawer.hidden = !open;
        staffMobileNavTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('staff-mobileNavOpen', open);
      }

      function setPinStatus(text, tone){
        if (!pinStatus) return;
        pinStatus.textContent = String(text || '');
        if (tone) {
          pinStatus.setAttribute('data-tone', tone);
        } else {
          pinStatus.removeAttribute('data-tone');
        }
      }

      function setPinValidationState(isValidating, message){
        var active = isValidating === true;
        if (pinCard) {
          pinCard.classList.toggle('is-validating', active);
        }
        if (pinInput) {
          pinInput.disabled = active;
          pinInput.setAttribute('aria-busy', active ? 'true' : 'false');
        }
        if (pinSubmitBtn) {
          pinSubmitBtn.disabled = active;
          if (active) {
            pinSubmitBtn.setAttribute('data-loading', 'true');
            pinSubmitBtn.textContent = 'Validating';
          } else {
            pinSubmitBtn.removeAttribute('data-loading');
            pinSubmitBtn.textContent = 'Continue';
          }
        }
        if (message) {
          setPinStatus(message, active ? 'loading' : '');
        }
      }

      function normalizePhoneDigits(value){
        return String(value || '').replace(/\D+/g, '');
      }

      function formatPhoneInputValue(value){
        var digits = normalizePhoneDigits(value).slice(0, 10);
        if (!digits) return '';
        if (digits.length < 4) return digits;
        if (digits.length < 7) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
        return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
      }

      function getComparablePhoneDigits(value){
        var digits = normalizePhoneDigits(value);
        return digits.length > 10 ? digits.slice(-10) : digits;
      }

      function showAppPage(){
        document.body.classList.remove('pin-locked');
        if (pinGate) {
          pinGate.hidden = true;
        }
        if (appPage) {
          appPage.hidden = false;
        }
        updateSessionIdentityDisplay();
        updateSessionSwitchLink();
      }

      function showPinGate(message, tone){
        setPinValidationState(false);
        document.body.classList.add('pin-locked');
        if (appPage) {
          appPage.hidden = true;
        }
        if (pinGate) {
          pinGate.hidden = false;
        }
        if (pinInput) {
          pinInput.value = '';
        }
        setPinStatus(message || 'Login code required.', tone || '');
        if (pinInput) {
          pinInput.focus();
        }
      }

      function persistSharedAccessSession(payload){
        try {
          if (!payload || typeof payload !== 'object') {
            window.localStorage.removeItem(HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY);
            return;
          }
          window.localStorage.setItem(HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY, JSON.stringify(payload));
        } catch (_error) {
        }
      }

      function restoreSharedAccessSession(){
        try {
          var raw = window.localStorage.getItem(HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY);
          if (!raw) return null;
          var parsed = JSON.parse(raw);
          return parsed && typeof parsed === 'object' ? parsed : null;
        } catch (_error) {
          return null;
        }
      }

      function hasManagerPageAccess(permission){
        var safePermission = permission && typeof permission === 'object' ? permission : null;
        if (!safePermission || safePermission.active === false || safePermission.can_access_staff_ops !== true) {
          return false;
        }
        return safePermission.can_view_kpis === true
          || safePermission.can_view_global_kpis === true
          || safePermission.can_view_color_discipline === true
          || safePermission.can_view_staff_growth === true
          || safePermission.can_manage_bonus === true
          || safePermission.can_manage_requests_off === true
          || safePermission.can_manage_open_shifts === true
          || safePermission.can_manage_retail_followup === true
          || safePermission.can_manage_rebook_queue === true
          || safePermission.can_manage_schedule === true
          || safePermission.can_view_weekly_calendar === true
          || safePermission.can_manage_todo === true
          || safePermission.can_manage_inventory === true
          || safePermission.can_view_progression === true
          || safePermission.can_manage_access_permissions === true
          || safePermission.can_manage_checkpoint_admin === true;
      }

      function canSwitchToManagerPage(){
        var sharedAccessSession = restoreSharedAccessSession();
        if (!sharedAccessSession || sharedAccessSession.mode !== 'manager' || !currentLoggedInStaff) {
          return false;
        }
        var sharedEditor = sharedAccessSession.editor || {};
        var sharedPermission = sharedAccessSession.permission || {};
        if (!hasManagerPageAccess(sharedPermission)) {
          return false;
        }
        var sharedStaffId = String(sharedPermission.boulevard_staff_id || sharedEditor.staff_id || '').trim();
        var currentStaffId = String((currentLoggedInStaff && currentLoggedInStaff.id) || '').trim();
        if (sharedStaffId && currentStaffId && sharedStaffId === currentStaffId) {
          return true;
        }
        return sameStaffName(sharedEditor.staff_name, currentLoggedInStaff && currentLoggedInStaff.name);
      }

      function updateSessionSwitchLink(){
        var canSwitch = canSwitchToManagerPage();
        [sessionSwitchLink, staffMobileDrawerManagerLink].forEach(function(link){
          if (!link || typeof window === 'undefined') return;
          link.hidden = !canSwitch;
          if (canSwitch) {
            link.textContent = 'Manager';
            link.setAttribute('href', '/pages/manager');
          }
        });
        updateClientRecsAccess();
      }

      function updateClientRecsAccess(){
        var shared = restoreSharedAccessSession();
        var permission = shared && shared.mode === 'manager' ? (shared.permission || {}) : {};
        var editor = shared && shared.editor ? shared.editor : {};
        var permissionStaffId = String(permission.boulevard_staff_id || editor.staff_id || '').trim();
        var loggedInStaffId = String((currentLoggedInStaff && currentLoggedInStaff.id) || '').trim();
        var sameStaff = !!permissionStaffId && !!loggedInStaffId
          ? permissionStaffId === loggedInStaffId
          : sameStaffName(editor.staff_name, currentLoggedInStaff && currentLoggedInStaff.name);
        currentClientRecsAllowed = permission.active !== false
          && permission.can_access_staff_ops === true
          && permission.can_manage_retail_followup === true
          && sameStaff;
      }

      function updateSessionIdentityDisplay(){
        var fullName = String((currentLoggedInStaff && currentLoggedInStaff.name) || '').trim();
        var roleLabel = String((currentLoggedInStaff && (currentLoggedInStaff.level || currentLoggedInStaff.role)) || '').trim();
        [
          { wrapper: sessionIdentity, name: sessionIdentityName, meta: sessionIdentityMeta },
          { wrapper: staffMobileDrawerIdentity, name: staffMobileDrawerIdentityName, meta: staffMobileDrawerIdentityMeta }
        ].forEach(function(target){
          if (!target.wrapper || !target.name) return;
          target.wrapper.hidden = !fullName;
          if (!fullName) return;
          target.name.textContent = fullName;
          if (target.meta) {
            target.meta.textContent = roleLabel || '';
            target.meta.hidden = !roleLabel;
          }
        });
      }

      function handleLogout(){
        stopIdleTimer();
        clearUnlockedSession();
        showPinGate('Logged out. Enter your login code to continue.', 'success');
      }

      function persistSharedStaffSession(staff){
        persistSharedAccessSession({
          mode: 'staff',
          staff: staff || null
        });
      }

      async function hydrateManagerAccessFromPin(pin){
        var normalizedPin = String(pin || '').trim();
        if (!normalizedPin) return false;
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'staff-ops-auth',
              pin: normalizedPin
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.editor || !data.staff_ops_permission) {
            return false;
          }
          if (!hasManagerPageAccess(data.staff_ops_permission)) {
            return false;
          }
          persistSharedAccessSession({
            mode: 'manager',
            editor: data.editor,
            permission: data.staff_ops_permission,
            editor_permission: data.editor_permission || null
          });
          return true;
        } catch (_error) {
          return false;
        }
      }

      function clearUnlockedSession(options){
        var safeOptions = options && typeof options === 'object' ? options : {};
        loggedInStaffContextRequestToken += 1;
        try {
          window.localStorage.removeItem(STAFF_OPERATIONS_PIN_STORAGE_KEY);
          window.localStorage.removeItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY);
          window.localStorage.removeItem(LEGACY_SHARED_UNLOCKED_STORAGE_KEY);
        } catch (_error) {
        }
        if (safeOptions.preserveShared !== true) {
          persistSharedAccessSession(null);
        }
        currentLoggedInStaff = null;
        currentLoggedInProgressionState = null;
        resetLoggedInStaffView('Enter your login code to continue.');
      }

      function resetLoggedInStaffView(message){
        currentAttendanceYtdRow = null;
        currentAttendance90Row = null;
        currentAttendanceYtdSnapshotDate = '';
        currentAttendance90SnapshotDate = '';
        currentSalesYtdSummary = null;
        currentSales90Summary = null;
        currentSalesYtdSnapshotDate = '';
        currentSales90SnapshotDate = '';
        currentSalesYtdWindow = null;
        currentSales90Window = null;
        currentSalesYtdSupplemental = null;
        currentSales90Supplemental = null;
        currentRetailGameCurrentWeek = null;
        currentRetailGameLastWeek = null;
        currentRetailGameOwnWeek = null;
        currentColorDisciplineCurrentWeek = null;
        currentColorDisciplineLastWeek = null;
        currentServiceMixWindows = [];
        currentServiceMixConfig = null;
        activeServiceMixWindow = 'service_mix_last_180_days';
        activeSalesWindow = 'ytd';
        stopRetailGameAutoRefresh();
        if (dashboardHeroTitle) dashboardHeroTitle.textContent = 'Loading your dashboard...';
        if (personalDashboardLevelBadge) {
          personalDashboardLevelBadge.hidden = true;
          personalDashboardLevelBadge.textContent = '';
        }
        if (requestOffStaff) {
          requestOffStaff.value = '';
          requestOffStaff.disabled = true;
        }
        if (requestOffMeta) {
          requestOffMeta.innerHTML = ''
            + '<div class="request-off-meta-name">Loading staff profile...</div>'
            + '<div class="request-off-meta-copy">' + escapeHtml(String(message || 'Please wait a moment.')) + '</div>';
        }
        setRequestOffStatus(String(message || 'Loading your staff profile...'));
        setDashboardSectionStatus(attendanceDashboardStatus, 'Loading attendance data...');
        setDashboardSectionStatus(salesDashboardStatus, 'Loading saved sales snapshot...');
        setDashboardSectionStatus(retailGameStatus, 'Loading Retail Success...');
        setDashboardSectionStatus(serviceMixStatus, 'Loading saved service mix snapshots...');
        setDashboardSectionStatus(nextMoveStatus, 'Loading next-step requirements...');
        renderDashboardLoadingCards(attendanceDashboardGrid, 4);
        renderDashboardLoadingCards(salesDashboardGrid, 5);
        renderRetailGame(null, null, null);
        renderServiceMix([], null);
        renderNextMove(null);
        renderPersonalRequests([]);
        renderOpenShiftState([]);
        setOpenShiftsStatus('Loading open shifts...');
        setDashboardToggleState(salesTabYtd, salesTab90, activeSalesWindow);
        setDashboardToggleState(serviceMixTab180, serviceMixTab365, activeServiceMixWindow === 'service_mix_last_180_days' ? 'ytd' : '90d');
      }

      function stopIdleTimer(){
        if (idleTimer) {
          clearTimeout(idleTimer);
          idleTimer = null;
        }
      }

      function relockForInactivity(){
        stopIdleTimer();
        clearUnlockedSession();
        showPinGate('Session expired. Enter your login code again.', 'error');
      }

      function resetIdleTimer(){
        stopIdleTimer();
      }

      function bindIdleTracking(){
        ['pointerdown', 'keydown', 'mousemove', 'touchstart', 'scroll'].forEach(function(eventName){
          window.addEventListener(eventName, function(){
            if (appPage && appPage.hidden) return;
            resetIdleTimer();
          }, { passive: true });
        });
      }

      function startApp(){
        if (appStarted) return;
        appStarted = true;

        tabButtons.forEach(function(button){
          button.addEventListener('click', function(){
            setActiveTab(button.getAttribute('data-tab-target') || 'requests');
            setMobileNavOpen(false);
          });
        });
        if (staffMobileNavBar) {
          staffMobileNavBar.hidden = false;
        }
        if (staffMobileNavTrigger) {
          staffMobileNavTrigger.addEventListener('click', function(){
            setMobileNavOpen(!(staffMobileNavDrawer && !staffMobileNavDrawer.hidden));
          });
        }
        staffMobileNavCloseButtons.forEach(function(button){
          button.addEventListener('click', function(){
            setMobileNavOpen(false);
          });
        });
        window.addEventListener('keydown', function(event){
          if (event && event.key === 'Escape') {
            setMobileNavOpen(false);
          }
        });
        if (salesTabYtd) {
          salesTabYtd.addEventListener('click', function(){
            activeSalesWindow = 'ytd';
            renderSalesDashboardSection();
          });
        }
        if (salesTab90) {
          salesTab90.addEventListener('click', function(){
            activeSalesWindow = '90d';
            renderSalesDashboardSection();
          });
        }
        if (serviceMixTab180) {
          serviceMixTab180.addEventListener('click', function(){
            activeServiceMixWindow = 'service_mix_last_180_days';
            renderServiceMix(currentServiceMixWindows, currentServiceMixConfig);
          });
        }
        if (serviceMixTab365) {
          serviceMixTab365.addEventListener('click', function(){
            activeServiceMixWindow = 'service_mix_last_365_days';
            renderServiceMix(currentServiceMixWindows, currentServiceMixConfig);
          });
        }
        requestOffStaff.addEventListener('change', function(){
          syncRequestOffScopeOptions();
          renderRequestOffSelectedStaff();
        });
        if (requestOffDate) {
          requestOffDate.addEventListener('change', function(){
            syncRequestOffScopeOptions();
            renderRequestOffSelectedStaff();
          });
        }
        if (requestOffScope) {
          requestOffScope.addEventListener('change', function(){
            renderRequestOffSelectedStaff();
          });
        }
        if (swapRequestDate) {
          swapRequestDate.addEventListener('change', function(){
            renderSwapRequestForm();
          });
        }
        if (swapRequestTeammate) {
          swapRequestTeammate.addEventListener('change', function(){
            renderSwapRequestForm();
          });
        }
        requestOffSubmitBtn.addEventListener('click', async function(){
          try {
            requestOffSubmitBtn.disabled = true;
            setRequestOffStatus('Sending request-off text...');
            var result = await submitRequestOffForm();
            var scopeLabel = formatRequestOffScopeLabel(getRequestOffMeta(result && result.request_row).request_scope);
            var successMessage = 'Request off sent for '
              + String(result.staff_name || '')
              + ' on '
              + String((result.requested_dates && result.requested_dates[0]) || requestOffDate.value || '')
              + ' (' + scopeLabel + ')'
              + '. Pending approval.';
            setRequestOffStatus(successMessage, 'success');
            requestOffNote.value = '';
            requestOffDate.value = '';
            syncRequestOffScopeOptions();
            if (requestOffScope) requestOffScope.value = 'full_shift';
            requestOffPhoneLast4.value = '';
            renderRequestOffSelectedStaff();
          } catch (error) {
            setRequestOffStatus(humanizeClientFetchErrorMessage(error, 'Could not submit request off.'), 'error');
          } finally {
            requestOffSubmitBtn.disabled = false;
          }
        });
        if (swapRequestSubmitBtn) {
          swapRequestSubmitBtn.addEventListener('click', async function(){
            try {
              swapRequestSubmitBtn.disabled = true;
              setSwapRequestStatus('Sending shift switch request...');
              var swapRow = await submitSwapRequestForm();
              shiftChangeQueue = Array.isArray(shiftChangeQueue) ? [swapRow].concat(shiftChangeQueue) : [swapRow];
              renderOpenShiftState(shiftChangeQueue);
              setOpenShiftsStatus('Your shift request was added to the queue.', 'success');
              setSwapRequestStatus('Shift switch request sent for approval.', 'success');
              if (swapRequestNote) swapRequestNote.value = '';
              if (swapRequestPhoneLast4) swapRequestPhoneLast4.value = '';
            } catch (error) {
              setSwapRequestStatus(humanizeClientFetchErrorMessage(error, 'Could not submit shift switch request.'), 'error');
            } finally {
              swapRequestSubmitBtn.disabled = false;
            }
          });
        }
        if (openShiftResultsList) {
          openShiftResultsList.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var deleteRequestId = String(target.getAttribute('data-shift-request-delete') || '').trim();
            if (deleteRequestId) {
              try {
                if (typeof window !== 'undefined' && window.confirm && !window.confirm('Delete this pending shift request?')) {
                  return;
                }
                target.disabled = true;
                setOpenShiftsStatus('Deleting shift request...');
                var deletedShiftRequest = await deleteShiftChangeQueueRow(deleteRequestId);
                setOpenShiftsStatus(String((deletedShiftRequest && deletedShiftRequest.staff_name) || 'Shift request') + ' deleted.', 'success');
              } catch (error) {
                setOpenShiftsStatus(humanizeClientFetchErrorMessage(error, 'Could not delete shift request.'), 'error');
                target.disabled = false;
              }
              return;
            }
            var action = String(target.getAttribute('data-open-shift-action') || '').trim();
            var openShiftId = String(target.getAttribute('data-open-shift-id') || '').trim();
            if (action !== 'pickup' || !openShiftId) return;

            try {
              target.disabled = true;
              var openShiftRow = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).find(function(row){
                return String((row && row.id) || '').trim() === openShiftId;
              }) || null;
              if (!openShiftRow) {
                throw new Error('Could not find that open shift.');
              }
              var noteField = openShiftResultsList.querySelector('[data-open-shift-note="' + openShiftId + '"]');
              var note = String(noteField && noteField.value || '').trim();
              setOpenShiftsStatus('Submitting pickup request...');
              var pickupRow = await submitOpenShiftPickup(openShiftRow, note);
              shiftChangeQueue = Array.isArray(shiftChangeQueue) ? shiftChangeQueue.concat([pickupRow]) : [pickupRow];
              renderOpenShiftState(shiftChangeQueue);
              setOpenShiftsStatus('Pickup request submitted for manager approval.', 'success');
            } catch (error) {
              setOpenShiftsStatus(humanizeClientFetchErrorMessage(error, 'Could not submit pickup request.'), 'error');
              target.disabled = false;
            }
          });
        }
        if (openShiftViewTabs) {
          openShiftViewTabs.addEventListener('click', function(event){
            var target = event && event.target && event.target.closest
              ? event.target.closest('[data-open-shift-view]')
              : null;
            if (!target || !target.getAttribute) return;
            setOpenShiftViewFilter(String(target.getAttribute('data-open-shift-view') || 'available'));
          });
        }
        if (openShiftDayFilter) {
          openShiftDayFilter.addEventListener('change', function(){
            openShiftDayFilterValue = String(openShiftDayFilter.value || 'all').trim().toLowerCase() || 'all';
            renderOpenShiftState(shiftChangeQueue);
          });
        }
        if (supplyItemName) {
          supplyItemName.addEventListener('input', function(){
            refreshSupplySuggestionOptions(String(supplyItemName.value || ''));
          });
          supplyItemName.addEventListener('focus', function(){
            refreshSupplySuggestionOptions(String(supplyItemName.value || ''));
          });
          supplyItemName.addEventListener('keydown', function(event){
            if (!event || event.key !== 'Tab') return;
            var typed = String(supplyItemName.value || '').trim();
            if (!typed || !activeSupplyAutocompleteSuggestion) return;
            if (typed.toLowerCase() === activeSupplyAutocompleteSuggestion.toLowerCase()) return;
            event.preventDefault();
            supplyItemName.value = activeSupplyAutocompleteSuggestion;
            refreshSupplySuggestionOptions(activeSupplyAutocompleteSuggestion);
          });
        }
        if (supplySubmitBtn) {
          supplySubmitBtn.addEventListener('click', async function(){
            try {
              supplySubmitBtn.disabled = true;
              setSupplyStatus('Adding supply request...');
              var row = await submitSupplyRequestForm();
              supplyRequests = [row].concat(Array.isArray(supplyRequests) ? supplyRequests : []);
              renderSupplyRequests(supplyRequests);
              setSupplyStatus('Supply request added to the inventory queue.', 'success');
              refreshSupplySuggestionOptions('');
              if (supplyItemName) supplyItemName.value = '';
              if (supplyNote) supplyNote.value = '';
            } catch (error) {
              setSupplyStatus(humanizeClientFetchErrorMessage(error, 'Could not add supply request.'), 'error');
            } finally {
              supplySubmitBtn.disabled = false;
            }
          });
        }
        if (todoSubmitBtn) {
          todoSubmitBtn.addEventListener('click', async function(){
            try {
              todoSubmitBtn.disabled = true;
              setTodoStatus('Posting to-do item...');
              var result = await submitTodoItemForm();
              var row = result && result.row ? result.row : null;
              if (row) {
                todoItems = [row].concat(Array.isArray(todoItems) ? todoItems.filter(function(existing){
                  return String((existing && existing.id) || '').trim() !== String((row && row.id) || '').trim();
                }) : []);
                renderTodoItems(todoItems);
              }
              setTodoStatus('To-do posted and tagged managers were notified.', 'success');
              if (todoTitle) todoTitle.value = '';
              if (todoRecurrence) todoRecurrence.value = 'none';
              if (todoDetail) todoDetail.value = '';
              Array.prototype.slice.call(document.querySelectorAll('input[name="todoManager"]')).forEach(function(node){
                node.checked = false;
              });
            } catch (error) {
              setTodoStatus(humanizeClientFetchErrorMessage(error, 'Could not post that to-do item.'), 'error');
            } finally {
              todoSubmitBtn.disabled = false;
            }
          });
        }
        if (todoViewTabs) {
          Array.prototype.slice.call(todoViewTabs.querySelectorAll('[data-todo-view]')).forEach(function(button){
            button.addEventListener('click', function(){
              var nextView = String(button && button.getAttribute('data-todo-view') || '').trim().toLowerCase();
              if (!nextView || activeTodoView === nextView) return;
              activeTodoView = nextView === 'completed' ? 'completed' : 'open';
              renderTodoItems(todoItems);
            });
          });
        }
        [logoutBtn, staffMobileDrawerLogoutBtn].forEach(function(button){
          if (!button) return;
          button.addEventListener('click', function(){
            setMobileNavOpen(false);
            handleLogout();
          });
        });
        initializeRequestOffForm();
        setActiveTab('dashboard');
      }

      async function unlockWithPin(){
        var entered = String((pinInput && pinInput.value) || '').trim();
        var enteredPin = entered.replace(/\D+/g, '');
        if (!enteredPin) {
          setPinStatus('Enter your login code.', 'error');
          if (pinInput) {
            pinInput.focus();
          }
          return;
        }

        try {
          setPinValidationState(true, 'Checking your login code...');
          var entries = await fetchStaffDirectoryEntries();
          var matched = entries.find(function(member){
            var employeePin = String(member.pin || '').replace(/\D+/g, '');
            return employeePin && employeePin === enteredPin;
          }) || null;

          if (!matched) {
            setPinValidationState(false);
            setPinStatus('We could not match that login code to a staff profile.', 'error');
            if (pinInput) {
              pinInput.value = '';
              pinInput.focus();
            }
            return;
          }

          currentLoggedInStaff = matched;
          currentLoggedInProgressionState = null;
          try {
            window.localStorage.setItem(STAFF_OPERATIONS_PIN_STORAGE_KEY, '1');
            window.localStorage.setItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY, JSON.stringify(matched));
            window.localStorage.removeItem(LEGACY_SHARED_UNLOCKED_STORAGE_KEY);
          } catch (_error) {
          }
          var unlockedManagerAccess = await hydrateManagerAccessFromPin(entered);
          if (!unlockedManagerAccess) {
            persistSharedAccessSession(null);
            persistSharedStaffSession(matched);
          }

          setPinStatus('Welcome, ' + String(matched.name || '').trim() + '.', 'success');
          startApp();
          resetLoggedInStaffView('Loading your dashboard...');
          showAppPage();
          setActiveTab('dashboard');
          await applyLoggedInStaffContext();
          resetIdleTimer();
        } catch (error) {
          setPinValidationState(false);
          setPinStatus(humanizeClientFetchErrorMessage(error, 'Could not verify that login code.'), 'error');
          if (pinInput) {
            pinInput.focus();
          }
        }
      }

      function humanizeDashboardErrorMessage(message){
        var raw = String(message || '').trim();
        if (!raw) return 'Could not build totals.';

        if (/Boulevard rate limited this request/i.test(raw)) {
          return raw;
        }

        if (/API limit exceeded/i.test(raw)) {
          var waitMatch = raw.match(/please wait\s+(\d+)\s*ms/i);
          var waitMs = waitMatch ? Number(waitMatch[1]) : 0;
          if (waitMs >= 1000) {
            return 'Boulevard rate limited this request. Please wait about ' + ((waitMs / 1000) % 1 === 0 ? String(waitMs / 1000) : (waitMs / 1000).toFixed(1)) + 's and try again.';
          }
          if (waitMs > 0) {
            return 'Boulevard rate limited this request. Please wait about ' + waitMs + 'ms and try again.';
          }
          return 'Boulevard rate limited this request. Please wait a moment and try again.';
        }

        if (/Raw KPI export is still processing/i.test(raw)) {
          return 'KPI export is still processing on Boulevard. Attendance totals are ready. Try again in about 1 minute.';
        }

        if (/export is still processing/i.test(raw)) {
          return 'Boulevard is still preparing this export. Try again in about 1 minute.';
        }

        if (/timed out/i.test(raw)) {
          return raw;
        }

        return raw;
      }

      function humanizeClientFetchErrorMessage(error, fallbackMessage){
        var raw = String((error && error.message) || fallbackMessage || '').trim();
        if (!raw) return 'Could not reach the reporting proxy.';

        if (error && error.name === 'AbortError') {
          return 'The request was canceled before Supabase could respond.';
        }

        if (/Failed to fetch/i.test(raw) || /NetworkError/i.test(raw) || /Load failed/i.test(raw)) {
          return 'The browser could not reach the reporting proxy. Supabase may not have received the request.';
        }

        if (/Could not fetch leaderboard from proxy\./i.test(raw)) {
          return 'The browser reached the proxy URL, but did not get a usable response back.';
        }

        var proxyStatusMatch = raw.match(/^Proxy response was not usable \(status (\d+)\)(?:\.\s*Body:\s*(.*))?$/i);
        if (proxyStatusMatch) {
          var status = proxyStatusMatch[1];
          var body = String(proxyStatusMatch[2] || '').trim();
          if (body) {
            return 'The proxy responded with status ' + status + '. ' + body;
          }
          return 'The proxy responded with status ' + status + ', but did not return usable JSON.';
        }

        var stripped = raw
          .replace(/\s*\|\s*action=.*$/i, '')
          .replace(/\s*\|\s*stack=.*$/i, '')
          .replace(/\s+at\s+submitStaffShiftChange[\s\S]*$/i, '')
          .replace(/\s+\(file:\/\/\/var\/tmp\/sb-compile-edge-runtime[\s\S]*$/i, '')
          .trim();
        if (stripped) {
          raw = stripped;
        }

        return humanizeDashboardErrorMessage(raw);
      }

      function setRequestOffStatus(text, tone){
        requestOffStatus.textContent = text;
        requestOffStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setRequestReviewStatus(text, tone){
        if (!requestReviewStatus) return;
        requestReviewStatus.textContent = text;
        requestReviewStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setOpenShiftsStatus(text, tone){
        if (!openShiftsStatus) return;
        openShiftsStatus.textContent = String(text || '');
        openShiftsStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setSwapRequestStatus(text, tone){
        if (!swapRequestStatus) return;
        swapRequestStatus.textContent = String(text || '');
        swapRequestStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setOpenShiftViewFilter(value){
        openShiftViewFilter = String(value || '').trim().toLowerCase() === 'mine' ? 'mine' : 'available';
        if (openShiftViewTabs) {
          Array.prototype.slice.call(openShiftViewTabs.querySelectorAll('[data-open-shift-view]')).forEach(function(button){
            var tabValue = String(button.getAttribute('data-open-shift-view') || '').trim().toLowerCase();
            var isActive = tabValue === openShiftViewFilter;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }
        renderOpenShiftState(shiftChangeQueue);
      }

      function setSupplyStatus(text, tone){
        if (!supplyStatus) return;
        supplyStatus.textContent = String(text || '');
        supplyStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setTodoStatus(text, tone){
        if (!todoStatus) return;
        todoStatus.textContent = String(text || '');
        todoStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setTabCount(node, count){
        if (!node) return;
        var numeric = Math.max(0, Number(count) || 0);
        node.textContent = String(numeric);
        node.hidden = numeric <= 0;
      }

      async function fetchMasterScheduleAssignments(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'master-schedule-list'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load master schedule.');
        }

        return data.rows.reduce(function(map, row){
          var staffId = String((row && row.staff_id) || '').trim();
          if (staffId) {
            map[staffId] = row;
          }
          return map;
        }, {});
      }

      async function fetchRequestOffQueue(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-request-off-list'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load request queue.');
        }
        return data.rows;
      }

      async function fetchShiftChangeQueue(requestType){
        var body = {
          action: 'staff-shift-change-list'
        };
        if (requestType) {
          body.request_type = requestType;
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load shift changes.');
        }
        return data.rows;
      }

      async function fetchSupplyRequests(){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) return [];
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'supply-request-list',
            staff_id: currentLoggedInStaff.id
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load supply requests.');
        }
        return {
          rows: data.rows,
          suggestions: Array.isArray(data.suggestions) ? data.suggestions : []
        };
      }

      async function fetchTodoView(){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) return { rows: [], managers: [] };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'todo-item-list',
            staff_id: currentLoggedInStaff.id
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load your to-do list.');
        }
        return {
          rows: data.rows,
          managers: Array.isArray(data.managers) ? data.managers : []
        };
      }

      async function submitTodoItemForm(){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) {
          throw new Error('Log in again to post a to-do item.');
        }
        var title = String(todoTitle && todoTitle.value || '').trim();
        if (!title) {
          throw new Error('Enter the task that needs attention.');
        }
        var selectedManagerIds = Array.prototype.slice.call(document.querySelectorAll('input[name="todoManager"]:checked')).map(function(node){
          return String(node && node.value || '').trim();
        }).filter(Boolean);
        if (!selectedManagerIds.length) {
          throw new Error('Select at least one manager to tag.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'todo-item-submit',
            staff_id: currentLoggedInStaff.id,
            title: title,
            detail: String(todoDetail && todoDetail.value || '').trim(),
            recurrence: String(todoRecurrence && todoRecurrence.value || 'none').trim(),
            tagged_manager_ids: selectedManagerIds
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not post that to-do item.');
        }
        return data;
      }

      async function deleteTodoItemForStaff(todoId){
        var normalizedTodoId = String(todoId || '').trim();
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) {
          throw new Error('Log in again to update your to-do list.');
        }
        if (!normalizedTodoId) {
          throw new Error('Missing to-do item.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'todo-item-delete',
            staff_id: currentLoggedInStaff.id,
            todo_id: normalizedTodoId
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not delete that to-do item.');
        }
        return data;
      }

      function renderSupplySuggestions(values){
        supplySuggestions = Array.isArray(values) ? values.slice() : [];
        refreshSupplySuggestionOptions(supplyItemName ? String(supplyItemName.value || '') : '');
      }

      function refreshSupplySuggestionOptions(query){
        if (!supplyItemSuggestions) return;
        var normalizedQuery = String(query || '').trim().toLowerCase();
        var ranked = supplySuggestions
          .map(function(value, index){
            var normalized = String(value || '').trim();
            var lowered = normalized.toLowerCase();
            if (!normalized) return null;
            var rank = normalizedQuery
              ? (lowered === normalizedQuery ? 0 : lowered.indexOf(normalizedQuery) === 0 ? 1 : lowered.indexOf(normalizedQuery) >= 0 ? 2 : 9)
              : 3;
            return {
              value: normalized,
              lowered: lowered,
              rank: rank,
              index: index
            };
          })
          .filter(function(entry){
            return entry && entry.rank < 9;
          })
          .sort(function(left, right){
            if (left.rank !== right.rank) return left.rank - right.rank;
            if (left.value.length !== right.value.length) return left.value.length - right.value.length;
            return left.index - right.index;
          })
          .reduce(function(list, entry){
            if (list.some(function(existing){ return existing.lowered === entry.lowered; })) return list;
            list.push(entry);
            return list;
          }, [])
          .slice(0, normalizedQuery ? 12 : 18);
        activeSupplyAutocompleteSuggestion = ranked.length ? ranked[0].value : '';
        supplyItemSuggestions.innerHTML = ranked.map(function(entry){
          return '<option value="' + escapeHtml(String(entry.value || '')) + '"></option>';
        }).join('');
        if (supplyLookupHint) {
          if (!normalizedQuery) {
            supplyLookupHint.textContent = 'Suggestions will appear as you type.';
          } else if (activeSupplyAutocompleteSuggestion && activeSupplyAutocompleteSuggestion.toLowerCase() !== normalizedQuery) {
            supplyLookupHint.textContent = 'Press Tab to use "' + activeSupplyAutocompleteSuggestion + '".';
          } else if (activeSupplyAutocompleteSuggestion) {
            supplyLookupHint.textContent = 'Matched to "' + activeSupplyAutocompleteSuggestion + '".';
          } else {
            supplyLookupHint.textContent = 'No close match yet. Add it and we will learn it.';
          }
        }
      }

      async function submitSupplyRequestForm(){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) {
          throw new Error('Log in again to add a supply request.');
        }
        var itemName = String(supplyItemName && supplyItemName.value || '').trim();
        if (!itemName) {
          throw new Error('Enter the item you need.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'supply-request-submit',
            staff_id: currentLoggedInStaff.id,
            item_name: itemName,
            note: String(supplyNote && supplyNote.value || '').trim()
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not add supply request.');
        }
        supplySuggestions = [data.row.matched_catalog_name, data.row.raw_item_name].concat(supplySuggestions || []).filter(Boolean);
        return data.row;
      }

      function getShiftChangeMeta(row){
        var sms = row && row.sms && typeof row.sms === 'object' ? row.sms : null;
        var meta = sms && sms.meta && typeof sms.meta === 'object' ? sms.meta : null;
        return meta || {};
      }

      function formatShiftChangeTypeLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'pick_up_shift') return 'Pick Up Shift';
        if (normalized === 'open_shift') return 'Open Shift';
        return 'Shift Switch';
      }

      function getRequestOffMeta(row){
        var sms = row && row.sms && typeof row.sms === 'object' ? row.sms : null;
        var meta = sms && sms.meta && typeof sms.meta === 'object' ? sms.meta : null;
        return meta || {};
      }

      function normalizeRequestOffScope(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'first_half') return 'first_half';
        if (normalized === 'second_half') return 'second_half';
        return 'full_shift';
      }

      function parseShiftLabelTimeRangeMinutes(label){
        var raw = String(label || '').trim().toLowerCase();
        if (!raw || raw === 'off') return null;
        var matched = raw.match(/^(\d{1,2})(?::(\d{2}))?\s*(a|am|p|pm)?\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(a|am|p|pm)?$/i);
        if (!matched) return null;

        var startHour = Number(matched[1]);
        var startMinute = Number(matched[2] || 0);
        var startMeridiem = String(matched[3] || '').toLowerCase();
        var endHour = Number(matched[4]);
        var endMinute = Number(matched[5] || 0);
        var endMeridiem = String(matched[6] || '').toLowerCase();

        function toMinutes(hour, minute, meridiem){
          if (!isFinite(hour) || !isFinite(minute)) return null;
          var safeHour = hour % 12;
          var suffix = String(meridiem || '').toLowerCase();
          if (suffix === 'p' || suffix === 'pm') safeHour += 12;
          return (safeHour * 60) + minute;
        }

        function inferStartMeridiem(){
          if (startMeridiem) return startMeridiem;
          if (!endMeridiem) return '';
          var sameMeridiemStart = toMinutes(startHour, startMinute, endMeridiem);
          var endWithGivenMeridiem = toMinutes(endHour, endMinute, endMeridiem);
          if (sameMeridiemStart != null && endWithGivenMeridiem != null && sameMeridiemStart < endWithGivenMeridiem) {
            return endMeridiem;
          }
          if (endMeridiem === 'p' || endMeridiem === 'pm') {
            return startHour === 12 ? 'pm' : 'am';
          }
          if (endMeridiem === 'a' || endMeridiem === 'am') {
            return startHour === 12 ? 'am' : 'pm';
          }
          return '';
        }

        var resolvedStartMeridiem = inferStartMeridiem();
        var startMinutes = toMinutes(startHour, startMinute, resolvedStartMeridiem);
        var endMinutes = toMinutes(endHour, endMinute, endMeridiem);
        if (startMinutes == null || endMinutes == null || endMinutes <= startMinutes) return null;
        return {
          startMinutes: startMinutes,
          endMinutes: endMinutes,
          midpointMinutes: startMinutes + Math.round((endMinutes - startMinutes) / 2)
        };
      }

      function formatMinutesAsTimeLabel(totalMinutes){
        var safeMinutes = Number(totalMinutes);
        if (!isFinite(safeMinutes)) return '';
        var minutes = Math.max(0, Math.round(safeMinutes));
        var hour24 = Math.floor(minutes / 60) % 24;
        var minute = minutes % 60;
        var meridiem = hour24 >= 12 ? 'PM' : 'AM';
        var hour12 = hour24 % 12;
        if (!hour12) hour12 = 12;
        return hour12 + ':' + String(minute).padStart(2, '0') + ' ' + meridiem;
      }

      function buildRequestOffScopeDetails(staffId, dateValue, staffName){
        var shiftLabel = getMasterScheduleShiftForDate(staffId, dateValue, staffName);
        var parsedRange = parseShiftLabelTimeRangeMinutes(shiftLabel);
        return {
          shiftLabel: shiftLabel,
          parsedRange: parsedRange
        };
      }

      function getRequestOffScopeOptionLabel(scope, details){
        var normalized = normalizeRequestOffScope(scope);
        var shiftLabel = String(details && details.shiftLabel || '').trim();
        var parsedRange = details && details.parsedRange ? details.parsedRange : null;
        if (normalized === 'full_shift') {
          return shiftLabel ? 'Full day off (' + shiftLabel + ')' : 'Full day off';
        }
        if (!parsedRange) {
          return normalized === 'first_half'
            ? 'First half off (coming in late)'
            : 'Second half off (leaving early)';
        }
        if (normalized === 'first_half') {
          return 'First half off (coming in at ' + formatMinutesAsTimeLabel(parsedRange.midpointMinutes) + ')';
        }
        return 'Second half off (leaving at ' + formatMinutesAsTimeLabel(parsedRange.midpointMinutes) + ')';
      }

      function resolveRequestOffLevelNumber(roleName, staffName){
        var directLevel = parseRoleLevelNumber(roleName);
        if (directLevel != null) return directLevel;
        var mappedLevel = parseRoleLevelNumber(getLevelLabel(staffName));
        if (mappedLevel != null) return mappedLevel;
        if (currentLoggedInStaff && sameStaffName(currentLoggedInStaff.name, staffName)) {
          var currentLevel = parseRoleLevelNumber(currentLoggedInStaff.level || currentLoggedInStaff.role);
          if (currentLevel != null) return currentLevel;
        }
        return null;
      }

      function canStaffRequestPartialShift(roleName, staffName){
        var levelNumber = resolveRequestOffLevelNumber(roleName, staffName);
        return levelNumber != null && levelNumber >= 4;
      }

      function formatRequestOffScopeLabel(value){
        return getRequestOffScopeOptionLabel(value, null);
      }

      function formatOpenShiftTypeLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'manager') return 'Manager';
        if (normalized === 'floor') return 'Floor';
        if (normalized === 'assisting') return 'Assisting';
        return '';
      }

      function formatRequestReviewSubmitted(value){
        var parsed = new Date(value);
        if (isNaN(parsed.getTime())) return String(value || '');
        return parsed.toLocaleString(undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });
      }

      function formatRequestReviewDates(values){
        if (!Array.isArray(values) || !values.length) return 'No dates';
        return values.map(function(value){
          var parsed = new Date(String(value) + 'T12:00:00');
          if (isNaN(parsed.getTime())) return String(value || '');
          return parsed.toLocaleDateString(undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          });
        }).join(', ');
      }

      function firstRequestDateValue(row){
        var values = Array.isArray(row && row.requested_dates) ? row.requested_dates : [];
        return String(values[0] || '').trim();
      }

      function isPastRequestRow(row){
        var firstDate = firstRequestDateValue(row);
        if (!firstDate) return false;
        var today = new Date();
        var todayValue = [
          today.getFullYear(),
          String(today.getMonth() + 1).padStart(2, '0'),
          String(today.getDate()).padStart(2, '0')
        ].join('-');
        return firstDate < todayValue;
      }

      function setPersonalRequestsCount(node, count){
        if (!node) return;
        node.textContent = String(Math.max(0, Number(count) || 0));
      }

      function renderPersonalRequestsTabs(futureCount, pastCount){
        setPersonalRequestsCount(personalRequestsCountFuture, futureCount);
        setPersonalRequestsCount(personalRequestsCountPast, pastCount);
        if (!personalRequestsTabs) return;
        Array.prototype.slice.call(personalRequestsTabs.querySelectorAll('[data-personal-requests-view]')).forEach(function(button){
          var view = String(button.getAttribute('data-personal-requests-view') || '').trim();
          var isActive = view === activePersonalRequestsView;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function setActivePersonalRequestsView(view){
        var nextView = String(view || '').trim().toLowerCase() === 'past' ? 'past' : 'future';
        if (activePersonalRequestsView === nextView) {
          renderPersonalRequests();
          return;
        }
        activePersonalRequestsView = nextView;
        renderPersonalRequests();
      }

      function uniqueNonEmptyStrings(values){
        if (!Array.isArray(values)) return [];
        var seen = {};
        return values.reduce(function(list, value){
          var text = String(value || '').trim();
          if (!text || seen[text]) return list;
          seen[text] = true;
          list.push(text);
          return list;
        }, []);
      }

      function renderRequestReviewDebugLine(label, value){
        var text = String(value || '').trim();
        if (!text) return '';
        return ''
          + '<div class="request-review-debug-line">'
          +   '<div class="request-review-debug-label">' + escapeHtml(label) + '</div>'
          +   '<div class="request-review-debug-value">' + escapeHtml(text) + '</div>'
          + '</div>';
      }

      function getPersonalShiftRequestRows(){
        return (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).filter(function(row){
          var requestType = String((row && row.request_type) || '').trim().toLowerCase();
          return (requestType === 'pick_up_shift' || requestType === 'replace_shift')
            && sameStaffName(row && row.staff_name, currentLoggedInStaff && currentLoggedInStaff.name);
        });
      }

      function getPersonalRequestRows(){
        return (Array.isArray(requestOffQueue) ? requestOffQueue : []).concat(getPersonalShiftRequestRows());
      }

      function renderRequestOffQueue(){
        var visibleRows = Array.isArray(requestOffQueue) ? requestOffQueue.filter(function(row){
          return !isPastRequestRow(row);
        }) : [];

        visibleRows.sort(function(a, b){
          var statusA = String((a && a.status) || '').trim().toLowerCase();
          var statusB = String((b && b.status) || '').trim().toLowerCase();
          var pendingA = statusA === 'pending' ? 0 : 1;
          var pendingB = statusB === 'pending' ? 0 : 1;
          if (pendingA !== pendingB) return pendingA - pendingB;

          var dateA = firstRequestDateValue(a);
          var dateB = firstRequestDateValue(b);
          if (dateA !== dateB) return dateA.localeCompare(dateB);

          var submittedA = String((a && a.submitted_at) || '').trim();
          var submittedB = String((b && b.submitted_at) || '').trim();
          return submittedA.localeCompare(submittedB);
        });

        if (!visibleRows.length) {
          requestReviewList.innerHTML = '<div class="request-review-empty">No request-off submissions yet.</div>';
          return;
        }

        requestReviewList.innerHTML = visibleRows.map(function(row){
          var status = String((row && row.status) || 'pending').trim().toLowerCase() || 'pending';
          var rowId = String((row && row.id) || '').trim();
          var staffName = String((row && row.staff_name) || '').trim();
          var roleName = String((row && row.role_name) || '').trim();
          var note = String((row && row.note) || '').trim();
          var submittedAt = formatRequestReviewSubmitted(row && row.submitted_at);
          var requestedDates = formatRequestReviewDates(row && row.requested_dates);
          var reviewedBy = String((row && row.reviewed_by) || '').trim();
          var statusNote = String((row && row.status_note) || '').trim();
          var notifyPhone = String((row && row.notify_phone) || '').trim();
          var verifiedLast4 = String((row && row.verified_phone_last4) || '').trim();
          var statusSms = row && row.sms && row.sms.status_update ? row.sms.status_update : null;
          var statusSmsSentAt = String((statusSms && statusSms.sent_at) || '').trim();
          var statusSmsCode = String((((statusSms && statusSms.result) || {}).response_code) || '').trim();
          var statusSmsMessage = String((((statusSms && statusSms.result) || {}).response_msg) || '').trim();
          var statusSmsSummary = statusSms
            ? [statusSmsCode || 'sent', statusSmsMessage].filter(Boolean).join(' - ')
            : '';
          var rawJson = JSON.stringify(row || {}, null, 2);
          var approvedDisabled = status === 'approved' ? ' disabled' : '';
          var deniedDisabled = status === 'denied' ? ' disabled' : '';
          return ''
            + '<article class="request-review-card" data-status="' + escapeHtml(status) + '">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-meta">'
            +         '<div class="request-review-name">' + escapeHtml(staffName) + '</div>'
            +         '<div class="request-review-dates">' + escapeHtml(requestedDates) + '</div>'
            +         (note ? '<div>Note: ' + escapeHtml(note) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +     '<div class="request-review-side">'
            +       '<span class="request-review-badge" data-status="' + escapeHtml(status) + '">' + escapeHtml(status) + '</span>'
            +       '<div class="request-review-actions">'
            +         '<button class="btn-primary" type="button" data-request-action="approve" data-request-id="' + escapeHtml(rowId) + '"' + approvedDisabled + '>Approve</button>'
            +         '<button class="btn-secondary" type="button" data-request-action="deny" data-request-id="' + escapeHtml(rowId) + '"' + deniedDisabled + '>Deny</button>'
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   '<details class="request-review-details">'
            +     '<summary>Details</summary>'
            +     '<div class="request-review-debug">'
            +       '<div class="request-review-debug-grid">'
            +         renderRequestReviewDebugLine('Request ID', rowId)
            +         renderRequestReviewDebugLine('Status', status)
            +         renderRequestReviewDebugLine('Submitted', submittedAt)
            +         renderRequestReviewDebugLine('Role', roleName)
            +         renderRequestReviewDebugLine('Reviewed by', reviewedBy)
            +         renderRequestReviewDebugLine('Status note', statusNote)
            +         renderRequestReviewDebugLine('Notify Phone', notifyPhone || 'none')
            +         renderRequestReviewDebugLine('Verified Last 4', verifiedLast4 || 'none')
            +         renderRequestReviewDebugLine('Status Text', statusSmsSummary || 'not sent')
            +         renderRequestReviewDebugLine('Status Text At', statusSmsSentAt || 'n/a')
            +       '</div>'
            +       '<details class="request-review-raw">'
            +         '<summary>Raw request debug</summary>'
            +         '<pre>' + escapeHtml(rawJson) + '</pre>'
            +       '</details>'
            +     '</div>'
            +   '</details>'
            + '</article>';
        }).join('');
      }

      async function refreshRequestOffQueue(){
        requestOffQueue = await fetchRequestOffQueue();
        renderRequestOffQueue();
      }

      async function updateRequestOffQueueStatus(requestId, status){
        var payload = {
          action: 'staff-request-off-update-status',
          request_id: requestId,
          status: status,
          reviewed_by: 'Dashboard'
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not update request status.');
        }
        var nextId = String((data.row && data.row.id) || '').trim();
        requestOffQueue = (Array.isArray(requestOffQueue) ? requestOffQueue : []).map(function(row){
          return String((row && row.id) || '').trim() === nextId ? data.row : row;
        });
        renderRequestOffQueue();
        return data.row;
      }

      function setMasterScheduleStatus(text, tone){
        if (!masterScheduleStatus) return;
        masterScheduleStatus.textContent = String(text || '');
        if (tone) {
          masterScheduleStatus.setAttribute('data-tone', tone);
        } else {
          masterScheduleStatus.removeAttribute('data-tone');
        }
      }

      function normalizeMasterScheduleValue(value, dayConfig){
        var normalized = String(value || '').trim();
        return dayConfig.options.indexOf(normalized) !== -1 ? normalized : 'OFF';
      }

      function getMasterScheduleCustomFieldKey(dayKey){
        return String(dayKey || '').trim() + '_custom_shift';
      }

      function getMasterScheduleDisplayValue(assignment, dayKey){
        var dayConfig = MASTER_SCHEDULE_DAYS.find(function(entry){
          return entry.key === dayKey;
        }) || { options: ['OFF'] };
        var shiftValue = normalizeMasterScheduleValue(assignment && assignment[dayKey], dayConfig);
        if (shiftValue !== 'CUSTOM') return shiftValue;
        var customValue = String((assignment && assignment[getMasterScheduleCustomFieldKey(dayKey)]) || '').trim();
        return customValue || 'Custom shift';
      }

      function toLocalDateKey(date){
        return [
          date.getFullYear(),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0')
        ].join('-');
      }

      function getCurrentWorkWeekDays(){
        var today = new Date();
        var currentDay = today.getDay();
        var mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
        var monday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + mondayOffset);
        return MASTER_SCHEDULE_DAYS.map(function(dayConfig, index){
          var date = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + index);
          return {
            key: dayConfig.key,
            label: dayConfig.label,
            date: date,
            dateKey: toLocalDateKey(date)
          };
        });
      }

      function getSelectedScheduleDate(){
        var rawValue = String((liveWeeklyDate && liveWeeklyDate.value) || '').trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(rawValue)) {
          var parts = rawValue.split('-').map(function(part){ return Number(part); });
          return new Date(parts[0], parts[1] - 1, parts[2]);
        }
        return new Date();
      }

      function getDayConfigForDate(date){
        var keys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var key = keys[date.getDay()] || '';
        return MASTER_SCHEDULE_DAYS.find(function(day){
          return day.key === key;
        }) || null;
      }

      function getDayConfigForDateValue(dateValue){
        var rawValue = String(dateValue || '').trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(rawValue)) return null;
        var parts = rawValue.split('-').map(function(part){ return Number(part); });
        return getDayConfigForDate(new Date(parts[0], parts[1] - 1, parts[2]));
      }

      function findMasterScheduleAssignment(staffId, staffName){
        var safeStaffId = String(staffId || '').trim();
        if (safeStaffId && masterScheduleAssignments[safeStaffId]) {
          return masterScheduleAssignments[safeStaffId];
        }
        var safeStaffName = String(staffName || '').trim();
        if (!safeStaffName) return null;
        var keys = Object.keys(masterScheduleAssignments || {});
        for (var index = 0; index < keys.length; index += 1) {
          var row = masterScheduleAssignments[keys[index]];
          if (sameStaffName(row && row.staff_name, safeStaffName)) {
            return row;
          }
        }
        return null;
      }

      function getMasterScheduleShiftForDate(staffId, dateValue, staffName){
        var safeStaffId = String(staffId || '').trim();
        var safeDateValue = String(dateValue || '').trim();
        if (!safeDateValue) return '';
        var dayConfig = getDayConfigForDateValue(safeDateValue);
        if (!dayConfig) return '';
        var assignment = findMasterScheduleAssignment(safeStaffId, staffName) || {};
        return getMasterScheduleDisplayValue(assignment, dayConfig.key);
      }

      function getDateValueForMasterScheduleDay(referenceDateValue, dayKey){
        var safeReference = String(referenceDateValue || '').trim();
        var targetDayIndex = MASTER_SCHEDULE_DAYS.findIndex(function(day){
          return day && day.key === dayKey;
        });
        if (!safeReference || targetDayIndex === -1) return '';
        var parts = safeReference.split('-').map(function(part){ return Number(part); });
        if (parts.length !== 3 || parts.some(function(part){ return !isFinite(part); })) return '';
        var referenceDate = new Date(parts[0], parts[1] - 1, parts[2]);
        if (isNaN(referenceDate.getTime())) return '';
        var weekStart = startOfWeekMonday(referenceDate);
        return formatDateInputValue(addDays(weekStart, targetDayIndex));
      }

      function findRequestOffOptionById(staffId){
        var safeStaffId = String(staffId || '').trim();
        if (!safeStaffId) return null;
        var options = Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : [];
        for (var index = 0; index < options.length; index += 1) {
          if (String((options[index] && options[index].id) || '').trim() === safeStaffId) {
            return options[index];
          }
        }
        return null;
      }

      function syncRequestOffScopeOptions(){
        if (!requestOffScope) return;
        var selectedStaffId = String(requestOffStaff && requestOffStaff.value || '').trim();
        var selectedDate = String(requestOffDate && requestOffDate.value || '').trim();
        var currentValue = normalizeRequestOffScope(requestOffScope.value);
        var selectedOption = findRequestOffOptionById(selectedStaffId);
        var details = buildRequestOffScopeDetails(selectedStaffId, selectedDate, selectedOption && selectedOption.name);
        var allowsPartialShift = canStaffRequestPartialShift(selectedOption && selectedOption.role, selectedOption && selectedOption.name);
        var canSplitShift = allowsPartialShift && !!(details && details.parsedRange);
        requestOffScope.innerHTML = ''
          + '<option value="full_shift">' + escapeHtml(getRequestOffScopeOptionLabel('full_shift', details)) + '</option>'
          + '<option value="first_half"' + (canSplitShift ? '' : ' disabled') + '>' + escapeHtml(getRequestOffScopeOptionLabel('first_half', details)) + '</option>'
          + '<option value="second_half"' + (canSplitShift ? '' : ' disabled') + '>' + escapeHtml(getRequestOffScopeOptionLabel('second_half', details)) + '</option>';
        if ((currentValue === 'first_half' || currentValue === 'second_half') && !canSplitShift) {
          requestOffScope.value = 'full_shift';
        } else {
          requestOffScope.value = currentValue;
        }
      }

      function formatWeekRangeLabel(days){
        if (!Array.isArray(days) || !days.length) return '';
        var start = days[0].date;
        var end = days[days.length - 1].date;
        var sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
        var startText = start.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric'
        });
        var endText = end.toLocaleDateString(undefined, {
          month: sameMonth ? undefined : 'short',
          day: 'numeric',
          year: 'numeric'
        });
        return startText + ' - ' + endText;
      }

      function buildApprovedRequestOffMap(){
        return (Array.isArray(requestOffQueue) ? requestOffQueue : []).reduce(function(map, row){
          if (String((row && row.status) || '').trim().toLowerCase() !== 'approved') {
            return map;
          }
          var staffId = String((row && row.staff_id) || '').trim();
          if (!staffId) return map;
          var dates = uniqueNonEmptyStrings(row && row.requested_dates);
          if (!dates.length) return map;
          if (!map[staffId]) {
            map[staffId] = {};
          }
          var scope = normalizeRequestOffScope(getRequestOffMeta(row).request_scope);
          dates.forEach(function(dateKey){
            map[staffId][dateKey] = {
              scope: scope,
              label: formatRequestOffScopeLabel(scope)
            };
          });
          return map;
        }, {});
      }

      function getShiftSortWeight(shift){
        var value = String(shift || '').trim().toLowerCase();
        if (value === '8-3pm') return 1;
        if (value === '11-6p') return 2;
        if (value === '12-9:30p') return 3;
        if (value === '3-9:30p') return 4;
        return 99;
      }

      function getRoleSortWeight(role){
        var value = String(role || '').trim();
        var levelMatch = value.match(/level\s+(\d+)/i);
        if (levelMatch) {
          return Number(levelMatch[1]);
        }
        if (/support/i.test(value) || /assistant/i.test(value) || /front desk/i.test(value)) {
          return 200;
        }
        if (/manager/i.test(value)) {
          return 300;
        }
        if (/owner/i.test(value)) {
          return 400;
        }
        return 250;
      }

      function getRoleBucket(role){
        var value = String(role || '').trim();
        var levelMatch = value.match(/level\s+(\d+)/i);
        if (levelMatch) {
          var level = Number(levelMatch[1]);
          if (level >= 0 && level <= 4) return 'levels_0_4';
          if (level >= 5 && level <= 7) return 'levels_5_7';
        }
        if (/manager/i.test(value) || /owner/i.test(value) || /front desk/i.test(value) || /desk/i.test(value)) {
          return 'management_desk';
        }
        return 'management_desk';
      }

      function renderLiveWeeklyBoard(){
        if (!liveWeeklyBoardMount) return;
        var staffOptions = Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions.slice() : [];
        if (!staffOptions.length) {
          liveWeeklyBoardMount.innerHTML = '<div class="live-weekly-empty">No staff available for this day yet.</div>';
          return;
        }

        var approvedMap = buildApprovedRequestOffMap();
        var selectedDate = getSelectedScheduleDate();
        var selectedDateKey = toLocalDateKey(selectedDate);
        var dayConfig = getDayConfigForDate(selectedDate);
        var dayLabel = selectedDate.toLocaleDateString(undefined, {
          weekday: 'long'
        });
        var dayDateLabel = selectedDate.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });

        if (!dayConfig) {
          liveWeeklyBoardMount.innerHTML = ''
            + '<div class="live-weekly-head">'
            +   '<div>'
            +     '<div class="live-weekly-label">Daily Schedule</div>'
            +     '<h2 class="live-weekly-title">Who&apos;s Working</h2>'
            +   '</div>'
            +   '<div class="live-weekly-range">' + escapeHtml(dayDateLabel) + '</div>'
            + '</div>'
            + '<div class="live-weekly-empty">No recurring shifts are set for weekends.</div>';
          return;
        }

        var workers = staffOptions.map(function(option){
          var assignment = masterScheduleAssignments[option.id] || {};
          var shift = getMasterScheduleDisplayValue(assignment, dayConfig.key);
          if (shift === 'OFF') return null;
          var approvedRequest = approvedMap[option.id] && approvedMap[option.id][selectedDateKey]
            ? approvedMap[option.id][selectedDateKey]
            : null;
          return {
            name: option.name || '',
            role: option.role || '',
            shift: shift,
            approved_request_off: !!approvedRequest,
            approved_request_scope: approvedRequest && approvedRequest.scope ? approvedRequest.scope : ''
          };
        }).filter(Boolean);

        workers.sort(function(a, b){
          var shiftCompare = getShiftSortWeight(a.shift) - getShiftSortWeight(b.shift);
          if (shiftCompare !== 0) return shiftCompare;
          var roleCompare = getRoleSortWeight(a.role) - getRoleSortWeight(b.role);
          if (roleCompare !== 0) return roleCompare;
          return String(a.name || '').localeCompare(String(b.name || ''));
        });

        var seenShiftLabels = {};
        var shiftGroups = workers.reduce(function(groups, worker){
          var shiftLabel = String((worker && worker.shift) || '').trim();
          if (!shiftLabel) return groups;
          if (!seenShiftLabels[shiftLabel]) {
            seenShiftLabels[shiftLabel] = {
              label: shiftLabel,
              workers: []
            };
            groups.push(seenShiftLabels[shiftLabel]);
          }
          seenShiftLabels[shiftLabel].workers.push(worker);
          return groups;
        }, []);
        shiftGroups.sort(function(a, b){
          return getShiftSortWeight(a.label) - getShiftSortWeight(b.label);
        });

        liveWeeklyBoardMount.innerHTML = ''
          + '<div class="live-weekly-head">'
          +   '<div>'
          +     '<div class="live-weekly-label">Daily Schedule</div>'
          +     '<h2 class="live-weekly-title">Who&apos;s Working</h2>'
          +   '</div>'
          +   '<div class="live-weekly-range">' + escapeHtml(dayDateLabel) + '</div>'
          + '</div>'
          + '<div class="live-weekly-grid">'
          +   '<section class="live-weekly-day">'
          +     '<div class="live-weekly-day-head">'
          +       '<div class="live-weekly-day-label">' + escapeHtml(dayLabel) + '</div>'
          +       '<div class="live-weekly-day-date">' + escapeHtml(dayDateLabel) + '</div>'
          +     '</div>'
          +     '<div class="live-weekly-list">'
          +       (shiftGroups.length ? shiftGroups.map(function(group){
                    function renderBucket(key, label){
                      var bucketWorkers = group.workers.filter(function(worker){
                        return getRoleBucket(worker.role) === key;
                      });
                        return ''
                          + '<div class="live-weekly-level-column">'
                          +   '<div class="live-weekly-level-head">' + escapeHtml(label) + '</div>'
                          +   (bucketWorkers.length
                              ? '<div class="live-weekly-workers">' + bucketWorkers.map(function(worker){
                                  return '<span class="live-weekly-chip' + (worker.approved_request_off ? ' live-weekly-chip--approved' : '') + '">' + escapeHtml(worker.name) + (worker.approved_request_scope && worker.approved_request_scope !== 'full_shift' ? ' <small>(' + escapeHtml(formatRequestOffScopeLabel(worker.approved_request_scope)) + ')</small>' : '') + '</span>';
                                }).join('') + '</div>'
                              : '<div class="live-weekly-level-empty"></div>')
                          + '</div>';
                    }
                    return ''
                      + '<section class="live-weekly-shift">'
                      +   '<div class="live-weekly-shift-head">'
                      +     '<div class="live-weekly-shift-pill">' + escapeHtml(group.label) + '</div>'
                      +   '</div>'
                      +   '<div class="live-weekly-level-grid">'
                      +     renderBucket('management_desk', 'Management / Desk')
                      +     renderBucket('levels_0_4', 'Levels 0-4')
                      +     renderBucket('levels_5_7', 'Levels 5-7')
                      +   '</div>'
                      + '</section>';
                }).join('') : '<div class="live-weekly-empty">Nobody scheduled.</div>')
          +     '</div>'
          +   '</section>'
          + '</div>';
      }

      async function refreshLiveWeeklyBoard(){
        if (!liveWeeklyBoardMount) return;
        try {
          masterScheduleAssignments = await fetchMasterScheduleAssignments();
          requestOffQueue = await fetchRequestOffQueue();
          renderLiveWeeklyBoard();
        } catch (_error) {
          renderLiveWeeklyBoard();
        }
      }

      function renderMasterScheduleCellSelect(staffId, dayConfig, value){
        return ''
          + '<select'
          + ' data-master-staff-id="' + escapeHtml(staffId) + '"'
          + ' data-master-day="' + escapeHtml(dayConfig.key) + '"'
          + '>'
          + dayConfig.options.map(function(option){
              var label = option === 'OFF' ? 'Off' : option;
              var selectedAttr = option === value ? ' selected' : '';
              return '<option value="' + escapeHtml(option) + '"' + selectedAttr + '>' + escapeHtml(label) + '</option>';
            }).join('')
          + '</select>';
      }

      function renderMasterScheduleWeekView(){
        var staffOptions = Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions.slice() : [];
        if (!staffOptions.length) {
          masterScheduleWeekMount.innerHTML = 'No staff available for the master schedule.';
          return;
        }

        masterScheduleWeekMount.innerHTML = ''
          + '<table>'
          +   '<thead><tr>'
          +     '<th>Staff</th>'
          +     MASTER_SCHEDULE_DAYS.map(function(dayConfig){
                  return '<th>' + escapeHtml(dayConfig.label) + '</th>';
                }).join('')
          +   '</tr></thead>'
          +   '<tbody>'
          +   staffOptions.map(function(option){
                var assignment = masterScheduleAssignments[option.id] || {};
                return ''
                  + '<tr>'
                  +   '<td class="master-schedule-staff">' + escapeHtml(option.name || '') + '</td>'
                  +   MASTER_SCHEDULE_DAYS.map(function(dayConfig){
                        var shiftValue = getMasterScheduleDisplayValue(assignment, dayConfig.key);
                        return '<td class="master-schedule-cell">' + renderMasterScheduleCellSelect(option.id || '', dayConfig, shiftValue) + '</td>';
                      }).join('')
                  + '</tr>';
              }).join('')
          +   '</tbody>'
          + '</table>';
      }

      function populateMasterScheduleStaffOptions(options){
        renderMasterScheduleWeekView();
      }

      async function saveMasterScheduleCell(staffId, dayKey, rawValue){
        var selected = requestOffStaffOptions.find(function(option){
          return String(option.id || '') === String(staffId || '').trim();
        }) || null;
        var dayConfig = MASTER_SCHEDULE_DAYS.find(function(item){
          return item.key === dayKey;
        }) || null;
        if (!selected || !dayConfig) {
          throw new Error('Could not match staff schedule row.');
        }

        var nextEntry = masterScheduleAssignments[staffId] || {
          staff_id: selected.id || '',
          staff_name: selected.name || ''
        };
        nextEntry.staff_id = selected.id || '';
        nextEntry.staff_name = selected.name || '';
        nextEntry[dayKey] = normalizeMasterScheduleValue(rawValue, dayConfig);
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'master-schedule-upsert',
            staff_id: nextEntry.staff_id,
            staff_name: nextEntry.staff_name,
            monday: normalizeMasterScheduleValue(nextEntry.monday, MASTER_SCHEDULE_DAYS[0]),
            tuesday: normalizeMasterScheduleValue(nextEntry.tuesday, MASTER_SCHEDULE_DAYS[1]),
            wednesday: normalizeMasterScheduleValue(nextEntry.wednesday, MASTER_SCHEDULE_DAYS[2]),
            thursday: normalizeMasterScheduleValue(nextEntry.thursday, MASTER_SCHEDULE_DAYS[3]),
            friday: normalizeMasterScheduleValue(nextEntry.friday, MASTER_SCHEDULE_DAYS[4])
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not save recurring schedule.');
        }
        masterScheduleAssignments[staffId] = data.row;
        renderMasterScheduleWeekView();
        setMasterScheduleStatus('Saved ' + dayConfig.label + ' shift for ' + String(selected.name || '') + '.', 'success');
      }

      function formatDateInputValue(date){
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
      }

      function parseLocalDateKey(value){
        if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(String(value))) return null;
        var parts = String(value).split('-').map(Number);
        if (parts.length !== 3) return null;
        return new Date(parts[0], parts[1] - 1, parts[2]);
      }

      function applyQuickRange(range){
        var today = new Date();
        var end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        var start;

        if (range === 'ytd') {
          start = new Date(end.getFullYear(), 0, 1);
        } else if (range === 'last-year') {
          start = new Date(end.getFullYear() - 1, 0, 1);
          end = new Date(end.getFullYear() - 1, 11, 31);
        } else {
          var days = Number(range);
          if (!days) return;
          start = new Date(end);
          start.setDate(start.getDate() - (days - 1));
        }

        dateFrom.value = formatDateInputValue(start);
        dateTo.value = formatDateInputValue(end);
      }

      function buildQuarterOptions(){
        var options = [];
        var startYear = 2020;
        var now = new Date();
        var endYear = now.getFullYear();
        var currentQuarter = Math.floor(now.getMonth() / 3) + 1;

        for (var year = startYear; year <= endYear; year += 1) {
          for (var quarter = 1; quarter <= 4; quarter += 1) {
            if (year === endYear && quarter > currentQuarter) break;
            var startMonth = (quarter - 1) * 3;
            var quarterStart = new Date(year, startMonth, 1);
            var quarterEnd = new Date(year, startMonth + 3, 0);
            options.push({
              value: String(year) + '-Q' + String(quarter),
              label: String(year) + ' Q' + String(quarter),
              start: quarterStart,
              end: quarterEnd
            });
          }
        }

        return options;
      }

      function populateGlobalQuarterOptions(){
        if (!globalKpiQuarter) return;
        var options = buildQuarterOptions();
        globalKpiQuarter.innerHTML = options.map(function(option){
          return '<option value="' + escapeHtml(option.value) + '">' + escapeHtml(option.label) + '</option>';
        }).join('');
        if (options.length) {
          globalKpiQuarter.value = options[options.length - 1].value;
        }
      }

      function getSelectedGlobalQuarter(){
        var selectedValue = String((globalKpiQuarter && globalKpiQuarter.value) || '').trim();
        return buildQuarterOptions().find(function(option){
          return option.value === selectedValue;
        }) || null;
      }

      function diffDaysFromToday(date){
        var today = startOfLocalDay(new Date());
        var target = startOfLocalDay(date);
        return Math.floor((today.getTime() - target.getTime()) / 86400000);
      }

      function buildGlobalKpiReportFilters(){
        var quarter = getSelectedGlobalQuarter();
        if (!quarter) {
          return { mode: 'missing_quarter', report_filters: [], warning: 'Choose a quarter first.' };
        }

        var startDiff = diffDaysFromToday(quarter.start);
        var endDiff = diffDaysFromToday(quarter.end);
        if (startDiff < 0 || endDiff < 0) {
          return { mode: 'future_quarter', report_filters: [], warning: 'Future quarters are not supported.' };
        }

        return {
          mode: 'quarter_range',
          report_filters: [
            {
              attribute_name: 'Sale Date',
              relative_date_query: {
                greater_equal: 'P' + String(startDiff + 1) + 'D'
              }
            },
            {
              attribute_name: 'Sale Date',
              relative_date_query: {
                less_equal: 'P' + String(endDiff) + 'D'
              }
            }
          ]
        };
      }

      async function fetchAttendanceTotals(){
        if (activeController) {
          activeController.abort();
        }

        var controller = new AbortController();
        activeController = controller;
        var timeoutId = setTimeout(function(){
          if (activeController === controller) {
            controller.abort();
          }
        }, REQUEST_TIMEOUT_MS);

        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
          body: JSON.stringify({
              action: 'attendance-totals',
              date_from: dateFrom.value || '',
              date_to: dateTo.value || '',
              include_debug: true,
              include_exports: true
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            var bodySnippet = String((data && data.error) || rawText || '')
              .replace(/\s+/g, ' ')
              .trim()
              .slice(0, 220);
            throw new Error(
              'Proxy response was not usable (status ' + response.status + ')'
              + (bodySnippet ? '. Body: ' + bodySnippet : '')
            );
          }
          return data;
        } catch (error) {
          if (error && error.name === 'AbortError') {
            throw new Error('Attendance request timed out after about 3 minutes. Boulevard is still preparing the export. Please try again in a moment.');
          }
          throw new Error(humanizeClientFetchErrorMessage(error, 'Could not fetch leaderboard from proxy.'));
        } finally {
          clearTimeout(timeoutId);
          if (activeController === controller) {
            activeController = null;
          }
        }
      }

      function renderMergedTable(rows){
        if (!rows.length) {
          tableMount.className = 'empty';
          tableMount.innerHTML = 'No attendance totals matched your filters.';
          return;
        }

        tableMount.className = 'table-wrap';
        tableMount.innerHTML = ''
          + '<table>'
          +   '<thead><tr>'
          +     '<th>Rank</th>'
          +     '<th>Staff</th>'
          +     '<th>Call Outs</th>'
          +     '<th>Late / Left Early</th>'
          +     '<th>Requests Off</th>'
          +     '<th>Reliability Score</th>'
          +   '</tr></thead>'
          +   '<tbody>'
          +   rows.map(function(row){
                var combinedLateLeftEarly = (Number(row.late_arrivals || 0) || 0) + (Number(row.leaving_early || 0) || 0);
                return ''
                  + '<tr>'
                  +   '<td class="rank">' + row.rank + '</td>'
                  +   '<td>' + escapeHtml(row.staff_name) + '</td>'
                  +   '<td class="count">' + row.call_outs + '</td>'
                  +   '<td class="count">' + combinedLateLeftEarly + '</td>'
                  +   '<td class="count">' + row.requests_off + '</td>'
                  +   '<td class="count">' + (row.reliability_score != null ? row.reliability_score : '') + '</td>'
                  + '</tr>';
              }).join('')
          +   '</tbody>'
          + '</table>';
      }

      function renderCallOutsTable(rows){
        if (!rows.length) {
          tableMount.className = 'empty';
          tableMount.innerHTML = 'No call-out totals matched your filters.';
          return;
        }

        tableMount.className = 'table-wrap';
        tableMount.innerHTML = ''
          + '<table>'
          +   '<thead><tr>'
          +     '<th>Rank</th>'
          +     '<th>Staff</th>'
          +     '<th>Call Outs</th>'
          +   '</tr></thead>'
          +   '<tbody>'
          +   rows.map(function(row){
                return ''
                  + '<tr>'
                  +   '<td class="rank">' + row.rank + '</td>'
                  +   '<td>' + escapeHtml(row.staff_name) + '</td>'
                  +   '<td class="count">' + row.sales_count + '</td>'
                  + '</tr>';
              }).join('')
          +   '</tbody>'
          + '</table>';
      }

      function formatMoney(value){
        var numeric = Number(value || 0);
        return '$' + numeric.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      function formatPercent(value){
        var numeric = Number(value || 0);
        return numeric.toFixed(1) + '%';
      }

      function formatCompactNumber(value, digits){
        var numeric = Number(value || 0);
        var precision = Number.isFinite(Number(digits)) ? Number(digits) : 0;
        return numeric.toLocaleString(undefined, {
          minimumFractionDigits: precision,
          maximumFractionDigits: precision
        });
      }

      function formatKpiDate(value){
        var text = value == null ? '' : String(value).trim();
        if (!text || text.toLowerCase() === 'all') return text;

        var parsed = new Date(text);
        if (isNaN(parsed.getTime())) return text;

        return parsed.toLocaleDateString(undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function formatNumericCell(header, value){
        var text = value == null ? '' : String(value);
        if (!text) return '';

        var normalizedHeader = String(header || '').toLowerCase();
        if (normalizedHeader === 'saledate date') {
          return formatKpiDate(text);
        }
        if (normalizedHeader === 'utilization %' && text === '__UNSCHEDULED__') {
          return 'Unscheduled';
        }
        var numeric = Number(text);
        if (!isFinite(numeric)) return text;

        if (normalizedHeader === 'prebooked %' || normalizedHeader === 'utilization %') {
          return (numeric * 100).toFixed(1) + '%';
        }
        if (/percent|%/.test(normalizedHeader)) {
          return (numeric <= 1 ? numeric * 100 : numeric).toFixed(1) + '%';
        }
        if (normalizedHeader === 'production rate') {
          return '$' + numeric.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) + '/hr';
        }
        if (/aov|average order|order value/.test(normalizedHeader)) {
          return '$' + numeric.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }
        if (/sales|tips?/.test(normalizedHeader)) {
          return '$' + numeric.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }
        if (/hours?/.test(normalizedHeader)) {
          return numeric.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          });
        }
        if (/count/.test(normalizedHeader)) {
          return numeric.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          });
        }

        return text;
      }

      function startOfLocalDay(date){
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      }

      function parseYmd(value){
        if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
        var parts = value.split('-').map(Number);
        return new Date(parts[0], parts[1] - 1, parts[2]);
      }

      function diffDaysInclusive(startDate, endDate){
        var start = startOfLocalDay(startDate);
        var end = startOfLocalDay(endDate);
        var diffMs = end.getTime() - start.getTime();
        if (diffMs < 0) return 0;
        return Math.floor(diffMs / 86400000) + 1;
      }

      function getSelectedRangeDays(){
        var matchedFrom = parseYmd(dateFrom.value);
        var matchedTo = parseYmd(dateTo.value);
        if (!matchedFrom || !matchedTo) return 0;
        return diffDaysInclusive(matchedFrom, matchedTo);
      }

      function buildKpiReportFilters(){
        var today = startOfLocalDay(new Date());
        var matchedFrom = parseYmd(dateFrom.value);
        var matchedTo = parseYmd(dateTo.value);

        if (!matchedFrom && !matchedTo) {
          return { mode: 'saved_report', report_filters: [] };
        }

        if (!matchedFrom || !matchedTo) {
          return {
            mode: 'partial_date_range',
            report_filters: [],
            warning: 'KPI filtering needs both Date from and Date to filled in.'
          };
        }

        if (startOfLocalDay(matchedTo).getTime() !== today.getTime()) {
          return {
            mode: 'absolute_date_range',
            report_filters: [],
            warning: 'KPI filtering only works when Date to is today because Boulevard only accepts relative date filters here.'
          };
        }

        var intervalDays = diffDaysInclusive(matchedFrom, matchedTo);

        if (!intervalDays) {
          return {
            mode: 'invalid_date_range',
            report_filters: [],
            warning: 'Could not determine a KPI time window, so the saved report window will be used.'
          };
        }

        return {
          mode: 'attendance_date_range',
          report_filters: [
            {
              attribute_name: 'Sale Date',
              relative_date_query: {
                greater_equal: 'P' + intervalDays + 'D'
              }
            }
          ]
        };
      }

      function canFetchKpiForSelectedRange(filterConfig){
        return !!filterConfig && (
          filterConfig.mode === 'saved_report' ||
          filterConfig.mode === 'attendance_date_range'
        );
      }

      function parseCsv(text){
        var rows = [];
        var row = [];
        var value = '';
        var inQuotes = false;
        for (var i = 0; i < text.length; i += 1) {
          var char = text[i];
          var next = text[i + 1];

          if (char === '"') {
            if (inQuotes && next === '"') {
              value += '"';
              i += 1;
            } else {
              inQuotes = !inQuotes;
            }
            continue;
          }

          if (char === ',' && !inQuotes) {
            row.push(value);
            value = '';
            continue;
          }

          if ((char === '\n' || char === '\r') && !inQuotes) {
            if (char === '\r' && next === '\n') {
              i += 1;
            }
            row.push(value);
            value = '';
            if (row.some(function(cell){ return cell !== ''; })) {
              rows.push(row);
            }
            row = [];
            continue;
          }

          value += char;
        }

        row.push(value);
        if (row.some(function(cell){ return cell !== ''; })) {
          rows.push(row);
        }
        return rows;
      }

      function csvRowsToObjects(csvRows){
        if (!csvRows.length) return { headers: [], rows: [] };
        var headers = csvRows[0];
        var rows = csvRows.slice(1).map(function(values){
          var entry = {};
          headers.forEach(function(header, index){
            entry[header] = values[index] == null ? '' : values[index];
          });
          return entry;
        });
        return { headers: headers, rows: rows };
      }

      function parseNumericCell(value){
        var text = value == null ? '' : String(value).trim();
        if (!text) return 0;
        var numeric = Number(text);
        return isFinite(numeric) ? numeric : 0;
      }

      function formatRawNumeric(value){
        if (!isFinite(value)) return '';
        if (Math.abs(value % 1) < 0.0000001) {
          return String(Math.round(value));
        }
        return String(Number(value.toFixed(6)));
      }

      function isAggregateKpiRow(row){
        var staffName = String((row && row['Staff Name']) || '').trim().toLowerCase();
        var locationName = String((row && row['Location name']) || '').trim().toLowerCase();
        return staffName === 'all' || locationName === 'all';
      }

      function detectKpiGroupingHeader(headers, rows){
        var reservedHeaders = {
          'location name': true,
          'staff name': true,
          'prebooked %': true,
          'appointment count': true,
          'service sales': true,
          'tip sales': true,
          'product sales': true,
          'utilization %': true,
          'hours booked': true,
          'hours scheduled': true
        };

        for (var index = 0; index < headers.length; index += 1) {
          var header = headers[index];
          var normalizedHeader = String(header || '').toLowerCase();
          if (reservedHeaders[normalizedHeader]) continue;

          var hasAll = false;
          var hasDetail = false;
          rows.forEach(function(row){
            var value = String((row && row[header]) || '').trim();
            if (!value) return;
            if (value.toLowerCase() === 'all') {
              hasAll = true;
            } else {
              hasDetail = true;
            }
          });

          if (hasAll && hasDetail) {
            return header;
          }
        }

        return '';
      }

      function selectKpiSummaryRows(headers, rows){
        var groupingHeader = detectKpiGroupingHeader(headers, rows);

        if (!groupingHeader) {
          return rows.filter(function(row){
            return !isAggregateKpiRow(row);
          });
        }

        return rows.filter(function(row){
          if (isAggregateKpiRow(row)) return false;
          return String((row && row[groupingHeader]) || '').trim().toLowerCase() !== 'all';
        });
      }

      function buildComputedKpiTotalRow(headers, rows){
        if (!rows.length) return null;

        var detailRows = rows.slice();

        var locationNames = detailRows
          .map(function(row){ return String(row['Location name'] || '').trim(); })
          .filter(Boolean)
          .filter(function(value, index, list){ return list.indexOf(value) === index; });

        var appointmentCount = 0;
        var serviceSales = 0;
        var tipSales = 0;
        var productSales = 0;
        var hoursBooked = 0;
        var hoursScheduled = 0;
        var weightedPrebooked = 0;

        detailRows.forEach(function(row){
          var rowAppointmentCount = parseNumericCell(row['Appointment Count']);
          var rowPrebookedRaw = parseNumericCell(row['Prebooked %']);
          var rowPrebooked = rowPrebookedRaw > 1 ? rowPrebookedRaw / 100 : rowPrebookedRaw;

          appointmentCount += rowAppointmentCount;
          serviceSales += parseNumericCell(row['Service Sales']);
          tipSales += parseNumericCell(row['Tip Sales']);
          productSales += parseNumericCell(row['Product Sales']);
          hoursBooked += parseNumericCell(row['Hours Booked']);
          hoursScheduled += parseNumericCell(row['Hours Scheduled']);
          weightedPrebooked += rowPrebooked * rowAppointmentCount;
        });

        var computed = {};
        headers.forEach(function(header){
          computed[header] = '';
        });

        computed['Location name'] = locationNames.length === 1 ? locationNames[0] : 'Computed Total';
        computed['Staff Name'] = 'Computed Total';
        if (headers.indexOf('Appointment Count') !== -1) {
          computed['Appointment Count'] = formatRawNumeric(appointmentCount);
        }
        if (headers.indexOf('Service Sales') !== -1) {
          computed['Service Sales'] = formatRawNumeric(serviceSales);
        }
        if (headers.indexOf('Tip Sales') !== -1) {
          computed['Tip Sales'] = formatRawNumeric(tipSales);
        }
        if (headers.indexOf('Product Sales') !== -1) {
          computed['Product Sales'] = formatRawNumeric(productSales);
        }
        if (headers.indexOf('Hours Booked') !== -1) {
          computed['Hours Booked'] = formatRawNumeric(hoursBooked);
        }
        if (headers.indexOf('Hours Scheduled') !== -1) {
          computed['Hours Scheduled'] = formatRawNumeric(hoursScheduled);
        }
        if (headers.indexOf('Prebooked %') !== -1) {
          computed['Prebooked %'] = appointmentCount > 0
            ? formatRawNumeric(weightedPrebooked / appointmentCount)
            : '0';
        }
        computed['Retail to Service %'] = serviceSales > 0
          ? formatRawNumeric(productSales / serviceSales)
          : '';
        if (headers.indexOf('Utilization %') !== -1) {
          computed['Utilization %'] = hoursScheduled > 0
            ? formatRawNumeric(hoursBooked / hoursScheduled)
            : '0';
        }
        computed['Production Rate'] = hoursBooked > 0
          ? formatRawNumeric(serviceSales / hoursBooked)
          : '0';

        return computed;
      }

      function getWeekdayLabel(value){
        var text = value == null ? '' : String(value).trim();
        if (!text || text.toLowerCase() === 'all') return '';
        var parsed = new Date(text);
        if (isNaN(parsed.getTime())) return '';
        return parsed.toLocaleDateString(undefined, { weekday: 'short' });
      }

      function buildWeekdayUtilizationLines(rows, groupingHeader){
        if (!groupingHeader || !Array.isArray(rows) || !rows.length) return '';

        var weekdayOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        var weekdayTotals = {};
        rows.forEach(function(row){
          var weekday = getWeekdayLabel(row[groupingHeader]);
          if (!weekday) return;

          if (!weekdayTotals[weekday]) {
            weekdayTotals[weekday] = {
              hoursBooked: 0,
              hoursScheduled: 0
            };
          }

          weekdayTotals[weekday].hoursBooked += parseNumericCell(row['Hours Booked']);
          weekdayTotals[weekday].hoursScheduled += parseNumericCell(row['Hours Scheduled']);
        });

        var labels = weekdayOrder
          .filter(function(weekday){
            return !!weekdayTotals[weekday];
          })
          .map(function(weekday){
            var totals = weekdayTotals[weekday];
            if (totals.hoursScheduled <= 0) {
              return weekday + ' Unscheduled';
            }
            return weekday + ' ' + formatNumericCell('Utilization %', String(totals.hoursBooked / totals.hoursScheduled));
          });

        return labels;
      }

      function buildExtremeDayLabels(rows, groupingHeader){
        if (!groupingHeader || !Array.isArray(rows) || !rows.length) {
          return { highestDayLabel: '', lowestDayLabel: '' };
        }

        var highestRow = null;
        var lowestRow = null;

        rows.forEach(function(row){
          var dateValue = String((row && row[groupingHeader]) || '').trim();
          if (!dateValue || dateValue.toLowerCase() === 'all') return;

          var serviceSales = parseNumericCell(row['Service Sales']);
          if (!highestRow || serviceSales > parseNumericCell(highestRow['Service Sales'])) {
            highestRow = row;
          }

          if (serviceSales <= 0) return;

          if (!lowestRow || serviceSales < parseNumericCell(lowestRow['Service Sales'])) {
            lowestRow = row;
          }
        });

        function formatDayLabel(prefix, row){
          if (!row) return '';
          var dateLabel = formatKpiDate(row[groupingHeader]);
          var salesLabel = formatNumericCell('Service Sales', row['Service Sales'] || '0');
          return prefix + ': ' + dateLabel + ' ' + salesLabel;
        }

        return {
          highestDayLabel: formatDayLabel('High', highestRow),
          lowestDayLabel: formatDayLabel('Low', lowestRow)
        };
      }

      function buildUnscheduledOpportunityLabel(rows, rangeDays){
        if (!Array.isArray(rows) || !rows.length) return '';

        var unscheduledDays = 0;
        var unscheduledHoursBooked = 0;
        var unscheduledSales = 0;
        var unscheduledAppointments = 0;
        var scheduledHours = 0;
        var scheduledBookedHours = 0;

        rows.forEach(function(row){
          var hoursScheduled = parseNumericCell(row['Hours Scheduled']);
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          var appointmentCount = parseNumericCell(row['Appointment Count']);
          if (hoursScheduled > 0) {
            scheduledHours += hoursScheduled;
            scheduledBookedHours += hoursBooked;
            return;
          }
          if (hoursBooked <= 0) return;

          unscheduledDays += 1;
          unscheduledHoursBooked += hoursBooked;
          unscheduledSales += parseNumericCell(row['Service Sales']);
          unscheduledAppointments += appointmentCount;
        });

        if (!unscheduledDays) return '';
        var baselineUtilization = scheduledHours > 0 ? (scheduledBookedHours / scheduledHours) : 0;
        var unscheduledProduction = unscheduledHoursBooked > 0 ? (unscheduledSales / unscheduledHoursBooked) : 0;
        var normalizedRangeDays = Math.max(0, Number(rangeDays) || 0);
        var requiredUnscheduledDays = normalizedRangeDays
          ? Math.max(3, Math.ceil(normalizedRangeDays * 0.08))
          : 3;
        var requiredUnscheduledAppointments = normalizedRangeDays
          ? Math.max(8, Math.ceil(normalizedRangeDays * 0.2))
          : 8;
        var requiredBookedHours = normalizedRangeDays
          ? Math.max(6, Math.ceil(normalizedRangeDays * 0.12))
          : 6;
        var requiredSales = normalizedRangeDays
          ? Math.max(500, normalizedRangeDays * 15)
          : 500;
        var highUnscheduledDayCount = unscheduledDays >= requiredUnscheduledDays;
        var highUnscheduledAppointmentCount = unscheduledAppointments >= requiredUnscheduledAppointments;
        var meaningfulSupport = unscheduledHoursBooked >= requiredBookedHours || unscheduledSales >= requiredSales;
        var hasBaseline = scheduledHours > 0 && baselineUtilization >= 0.65;

        if (!(highUnscheduledDayCount && highUnscheduledAppointmentCount && meaningfulSupport)) return '';

        var reasonParts = [
          unscheduledDays + (normalizedRangeDays ? '/' + normalizedRangeDays : '') + ' unscheduled day' + (unscheduledDays === 1 ? '' : 's'),
          formatNumericCell('Appointment Count', String(unscheduledAppointments)) + ' appts',
          formatNumericCell('Hours Booked', String(unscheduledHoursBooked)) + ' booked',
          formatNumericCell('Service Sales', String(unscheduledSales))
        ];

        if (hasBaseline) {
          reasonParts.push('scheduled util ' + formatNumericCell('Utilization %', String(baselineUtilization)));
        }
        if (unscheduledProduction > 0) {
          reasonParts.push(formatNumericCell('Production Rate', String(unscheduledProduction)));
        }

        return 'Floor time recommendation: ' + reasonParts.join(' · ');
      }

      function buildSupportPatternLabel(rows, rangeDays){
        if (!Array.isArray(rows) || !rows.length) return '';

        var normalizedRangeDays = Math.max(0, Number(rangeDays) || 0);
        var activeBookingDays = 0;
        var appointmentCount = 0;
        var serviceSales = 0;
        var hoursBooked = 0;

        rows.forEach(function(row){
          var rowAppointments = parseNumericCell(row['Appointment Count']);
          var rowSales = parseNumericCell(row['Service Sales']);
          var rowHoursBooked = parseNumericCell(row['Hours Booked']);

          appointmentCount += rowAppointments;
          serviceSales += rowSales;
          hoursBooked += rowHoursBooked;

          if (rowAppointments > 0 || rowHoursBooked > 0 || rowSales > 0) {
            activeBookingDays += 1;
          }
        });

        var lowBookingDaysThreshold = normalizedRangeDays
          ? Math.max(4, Math.ceil(normalizedRangeDays * 0.1))
          : 4;
        var lowAppointmentsThreshold = normalizedRangeDays
          ? Math.max(10, Math.ceil(normalizedRangeDays * 0.18))
          : 10;
        var lowSalesThreshold = normalizedRangeDays
          ? Math.max(600, normalizedRangeDays * 12)
          : 600;
        var lowBookedHoursThreshold = normalizedRangeDays
          ? Math.max(10, Math.ceil(normalizedRangeDays * 0.2))
          : 10;

        var veryLowBookingDaysThreshold = normalizedRangeDays
          ? Math.max(2, Math.ceil(normalizedRangeDays * 0.06))
          : 2;
        var veryLowAppointmentsThreshold = normalizedRangeDays
          ? Math.max(4, Math.ceil(normalizedRangeDays * 0.08))
          : 4;
        var veryLowSalesThreshold = normalizedRangeDays
          ? Math.max(250, normalizedRangeDays * 5)
          : 250;

        if (
          activeBookingDays <= veryLowBookingDaysThreshold
          && appointmentCount <= veryLowAppointmentsThreshold
          && serviceSales <= veryLowSalesThreshold
        ) {
          return 'Likely support / non-producing role: '
            + activeBookingDays + (normalizedRangeDays ? '/' + normalizedRangeDays : '') + ' booking days'
            + ' · '
            + formatNumericCell('Appointment Count', String(appointmentCount)) + ' appts'
            + ' · '
            + formatNumericCell('Service Sales', String(serviceSales));
        }

        if (
          activeBookingDays <= lowBookingDaysThreshold
          && appointmentCount <= lowAppointmentsThreshold
          && serviceSales <= lowSalesThreshold
          && hoursBooked <= lowBookedHoursThreshold
        ) {
          return 'Support-staff pattern: '
            + activeBookingDays + (normalizedRangeDays ? '/' + normalizedRangeDays : '') + ' booking days'
            + ' · '
            + formatNumericCell('Appointment Count', String(appointmentCount)) + ' appts'
            + ' · '
            + formatNumericCell('Hours Booked', String(hoursBooked)) + ' booked';
        }

        return '';
      }

      function buildDisplayKpiRows(headers, rows){
        if (!Array.isArray(rows) || !rows.length) return [];

        var detailRows = selectKpiSummaryRows(headers, rows);

        if (!detailRows.length) {
          return rows.slice();
        }

        var computedTotalRow = buildComputedKpiTotalRow(headers, detailRows);
        return computedTotalRow ? [computedTotalRow].concat(detailRows) : detailRows;
      }

      function buildKpiStaffGroups(headers, rows){
        var groupingHeader = detectKpiGroupingHeader(headers, rows);
        if (!groupingHeader) return null;
        var selectedRangeDays = getSelectedRangeDays();

        var detailRows = selectKpiSummaryRows(headers, rows);
        if (!detailRows.length) return null;

        var order = [];
        var grouped = {};

        detailRows.forEach(function(row){
          var staffName = String((row && row['Staff Name']) || '').trim();
          if (!staffName) return;
          if (!grouped[staffName]) {
            grouped[staffName] = [];
            order.push(staffName);
          }
          grouped[staffName].push(row);
        });

        var totalRow = buildComputedKpiTotalRow(headers, detailRows);
        return {
          groupingHeader: groupingHeader,
          totalRow: totalRow,
          companyServiceSales: parseNumericCell(totalRow && totalRow['Service Sales']),
          groups: order.map(function(staffName){
            var staffRows = grouped[staffName];
            var summaryRow = buildComputedKpiTotalRow(headers, staffRows) || {};
            var extremeDayLabels = buildExtremeDayLabels(staffRows, groupingHeader);
            summaryRow['Staff Name'] = staffName;
            if (groupingHeader) {
              summaryRow[groupingHeader] = 'All';
            }
            return {
              staffName: staffName,
              summaryRow: summaryRow,
              rows: staffRows,
              weekdayUtilizationLines: buildWeekdayUtilizationLines(staffRows, groupingHeader),
              highestDayLabel: extremeDayLabels.highestDayLabel,
              lowestDayLabel: extremeDayLabels.lowestDayLabel,
              unscheduledOpportunityLabel: buildUnscheduledOpportunityLabel(staffRows, selectedRangeDays),
              supportPatternLabel: buildSupportPatternLabel(staffRows, selectedRangeDays)
            };
          })
        };
      }

      function getDisplayedKpiHeaders(headers){
        var displayed = headers.filter(function(header){
          var normalized = String(header || '').toLowerCase();
          return normalized !== 'location name'
            && normalized !== 'appointment count'
            && normalized !== 'tip sales';
        });

        if (displayed.indexOf('Production Rate') === -1) {
          var insertIndex = displayed.indexOf('Service Sales');
          if (insertIndex === -1) {
            displayed.push('Production Rate');
          } else {
            displayed.splice(insertIndex + 1, 0, 'Production Rate');
          }
        }

        return displayed;
      }

      function getKpiDisplayValue(header, row){
        if (header === 'Utilization %') {
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          var hoursScheduled = parseNumericCell(row['Hours Scheduled']);
          if (hoursScheduled <= 0 && hoursBooked > 0) {
            return '__UNSCHEDULED__';
          }
          return hoursScheduled > 0 ? String(hoursBooked / hoursScheduled) : '0';
        }
        if (header === 'Production Rate') {
          var serviceSales = parseNumericCell(row['Service Sales']);
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          return hoursBooked > 0 ? String(serviceSales / hoursBooked) : '0';
        }
        return row[header];
      }

      function renderKpiDataRow(headers, row){
        return '<tr>'
          + headers.map(function(header){
              var formatted = formatNumericCell(header, getKpiDisplayValue(header, row));
              var cellClass = /sales|tips?|hours?|count|percent|%/i.test(header) ? 'count' : '';
              return '<td class="' + cellClass + '">' + escapeHtml(formatted) + '</td>';
            }).join('')
          + '</tr>';
      }

      function renderKpiTableMarkup(headers, rows){
        var displayedHeaders = getDisplayedKpiHeaders(headers);
        return ''
          + '<table>'
          +   '<thead><tr>'
          +   displayedHeaders.map(function(header){
                return '<th>' + escapeHtml(header) + '</th>';
              }).join('')
          +   '</tr></thead>'
          +   '<tbody>'
          +   rows.map(function(row){
                return renderKpiDataRow(displayedHeaders, row);
              }).join('')
          +   '</tbody>'
          + '</table>';
      }

      function renderSummaryLine(label, value, extraClass){
        if (!value) return '';
        var labelMarkup = label
          ? '<span class="kpi-summary-label">' + escapeHtml(label) + '</span>'
          : '';
        return ''
          + '<span class="kpi-summary-line' + (extraClass ? ' ' + extraClass : '') + '">'
          +   labelMarkup
          +   '<span class="kpi-summary-value">' + escapeHtml(value) + '</span>'
          + '</span>';
      }

      function getReliabilityScoreLabel(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return '100.0%';
        var score = reliabilityScoreByStaff[normalizedName];
        var numeric = score == null ? 100 : Number(score);
        if (!isFinite(numeric)) numeric = 100;
        return numeric.toFixed(1) + '%';
      }

      function getStaffAttendanceCount(map, staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return 0;
        var value = map && map[normalizedName];
        var numeric = Number(value);
        return isFinite(numeric) ? numeric : 0;
      }

      function renderReliabilityDetailLines(staffName){
        return ''
          + renderSummaryLine('Scoring', 'First 5 callouts protected; add back +1 for each callout below 5; extra callouts -10; requests off and late / left early -0.5 each')
          + renderSummaryLine('Requests off', String(getStaffAttendanceCount(requestsOffByStaff, staffName)))
          + renderSummaryLine('Callouts', String(getStaffAttendanceCount(callOutsByStaff, staffName)))
          + renderSummaryLine('Late / Left Early', String(getStaffAttendanceCount(lateArrivalsByStaff, staffName)));
      }

      function getLevelLabel(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return '';
        return levelByStaff[normalizedName] || '';
      }

      function getAvatarUrl(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return '';
        return avatarByStaff[normalizedName] || '';
      }

      function getInitials(name){
        return String(name || '')
          .trim()
          .split(/\s+/)
          .slice(0, 2)
          .map(function(part){ return part.charAt(0).toUpperCase(); })
          .join('') || 'S';
      }

      function extractLevelFromRecord(record){
        if (!record || typeof record !== 'object') return '';

        var candidates = [
          record.role_name,
          record.roleName,
          record.staff_role_name,
          record.staffRoleName,
          record['Role Name'],
          record['role_name'],
          record['role name'],
          record['Staff Role Name'],
          record['staff_role_name'],
          record['staff role name'],
          record.level,
          record.Level,
          record['Staff Level'],
          record['staff level']
        ];

        for (var index = 0; index < candidates.length; index += 1) {
          var value = String(candidates[index] || '').trim();
          if (value) return value;
        }

        return '';
      }

      async function createKpiExport(){
        var filterConfig = buildKpiReportFilters();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'create-report-export',
            report_id: KPI_REPORT_ID,
            file_content_type: 'CSV',
            frequency: 'ONCE',
            report_filters: filterConfig.report_filters
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok || !data.report_export) {
          throw new Error((data && data.error) || 'Could not create raw KPI export.');
        }
        return {
          report_export: data.report_export,
          filter_config: filterConfig
        };
      }

      async function fetchStaffDirectoryInfo(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-directory-derived',
            force_refresh: false
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok) {
          return {};
        }

        return Array.isArray(data.staff)
          ? data.staff.reduce(function(map, member){
              var staffName = String((member && member.name) || '').trim();
              var roleName = String((member && member.role) || '').trim();
              var avatar = String((member && member.avatar) || '').trim();
              if (staffName && !map[staffName]) {
                map[staffName] = {
                  role: roleName,
                  avatar: avatar
                };
              }
              return map;
            }, {})
          : {};
      }

      async function fetchRequestOffFormOptions(){
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'staff-request-off-form-options'
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not load staff request-off options.');
          }
          return Array.isArray(data.staff) ? data.staff : [];
        } catch (_error) {
          var mergedMap = {};
          async function readStaffAction(action){
            var response = await fetch(REPORT_PROXY_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ action: action })
            });
            var rawText = await response.text();
            var data = null;
            try {
              data = rawText ? JSON.parse(rawText) : null;
            } catch (_error) {
              data = null;
            }
            if (!response.ok || !data || !data.ok || !Array.isArray(data.staff)) {
              return [];
            }
            return data.staff;
          }

          var directStaff = await readStaffAction('staff-directory');
          var derivedStaff = await readStaffAction('staff-directory-derived');
          directStaff.concat(derivedStaff).forEach(function(member){
            var staffName = String((member && member.name) || '').trim();
            if (!staffName) return;
            if (!mergedMap[staffName]) {
              mergedMap[staffName] = {
                name: staffName,
                role: String((member && member.role) || '').trim(),
                avatar: String((member && member.avatar) || '').trim()
              };
              return;
            }
            if (!mergedMap[staffName].role) {
              mergedMap[staffName].role = String((member && member.role) || '').trim();
            }
            if (!mergedMap[staffName].avatar) {
              mergedMap[staffName].avatar = String((member && member.avatar) || '').trim();
            }
          });

          return Object.keys(mergedMap).sort(function(a, b){
            var roleA = String((mergedMap[a] && mergedMap[a].role) || '').trim();
            var roleB = String((mergedMap[b] && mergedMap[b].role) || '').trim();
            var roleCompare = roleA.localeCompare(roleB);
            if (roleCompare !== 0) return roleCompare;
            return a.localeCompare(b);
          }).map(function(staffName){
            var item = mergedMap[staffName] || {};
            return {
              id: staffName,
              name: staffName,
              role: String(item.role || '').trim(),
              avatar: String(item.avatar || '').trim(),
              display_label: [staffName, String(item.role || '').trim() || 'Salon Team'].filter(Boolean).join(' · ')
            };
          });
        }
      }

      function renderRequestOffSelectedStaff(){
        var selectedId = String(requestOffStaff.value || '');
        var selected = requestOffStaffOptions.find(function(option){
          return String(option.id || '') === selectedId;
        }) || null;
        var selectedDate = String(requestOffDate && requestOffDate.value || '').trim();
        var details = buildRequestOffScopeDetails(selectedId, selectedDate, selected && selected.name);
        var scopeLabel = getRequestOffScopeOptionLabel(requestOffScope && requestOffScope.value, details);
        var shiftLabel = String(details && details.shiftLabel || '').trim();

        function renderMetaCard(config){
          var chips = Array.isArray(config && config.chips) ? config.chips.filter(Boolean) : [];
          var chipSummary = chips.map(function(chip){
            var label = String((chip && chip.label) || '').trim();
            var value = String((chip && chip.value) || '').trim();
            if (!label && !value) return '';
            return label ? (label + ': ' + value) : value;
          }).filter(Boolean).join(' • ');
          var badge = String((config && config.badge) || '').trim();
          requestOffMeta.innerHTML = ''
            + '<div class="request-off-meta-name">' + escapeHtml(String((config && config.title) || '')) + '</div>'
            + '<div class="request-off-meta-copy">' + escapeHtml(String((config && config.copy) || '')) + '</div>'
            + ((badge || chipSummary)
                ? '<div class="request-off-meta-copy request-off-meta-copy--compact">' + escapeHtml([badge, chipSummary].filter(Boolean).join(' • ')) + '</div>'
                : '');
        }

        if (!selected) {
        renderMetaCard({
          label: 'Request',
          title: 'Start with who',
          badge: 'Step 1',
          copy: 'Choose the staff member first.'
        });
          return;
        }

        if (!selectedDate) {
          renderMetaCard({
            label: 'Request',
            title: String(selected.name || ''),
            badge: 'Step 2',
            copy: 'Pick the day to load the shift.',
            chips: [
              { label: 'Time off', value: 'Pick a day first' }
            ]
          });
          return;
        }

        if (!shiftLabel || shiftLabel === 'OFF') {
          renderMetaCard({
            label: 'Request',
            title: String(selected.name || ''),
            badge: 'Full day only',
            tone: 'warn',
            copy: 'No regular shift is scheduled that day. You can still request the full day off.',
            chips: [
              { label: 'Date', value: selectedDate },
              { label: 'Time off', value: 'Full day only' }
            ]
          });
          return;
        }

        if (!canStaffRequestPartialShift(selected && selected.role, selected && selected.name)) {
          renderMetaCard({
            label: 'Request',
            title: String(selected.name || '') + ' · ' + shiftLabel,
            badge: 'Full day only',
            tone: 'warn',
            copy: 'Only level 4 and above can request part of a shift. You can still request the full day off here.',
            chips: [
              { label: 'Date', value: selectedDate },
              { label: 'Shift', value: shiftLabel },
              { label: 'Time off', value: 'Full day only' }
            ]
          });
          return;
        }

        renderMetaCard({
          label: 'Request',
          title: String(selected.name || '') + ' · ' + shiftLabel,
          badge: 'Ready',
          tone: 'ready',
          copy: 'Looks good. Send when ready.',
          chips: [
            { label: 'Date', value: selectedDate },
            { label: 'Shift', value: shiftLabel },
            { label: 'Time off', value: scopeLabel }
          ]
        });
      }

      function populateRequestOffStaffOptions(options){
        requestOffStaffOptions = (Array.isArray(options) ? options.slice() : []).filter(function(option){
          return String((option && option.name) || '').trim().toLowerCase() !== 'chase ognibene';
        });
        requestOffStaff.innerHTML = ''
          + '<option value="">Choose staff</option>'
          + requestOffStaffOptions.map(function(option){
              return '<option value="' + escapeHtml(option.id || '') + '">' + escapeHtml(option.display_label || option.name || '') + '</option>';
            }).join('');
        if (currentLoggedInStaff) {
          var matchedOption = requestOffStaffOptions.find(function(option){
            return sameStaffName(option && option.name, currentLoggedInStaff.name)
              || String((option && option.id) || '').trim() === String(currentLoggedInStaff.id || '').trim();
          }) || null;
          requestOffStaff.value = matchedOption ? (matchedOption.id || '') : '';
          requestOffStaff.disabled = true;
        } else {
          requestOffStaff.disabled = false;
        }
        syncRequestOffScopeOptions();
        renderRequestOffSelectedStaff();
      }

      function renderSwapRequestMeta(message, detail){
        if (!swapRequestMeta) return;
        swapRequestMeta.innerHTML = ''
          + '<div class="request-off-meta-name">' + escapeHtml(String(message || 'No shift selected')) + '</div>'
          + '<div class="request-off-meta-copy">' + escapeHtml(String(detail || 'Choose a date to see your schedule and eligible teammates.')) + '</div>';
      }

      function renderSwapTradePreview(ownDate, ownShift, teammate){
        if (!swapRequestMeta || !teammate) return;
        var ownName = String((currentLoggedInStaff && currentLoggedInStaff.name) || 'You').trim() || 'You';
        var ownRole = String((currentLoggedInStaff && currentLoggedInStaff.role) || '').trim();
        var ownDateLabel = formatRequestReviewDates([ownDate]);
        var teammateDateLabel = formatRequestReviewDates([teammate.date]);
        var teammateRole = String(teammate.role || '').trim();
        swapRequestMeta.innerHTML = ''
          + '<div class="request-off-meta-name">Shift swap preview</div>'
          + '<div class="request-off-meta-copy">This is the trade that will be sent for manager approval.</div>'
          + '<div class="swap-trade-preview">'
          +   '<div class="swap-trade-row">'
          +     '<div class="swap-trade-person">'
          +       '<div class="swap-trade-personName">' + escapeHtml(ownName) + '</div>'
          +       '<div class="swap-trade-personMeta">' + escapeHtml(ownRole || 'Salon Team') + '</div>'
          +     '</div>'
          +     '<div class="swap-trade-flow">'
          +       '<span class="swap-trade-shift swap-trade-shift--from"><s>' + escapeHtml(ownDateLabel + ' · ' + ownShift) + '</s></span>'
          +       '<span class="swap-trade-arrow" aria-hidden="true">→</span>'
          +       '<span class="swap-trade-shift swap-trade-shift--to">' + escapeHtml(teammateDateLabel + ' · ' + teammate.shift) + '</span>'
          +     '</div>'
          +   '</div>'
          +   '<div class="swap-trade-row">'
          +     '<div class="swap-trade-person">'
          +       '<div class="swap-trade-personName">' + escapeHtml(teammate.name) + '</div>'
          +       '<div class="swap-trade-personMeta">' + escapeHtml(teammateRole || 'Salon Team') + '</div>'
          +     '</div>'
          +     '<div class="swap-trade-flow">'
          +       '<span class="swap-trade-shift swap-trade-shift--from"><s>' + escapeHtml(teammateDateLabel + ' · ' + teammate.shift) + '</s></span>'
          +       '<span class="swap-trade-arrow" aria-hidden="true">→</span>'
          +       '<span class="swap-trade-shift swap-trade-shift--to">' + escapeHtml(ownDateLabel + ' · ' + ownShift) + '</span>'
          +     '</div>'
          +   '</div>'
          + '</div>';
      }

      function buildSwapTeammateOptionValue(teammateId, teammateDate, teammateShift){
        return [String(teammateId || '').trim(), String(teammateDate || '').trim(), String(teammateShift || '').trim()].join('||');
      }

      function buildSwapTeammateOptions(selectedDate, ownShift){
        var safeDate = String(selectedDate || '').trim();
        var safeOwnShift = String(ownShift || '').trim();
        var currentStaffId = String(currentLoggedInStaff && currentLoggedInStaff.id || '').trim();
        if (!safeDate || !currentStaffId) return [];

        var options = [];
        requestOffStaffOptions.forEach(function(option){
          if (!option) return;
          var optionId = String(option.id || '').trim();
          if (!optionId || optionId === currentStaffId) return;
          if (sameStaffName(option.name, currentLoggedInStaff && currentLoggedInStaff.name)) return;

          MASTER_SCHEDULE_DAYS.forEach(function(dayConfig){
            if (!dayConfig || !dayConfig.key) return;
            var teammateDate = getDateValueForMasterScheduleDay(safeDate, dayConfig.key);
            if (!teammateDate) return;
            var teammateShift = getMasterScheduleShiftForDate(optionId, teammateDate, option.name);
            if (!teammateShift || teammateShift === 'OFF') return;
            if (teammateDate === safeDate && teammateShift === safeOwnShift) return;
            options.push({
              value: buildSwapTeammateOptionValue(optionId, teammateDate, teammateShift),
              id: optionId,
              name: String(option.name || '').trim(),
              role: String(option.role || '').trim(),
              date: teammateDate,
              shift: teammateShift,
              sameDay: teammateDate === safeDate
            });
          });
        });

        return options.sort(function(a, b){
          if (a.sameDay !== b.sameDay) return a.sameDay ? -1 : 1;
          if (a.date !== b.date) return a.date.localeCompare(b.date);
          if (a.name !== b.name) return a.name.localeCompare(b.name);
          return a.shift.localeCompare(b.shift);
        });
      }

      function getSwapTeammateOptionById(value){
        var targetValue = String(value || '').trim();
        if (!targetValue) return null;
        for (var index = 0; index < currentSwapTeammateOptions.length; index += 1) {
          if (String((currentSwapTeammateOptions[index] && currentSwapTeammateOptions[index].value) || '').trim() === targetValue) {
            return currentSwapTeammateOptions[index];
          }
        }
        return null;
      }

      function renderSwapRequestForm(){
        if (!swapRequestShift || !swapRequestTeammate) return;
        var selectedDate = String(swapRequestDate && swapRequestDate.value || '').trim();
        var currentStaffId = String(currentLoggedInStaff && currentLoggedInStaff.id || '').trim();
        var ownShift = selectedDate && currentStaffId ? getMasterScheduleShiftForDate(currentStaffId, selectedDate, currentLoggedInStaff && currentLoggedInStaff.name) : '';

        if (!selectedDate) {
          swapRequestShift.innerHTML = '<option value="">Choose date first</option>';
          swapRequestTeammate.innerHTML = '<option value="">Choose date first</option>';
          currentSwapTeammateOptions = [];
          renderSwapRequestMeta('No shift selected', 'Choose a date to see your schedule and eligible teammates.');
          setSwapRequestStatus('Pick the day to load your shift.');
          return;
        }

        if (!ownShift || ownShift === 'OFF') {
          swapRequestShift.innerHTML = '<option value="">No scheduled shift found</option>';
          swapRequestTeammate.innerHTML = '<option value="">No eligible teammates</option>';
          currentSwapTeammateOptions = [];
          renderSwapRequestMeta('No scheduled shift found', 'You are not scheduled from the master schedule on that date, so a switch request is not available.');
          setSwapRequestStatus('No scheduled shift found for that day.', 'error');
          return;
        }

        swapRequestShift.innerHTML = '<option value="' + escapeHtml(ownShift) + '">' + escapeHtml(ownShift) + '</option>';

        var teammateOptions = buildSwapTeammateOptions(selectedDate, ownShift);
        currentSwapTeammateOptions = teammateOptions.slice();

        var preservedTeammateId = String(swapRequestTeammate.value || '').trim();
        swapRequestTeammate.innerHTML = teammateOptions.length
          ? '<option value="">Choose teammate</option>' + teammateOptions.map(function(option){
              var dayLabel = option.sameDay ? 'Same day' : formatRequestReviewDates([option.date]);
              var label = [option.name, dayLabel, option.shift, option.role].filter(Boolean).join(' · ');
              return '<option value="' + escapeHtml(option.value) + '">' + escapeHtml(label) + '</option>';
            }).join('')
          : '<option value="">No eligible swap shifts found</option>';
        if (preservedTeammateId && teammateOptions.some(function(option){ return option.value === preservedTeammateId; })) {
          swapRequestTeammate.value = preservedTeammateId;
        }

        var selectedTeammate = getSwapTeammateOptionById(swapRequestTeammate.value);
        if (selectedTeammate) {
          renderSwapTradePreview(selectedDate, ownShift, selectedTeammate);
          setSwapRequestStatus('Swap looks ready to send.');
        } else if (teammateOptions.length) {
          renderSwapRequestMeta(
            ownShift + ' shift selected',
            'Choose the teammate shift you want to trade for. Identical same-day shifts are hidden.'
          );
          setSwapRequestStatus('Pick who you want to trade with.');
        } else {
          renderSwapRequestMeta(
            ownShift + ' shift selected',
            'No useful teammate shifts were found to trade against this week.'
          );
          setSwapRequestStatus('No eligible swap shifts were found for this week.', 'error');
        }
      }

      async function submitSwapRequestForm(){
        if (!currentLoggedInStaff) {
          throw new Error('Log in again before sending a shift switch request.');
        }
        var selectedDate = String(swapRequestDate && swapRequestDate.value || '').trim();
        var ownShift = String(swapRequestShift && swapRequestShift.value || '').trim();
        var teammate = getSwapTeammateOptionById(swapRequestTeammate && swapRequestTeammate.value);
        var staffPhoneLast4 = String((swapRequestPhoneLast4 && swapRequestPhoneLast4.value) || '').replace(/\D+/g, '').slice(-4);

        if (!selectedDate) {
          throw new Error('Choose a shift date first.');
        }
        if (!ownShift) {
          throw new Error('No scheduled shift was found for that date.');
        }
        if (!teammate) {
          throw new Error('Choose who you want to switch with.');
        }
        if (staffPhoneLast4.length !== 4) {
          throw new Error('Enter the last 4 digits of your phone number on file.');
        }

        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-shift-change-submit',
            request_type: 'replace_shift',
            staff_id: currentLoggedInStaff.id || '',
            staff_name: currentLoggedInStaff.name || '',
            role_name: currentLoggedInStaff.role || '',
            request_date: selectedDate,
            shift_label: ownShift,
            note: swapRequestNote ? (swapRequestNote.value || '') : '',
            notify_phone: REQUEST_OFF_NOTIFY_PHONES,
            staff_phone_last4: staffPhoneLast4,
            replacement_staff_id: teammate.id,
            replacement_staff_name: teammate.name,
            replacement_role_name: teammate.role,
            replacement_request_date: teammate.date,
            replacement_shift_label: teammate.shift
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not submit shift switch request.');
        }
        return data.row;
      }

      async function submitRequestOffForm(){
        var selectedId = String(requestOffStaff.value || '');
        var selected = requestOffStaffOptions.find(function(option){
          return String(option.id || '') === selectedId;
        }) || null;
        var notifyPhones = REQUEST_OFF_NOTIFY_PHONES.slice();
        var staffPhoneLast4 = String((requestOffPhoneLast4 && requestOffPhoneLast4.value) || '').replace(/\D+/g, '').slice(-4);

        if (!selected) {
          throw new Error('Choose a staff member first.');
        }
        if (!requestOffDate.value) {
          throw new Error('Choose a requested date first.');
        }
        if (!notifyPhones.length) {
          throw new Error('Missing hardcoded notify phones.');
        }
        if (staffPhoneLast4.length !== 4) {
          throw new Error('Enter the last 4 digits of your phone number on file.');
        }

        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-request-off-submit',
            staff_id: selected.id || '',
            staff_name: selected.name || '',
            role_name: (currentLoggedInStaff && sameStaffName(currentLoggedInStaff.name, selected.name)
              ? (currentLoggedInStaff.level || currentLoggedInStaff.role || selected.role)
              : selected.role) || '',
            requested_date: requestOffDate.value,
            request_scope: normalizeRequestOffScope(requestOffScope && requestOffScope.value),
            note: requestOffNote.value || '',
            notify_phone: notifyPhones,
            staff_phone_last4: staffPhoneLast4
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not submit request off.');
        }
        return data;
      }

      async function initializeRequestOffForm(){
        try {
          setRequestOffStatus('Loading staff options...');
          setSwapRequestStatus('Loading schedule options...');
          var options = await fetchRequestOffFormOptions();
          masterScheduleAssignments = await fetchMasterScheduleAssignments().catch(function(){
            return {};
          });
          populateRequestOffStaffOptions(options);
          setRequestOffStatus('Ready to submit a request off.');
          syncRequestOffScopeOptions();
          renderSwapRequestForm();
        } catch (error) {
          setRequestOffStatus(humanizeClientFetchErrorMessage(error, 'Could not load staff request-off options.'), 'error');
          setSwapRequestStatus(humanizeClientFetchErrorMessage(error, 'Could not load shift switch options.'), 'error');
        }
      }

      function setPersonalDashboardStatus(text, tone){
        return;
      }

      function setRetailGameBoardWindow(value){
        activeRetailGameBoardWindow = String(value || '').trim().toLowerCase() === 'last' ? 'last' : 'current';
        renderRetailGame(currentRetailGameCurrentWeek, currentRetailGameLastWeek, currentRetailGameOwnWeek);
      }

      function setDashboardToggleState(primaryButton, secondaryButton, activeWindow){
        var isPrimaryActive = String(activeWindow || 'ytd') === 'ytd';
        if (primaryButton) primaryButton.setAttribute('aria-selected', isPrimaryActive ? 'true' : 'false');
        if (secondaryButton) secondaryButton.setAttribute('aria-selected', isPrimaryActive ? 'false' : 'true');
      }

      function buildAttendanceDashboardCards(attendanceRow){
        var callOuts = attendanceRow ? Number(attendanceRow.call_outs || 0) || 0 : 0;
        var requestsOff = attendanceRow ? Number(attendanceRow.requests_off || 0) || 0 : 0;
        var lateArrivals = attendanceRow ? Number(attendanceRow.late_arrivals || 0) || 0 : 0;
        var leavingEarly = attendanceRow ? Number(attendanceRow.leaving_early || 0) || 0 : 0;
        var combinedLateLeftEarly = lateArrivals + leavingEarly;
        var unusedCalloutCredits = Math.max(0, 5 - callOuts);
        var extraCallOuts = Math.max(0, callOuts - 5);
        var requestPenalty = requestsOff * 0.5;
        var combinedLateLeftEarlyPenalty = combinedLateLeftEarly * 0.5;
        var calloutPenalty = extraCallOuts * 10;
        var reliabilityBreakdown = [
          'Starts at 100',
          unusedCalloutCredits ? ('+' + formatCompactNumber(unusedCalloutCredits, 0) + ' unused callout credit') : '',
          extraCallOuts ? ('-' + formatCompactNumber(calloutPenalty, 0) + ' extra callout penalty') : '',
          requestsOff ? ('-' + formatCompactNumber(requestPenalty, 1) + ' from requests off') : '',
          combinedLateLeftEarly ? ('-' + formatCompactNumber(combinedLateLeftEarlyPenalty, 1) + ' from late / left early') : ''
        ].filter(Boolean).join(' • ');
        return [
          {
            label: 'Reliability',
            value: attendanceRow && attendanceRow.reliability_score != null ? Number(attendanceRow.reliability_score).toFixed(1) + '%' : '—',
            subvalue: reliabilityBreakdown || 'Starts at 100. First 5 callouts do not count. Unused callouts add +1 back each. Requests off and late / left early are -0.5 each.'
          },
          {
            label: 'Requests Off',
            value: attendanceRow ? String(attendanceRow.requests_off || 0) : '—',
            subvalue: requestsOff ? ('-' + formatCompactNumber(requestPenalty, 1) + ' reliability impact') : 'No reliability hit'
          },
          {
            label: 'Call Outs',
            value: attendanceRow ? String(attendanceRow.call_outs || 0) : '—',
            subvalue: callOuts <= 5
              ? (unusedCalloutCredits ? ('First 5 are free • +' + formatCompactNumber(unusedCalloutCredits, 0) + ' credit back') : 'At the 5-callout allowance')
              : ('-' + formatCompactNumber(calloutPenalty, 0) + ' beyond the 5-callout allowance')
          },
          {
            label: 'Late / Left Early',
            value: attendanceRow ? String(combinedLateLeftEarly) : '—',
            subvalue: combinedLateLeftEarly ? ('-' + formatCompactNumber(combinedLateLeftEarlyPenalty, 1) + ' reliability impact') : 'No reliability hit'
          }
        ];
      }

      function createPerfectAttendanceRow(){
        return {
          reliability_score: 100,
          requests_off: 0,
          call_outs: 0,
          late_arrivals: 0,
          leaving_early: 0,
          reliability_forecast: {
            available: true,
            as_of_date: '',
            window_days: 365,
            free_callouts_left: 5,
            total_callouts: 0,
            next_score_relief: null,
            next_callout_relief: null,
            next_callout_risk: null,
            upcoming_relief: [],
            reason: ''
          }
        };
      }

      function normalizeAttendanceRowForBenchmarks(attendanceRow, snapshotDate){
        if (attendanceRow && typeof attendanceRow === 'object') {
          return attendanceRow;
        }
        return String(snapshotDate || '').trim() ? createPerfectAttendanceRow() : null;
      }

      function buildSalesDashboardRunRate(kpiSummary, snapshotDate){
        if (!kpiSummary || typeof kpiSummary !== 'object') return null;
        var throughDate = parseYmd(snapshotDate) || startOfLocalDay(new Date());
        var yearStart = new Date(throughDate.getFullYear(), 0, 1);
        var yearEnd = new Date(throughDate.getFullYear(), 11, 31);
        var elapsedDays = diffDaysInclusive(yearStart, throughDate);
        var totalDays = diffDaysInclusive(yearStart, yearEnd);
        if (!elapsedDays || !totalDays || totalDays <= elapsedDays) return null;
        var scale = totalDays / elapsedDays;
        return {
          projectedServiceSales: getStaffKpiMetricNumber(kpiSummary, 'Service Sales') * scale,
          projectedAppointments: getStaffKpiMetricNumber(kpiSummary, 'Appointment Count') * scale,
          projectedHoursBooked: getStaffKpiMetricNumber(kpiSummary, 'Hours Booked') * scale
        };
      }

      function getPersonalLevel7PeriodMeta(periodKey){
        var key = String(periodKey || '2026_ytd').trim() || '2026_ytd';
        for (var index = 0; index < PERSONAL_LEVEL7_PERIOD_OPTIONS.length; index += 1) {
          if (PERSONAL_LEVEL7_PERIOD_OPTIONS[index].key === key) return PERSONAL_LEVEL7_PERIOD_OPTIONS[index];
        }
        return PERSONAL_LEVEL7_PERIOD_OPTIONS[PERSONAL_LEVEL7_PERIOD_OPTIONS.length - 1];
      }

      function detectStaffGrowthYear(row){
        var explicitYear = String((row && row.__staffGrowthYear) || '').trim();
        if (/^\d{4}$/.test(explicitYear)) return explicitYear;
        ['SaleDate Year', 'Sale Date Year', 'Sale Year', 'Year'].some(function(key){
          var value = String((row && row[key]) || '').trim();
          if (/^\d{4}$/.test(value)) {
            explicitYear = value;
            return true;
          }
          return false;
        });
        if (explicitYear) return explicitYear;
        ['Sale Date', 'SaleDate Date', 'SaleDate', 'Date'].some(function(key){
          var raw = String((row && row[key]) || '').trim();
          if (!raw) return false;
          var parsed = new Date(raw);
          if (isNaN(parsed.getTime())) return false;
          explicitYear = String(parsed.getFullYear());
          return true;
        });
        return explicitYear || '';
      }

      function detectStaffGrowthIsYtd(row){
        return String((row && row.__staffGrowthIsYtd) || '').trim() === 'true';
      }

      function buildPersonalStaffGrowthCandidateNames(directoryStaff){
        var names = [];
        var currentName = String((currentLoggedInStaff && currentLoggedInStaff.name) || '').trim();
        if (currentName) names.push(currentName);
        var currentStaffId = String((currentLoggedInStaff && currentLoggedInStaff.id) || '').trim();
        if (currentStaffId && Array.isArray(directoryStaff)) {
          directoryStaff.forEach(function(entry){
            var entryId = String((entry && entry.id) || '').trim();
            var entryName = String((entry && entry.name) || '').trim();
            if (!entryName || !entryId || entryId !== currentStaffId) return;
            if (names.indexOf(entryName) === -1) names.push(entryName);
          });
        }
        return names;
      }

      function buildCurrentStaffCandidateNames(){
        if (personalStaffGrowthDataset && Array.isArray(personalStaffGrowthDataset.directoryStaff) && personalStaffGrowthDataset.directoryStaff.length) {
          return buildPersonalStaffGrowthCandidateNames(personalStaffGrowthDataset.directoryStaff);
        }
        return buildPersonalStaffGrowthCandidateNames([]);
      }

      function staffGrowthRowMatchesCandidates(staffName, candidateNames){
        var name = String(staffName || '').trim();
        if (!name) return false;
        if (name.toLowerCase() === 'all') return false;
        var candidates = Array.isArray(candidateNames) ? candidateNames : [];
        return candidates.some(function(candidate){
          return sameStaffName(name, candidate);
        });
      }

      function supplementalRowMatchesCandidateFirstName(staffName, candidateNames){
        var normalizedName = canonicalStaffName(staffName);
        if (!normalizedName) return false;
        var normalizedFirst = normalizedName.split(' ')[0] || '';
        if (!normalizedFirst) return false;
        return (Array.isArray(candidateNames) ? candidateNames : []).some(function(candidate){
          var candidateFirst = canonicalStaffName(candidate).split(' ')[0] || '';
          return candidateFirst && candidateFirst === normalizedFirst;
        });
      }

      function findMatchingSupplementalRow(rows, targetStaffId, candidateNames){
        var safeRows = Array.isArray(rows) ? rows.filter(Boolean) : [];
        if (!safeRows.length) return null;
        if (targetStaffId) {
          var exactIdRow = safeRows.find(function(row){
            return String((row && row.staff_id) || '').trim() === targetStaffId;
          });
          if (exactIdRow) return exactIdRow;
        }
        var exactNameRow = safeRows.find(function(row){
          return row && staffGrowthRowMatchesCandidates(row.staff_name, candidateNames);
        });
        if (exactNameRow) return exactNameRow;
        var firstNameRow = safeRows.find(function(row){
          return row && supplementalRowMatchesCandidateFirstName(row.staff_name, candidateNames);
        });
        if (firstNameRow) return firstNameRow;
        return safeRows.length === 1 ? safeRows[0] : null;
      }

      function preparePersonalStaffGrowthRows(rows, directoryStaff){
        var candidateNames = buildPersonalStaffGrowthCandidateNames(directoryStaff);
        var matchedRows = (Array.isArray(rows) ? rows : []).filter(function(row){
          var staffName = String((row && row['Staff Name']) || '').trim();
          var locationName = String((row && row['Location name']) || '').trim().toLowerCase();
          if (locationName === 'all') return false;
          if (!staffName || !currentLoggedInStaff || !staffGrowthRowMatchesCandidates(staffName, candidateNames)) return false;
          return !!detectStaffGrowthYear(row);
        });
        if (matchedRows.length || !candidateNames.length) return matchedRows;
        var fallbackFirstNames = candidateNames.map(function(name){
          return canonicalStaffName(name).split(' ')[0] || '';
        }).filter(Boolean);
        var firstNameMatches = (Array.isArray(rows) ? rows : []).filter(function(row){
          var staffName = canonicalStaffName(row && row['Staff Name']);
          var locationName = String((row && row['Location name']) || '').trim().toLowerCase();
          if (locationName === 'all' || staffName === 'all') return false;
          if (!staffName) return false;
          var first = staffName.split(' ')[0] || '';
          return fallbackFirstNames.indexOf(first) !== -1 && !!detectStaffGrowthYear(row);
        });
        return firstNameMatches;
      }

      function aggregatePersonalStaffGrowthByYear(rows){
        var grouped = {};
        (Array.isArray(rows) ? rows : []).forEach(function(row){
          var year = detectStaffGrowthYear(row);
          if (!year) return;
          if (!grouped[year]) {
            grouped[year] = {
              year: year,
              serviceSales: 0,
              appointmentCount: 0,
              productSales: 0,
              tipSales: 0,
              newClientCount: 0,
              returningClientCount: 0,
              requestedAppointmentCount: 0,
              hoursBooked: 0,
              hoursScheduled: 0,
              weightedPrebookedNumerator: 0,
              weightedPrebookedDenominator: 0,
              weightedSelfBookedNumerator: 0,
              weightedSelfBookedDenominator: 0,
              isYtd: false
            };
          }
          var target = grouped[year];
          target.isYtd = target.isYtd || detectStaffGrowthIsYtd(row);
          var appointments = parseNumericCell(row['Appointment Count']);
          var booked = parseNumericCell(row['Hours Booked']);
          var scheduled = parseNumericCell(row['Hours Scheduled']);
          var serviceSales = parseNumericCell(row['Service Sales']);
          var productSales = parseNumericCell(row['Product Sales']);
          var tipSales = parseNumericCell(row['Tip Sales']);
          var newClients = parseNumericCell(row['New Client Count']);
          var returningClients = parseNumericCell(row['Returning Client Count']);
          var requestedAppointments = parseNumericCell(row['Requested Appointment Count']);
          var prebooked = parseNumericCell(row['Prebooked %']);
          var selfBooked = parseNumericCell(row['Self-booked %']);
          var prebookedRatio = prebooked > 1 ? prebooked / 100 : prebooked;
          var selfBookedRatio = selfBooked > 1 ? selfBooked / 100 : selfBooked;
          target.serviceSales += serviceSales;
          target.appointmentCount += appointments;
          target.productSales += productSales;
          target.tipSales += tipSales;
          target.newClientCount += newClients;
          target.returningClientCount += returningClients;
          target.requestedAppointmentCount += requestedAppointments;
          target.hoursBooked += booked;
          target.hoursScheduled += scheduled;
          target.weightedPrebookedNumerator += prebookedRatio * appointments;
          target.weightedPrebookedDenominator += appointments;
          target.weightedSelfBookedNumerator += selfBookedRatio * appointments;
          target.weightedSelfBookedDenominator += appointments;
        });
        return Object.keys(grouped).sort().map(function(year){
          var row = grouped[year];
          var productionRate = row.hoursBooked > 0 ? row.serviceSales / row.hoursBooked : null;
          var utilizationRate = row.hoursScheduled > 0 ? row.hoursBooked / row.hoursScheduled : null;
          var prebookedRate = row.weightedPrebookedDenominator > 0 ? row.weightedPrebookedNumerator / row.weightedPrebookedDenominator : null;
          var selfBookedRate = row.weightedSelfBookedDenominator > 0 ? row.weightedSelfBookedNumerator / row.weightedSelfBookedDenominator : null;
          var retailToServiceRate = row.serviceSales > 0 ? row.productSales / row.serviceSales : null;
          var result = {
            year: year,
            serviceSales: row.serviceSales,
            appointmentCount: row.appointmentCount,
            productSales: row.productSales,
            tipSales: row.tipSales,
            newClientCount: row.newClientCount,
            returningClientCount: row.returningClientCount,
            requestedAppointmentCount: row.requestedAppointmentCount,
            hoursBooked: row.hoursBooked,
            hoursScheduled: row.hoursScheduled,
            productionRate: productionRate,
            prebookedRate: prebookedRate,
            utilizationRate: utilizationRate,
            selfBookedRate: selfBookedRate,
            retailToServiceRate: retailToServiceRate,
            isYtd: !!row.isYtd
          };
          if (result.isYtd) {
            var ytdDate = startOfLocalDay(new Date());
            var yearStart = startOfLocalDay(new Date(Number(year), 0, 1));
            var yearEnd = startOfLocalDay(new Date(Number(year), 11, 31));
            var elapsedDays = Math.max(1, Math.floor((ytdDate.getTime() - yearStart.getTime()) / 86400000) + 1);
            var totalDays = Math.max(elapsedDays, Math.floor((yearEnd.getTime() - yearStart.getTime()) / 86400000) + 1);
            var runRate = totalDays / elapsedDays;
            result.ytdThroughLabel = ytdDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
            result.projectedServiceSales = result.serviceSales * runRate;
          }
          return result;
        });
      }

      function buildPersonalStaffGrowthDataset(headers, rows, snapshot, directoryStaff){
        var preparedRows = preparePersonalStaffGrowthRows(rows, directoryStaff);
        return {
          headers: headers,
          rows: preparedRows,
          snapshot: snapshot || null,
          directoryStaff: Array.isArray(directoryStaff) ? directoryStaff.slice() : [],
          staffName: String((currentLoggedInStaff && currentLoggedInStaff.name) || '').trim(),
          levelLabel: String((currentLoggedInStaff && (currentLoggedInStaff.level || currentLoggedInStaff.role)) || '').trim(),
          yearlyRows: aggregatePersonalStaffGrowthByYear(preparedRows)
        };
      }

      function getPersonalLevel7RowsForPeriod(yearlyRows, periodKey){
        var safeRows = Array.isArray(yearlyRows) ? yearlyRows.slice() : [];
        if (String(periodKey || '') === 'all') return safeRows.filter(function(row){
          return PERSONAL_LEVEL7_PERIOD_OPTIONS.some(function(option){
            return option.key !== 'all' && option.key === (String(row.year || '') + (row.isYtd ? '_ytd' : ''));
          });
        });
        return safeRows.filter(function(row){
          return (String(row.year || '') + (row.isYtd ? '_ytd' : '')) === String(periodKey || '');
        });
      }

      function aggregatePersonalLevel7Rows(rows){
        var safeRows = Array.isArray(rows) ? rows : [];
        if (!safeRows.length) return null;
        return safeRows.reduce(function(result, row, index){
          if (!row) return result;
          if (index === 0) {
            result = {
              year: 'all',
              serviceSales: 0,
              appointmentCount: 0,
              productSales: 0,
              tipSales: 0,
              newClientCount: 0,
              returningClientCount: 0,
              requestedAppointmentCount: 0,
              hoursBooked: 0,
              hoursScheduled: 0,
              weightedPrebookedNumerator: 0,
              weightedPrebookedDenominator: 0,
              weightedSelfBookedNumerator: 0,
              weightedSelfBookedDenominator: 0,
              projectedServiceSales: null,
              isYtd: false
            };
          }
          var appointments = Number(row.appointmentCount) || 0;
          result.serviceSales += Number(row.serviceSales) || 0;
          result.appointmentCount += appointments;
          result.productSales += Number(row.productSales) || 0;
          result.tipSales += Number(row.tipSales) || 0;
          result.newClientCount += Number(row.newClientCount) || 0;
          result.returningClientCount += Number(row.returningClientCount) || 0;
          result.requestedAppointmentCount += Number(row.requestedAppointmentCount) || 0;
          result.hoursBooked += Number(row.hoursBooked) || 0;
          result.hoursScheduled += Number(row.hoursScheduled) || 0;
          result.weightedPrebookedNumerator += (Number(row.prebookedRate) || 0) * appointments;
          result.weightedPrebookedDenominator += appointments;
          result.weightedSelfBookedNumerator += (Number(row.selfBookedRate) || 0) * appointments;
          result.weightedSelfBookedDenominator += appointments;
          return result;
        }, null);
      }

      function finalizePersonalLevel7Aggregate(row){
        if (!row) return null;
        row.productionRate = row.hoursBooked > 0 ? row.serviceSales / row.hoursBooked : null;
        row.prebookedRate = row.weightedPrebookedDenominator > 0 ? row.weightedPrebookedNumerator / row.weightedPrebookedDenominator : null;
        row.utilizationRate = row.hoursScheduled > 0 ? row.hoursBooked / row.hoursScheduled : null;
        row.selfBookedRate = row.weightedSelfBookedDenominator > 0 ? row.weightedSelfBookedNumerator / row.weightedSelfBookedDenominator : null;
        row.retailToServiceRate = row.serviceSales > 0 ? row.productSales / row.serviceSales : null;
        return row;
      }

      function buildSalesSupplementalCards(supplemental, loading){
        var safeSupplemental = supplemental && typeof supplemental === 'object' ? supplemental : null;
        return [
          {
            label: 'Attach',
            value: safeSupplemental && safeSupplemental.attachRate != null ? formatPercent(safeSupplemental.attachRate * 100) : '—',
            subvalue: safeSupplemental && safeSupplemental.attachClosedAppointments != null
              ? (formatNumericCell('Appointment Count', String(safeSupplemental.attachClosedAppointments || 0)) + ' closed appts')
              : (loading ? 'Loading selected range...' : 'No closed appointment retail history')
          },
          {
            label: 'Reweigh',
            value: safeSupplemental && safeSupplemental.colorDisciplineReweighRate != null ? formatPercent(safeSupplemental.colorDisciplineReweighRate * 100) : '—',
            subvalue: safeSupplemental && safeSupplemental.colorDisciplineServices != null
              ? (formatNumericCell('Service Count', String(safeSupplemental.colorDisciplineServices || 0)) + ' Vish services')
              : (loading ? 'Loading selected range...' : 'No Vish services in this range')
          }
        ];
      }

      function buildClientsDashboardCard(kpiSummary){
        if (!kpiSummary || typeof kpiSummary !== 'object') return null;
        var hasNew = Object.prototype.hasOwnProperty.call(kpiSummary, 'New Client Count');
        var hasReturning = Object.prototype.hasOwnProperty.call(kpiSummary, 'Returning Client Count');
        if (!hasNew && !hasReturning) return null;
        return {
          label: 'Clients',
          value: formatNumericCell('New Client Count', String(getStaffKpiMetricNumber(kpiSummary, 'New Client Count'))),
          subvalue: formatNumericCell('Returning Client Count', String(getStaffKpiMetricNumber(kpiSummary, 'Returning Client Count'))) + ' returning'
        };
      }

      function calculateDashboardRevenuePerBookedHour(kpiSummary){
        if (!kpiSummary || typeof kpiSummary !== 'object') return null;
        var serviceSales = getStaffKpiMetricNumber(kpiSummary, 'Service Sales');
        var bookedHours = getStaffKpiMetricNumber(kpiSummary, 'Hours Booked');
        if (bookedHours <= 0) return null;
        return serviceSales / bookedHours;
      }

      async function fetchPersonalStaffGrowthRows(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-growth-snapshot-get',
            refresh_if_missing: true
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load staff growth snapshot.');
        }
        return {
          headers: Array.isArray(data.headers) ? data.headers : [],
          rows: Array.isArray(data.rows) ? data.rows : [],
          snapshot: data && data.snapshot && typeof data.snapshot === 'object' ? data.snapshot : null,
          directoryStaff: Array.isArray(data.directory_staff) ? data.directory_staff : []
        };
      }

      function normalizePersonalLevel7SnapshotRows(periodKey, rows){
        var key = String(periodKey || '').trim();
        var isYtd = key === '2026_ytd';
        var year = isYtd ? '2026' : key;
        return (Array.isArray(rows) ? rows : []).map(function(row){
          return Object.assign({}, row || {}, {
            __staffGrowthYear: year,
            __staffGrowthIsYtd: isYtd ? 'true' : 'false'
          });
        });
      }

      async function fetchPersonalLevel7SnapshotBundle(){
        return fetchPersonalStaffGrowthRows();
      }

      function buildAttendanceCoverageMapFromResponse(data){
        var remote = data && typeof data === 'object' ? data : {};
        var leaderboard = Array.isArray(remote.leaderboard) ? remote.leaderboard : [];
        return leaderboard.reduce(function(map, row){
          var name = String((row && row.staff_name) || '').trim();
          if (!name) return map;
          map[name] = {
            reliability_score: row && row.reliability_score != null ? Number(row.reliability_score) || 0 : null,
            requests_off: row && row.requests_off != null ? Number(row.requests_off) || 0 : null,
            call_outs: row && row.call_outs != null ? Number(row.call_outs) || 0 : null,
            late_arrivals: row && row.late_arrivals != null ? Number(row.late_arrivals) || 0 : null,
            leaving_early: row && row.leaving_early != null ? Number(row.leaving_early) || 0 : 0
          };
          return map;
        }, {});
      }

      async function fetchPersonalAttendanceCoverage(snapshotDate){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'attendance-totals-snapshot-get',
            snapshot_key: 'attendance_ytd',
            snapshot_date: snapshotDate || '',
            refresh_if_missing: false
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load attendance coverage.');
        }
        return buildAttendanceCoverageMapFromResponse(data);
      }

      function buildPersonalLevel7SupplementalWindow(periodKey){
        var key = String(periodKey || '').trim();
        var today = formatDateInputValue(startOfLocalDay(new Date()));
        if (key === '2026_ytd') return { date_from: '2026-01-01', date_to: today };
        if (/^\d{4}$/.test(key)) return { date_from: key + '-01-01', date_to: key + '-12-31' };
        return null;
      }

      function ensurePersonalLevel7Supplemental(periodKey){
        var key = String(periodKey || '').trim();
        if (!key) return;
        if (key === 'all') {
          PERSONAL_LEVEL7_PERIOD_OPTIONS.forEach(function(option){
            if (option && option.key && option.key !== 'all') ensurePersonalLevel7Supplemental(option.key);
          });
          return;
        }
        if (Object.prototype.hasOwnProperty.call(personalLevel7SupplementalByPeriod, key) || personalLevel7SupplementalLoading[key]) return;
        var window = buildPersonalLevel7SupplementalWindow(key);
        if (!window) return;
        personalLevel7SupplementalLoading[key] = true;
        fetchStaffKpiSupplementalMetrics(window.date_from, window.date_to).then(function(result){
          personalLevel7SupplementalByPeriod[key] = result || {};
        }).catch(function(){
          personalLevel7SupplementalByPeriod[key] = {};
        }).finally(function(){
          delete personalLevel7SupplementalLoading[key];
          renderSalesDashboardSection();
        });
      }

      function getPersonalLevel7AggregateSupplemental(){
        var periodKeys = PERSONAL_LEVEL7_PERIOD_OPTIONS
          .map(function(option){ return option && option.key ? String(option.key) : ''; })
          .filter(function(key){ return key && key !== 'all'; });
        var hasAny = false;
        var missingAny = false;
        var attachClosedAppointments = 0;
        var attachRetailAppointments = 0;
        var colorDisciplineServices = 0;
        var colorDisciplineReweighServices = 0;

        periodKeys.forEach(function(key){
          if (personalLevel7SupplementalLoading[key] === true) {
            missingAny = true;
          }
          if (!Object.prototype.hasOwnProperty.call(personalLevel7SupplementalByPeriod, key)) {
            missingAny = true;
            return;
          }
          var supplemental = personalLevel7SupplementalByPeriod[key];
          if (!supplemental || typeof supplemental !== 'object') return;
          hasAny = true;
          var closed = supplemental.attachClosedAppointments != null ? Math.max(0, Number(supplemental.attachClosedAppointments) || 0) : 0;
          var attachRate = supplemental.attachRate != null ? Math.max(0, Number(supplemental.attachRate) || 0) : null;
          var services = supplemental.colorDisciplineServices != null ? Math.max(0, Number(supplemental.colorDisciplineServices) || 0) : 0;
          var reweighRate = supplemental.colorDisciplineReweighRate != null ? Math.max(0, Number(supplemental.colorDisciplineReweighRate) || 0) : null;
          attachClosedAppointments += closed;
          colorDisciplineServices += services;
          if (attachRate != null) attachRetailAppointments += attachRate * closed;
          if (reweighRate != null) colorDisciplineReweighServices += reweighRate * services;
        });

        return {
          loading: missingAny,
          value: hasAny ? {
            attachRate: attachClosedAppointments > 0 ? attachRetailAppointments / attachClosedAppointments : null,
            attachClosedAppointments: attachClosedAppointments > 0 ? attachClosedAppointments : null,
            colorDisciplineReweighRate: colorDisciplineServices > 0 ? colorDisciplineReweighServices / colorDisciplineServices : null,
            colorDisciplineServices: colorDisciplineServices > 0 ? colorDisciplineServices : null
          } : null
        };
      }

      function findPersonalAttendanceEntry(periodKey){
        var coverage = personalLevel7AttendanceByPeriod[String(periodKey || '').trim()] || {};
        var keys = Object.keys(coverage);
        var candidateNames = buildCurrentStaffCandidateNames();
        for (var index = 0; index < keys.length; index += 1) {
          if (staffGrowthRowMatchesCandidates(keys[index], candidateNames)) return coverage[keys[index]];
        }
        for (var firstNameIndex = 0; firstNameIndex < keys.length; firstNameIndex += 1) {
          if (supplementalRowMatchesCandidateFirstName(keys[firstNameIndex], candidateNames)) return coverage[keys[firstNameIndex]];
        }
        if (keys.length) {
          return {
            reliability_score: 100,
            requests_off: 0,
            call_outs: 0,
            late_arrivals: 0,
            leaving_early: 0
          };
        }
        return null;
      }

      function getPersonalLevel7PreviousRow(yearlyRows, periodKey){
        var safeRows = Array.isArray(yearlyRows) ? yearlyRows : [];
        if (String(periodKey || '') === '2026_ytd') {
          return safeRows.filter(function(row){ return !row.isYtd; }).slice(-1)[0] || null;
        }
        if (String(periodKey || '') === 'all') return safeRows.length > 1 ? safeRows[safeRows.length - 2] : null;
        var targetYear = Number(String(periodKey || '').slice(0, 4));
        return safeRows.find(function(row){ return Number(row.year) === targetYear - 1; }) || null;
      }

      function buildPersonalLevel7TrendLabel(row, previousRow){
        if (!row) return 'No comparison yet';
        if (row.isYtd && row.projectedServiceSales != null && previousRow && previousRow.serviceSales != null) {
          var delta = previousRow.serviceSales
            ? (((Number(row.projectedServiceSales) || 0) - (Number(previousRow.serviceSales) || 0)) / Math.abs(Number(previousRow.serviceSales) || 1)) * 100
            : 0;
          return (delta > 0 ? '+' : '') + delta.toFixed(1) + '% run rate';
        }
        if (!previousRow || previousRow.serviceSales == null || row.serviceSales == null) return 'No comparison yet';
        var ratio = previousRow.serviceSales
          ? (((Number(row.serviceSales) || 0) - (Number(previousRow.serviceSales) || 0)) / Math.abs(Number(previousRow.serviceSales) || 1)) * 100
          : 0;
        return (ratio > 0 ? '+' : '') + ratio.toFixed(1) + '% YoY';
      }

      function renderPersonalLevel7ComparisonHeader(shortLabel, fullLabel, subLabel, className){
        var classes = 'level7-compare-header' + (className ? ' ' + className : '');
        return ''
          + '<span class="' + escapeHtml(classes) + '" title="' + escapeHtml(fullLabel) + '">'
          +   '<span class="level7-compare-headerMain">' + escapeHtml(shortLabel) + '</span>'
          +   (subLabel ? '<span class="level7-compare-headerSub">' + escapeHtml(subLabel) + '</span>' : '')
          + '</span>';
      }

      function renderPersonalLevel7MetricValue(label, value, metricLabel, loading, isPrimary){
        var displayValue = value == null || value === ''
          ? (loading ? renderLevel7LoadingValue() : '—')
          : escapeHtml(formatNumericCell(metricLabel, String(value)));
        return ''
          + '<div class="level7-compare-metricValue' + (isPrimary ? ' is-primary' : '') + '">'
          +   '<span class="level7-compare-metricLabel">' + escapeHtml(label) + '</span>'
          +   '<strong class="level7-compare-metricNumber">' + displayValue + '</strong>'
          + '</div>';
      }

      function renderPersonalLevel7MetricRow(label, primaryHtml, secondaryHtml, className){
        return ''
          + '<tr class="level7-compare-row' + (className ? ' ' + className : '') + '">'
          +   '<th scope="row" class="level7-compare-rowLabel">' + escapeHtml(label) + '</th>'
          +   '<td class="level7-compare-rowValue">' + primaryHtml + '</td>'
          +   (secondaryHtml
            ? '<td class="level7-compare-rowValue">' + secondaryHtml + '</td>'
            : '<td class="level7-compare-rowValue is-empty"></td>')
          + '</tr>';
      }

      function renderPersonalLevel7PeriodTabs(activePeriodKey){
        return '<div class="level7-compare-periodTabs">' + PERSONAL_LEVEL7_PERIOD_OPTIONS.map(function(option){
          return '<button type="button" class="level7-compare-periodTab' + (option.key === activePeriodKey ? ' is-active' : '') + '" data-personal-level7-period="' + escapeHtml(option.key) + '">' + escapeHtml(option.label) + '</button>';
        }).join('') + '</div>';
      }

      function renderPersonalLevel7LoadingState(){
        if (!salesDashboardGrid) return;
        var meta = getPersonalLevel7PeriodMeta(personalLevel7ActivePeriod || '2026_ytd');
        var loadingCell = '<span class="level7-compare-loadingValue"><span class="level7-compare-loadingDot" aria-hidden="true"></span>Loading</span>';
        salesDashboardGrid.className = 'level7-compare-layout';
        salesDashboardGrid.innerHTML = ''
          + renderPersonalLevel7PeriodTabs(meta.key)
          + '<div class="level7-compare-period">'
          +   '<div class="level7-compare-periodHead">'
          +     '<div><h2>' + escapeHtml(meta.label) + '</h2><p>' + escapeHtml(meta.description) + '</p></div>'
          +     '<span class="staff-growth-pill">Loading employee KPI</span>'
          +   '</div>'
          +   '<div class="level7-compare-tableWrap"><table class="level7-compare-table"><tbody>'
          +     renderPersonalLevel7MetricRow('Stylist', loadingCell, loadingCell, 'is-stylist')
          +     renderPersonalLevel7MetricRow('Service Sales', loadingCell, '', 'is-single')
          +     renderPersonalLevel7MetricRow('Trend', loadingCell, '', 'is-single')
          +     renderPersonalLevel7MetricRow('Demand', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow('Hours', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow('Revenue', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow('Booking', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow('Retail', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow('Attach', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow('Color', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow('Clients', loadingCell, loadingCell, '')
          +     renderPersonalLevel7MetricRow(meta.key === '2026_ytd' ? 'Reliability (365D)' : 'Reliability', loadingCell, '', 'is-single')
          +   '</tbody></table></div>'
          + '</div>';
      }

      function renderPersonalLevel7Table(){
        if (!salesDashboardGrid) return;
        if (!personalStaffGrowthDataset || !Array.isArray(personalStaffGrowthDataset.yearlyRows) || !personalStaffGrowthDataset.yearlyRows.length) {
          salesDashboardGrid.className = 'empty';
          salesDashboardGrid.innerHTML = 'No Staff Level KPI data is available for this employee yet.';
          setDashboardSectionStatus(salesDashboardStatus, 'Staff level KPI unavailable.', 'error');
          return;
        }
        var meta = getPersonalLevel7PeriodMeta(personalLevel7ActivePeriod);
        var yearlyRows = personalStaffGrowthDataset.yearlyRows.slice();
        var rowsForPeriod = getPersonalLevel7RowsForPeriod(yearlyRows, meta.key);
        var row = meta.key === 'all' ? finalizePersonalLevel7Aggregate(aggregatePersonalLevel7Rows(rowsForPeriod)) : (rowsForPeriod[0] || null);
        var previousRow = getPersonalLevel7PreviousRow(yearlyRows, meta.key);
        var attendance = meta.key === 'all' ? null : findPersonalAttendanceEntry(meta.key);
        var aggregatedSupplemental = meta.key === 'all' ? getPersonalLevel7AggregateSupplemental() : null;
        var supplemental = meta.key === 'all'
          ? (aggregatedSupplemental ? aggregatedSupplemental.value : null)
          : (personalLevel7SupplementalByPeriod[meta.key] || null);
        var supplementalLoading = meta.key === 'all'
          ? !!(aggregatedSupplemental && aggregatedSupplemental.loading)
          : (personalLevel7SupplementalLoading[meta.key] === true || !Object.prototype.hasOwnProperty.call(personalLevel7SupplementalByPeriod, meta.key));
        if (!row) {
          salesDashboardGrid.className = 'empty';
          salesDashboardGrid.innerHTML = 'No Staff Level KPI data is available for ' + escapeHtml(meta.label) + '.';
          setDashboardSectionStatus(salesDashboardStatus, 'Staff level KPI unavailable.', 'error');
          return;
        }
        if (attendance) {
          row.reliabilityScore = attendance.reliability_score;
          row.requestsOff = attendance.requests_off;
          row.callOuts = attendance.call_outs;
          row.lateArrivals = attendance.late_arrivals;
          row.leavingEarly = attendance.leaving_early;
        }
        if (supplemental && typeof supplemental === 'object') {
          row.attachRate = supplemental.attachRate;
          row.attachClosedAppointments = supplemental.attachClosedAppointments;
          row.colorDisciplineReweighRate = supplemental.colorDisciplineReweighRate;
          row.colorDisciplineServices = supplemental.colorDisciplineServices;
        }
        var snapshotMeta = personalStaffGrowthDataset.snapshot && personalStaffGrowthDataset.snapshot.updated_at
          ? 'Snapshot updated ' + formatDashboardDateTime(personalStaffGrowthDataset.snapshot.updated_at)
          : '';
        var trendLabel = buildPersonalLevel7TrendLabel(row, previousRow);
        var revenuePerBookedHour = calculateLevel7RevenuePerBookedHour(row);
        var stylistPrimary = '<div class="level7-compare-staffStatic"><span class="level7-compare-staffName">' + escapeHtml(personalStaffGrowthDataset.staffName) + '</span><span class="level7-compare-staffMeta">' + escapeHtml(personalStaffGrowthDataset.levelLabel || 'No level') + '</span></div>';
        var stylistSecondary = '<div class="level7-compare-staffStatic"><span class="level7-compare-staffMeta">Period</span><span class="level7-compare-staffName is-period">' + escapeHtml(meta.label) + '</span></div>';
        var serviceSalesPrimary = '<div class="level7-compare-cellNumeric">' + escapeHtml(row.serviceSales != null ? formatNumericCell('Service Sales', String(row.serviceSales)) : 'N/A') + '</div>';
        var trendPrimary = '<div class="level7-compare-trendCell">' + escapeHtml(trendLabel) + (meta.key === '2026_ytd' && previousRow ? '<span class="level7-compare-trendMeta">Run rate vs ' + escapeHtml(String(previousRow.year)) + '</span>' : '') + '</div>';
        salesDashboardGrid.className = 'level7-compare-layout';
        salesDashboardGrid.innerHTML = ''
          + renderPersonalLevel7PeriodTabs(meta.key)
          + '<div class="level7-compare-period">'
          +   '<div class="level7-compare-periodHead">'
          +     '<div><h2>' + escapeHtml(meta.label) + '</h2><p>' + escapeHtml(meta.description) + '</p>' + (snapshotMeta ? '<p class="staff-growth-hero-copy">' + escapeHtml(snapshotMeta) + '</p>' : '') + '</div>'
          +     '<span class="staff-growth-pill">1 employee · ' + escapeHtml(personalStaffGrowthDataset.levelLabel || 'No level') + '</span>'
          +   '</div>'
          +   (meta.key === '2026_ytd' ? '<p class="staff-growth-hero-copy">KPI columns are 2026 YTD through ' + escapeHtml(row.ytdThroughLabel || 'the current saved date') + '. Attendance counts and reliability use the trailing 365-day window.</p>' : '')
          +   (supplementalLoading ? '<p class="staff-growth-hero-copy"><span class="level7-compare-loadingValue"><span class="level7-compare-loadingDot" aria-hidden="true"></span>Attach and Color are still loading for this period.</span></p>' : '')
          +   '<div class="level7-compare-tableWrap"><table class="level7-compare-table"><tbody>'
          +     renderPersonalLevel7MetricRow('Stylist', stylistPrimary, stylistSecondary, 'is-stylist')
          +     renderPersonalLevel7MetricRow('Service Sales', serviceSalesPrimary, '', 'is-single')
          +     renderPersonalLevel7MetricRow('Trend', trendPrimary, '', 'is-single')
          +     renderPersonalLevel7MetricRow('Demand',
                  renderPersonalLevel7MetricValue('Appts', row.appointmentCount, 'Appointment Count', false, true),
                  renderPersonalLevel7MetricValue('Req', row.requestedAppointmentCount, 'Appointment Count', false, false),
                  '')
          +     renderPersonalLevel7MetricRow('Hours',
                  renderPersonalLevel7MetricValue('Booked', row.hoursBooked, 'Hours Booked', false, true),
                  renderPersonalLevel7MetricValue('Sched', row.hoursScheduled, 'Hours Scheduled', false, false),
                  '')
          +     renderPersonalLevel7MetricRow('Revenue',
                  renderPersonalLevel7MetricValue('$/Hr', revenuePerBookedHour, 'Production Rate', false, true),
                  renderPersonalLevel7MetricValue('Util', row.utilizationRate, 'Utilization %', false, false),
                  '')
          +     renderPersonalLevel7MetricRow('Booking',
                  renderPersonalLevel7MetricValue('Prebook', row.prebookedRate, 'Prebooked %', false, true),
                  renderPersonalLevel7MetricValue('Self', row.selfBookedRate, 'Self-booked %', false, false),
                  '')
          +     renderPersonalLevel7MetricRow('Retail',
                  renderPersonalLevel7MetricValue('Product', row.productSales, 'Product Sales', false, true),
                  renderPersonalLevel7MetricValue('R:S', row.retailToServiceRate, 'Retail to Service %', false, false),
                  '')
          +     renderPersonalLevel7MetricRow('Attach',
                  renderPersonalLevel7MetricValue('Attach', row.attachRate, 'Utilization %', supplementalLoading, true),
                  renderPersonalLevel7MetricValue('Closed', row.attachClosedAppointments, 'Appointment Count', supplementalLoading, false),
                  '')
          +     renderPersonalLevel7MetricRow('Color',
                  renderPersonalLevel7MetricValue('Reweigh', row.colorDisciplineReweighRate, 'Utilization %', supplementalLoading, true),
                  renderPersonalLevel7MetricValue('Vish svcs', row.colorDisciplineServices, 'Service Count', supplementalLoading, false),
                  '')
          +     renderPersonalLevel7MetricRow('Clients',
                  renderPersonalLevel7MetricValue('New', row.newClientCount, 'New Client Count', false, true),
                  renderPersonalLevel7MetricValue('Return', row.returningClientCount, 'Returning Client Count', false, false),
                  '')
          +     renderPersonalLevel7MetricRow(meta.key === '2026_ytd' ? 'Reliability (365D)' : 'Reliability', renderLevel7ReliabilityContent(row), '', 'is-single is-reliability')
          +   '</tbody></table></div>'
          + '</div>';
        Array.prototype.slice.call(salesDashboardGrid.querySelectorAll('[data-personal-level7-period]')).forEach(function(button){
          button.addEventListener('click', function(){
            var key = String(button.getAttribute('data-personal-level7-period') || '').trim();
            if (!key || key === personalLevel7ActivePeriod) return;
            personalLevel7ActivePeriod = key;
            ensurePersonalLevel7Supplemental(key);
            renderSalesDashboardSection();
          });
        });
        setDashboardSectionStatus(
          salesDashboardStatus,
          (supplementalLoading ? 'Loading attach and color for ' : 'Staff level KPI updated for ') + meta.summaryLabel + '.',
          supplementalLoading ? 'loading' : 'success'
        );
      }

      function getPersonalBenchmarkSourceRow(){
        if (!personalStaffGrowthDataset || !Array.isArray(personalStaffGrowthDataset.yearlyRows) || !personalStaffGrowthDataset.yearlyRows.length) {
          return null;
        }
        var yearlyRows = personalStaffGrowthDataset.yearlyRows.slice();
        var ytdRows = getPersonalLevel7RowsForPeriod(yearlyRows, '2026_ytd');
        if (ytdRows[0]) return ytdRows[0];
        var currentYearRow = yearlyRows.find(function(row){
          return String((row && row.year) || '').trim() === '2026';
        });
        if (currentYearRow) return currentYearRow;
        var datedRows = yearlyRows.filter(function(row){
          return /^\d{4}$/.test(String((row && row.year) || '').trim());
        }).sort(function(left, right){
          return Number(String((right && right.year) || '').trim()) - Number(String((left && left.year) || '').trim());
        });
        return datedRows[0] || null;
      }

      function getPersonalKpiSummaryForBenchmarks(){
        var row = getPersonalBenchmarkSourceRow();
        if (!row) return null;
        return {
          'Service Sales': row.serviceSales != null ? String(row.serviceSales) : '',
          'Appointment Count': row.appointmentCount != null ? String(row.appointmentCount) : '',
          'Product Sales': row.productSales != null ? String(row.productSales) : '',
          'Tip Sales': row.tipSales != null ? String(row.tipSales) : '',
          'New Client Count': row.newClientCount != null ? String(row.newClientCount) : '',
          'Returning Client Count': row.returningClientCount != null ? String(row.returningClientCount) : '',
          'Requested Appointment Count': row.requestedAppointmentCount != null ? String(row.requestedAppointmentCount) : '',
          'Hours Booked': row.hoursBooked != null ? String(row.hoursBooked) : '',
          'Hours Scheduled': row.hoursScheduled != null ? String(row.hoursScheduled) : '',
          'Prebooked %': row.prebookedRate != null ? String(row.prebookedRate) : '',
          'Self-booked %': row.selfBookedRate != null ? String(row.selfBookedRate) : '',
          'Retail to Service %': row.retailToServiceRate != null ? String(row.retailToServiceRate) : '',
          'Utilization %': row.utilizationRate != null ? String(row.utilizationRate) : '',
          'Production Rate': row.productionRate != null ? String(row.productionRate) : ''
        };
      }

      function buildCurrentStaffKpiSnapshotSummary(headers, rows){
        var candidateNames = buildCurrentStaffCandidateNames();
        var staffName = String((currentLoggedInStaff && currentLoggedInStaff.name) || '').trim();
        var matchingRows = (Array.isArray(rows) ? rows : []).filter(function(row){
          var rowStaffName = String((row && row['Staff Name']) || (row && row.staff_name) || '').trim();
          var locationName = String((row && row['Location name']) || '').trim().toLowerCase();
          if (!rowStaffName || rowStaffName.toLowerCase() === 'all' || locationName === 'all') return false;
          return staffGrowthRowMatchesCandidates(rowStaffName, candidateNames);
        });
        if (!matchingRows.length) {
          return {
            summaryRow: null,
            detailRows: []
          };
        }
        var groupingHeader = detectKpiGroupingHeader(headers, matchingRows);
        var detailRows = selectKpiSummaryRows(headers, matchingRows);
        if (!detailRows.length && groupingHeader) {
          detailRows = matchingRows.filter(function(row){
            return String((row && row[groupingHeader]) || '').trim().toLowerCase() !== 'all';
          });
        }
        if (!detailRows.length) {
          detailRows = matchingRows.slice();
        }
        var summaryRow = buildComputedKpiTotalRow(headers, detailRows) || null;
        if (summaryRow) {
          summaryRow['Staff Name'] = staffName || String((detailRows[0] && detailRows[0]['Staff Name']) || '').trim();
          if (groupingHeader) summaryRow[groupingHeader] = 'All';
        }
        return {
          summaryRow: summaryRow,
          detailRows: detailRows
        };
      }

      function resolveCurrentStaffKpiSummaryForBenchmarks(preferredSummary){
        if (hasStaffKpiSummaryData(preferredSummary)) return preferredSummary;
        if (hasStaffKpiSummaryData(currentSales90Summary)) return currentSales90Summary;
        if (currentSales90Window && Array.isArray(currentSales90Window.rows) && currentSales90Window.rows.length) {
          var derived90 = buildCurrentStaffKpiSnapshotSummary(currentSales90Headers, currentSales90Window.rows);
          if (hasStaffKpiSummaryData(derived90.summaryRow)) {
            currentSales90Summary = derived90.summaryRow;
            currentSales90DetailRows = derived90.detailRows;
            return derived90.summaryRow;
          }
        }
        if (hasStaffKpiSummaryData(currentSalesYtdSummary)) return currentSalesYtdSummary;
        if (currentSalesYtdWindow && Array.isArray(currentSalesYtdWindow.rows) && currentSalesYtdWindow.rows.length) {
          var derivedYtd = buildCurrentStaffKpiSnapshotSummary(currentSalesYtdHeaders, currentSalesYtdWindow.rows);
          if (hasStaffKpiSummaryData(derivedYtd.summaryRow)) {
            currentSalesYtdSummary = derivedYtd.summaryRow;
            currentSalesYtdDetailRows = derivedYtd.detailRows;
            return derivedYtd.summaryRow;
          }
        }
        return getPersonalKpiSummaryForBenchmarks() || preferredSummary || null;
      }

      function buildSalesDashboardCards(kpiSummary, windowKey, snapshotDate, supplemental, supplementalLoading){
        var normalizedWindow = String(windowKey || '').trim().toLowerCase();
        var isYtd = normalizedWindow === 'ytd';
        var runRate = isYtd ? buildSalesDashboardRunRate(kpiSummary, snapshotDate) : null;
        var serviceSalesLabel = kpiSummary ? formatNumericCell('Service Sales', kpiSummary['Service Sales'] || '0') : '—';
        var productSalesLabel = kpiSummary ? formatNumericCell('Product Sales', kpiSummary['Product Sales'] || '0') : '—';
        var appointmentLabel = kpiSummary ? formatNumericCell('Appointment Count', kpiSummary['Appointment Count'] || '0') : '—';
        var hoursBookedLabel = kpiSummary ? formatNumericCell('Hours Booked', kpiSummary['Hours Booked'] || '0') : '—';
        var hoursScheduledLabel = kpiSummary ? formatNumericCell('Hours Scheduled', kpiSummary['Hours Scheduled'] || '0') : '—';
        var requestedAppointmentLabel = kpiSummary
          ? (formatNumericCell('Appointment Count', String(getStaffKpiMetricNumber(kpiSummary, 'Requested Appointment Count'))) || '—')
          : '—';
        var revenuePerBookedHourLabel = kpiSummary && calculateDashboardRevenuePerBookedHour(kpiSummary) != null
          ? formatNumericCell('Production Rate', String(calculateDashboardRevenuePerBookedHour(kpiSummary)))
          : '—';
        var cards = [
          {
            label: 'Service Sales',
            value: serviceSalesLabel,
            subvalue: runRate ? ('Run rate ' + formatNumericCell('Service Sales', String(runRate.projectedServiceSales || 0))) : ''
          },
          {
            label: 'Demand',
            value: appointmentLabel,
            subvalue: requestedAppointmentLabel + ' requested'
          },
          {
            label: 'Hours',
            value: hoursBookedLabel,
            subvalue: hoursScheduledLabel + ' scheduled'
          },
          {
            label: 'Revenue',
            value: revenuePerBookedHourLabel,
            subvalue: kpiSummary ? formatNumericCell('Utilization %', getKpiDisplayValue('Utilization %', kpiSummary) || '0') + ' utilization' : ''
          },
          {
            label: 'Booking',
            value: kpiSummary ? (formatNumericCell('Prebooked %', kpiSummary['Prebooked %'] || '') || '—') : '—',
            subvalue: kpiSummary ? ((formatNumericCell('Self-booked %', kpiSummary['Self-booked %'] || '') || '—') + ' self-booked') : ''
          },
          {
            label: 'Retail',
            value: productSalesLabel,
            subvalue: kpiSummary ? (formatNumericCell('Retail to Service %', kpiSummary['Retail to Service %'] || '') || '') : ''
          },
        ];
        buildSalesSupplementalCards(supplemental, supplementalLoading).forEach(function(card){
          cards.push(card);
        });
        var clientsCard = buildClientsDashboardCard(kpiSummary);
        if (clientsCard) cards.push(clientsCard);
        return cards;
      }

      function setDashboardSectionStatus(node, text, tone){
        if (!node) return;
        node.textContent = String(text || '');
        node.className = 'personal-dashboard-status' + (tone ? ' personal-dashboard-status--' + tone : '');
      }

      function renderDashboardLoadingCards(gridNode, count){
        if (!gridNode) return;
        var items = [];
        var total = Math.max(1, Number(count) || 1);
        for (var index = 0; index < total; index += 1) {
          items.push({
            label: 'Loading',
            value: '—',
            subvalue: '',
            loading: true
          });
        }
        renderDashboardCards(gridNode, items);
      }

      function renderLevel7LoadingValue(){
        return '<span class="level7-compare-loadingValue"><span class="level7-compare-loadingDot" aria-hidden="true"></span>Loading</span>';
      }

      function calculateLevel7RevenuePerBookedHour(row){
        if (!row) return null;
        if (row.productionRate != null && isFinite(Number(row.productionRate))) {
          return Number(row.productionRate) || 0;
        }
        var serviceSales = Number(row.serviceSales) || 0;
        var hoursBooked = Number(row.hoursBooked) || 0;
        return hoursBooked > 0 ? serviceSales / hoursBooked : null;
      }

      function calculateLevel7ReliabilityScore(callOuts, lateArrivals, leavingEarly, requestsOff){
        var normalizedCallOuts = Math.max(0, Number(callOuts) || 0);
        var normalizedLateArrivals = Math.max(0, Number(lateArrivals) || 0);
        var normalizedLeavingEarly = Math.max(0, Number(leavingEarly) || 0);
        var normalizedRequestsOff = Math.max(0, Number(requestsOff) || 0);
        var chargeableCallOuts = Math.max(0, normalizedCallOuts - 5);
        var calloutCredit = Math.max(0, 5 - normalizedCallOuts);
        var weightedIncidents = chargeableCallOuts * 10
          + normalizedLateArrivals * 0.5
          + normalizedLeavingEarly * 0.5
          + normalizedRequestsOff * 0.5;
        return Math.min(100, Math.max(0, Math.round((100 - weightedIncidents + calloutCredit) * 10) / 10));
      }

      function getLevel7ReliabilityBreakdown(callOuts, lateArrivals, leavingEarly, requestsOff){
        var normalizedCallOuts = Math.max(0, Number(callOuts) || 0);
        var normalizedLateArrivals = Math.max(0, Number(lateArrivals) || 0);
        var normalizedLeavingEarly = Math.max(0, Number(leavingEarly) || 0);
        var normalizedRequestsOff = Math.max(0, Number(requestsOff) || 0);
        var chargeableCallOuts = Math.max(0, normalizedCallOuts - 5);
        var calloutCredit = Math.max(0, 5 - normalizedCallOuts);
        return {
          score: calculateLevel7ReliabilityScore(normalizedCallOuts, normalizedLateArrivals, normalizedLeavingEarly, normalizedRequestsOff),
          callOuts: normalizedCallOuts,
          lateArrivals: normalizedLateArrivals,
          leavingEarly: normalizedLeavingEarly,
          requestsOff: normalizedRequestsOff,
          chargeableCallOuts: chargeableCallOuts,
          calloutCredit: calloutCredit,
          calloutDeduction: chargeableCallOuts * 10,
          lateDeduction: normalizedLateArrivals * 0.5,
          leavingEarlyDeduction: normalizedLeavingEarly * 0.5,
          requestsOffDeduction: normalizedRequestsOff * 0.5
        };
      }

      function formatLevel7ReliabilityImpactValue(value){
        var numeric = Number(value) || 0;
        if (Math.abs(numeric - Math.round(numeric)) < 0.001) return String(Math.round(numeric));
        return numeric.toFixed(1);
      }

      function formatAttendanceForecastDate(value){
        var parsed = parseYmd(String(value || '').trim());
        if (!parsed) return String(value || '').trim();
        return parsed.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function formatLevel7ReliabilitySignedValue(value){
        var numeric = Number(value) || 0;
        return numeric > 0 ? '+' + formatLevel7ReliabilityImpactValue(numeric) : formatLevel7ReliabilityImpactValue(numeric);
      }

      function renderLevel7ReliabilityLine(label, detail, value, tone){
        return ''
          + '<div class="level7-compare-reliabilityLine' + (tone ? ' is-' + tone : '') + '">'
          +   '<div class="level7-compare-reliabilityLineCopy">'
          +     '<span class="level7-compare-reliabilityLineLabel">' + escapeHtml(label) + '</span>'
          +     '<span class="level7-compare-reliabilityLineDetail">' + escapeHtml(detail) + '</span>'
          +   '</div>'
          +   '<strong class="level7-compare-reliabilityLineValue">' + escapeHtml(formatLevel7ReliabilitySignedValue(value)) + '</strong>'
          + '</div>';
      }

      function renderLevel7ReliabilitySummary(breakdown){
        return ''
          + '<div>Total Callouts: ' + escapeHtml(String(breakdown.callOuts)) + '</div>'
          + '<div>Free Callouts Left: ' + escapeHtml(String(breakdown.calloutCredit)) + '</div>';
      }

      function normalizeAttendanceForecast(forecast){
        var source = forecast && typeof forecast === 'object' ? forecast : {};
        var nextScoreRelief = source.next_score_relief && typeof source.next_score_relief === 'object'
          ? source.next_score_relief
          : null;
        var nextCalloutRelief = source.next_callout_relief && typeof source.next_callout_relief === 'object'
          ? source.next_callout_relief
          : null;
        var nextCalloutRisk = source.next_callout_risk && typeof source.next_callout_risk === 'object'
          ? source.next_callout_risk
          : null;
        return {
          available: source.available === true,
          freeCalloutsLeft: Math.max(0, Number(source.free_callouts_left || 0) || 0),
          totalCallouts: Math.max(0, Number(source.total_callouts || 0) || 0),
          nextScoreRelief: nextScoreRelief ? {
            date: String(nextScoreRelief.date || '').trim(),
            points: Number(nextScoreRelief.points || 0) || 0,
            reasons: Array.isArray(nextScoreRelief.reasons) ? nextScoreRelief.reasons.map(function(reason){ return String(reason || '').trim(); }).filter(Boolean) : []
          } : null,
          nextCalloutRelief: nextCalloutRelief ? {
            date: String(nextCalloutRelief.date || '').trim(),
            points: Number(nextCalloutRelief.points || 0) || 0,
            type: String(nextCalloutRelief.type || '').trim(),
            reason: String(nextCalloutRelief.reason || '').trim()
          } : null,
          nextCalloutRisk: nextCalloutRisk ? {
            date: String(nextCalloutRisk.date || '').trim(),
            points: Number(nextCalloutRisk.points || 0) || 0,
            reason: String(nextCalloutRisk.reason || '').trim()
          } : null,
          reason: String(source.reason || '').trim()
        };
      }

      function renderAttendanceForecastContent(forecast){
        var normalized = normalizeAttendanceForecast(forecast);
        if (!normalized.available) {
          return '<div class="level7-compare-reliabilityRule">Forecast not available until this saved snapshot is refreshed.</div>';
        }
        var lines = [];
        lines.push('<div class="level7-compare-reliabilityRule">Forecast</div>');
        if (normalized.nextScoreRelief && normalized.nextScoreRelief.date) {
          lines.push(
            renderLevel7ReliabilityLine(
              'Next score relief',
              formatAttendanceForecastDate(normalized.nextScoreRelief.date) + (normalized.nextScoreRelief.reasons.length ? ' · ' + normalized.nextScoreRelief.reasons.join(', ') : ''),
              normalized.nextScoreRelief.points,
              'plus'
            )
          );
        }
        if (normalized.nextCalloutRelief && normalized.nextCalloutRelief.date) {
          lines.push(
            renderLevel7ReliabilityLine(
              normalized.nextCalloutRelief.type === 'penalty_relief' ? 'Callout penalty resets' : 'Free callout returns',
              formatAttendanceForecastDate(normalized.nextCalloutRelief.date) + (normalized.nextCalloutRelief.reason ? ' · ' + normalized.nextCalloutRelief.reason : ''),
              normalized.nextCalloutRelief.points,
              normalized.nextCalloutRelief.type === 'penalty_relief' ? 'plus' : 'neutral'
            )
          );
        }
        if (normalized.nextCalloutRisk && normalized.nextCalloutRisk.date) {
          lines.push(
            renderLevel7ReliabilityLine(
              'Callout risk window',
              formatAttendanceForecastDate(normalized.nextCalloutRisk.date) + ' · ' + normalized.nextCalloutRisk.reason,
              normalized.nextCalloutRisk.points ? -normalized.nextCalloutRisk.points : 0,
              normalized.nextCalloutRisk.points ? 'minus' : 'neutral'
            )
          );
        } else if (normalized.freeCalloutsLeft > 0) {
          lines.push('<div class="level7-compare-reliabilityRule">' + escapeHtml(String(normalized.freeCalloutsLeft)) + ' free callout' + (normalized.freeCalloutsLeft === 1 ? '' : 's') + ' left right now.</div>');
        }
        return lines.join('');
      }

      function renderLevel7ReliabilityContent(row){
        if (row == null || row.reliabilityScore == null || row.reliabilityScore === '') {
          return '<div class="level7-compare-cellNumeric">N/A</div>';
        }
        var breakdown = getLevel7ReliabilityBreakdown(row.callOuts, row.lateArrivals, row.leavingEarly, row.requestsOff);
        var combinedLateLeftEarly = breakdown.lateArrivals + breakdown.leavingEarly;
        var combinedLateLeftEarlyDeduction = breakdown.lateDeduction + breakdown.leavingEarlyDeduction;
        var forecastContent = renderAttendanceForecastContent(row && row.reliabilityForecast);
        return ''
          + '<div class="level7-compare-reliabilityCell">'
          +   '<div class="level7-compare-reliabilityScoreWrap"><strong class="level7-compare-reliabilityScore">' + escapeHtml(String(breakdown.score)) + '</strong></div>'
          +   '<details class="level7-compare-reliabilityDetails" open>'
          +     '<summary class="level7-compare-reliabilityToggle">How it\'s calculated:</summary>'
          +     '<div class="level7-compare-reliabilityRule">We look back 365 days</div>'
          +     '<div class="level7-compare-reliabilityRule">Starts at 100.</div>'
          +     '<div class="level7-compare-reliabilityRule">Your first 5 callouts in the last 365 are free, meaning 0 points deducted from your score.</div>'
          +     '<div class="level7-compare-reliabilityRule">Every unused free callout adds 1 point back to your score.</div>'
          +     '<div class="level7-compare-reliabilityRule">Requests off and late / left early each subtract 0.5 per offense from your score.</div>'
          +     '<div class="level7-compare-reliabilitySummary">' + renderLevel7ReliabilitySummary(breakdown) + '</div>'
          +     '<div class="level7-compare-reliabilityFormula">'
          +       renderLevel7ReliabilityLine('Callouts in Excess of First 5', String(breakdown.chargeableCallOuts) + ' × 10', -breakdown.calloutDeduction, breakdown.calloutDeduction ? 'minus' : 'neutral')
          +       renderLevel7ReliabilityLine('Requests Off', String(breakdown.requestsOff) + ' × 0.5', -breakdown.requestsOffDeduction, breakdown.requestsOffDeduction ? 'minus' : 'neutral')
          +       renderLevel7ReliabilityLine('Late / Left Early', String(combinedLateLeftEarly) + ' × 0.5', -combinedLateLeftEarlyDeduction, combinedLateLeftEarlyDeduction ? 'minus' : 'neutral')
          +       renderLevel7ReliabilityLine('Unused Callouts', String(breakdown.calloutCredit) + ' × 1', breakdown.calloutCredit, breakdown.calloutCredit ? 'plus' : 'neutral')
          +     '</div>'
          +     forecastContent
          +   '</details>'
          + '</div>';
      }

      function isPerfectAttendanceRow(attendanceRow){
        if (!attendanceRow) return true;
        var requestsOff = Number(attendanceRow.requests_off || 0);
        var callOuts = Number(attendanceRow.call_outs || 0);
        var lateArrivals = Number(attendanceRow.late_arrivals || 0);
        var leavingEarly = Number(attendanceRow.leaving_early || 0);
        var reliability = attendanceRow.reliability_score == null
          ? 100
          : Number(attendanceRow.reliability_score || 0);
        return requestsOff <= 0 && callOuts <= 0 && lateArrivals <= 0 && leavingEarly <= 0 && reliability >= 100;
      }

      function renderAttendanceDashboardSection(){
        var row = currentAttendanceYtdRow;
        var snapshotDate = currentAttendanceYtdSnapshotDate;
        if (!snapshotDate && !row) {
          renderDashboardLoadingCards(attendanceDashboardGrid, 4);
          setDashboardSectionStatus(attendanceDashboardStatus, 'Loading attendance data...');
          return;
        }
        renderAttendanceDashboardDetail(row);
        setDashboardSectionStatus(attendanceDashboardStatus, formatSnapshotRefreshLabel(snapshotDate));
      }

      function renderAttendanceDashboardStatCard(label, value, subvalue){
        return ''
          + '<div class="personal-dashboard-card">'
          +   '<div class="personal-dashboard-label">' + escapeHtml(label || '') + '</div>'
          +   '<div class="personal-dashboard-value">' + escapeHtml(value || '') + '</div>'
          +   (subvalue ? '<div class="personal-dashboard-subvalue">' + escapeHtml(subvalue) + '</div>' : '')
          + '</div>';
      }

      function renderAttendanceDashboardDetail(attendanceRow){
        if (!attendanceDashboardGrid) return;
        if (!attendanceRow) {
          attendanceDashboardGrid.innerHTML = '<div class="personal-dashboard-banner"><div class="personal-dashboard-bannerLabel">Attendance</div><h3>Attendance unavailable</h3><p>No attendance snapshot is available for this window yet.</p></div>';
          return;
        }
        var normalizedRow = {
          reliabilityScore: attendanceRow && attendanceRow.reliability_score != null ? Number(attendanceRow.reliability_score) : null,
          requestsOff: attendanceRow && attendanceRow.requests_off != null ? Number(attendanceRow.requests_off) || 0 : 0,
          callOuts: attendanceRow && attendanceRow.call_outs != null ? Number(attendanceRow.call_outs) || 0 : 0,
          lateArrivals: attendanceRow && attendanceRow.late_arrivals != null ? Number(attendanceRow.late_arrivals) || 0 : 0,
          leavingEarly: attendanceRow && attendanceRow.leaving_early != null ? Number(attendanceRow.leaving_early) || 0 : 0,
          reliabilityForecast: attendanceRow && attendanceRow.reliability_forecast ? attendanceRow.reliability_forecast : null
        };
        attendanceDashboardGrid.innerHTML = ''
          + '<div class="personal-dashboard-card personal-dashboard-card--reliability">'
          +   renderLevel7ReliabilityContent(normalizedRow)
          + '</div>';
      }

      function renderSalesDashboardSection(){
        if (salesTabYtd) salesTabYtd.parentNode && (salesTabYtd.parentNode.style.display = 'none');
        renderPersonalLevel7Table();
      }

      function formatSnapshotRefreshLabel(snapshotDate){
        var value = String(snapshotDate || '').trim();
        if (!value) return 'Latest saved snapshot';
        var parsed = parseYmd(value);
        if (!parsed) return 'Snapshot refreshed ' + value;
        return 'Snapshot refreshed ' + parsed.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function formatDashboardDateTime(value){
        var raw = String(value || '').trim();
        if (!raw) return '';
        var parsed = new Date(raw);
        if (isNaN(parsed.getTime())) return raw;
        return parsed.toLocaleString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });
      }

      function renderDashboardCards(gridNode, cards){
        if (!gridNode) return;
        if (!Array.isArray(cards) || !cards.length) {
          gridNode.innerHTML = '';
          return;
        }

        gridNode.innerHTML = cards.map(function(card){
          var subvalue = String(card.subvalue || '').trim();
          return ''
            + '<div class="personal-dashboard-card' + (card.loading ? ' personal-dashboard-card--loading' : '') + '">'
            +   '<div class="personal-dashboard-label">' + escapeHtml(card.label || '') + '</div>'
            +   '<div class="personal-dashboard-value">' + escapeHtml(card.value || '') + '</div>'
            +   (subvalue ? '<div class="personal-dashboard-subvalue">' + escapeHtml(subvalue) + '</div>' : '')
            + '</div>';
        }).join('');
      }

      function renderDashboardBanner(gridNode, banner){
        if (!gridNode) return;
        if (!banner || typeof banner !== 'object') {
          gridNode.innerHTML = '';
          return;
        }

        gridNode.innerHTML = ''
          + '<div class="personal-dashboard-banner">'
          +   '<div class="personal-dashboard-bannerLabel">' + escapeHtml(banner.label || '') + '</div>'
          +   '<div class="personal-dashboard-bannerTitle">' + escapeHtml(banner.title || '') + '</div>'
          +   '<div class="personal-dashboard-bannerCopy">' + escapeHtml(banner.copy || '') + '</div>'
          + '</div>';
      }

      function renderPersonalRequests(rows){
        if (!personalRequestsList) return;

        var sourceRows = Array.isArray(rows) ? rows.slice() : getPersonalRequestRows();
        var sortedRows = sourceRows.sort(function(a, b){
          var isShiftA = Array.isArray(a && a.requested_dates) ? 0 : 1;
          var isShiftB = Array.isArray(b && b.requested_dates) ? 0 : 1;
          var dateA = isShiftA ? String((a && a.request_date) || '') : firstRequestDateValue(a);
          var dateB = isShiftB ? String((b && b.request_date) || '') : firstRequestDateValue(b);
          if (dateA && dateB && dateA !== dateB) return dateA < dateB ? -1 : 1;
          if (dateA && !dateB) return -1;
          if (!dateA && dateB) return 1;

          var submittedA = String((a && a.submitted_at) || '');
          var submittedB = String((b && b.submitted_at) || '');
          return submittedA > submittedB ? -1 : 1;
        });

        var futureRows = sortedRows.filter(function(row){
          return Array.isArray(row && row.requested_dates)
            ? !isPastRequestRow(row)
            : !isPastRequestRow({ requested_dates: [row && row.request_date] });
        });
        var pastRows = sortedRows.filter(function(row){
          return Array.isArray(row && row.requested_dates)
            ? isPastRequestRow(row)
            : isPastRequestRow({ requested_dates: [row && row.request_date] });
        });

        renderPersonalRequestsTabs(futureRows.length, pastRows.length);

        if (pastRows.length) {
          pastRows = pastRows.slice().sort(function(a, b){
            var dateA = Array.isArray(a && a.requested_dates) ? firstRequestDateValue(a) : String((a && a.request_date) || '');
            var dateB = Array.isArray(b && b.requested_dates) ? firstRequestDateValue(b) : String((b && b.request_date) || '');
            if (dateA && dateB && dateA !== dateB) return dateA > dateB ? -1 : 1;
            var submittedA = String((a && a.submitted_at) || '');
            var submittedB = String((b && b.submitted_at) || '');
            return submittedA > submittedB ? -1 : 1;
          });
        }

        var visibleRows = activePersonalRequestsView === 'past' ? pastRows : futureRows;

        if (!visibleRows.length) {
          personalRequestsList.innerHTML = '<div class="personal-requests-empty">'
            + escapeHtml(!futureRows.length && !pastRows.length
              ? 'No requests submitted yet.'
              : (activePersonalRequestsView === 'past'
                ? 'No past requests yet.'
                : 'No upcoming requests yet.'))
            + '</div>';
          return;
        }

        personalRequestsList.innerHTML = visibleRows.map(function(row){
          var isShiftRequest = !Array.isArray(row && row.requested_dates);
          var rowId = String((row && row.id) || '').trim();
          var status = String((row && row.status) || 'pending').trim().toLowerCase() || 'pending';
          var firstDate = isShiftRequest ? String((row && row.request_date) || '').trim() : firstRequestDateValue(row);
          var dates = isShiftRequest
            ? formatRequestReviewDates([row && row.request_date])
            : formatRequestReviewDates(Array.isArray(row && row.requested_dates) ? row.requested_dates : []);
          var submittedAt = formatRequestReviewSubmitted(row && row.submitted_at);
          var note = String((row && row.note) || '').trim();
          var statusNote = String((row && row.status_note) || '').trim();
          var canDelete = !!rowId && status === 'pending';
          var scopeLabel = isShiftRequest
            ? formatShiftChangeTypeLabel(row && row.request_type)
            : getRequestOffScopeOptionLabel(
                getRequestOffMeta(row).request_scope,
                buildRequestOffScopeDetails(row && row.staff_id, firstDate, row && row.staff_name)
              );
          var shiftMeta = isShiftRequest ? getShiftChangeMeta(row) : null;
          var shiftTypeLabel = isShiftRequest ? formatOpenShiftTypeLabel(shiftMeta && shiftMeta.shift_type) : '';
          var roleName = isShiftRequest ? (String((row && row.role_name) || '').trim() || 'Salon Team') : '';
          var replacementCopy = isShiftRequest && String((row && row.request_type) || '').trim().toLowerCase() === 'replace_shift'
            ? [
                shiftMeta && shiftMeta.replacement_staff_name ? ('Switch with ' + String(shiftMeta.replacement_staff_name).trim()) : '',
                shiftMeta && shiftMeta.replacement_request_date ? ('on ' + formatRequestReviewDates([shiftMeta.replacement_request_date])) : '',
                shiftMeta && shiftMeta.replacement_shift_label ? ('scheduled ' + String(shiftMeta.replacement_shift_label).trim()) : ''
              ].filter(Boolean).join(' · ')
            : '';

          return ''
            + '<article class="request-review-card personal-request-card" data-status="' + escapeHtml(status) + '">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">' + escapeHtml(dates) + '</div>'
            +       '<div class="request-review-metaRow">'
            +         '<span class="request-review-token">' + escapeHtml(scopeLabel) + '</span>'
            +         '<span class="request-review-token">Submitted ' + escapeHtml(submittedAt || 'recently') + '</span>'
            +       '</div>'
            +       (isShiftRequest ? renderOpenShiftCardShiftBlock(String((row && row.shift_label) || '').trim(), shiftTypeLabel, 'Role', roleName) : '')
            +       '<div class="request-review-meta">'
            +         (replacementCopy ? '<div>Plan: ' + escapeHtml(replacementCopy) + '</div>' : '')
            +         (note ? '<div>Note: ' + escapeHtml(note) + '</div>' : '')
            +         (statusNote ? '<div>Status: ' + escapeHtml(statusNote) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +     '<div class="request-review-side">'
            +       '<span class="request-review-badge" data-status="' + escapeHtml(status) + '">' + escapeHtml(status) + '</span>'
            +       (canDelete
                  ? '<div class="request-review-actions">'
                    + '<button class="btn-secondary" type="button" data-personal-request-delete="' + escapeHtml(rowId) + '" data-personal-request-kind="' + escapeHtml(isShiftRequest ? 'shift' : 'request_off') + '">Delete</button>'
                  + '</div>'
                  : '')
            +     '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      async function deleteRequestOffQueueRow(requestId){
        var payload = {
          action: 'staff-request-off-delete',
          request_id: requestId
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not delete request.');
        }
        var deletedId = String((data.row && data.row.id) || '').trim();
        requestOffQueue = (Array.isArray(requestOffQueue) ? requestOffQueue : []).filter(function(row){
          return String((row && row.id) || '').trim() !== deletedId;
        });
        renderPersonalRequests();
        return data.row;
      }

      function renderSupplyRequests(rows){
        if (!supplyRequestList) return;
        var visibleRows = (Array.isArray(rows) ? rows.slice() : []).filter(function(row){
          var status = String((row && row.status) || '').trim().toLowerCase();
          return status !== 'ordered' && status !== 'dismissed' && status !== 'received';
        });
        visibleRows.sort(function(left, right){
          var leftCreated = String((left && left.created_at) || '');
          var rightCreated = String((right && right.created_at) || '');
          return rightCreated.localeCompare(leftCreated);
        });
        if (!visibleRows.length) {
          supplyRequestList.innerHTML = '<div class="request-review-empty">No active supply requests right now. Add what the salon is low on and it will land in the shared queue.</div>';
          return;
        }

        supplyRequestList.innerHTML = visibleRows.map(function(row){
          var itemName = String((row && (row.matched_catalog_name || row.raw_item_name)) || '').trim() || 'Supply request';
          var status = String((row && row.status) || '').trim().toLowerCase();
          var note = String((row && row.note) || '').trim();
          var matchStrategy = String((row && row.match_strategy) || '').trim();
          var addedAt = formatRequestReviewSubmitted(row && row.created_at);
          var lastOrderedAt = formatRequestReviewSubmitted(row && row.last_ordered_at);
          var queueLabel = status === 'ordered' ? 'Ordered' : 'In queue';
          return ''
            + '<article class="request-review-card supply-card">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">' + escapeHtml(itemName) + '</div>'
            +       '<div class="request-review-metaRow">'
            +         '<span class="request-review-token">' + escapeHtml(queueLabel) + '</span>'
            +         (lastOrderedAt ? '<span class="request-review-token">Last ordered ' + escapeHtml(lastOrderedAt) + '</span>' : '')
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   (note ? '<div class="request-review-copy">' + escapeHtml(note) + '</div>' : '')
            +   '<div class="request-review-meta">'
            +     '<span>Added ' + escapeHtml(addedAt || 'recently') + '</span>'
            +     '<span>' + escapeHtml(matchStrategy && matchStrategy !== 'new_item' ? 'Matched to normal inventory' : 'New item candidate') + '</span>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      function renderTodoManagerPicker(rows){
        if (!todoManagerPicker) return;
        var managers = Array.isArray(rows) ? rows.slice() : [];
        if (!managers.length) {
          todoManagerPicker.innerHTML = '<div class="request-review-empty">No managers are ready to tag yet.</div>';
          return;
        }
        todoManagerPicker.innerHTML = managers.map(function(manager, index){
          var id = String(manager && manager.id || '').trim();
          var name = String(manager && manager.name || '').trim() || 'Manager';
          var role = String(manager && manager.role || '').trim();
          var avatarUrl = getAvatarUrl(name);
          var avatarMarkup = avatarUrl
            ? '<span class="todo-manager-avatar"><img src="' + escapeHtml(avatarUrl) + '" alt="' + escapeHtml(name) + '" loading="lazy" /></span>'
            : '<span class="todo-manager-avatar">' + escapeHtml(getInitials(name)) + '</span>';
          return ''
            + '<label class="todo-manager-option">'
            +   '<input type="checkbox" name="todoManager" value="' + escapeHtml(id) + '"' + (index === 0 ? '' : '') + ' />'
            +   '<span class="todo-manager-optionContent">'
            +     avatarMarkup
            +     '<span class="todo-manager-optionBody">'
            +       '<strong>' + escapeHtml(name) + '</strong>'
            +       (role ? '<small>' + escapeHtml(role) + '</small>' : '')
            +     '</span>'
            +   '</span>'
            + '</label>';
        }).join('');
      }

      function formatTodoRecurrenceLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'weekly') return 'Repeats weekly';
        if (normalized === 'biweekly') return 'Repeats every 2 weeks';
        if (normalized === 'monthly') return 'Repeats every 4 weeks';
        return '';
      }

      function syncTodoViewTabs(){
        var openCount = Array.isArray(todoItems) ? todoItems.filter(function(row){
          return String((row && row.status) || '').trim().toLowerCase() !== 'completed';
        }).length : 0;
        var completedCount = Array.isArray(todoItems) ? todoItems.filter(function(row){
          return String((row && row.status) || '').trim().toLowerCase() === 'completed';
        }).length : 0;
        if (todoViewTabOpen) {
          todoViewTabOpen.textContent = 'Open (' + String(openCount) + ')';
        }
        if (todoViewTabCompleted) {
          todoViewTabCompleted.textContent = 'Completed (' + String(completedCount) + ')';
        }
        [
          { node: todoViewTabOpen, value: 'open' },
          { node: todoViewTabCompleted, value: 'completed' }
        ].forEach(function(item){
          if (!item.node) return;
          var active = activeTodoView === item.value;
          item.node.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function renderTodoItems(rows){
        if (!todoList) return;
        syncTodoViewTabs();
        var allRows = Array.isArray(rows) ? rows.slice() : [];
        var visibleRows = allRows.filter(function(row){
          var status = String((row && row.status) || '').trim().toLowerCase();
          if (activeTodoView === 'completed') {
            return status === 'completed';
          }
          return status !== 'completed';
        });
        visibleRows.sort(function(left, right){
          var leftPending = String((left && left.status) || '').trim().toLowerCase() !== 'completed';
          var rightPending = String((right && right.status) || '').trim().toLowerCase() !== 'completed';
          if (leftPending !== rightPending) return leftPending ? -1 : 1;
          var leftStamp = String((left && (left.completed_at || left.created_at)) || '');
          var rightStamp = String((right && (right.completed_at || right.created_at)) || '');
          return rightStamp.localeCompare(leftStamp);
        });
        if (!visibleRows.length) {
          todoList.innerHTML = '<div class="request-review-empty">' + escapeHtml(
            activeTodoView === 'completed'
              ? 'No completed to-dos yet.'
              : 'Nothing open right now. Add a real salon follow-up and it will text the tagged managers.'
          ) + '</div>';
          return;
        }
        todoList.innerHTML = visibleRows.map(function(row){
          var rowId = String((row && row.id) || '').trim();
          var title = String((row && row.title) || '').trim() || 'Salon to-do';
          var detail = String((row && row.detail) || '').trim();
          var status = String((row && row.status) || '').trim().toLowerCase();
          var taggedManagers = Array.isArray(row && row.tagged_manager_names) ? row.tagged_manager_names : [];
          var createdAt = formatRequestReviewSubmitted(row && row.created_at);
          var completedAt = formatRequestReviewSubmitted(row && row.completed_at);
          var completedBy = String((row && row.completed_by_staff_name) || '').trim();
          var meta = row && row.metadata && typeof row.metadata === 'object' ? row.metadata : {};
          var recurrenceLabel = formatTodoRecurrenceLabel(meta && meta.recurrence);
          var nextDueDate = String((meta && meta.next_due_date) || '').trim();
          return ''
            + '<article class="request-review-card todo-card" data-status="' + escapeHtml(status || 'pending') + '">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">' + escapeHtml(title) + '</div>'
            +       '<div class="request-review-metaRow">'
            +         '<span class="request-review-token">' + escapeHtml(status === 'completed' ? 'Completed' : 'Open') + '</span>'
            +         (createdAt ? '<span class="request-review-token">Posted ' + escapeHtml(createdAt) + '</span>' : '')
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   (detail ? '<div class="request-review-copy">' + escapeHtml(detail) + '</div>' : '')
            +   '<div class="request-review-meta">'
            +     (recurrenceLabel ? '<span>' + escapeHtml(recurrenceLabel) + (nextDueDate ? ' · Next ' + escapeHtml(nextDueDate) : '') + '</span>' : '')
            +     (taggedManagers.length ? '<span>Tagged ' + escapeHtml(taggedManagers.join(', ')) + '</span>' : '')
            +     (status === 'completed' && completedAt ? '<span>Done ' + escapeHtml(completedAt) + (completedBy ? ' by ' + escapeHtml(completedBy) : '') + '</span>' : '')
            +   '</div>'
            +   '<div class="request-off-actions request-off-actions--todo">'
            +     '<button class="btn-secondary" type="button" data-todo-action="delete" data-todo-id="' + escapeHtml(rowId) + '">' + escapeHtml(status === 'completed' ? 'Delete' : 'Delete item') + '</button>'
            +   '</div>'
            + '</article>';
        }).join('');
        Array.prototype.slice.call(todoList.querySelectorAll('[data-todo-action="delete"]')).forEach(function(button){
          button.addEventListener('click', async function(){
            var todoId = String(button && button.getAttribute('data-todo-id') || '').trim();
            if (!todoId) return;
            try {
              button.disabled = true;
              setTodoStatus('Deleting to-do item...');
              await deleteTodoItemForStaff(todoId);
              todoItems = Array.isArray(todoItems) ? todoItems.filter(function(row){
                return String((row && row.id) || '').trim() !== todoId;
              }) : [];
              renderTodoItems(todoItems);
              setTodoStatus('To-do item deleted.', 'success');
            } catch (error) {
              button.disabled = false;
              setTodoStatus(humanizeClientFetchErrorMessage(error, 'Could not delete that to-do item.'), 'error');
            }
          });
        });
      }

      function renderOpenShiftCards(rows, pendingPickupOpenShiftIds){
        var visibleRows = Array.isArray(rows) ? rows.slice() : [];
        var pendingLookup = pendingPickupOpenShiftIds && typeof pendingPickupOpenShiftIds === 'object'
          ? pendingPickupOpenShiftIds
          : {};
        if (!visibleRows.length) {
          return '<div class="request-review-empty">No open shifts are available right now.</div>';
        }

        return visibleRows.map(function(row){
          var rowId = String((row && row.id) || '').trim();
          var note = String((row && row.note) || '').trim();
          var meta = getShiftChangeMeta(row);
          var allowedRoles = Array.isArray(meta.allowed_role_labels) ? meta.allowed_role_labels : [];
          var minimumLevelValue = Number(meta.minimum_level);
          var minimumRoleLabel = String(meta.minimum_role_label || '').trim();
          var minimumLabel = formatOpenShiftEligibilityLabel(allowedRoles, minimumLevelValue, minimumRoleLabel);
          var shiftTypeLabel = formatOpenShiftTypeLabel(meta.shift_type);
          var dateLabel = formatRequestReviewDates([row && row.request_date]);
          var shiftLabel = String((row && row.shift_label) || '').trim();
          var isRequested = !!pendingLookup[rowId];
          return ''
            + '<article class="request-review-card request-review-card--open-shift" data-status="approved">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">Open shift available</div>'
            +       '<div class="request-review-dates">' + escapeHtml(dateLabel) + '</div>'
            +       (isRequested
                      ? '<div class="request-review-metaRow"><span class="request-review-token request-review-token--accent">Pickup requested</span></div>'
                      : '')
            +       renderOpenShiftCardShiftBlock(shiftLabel, shiftTypeLabel, 'Eligible', minimumLabel || 'Any role')
            +       (isRequested
                      ? '<div class="request-review-inlineNotice request-review-inlineNotice--success">'
                        + '<strong>Requested</strong>'
                        + '<span>Your pickup request went through and is waiting for manager approval.</span>'
                      + '</div>'
                      : '')
            +       '<div class="request-review-meta">'
            +         '<div>' + escapeHtml(isRequested ? 'Your request is in. Waiting for manager approval.' : 'Tap in if you want this shift.') + '</div>'
            +         (note ? '<div>Note: ' + escapeHtml(note) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   '<div class="field">'
            +     '<label for="pickupNote_' + escapeHtml(rowId) + '">Note</label>'
            +     '<input id="pickupNote_' + escapeHtml(rowId) + '" class="request-off-note request-off-note--compact" type="text" maxlength="140" data-open-shift-note="' + escapeHtml(rowId) + '" placeholder="Add an optional note"' + (isRequested ? ' disabled' : '') + ' />'
            +   '</div>'
            +   '<div class="request-off-actions">'
            +     '<button class="' + escapeHtml(isRequested ? 'btn-secondary' : 'btn-primary') + '" type="button" data-open-shift-action="pickup" data-open-shift-id="' + escapeHtml(rowId) + '"' + (isRequested ? ' disabled' : '') + '>' + escapeHtml(isRequested ? 'Requested' : 'Request pickup') + '</button>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      function formatOpenShiftEligibilityLabel(allowedRoles, minimumLevelValue, minimumRoleLabel){
        var roles = Array.isArray(allowedRoles) ? allowedRoles.slice() : [];
        var levels = roles.map(function(role){
          return parseRoleLevelNumber(role);
        }).filter(function(level){
          return level != null;
        }).sort(function(a, b){
          return a - b;
        });
        var hasManagementRole = roles.some(function(role){
          return isManagementLikeRole(role);
        });
        if (levels.length) {
          var uniqueLevels = levels.filter(function(level, index){
            return index === 0 || level !== levels[index - 1];
          });
          var levelsLabel = '';
          if (uniqueLevels.length === 1) {
            levelsLabel = 'Level ' + uniqueLevels[0];
          } else {
            var firstLevel = uniqueLevels[0];
            var lastLevel = uniqueLevels[uniqueLevels.length - 1];
            var isContinuous = uniqueLevels.every(function(level, index){
              return index === 0 || level === uniqueLevels[index - 1] + 1;
            });
            levelsLabel = isContinuous
              ? ('Levels ' + firstLevel + '-' + lastLevel)
              : ('Levels ' + uniqueLevels.join(', '));
          }
          return hasManagementRole ? (levelsLabel + ' + Management') : levelsLabel;
        }
        if (hasManagementRole) return 'Management';
        if (isFinite(minimumLevelValue)) {
          return 'Level ' + minimumLevelValue + '+';
        }
        if (minimumRoleLabel) {
          return minimumRoleLabel;
        }
        return 'Any role';
      }

      function isManagementLikeRole(role){
        var value = String(role || '').trim().toLowerCase();
        if (!value) return false;
        return value.indexOf('manager') >= 0
          || value.indexOf('owner') >= 0
          || value.indexOf('front desk') >= 0
          || value.indexOf('general staff') >= 0;
      }

      function roleMatchesOpenShiftEligibility(staffRole, allowedRoles){
        var roles = Array.isArray(allowedRoles) ? allowedRoles : [];
        var normalizedStaffRole = String(staffRole || '').trim();
        if (!roles.length) return true;
        if (!normalizedStaffRole) return false;
        var staffLevel = parseRoleLevelNumber(normalizedStaffRole);
        var staffIsManagement = isManagementLikeRole(normalizedStaffRole);
        return roles.some(function(role){
          var normalizedAllowedRole = String(role || '').trim();
          if (!normalizedAllowedRole) return false;
          if (normalizedAllowedRole === normalizedStaffRole) return true;
          var allowedLevel = parseRoleLevelNumber(normalizedAllowedRole);
          if (staffLevel != null && allowedLevel != null && staffLevel === allowedLevel) return true;
          if (staffIsManagement && isManagementLikeRole(normalizedAllowedRole)) return true;
          return false;
        });
      }

      function renderMyShiftRequests(rows){
        var visibleRows = Array.isArray(rows) ? rows.slice() : [];
        if (!visibleRows.length) {
          return '<div class="request-review-empty">No shift requests submitted yet.</div>';
        }

        return visibleRows.map(function(row){
          var rowId = String((row && row.id) || '').trim();
          var status = String((row && row.status) || 'pending').trim().toLowerCase() || 'pending';
          var note = String((row && row.note) || '').trim();
          var statusNote = String((row && row.status_note) || '').trim();
          var meta = getShiftChangeMeta(row);
          var shiftTypeLabel = formatOpenShiftTypeLabel(meta.shift_type);
          var roleName = String((row && row.role_name) || '').trim() || 'Salon Team';
          var submittedAt = formatRequestReviewSubmitted(row && row.submitted_at);
          var replacementName = String(meta.replacement_staff_name || '').trim();
          var replacementDate = String(meta.replacement_request_date || '').trim();
          var replacementShift = String(meta.replacement_shift_label || '').trim();
          var requestTypeLabel = formatShiftChangeTypeLabel(row && row.request_type);
          var canDelete = !!rowId && status === 'pending';
          var replacementCopy = String((row && row.request_type) || '').trim().toLowerCase() === 'replace_shift'
            ? [
                replacementName ? ('Switch with ' + replacementName) : '',
                replacementDate ? ('on ' + formatRequestReviewDates([replacementDate])) : '',
                replacementShift ? ('scheduled ' + replacementShift) : ''
              ].filter(Boolean).join(' · ')
            : '';
          return ''
            + '<article class="request-review-card" data-status="' + escapeHtml(status) + '">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
              +       '<div class="request-review-name">' + escapeHtml(requestTypeLabel) + '</div>'
              +       '<div class="request-review-dates">' + escapeHtml(formatRequestReviewDates([row && row.request_date])) + '</div>'
              +       '<div class="request-review-metaRow">'
              +         '<span class="request-review-token">' + escapeHtml(status === 'pending' ? 'Awaiting review' : 'Updated') + '</span>'
              +         (submittedAt ? '<span class="request-review-token">Sent ' + escapeHtml(submittedAt) + '</span>' : '')
              +       '</div>'
              +       renderOpenShiftCardShiftBlock(String((row && row.shift_label) || '').trim(), shiftTypeLabel, 'Role', roleName)
              +       '<div class="request-review-meta">'
            +         (replacementCopy ? '<div>Plan: ' + escapeHtml(replacementCopy) + '</div>' : '')
            +         (note ? '<div>Note: ' + escapeHtml(note) + '</div>' : '')
            +         (statusNote ? '<div>Status: ' + escapeHtml(statusNote) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +     '<div class="request-review-side">'
            +       '<span class="request-review-badge" data-status="' + escapeHtml(status) + '">' + escapeHtml(status) + '</span>'
            +       (canDelete
                      ? '<div class="request-review-actions">'
                        + '<button class="btn-secondary" type="button" data-shift-request-delete="' + escapeHtml(rowId) + '">Delete</button>'
                      + '</div>'
                      : '')
            +     '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      function renderOpenShiftCardShiftBlock(shiftLabel, shiftTypeLabel, roleLabel, roleValue){
        var safeShiftLabel = String(shiftLabel || '').trim();
        var safeShiftTypeLabel = String(shiftTypeLabel || '').trim();
        var safeRoleLabel = String(roleLabel || '').trim();
        var safeRoleValue = String(roleValue || '').trim();
        return ''
          + (safeShiftLabel || safeShiftTypeLabel
              ? '<div class="request-review-shiftLine">'
                + (safeShiftLabel ? '<span class="request-review-shiftValue">' + escapeHtml(safeShiftLabel) + '</span>' : '')
                + (safeShiftTypeLabel ? '<span class="request-review-token request-review-token--accent">' + escapeHtml(safeShiftTypeLabel) + '</span>' : '')
              + '</div>'
              : '')
          + (safeRoleValue
              ? '<div class="request-review-roleLine">'
                + (safeRoleLabel ? '<span class="request-review-label">' + escapeHtml(safeRoleLabel) + '</span>' : '')
                + '<span>' + escapeHtml(safeRoleValue) + '</span>'
              + '</div>'
              : '');
      }

      async function submitOpenShiftPickup(openShiftRow, note){
        if (!currentLoggedInStaff) {
          throw new Error('Log in again before requesting a pickup.');
        }
        var staffPhoneLast4 = String(currentLoggedInStaff.mobile_phone || '').replace(/\D+/g, '').slice(-4);
        if (staffPhoneLast4.length !== 4) {
          throw new Error('Your profile is missing a mobile phone number on file.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-shift-change-submit',
            request_type: 'pick_up_shift',
            open_shift_id: openShiftRow.id || '',
            staff_id: currentLoggedInStaff.id || '',
            staff_name: currentLoggedInStaff.name || '',
            role_name: currentLoggedInStaff.role || '',
            request_date: openShiftRow.request_date || '',
            shift_label: openShiftRow.shift_label || '',
            note: note || '',
            notify_phone: REQUEST_OFF_NOTIFY_PHONES,
            staff_phone_last4: staffPhoneLast4
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not submit pickup request.');
        }
        return data.row;
      }

      async function deleteShiftChangeQueueRow(requestId){
        var payload = {
          action: 'staff-shift-change-delete',
          request_id: requestId
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not delete shift request.');
        }
        var deletedId = String((data.row && data.row.id) || '').trim();
        shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).filter(function(row){
          return String((row && row.id) || '').trim() !== deletedId;
        });
        renderOpenShiftState(shiftChangeQueue);
        return data.row;
      }

      function buildOpenShiftState(rows){
        var todayValue = [
          (new Date()).getFullYear(),
          String((new Date()).getMonth() + 1).padStart(2, '0'),
          String((new Date()).getDate()).padStart(2, '0')
        ].join('-');
        var queueRows = Array.isArray(rows) ? rows : [];
        var currentLevel = parseRoleLevelNumber(currentLoggedInStaff && currentLoggedInStaff.role);
        var currentRole = String((currentLoggedInStaff && currentLoggedInStaff.role) || '').trim();
        var myExistingPickupOpenShiftIds = queueRows.reduce(function(list, row){
          if (!sameStaffName(row && row.staff_name, currentLoggedInStaff && currentLoggedInStaff.name)) return list;
          if (String((row && row.request_type) || '').trim().toLowerCase() !== 'pick_up_shift') return list;
          if (String((row && row.status) || '').trim().toLowerCase() === 'denied') return list;
          var meta = getShiftChangeMeta(row);
          var openShiftId = String(meta.open_shift_id || '').trim();
          if (openShiftId && list.indexOf(openShiftId) === -1) {
            list.push(openShiftId);
          }
          return list;
        }, []);
        var openShifts = queueRows.filter(function(row){
          var meta = getShiftChangeMeta(row);
          var allowedRoles = Array.isArray(meta.allowed_role_labels) ? meta.allowed_role_labels : [];
          var matchesAllowedRole = roleMatchesOpenShiftEligibility(currentRole, allowedRoles);
          var minimumLevelValue = Number(meta.minimum_level);
          var meetsLevelRequirement = !isFinite(minimumLevelValue) || (currentLevel != null && currentLevel >= minimumLevelValue);
          var requestDate = String((row && row.request_date) || '').trim();
          if (openShiftDayFilterValue !== 'all' && requestDate) {
            var dateParts = requestDate.split('-').map(function(part){ return Number(part); });
            if (dateParts.length === 3) {
              var weekdayValue = new Date(dateParts[0], (dateParts[1] || 1) - 1, dateParts[2] || 1).getDay();
              if (String(weekdayValue) !== openShiftDayFilterValue) return false;
            }
          }
          return String((row && row.request_type) || '').trim().toLowerCase() === 'open_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'approved'
            && String((meta.open_status) || 'open').trim().toLowerCase() !== 'filled'
            && requestDate >= todayValue
            && !sameStaffName(row && row.staff_name, currentLoggedInStaff && currentLoggedInStaff.name)
            && matchesAllowedRole
            && (!allowedRoles.length ? meetsLevelRequirement : true);
        }).sort(function(a, b){
          return String((a && a.request_date) || '').localeCompare(String((b && b.request_date) || ''))
            || String((a && a.shift_label) || '').localeCompare(String((b && b.shift_label) || ''));
        });

        var myShiftRequests = queueRows.filter(function(row){
          var requestType = String((row && row.request_type) || '').trim().toLowerCase();
          return (requestType === 'pick_up_shift' || requestType === 'replace_shift')
            && sameStaffName(row && row.staff_name, currentLoggedInStaff && currentLoggedInStaff.name);
        }).sort(function(a, b){
          var pendingA = String((a && a.status) || '').trim().toLowerCase() === 'pending' ? 0 : 1;
          var pendingB = String((b && b.status) || '').trim().toLowerCase() === 'pending' ? 0 : 1;
          return pendingA - pendingB
            || String((a && a.request_date) || '').localeCompare(String((b && b.request_date) || ''));
        });

        return {
          openShifts: openShifts,
          myShiftRequests: myShiftRequests,
          pendingPickupOpenShiftIds: myExistingPickupOpenShiftIds.reduce(function(map, id){
            map[id] = true;
            return map;
          }, {})
        };
      }

      function renderOpenShiftState(rows){
        var state = buildOpenShiftState(rows);
        if (!openShiftResultsList) return;
        openShiftResultsList.innerHTML = openShiftViewFilter === 'mine'
          ? renderMyShiftRequests(state.myShiftRequests)
          : renderOpenShiftCards(state.openShifts, state.pendingPickupOpenShiftIds);
        setTabCount(openShiftsTabCount, state.openShifts.length);
        setTabCount(openShiftViewCountAvailable, state.openShifts.length);
        setTabCount(openShiftViewCountMine, state.myShiftRequests.length);
        setOpenShiftsStatus(
          openShiftViewFilter === 'mine'
            ? (state.myShiftRequests.length ? 'Your shift activity is listed below.' : 'No shift activity yet.')
            : (state.openShifts.length ? 'Open shifts are listed below.' : 'No open shifts match this filter right now.')
        );
      }

      function getServiceMixCategoryLabel(row){
        var candidates = [
          row && row['Service category_name'],
          row && row['Service Category'],
          row && row['Category'],
          row && row['category']
        ];
        for (var i = 0; i < candidates.length; i += 1) {
          var label = String(candidates[i] || '').trim();
          if (label) return label;
        }
        return '';
      }

      function getServiceMixStaffName(row){
        return String((row && row['Staff Name']) || (row && row.staff_name) || '').trim();
      }

      function formatPercentValue(value){
        var numeric = Number(value) || 0;
        if (numeric >= 10) return numeric.toFixed(0) + '%';
        if (numeric >= 1) return numeric.toFixed(1) + '%';
        return numeric.toFixed(2) + '%';
      }

      function getCompactServiceMixLabel(value){
        var label = String(value || '').trim();
        if (!label) return '';
        return label
          .replace(/^Going\s+/i, '')
          .replace(/ or /gi, '/')
          .replace(/\s+Service$/i, '')
          .replace(/^Hand-Tied Hair Extensions$/i, 'Extensions')
          .replace(/^Hair Styling$/i, 'Styling')
          .replace(/^Going Darker\/Covering Gray$/i, 'Darker/Gray')
          .replace(/^Darker\/Covering Gray$/i, 'Darker/Gray')
          .replace(/^Lighter\/Highlights$/i, 'Highlights');
      }

      function parseRoleLevelNumber(role){
        var raw = String(role || '').trim().toLowerCase();
        if (!raw) return null;
        var matched = raw.match(/level\s+(\d+)/i);
        if (!matched) return null;
        var level = Number(matched[1]);
        return isFinite(level) ? level : null;
      }

      function resolveRetailTrackLevelNumber(value, staffName){
        var directLevel = parseRoleLevelNumber(value);
        if (directLevel != null) return directLevel;
        var mappedLevel = parseRoleLevelNumber(getLevelLabel(staffName));
        if (mappedLevel != null) return mappedLevel;
        return null;
      }

      function retailTrackModeForLevel(levelNumber){
        var numeric = Number(levelNumber);
        if (!isFinite(numeric)) return null;
        if (numeric >= 0 && numeric <= 4) return 'assistant';
        if (numeric >= 5 && numeric <= 7) return 'stylist';
        return null;
      }

      function resolveRetailTrackMode(value, staffName){
        var levelMode = retailTrackModeForLevel(resolveRetailTrackLevelNumber(value, staffName));
        if (levelMode) return levelMode;
        var raw = String(value || '').trim().toLowerCase();
        if (/assistant|support|front desk|desk/i.test(raw)) return 'assistant';
        if (/stylist/i.test(raw)) return 'stylist';
        return null;
      }

      function isAssistantSupportRole(role){
        return resolveRetailTrackMode(role, '') === 'assistant';
      }

      function getRetailGameMode(){
        var currentMode = resolveRetailTrackMode(
          (currentLoggedInStaff && (currentLoggedInStaff.level || currentLoggedInStaff.role)) || '',
          currentLoggedInStaff && currentLoggedInStaff.name
        );
        return currentMode === 'assistant' ? 'assistant' : 'stylist';
      }

      function shouldHideSalesForRole(role){
        var levelNumber = parseRoleLevelNumber(role);
        if (levelNumber == null) return false;
        return levelNumber < 5;
      }

      function isStylingServiceMixCategory(category){
        return String(category || '').trim().toLowerCase().indexOf('styling') >= 0;
      }

      function isServiceMixAggregateValue(value){
        var normalized = String(value || '').trim().toLowerCase();
        return normalized === 'all' || normalized === 'total' || normalized === 'totals';
      }

      function detectServiceMixGroupingHeaders(rows){
        var reservedHeaders = {
          'staff name': true,
          'service category': true,
          'service category_name': true,
          'category': true,
          'location name': true,
          'service sales': true,
          'appointment count': true
        };
        var headers = {};
        (Array.isArray(rows) ? rows : []).forEach(function(row){
          Object.keys(row || {}).forEach(function(header){
            headers[String(header || '')] = true;
          });
        });

        return Object.keys(headers).filter(function(header){
          var normalizedHeader = String(header || '').trim().toLowerCase();
          if (!normalizedHeader || reservedHeaders[normalizedHeader]) return false;
          var hasAggregate = false;
          var hasDetail = false;
          (Array.isArray(rows) ? rows : []).forEach(function(row){
            var value = String((row && row[header]) || '').trim();
            if (!value) return;
            if (isServiceMixAggregateValue(value)) {
              hasAggregate = true;
            } else {
              hasDetail = true;
            }
          });
          return hasAggregate && hasDetail;
        });
      }

      function getServiceMixDisplayConfig(role){
        var levelNumber = parseRoleLevelNumber(role);
        if (levelNumber == null) {
          return {
            level: null,
            title: 'Service Mix',
            mode: 'sales',
            copy: 'Category sales mix from the latest 180-day and 365-day snapshots.',
            empty_copy: 'No category sales mix found in the latest saved snapshots.'
          };
        }
        if (levelNumber === 0 || levelNumber === 1) return null;
        if (levelNumber === 2) {
          return {
            level: levelNumber,
            title: 'Blowdry Reps',
            mode: 'appointments',
            only_styling: true,
            copy: 'Styling appointment count from the latest 180-day and 365-day snapshots.',
            empty_copy: 'No styling appointments found in the latest saved snapshots.'
          };
        }
        if (levelNumber === 3) {
          return {
            level: levelNumber,
            title: 'Category Reps',
            mode: 'appointments',
            copy: 'Category appointment count from the latest 180-day and 365-day snapshots.',
            empty_copy: 'No category appointments found in the latest saved snapshots.'
          };
        }
        if (levelNumber === 4) {
          return {
            level: levelNumber,
            title: 'Service Mix',
            mode: 'sales_and_appointments',
            copy: 'Category sales share and appointment count from the latest 180-day and 365-day snapshots.',
            empty_copy: 'No category sales mix found in the latest saved snapshots.'
          };
        }
        return {
          level: levelNumber,
          title: 'Service Mix',
          mode: 'sales',
          copy: 'Category sales share from the latest 180-day and 365-day snapshots.',
          empty_copy: 'No category sales mix found in the latest saved snapshots.'
        };
      }

      var LEVEL_TITLES = {
        0: 'Salon Support',
        1: 'Guest Support Assistant',
        2: 'Color Support Assistant',
        3: 'Finishing Assistant',
        4: 'Stylist I / Lead Assistant',
        5: 'Stylist I',
        6: 'Stylist II',
        7: 'hs.Stylist'
      };

      var NEXT_MOVE_KEY_LABELS = {
        caping: 'Caping',
        preguard: 'Preguard',
        timer_management: 'Timer management',
        brushing_detangling: 'Brushing and detangling',
        client_prep: 'Client prep',
        greet_and_seat: 'Greet and seat guests',
        service_flow: 'Follow service flow',
        timing_handoffs: 'Timing and handoffs',
        shampoo_products: 'Explain products',
        shampoo_client_needs: 'Identify client needs',
        shampoo_cleanse_rinse: 'Thorough cleanse and rinse',
        shampoo_detangle: 'Detangle properly',
        shampoo_remove_residue: 'Remove residue or stains',
        shampoo_reset_sink: 'Reset the sink',
        formula_retention: 'Retain formula information',
        mixing_lightener: 'Mix lightener',
        mixing_glaze: 'Mix glaze',
        mixing_single_process: 'Mix single process color',
        bowl_labeling: 'Label and organize bowls',
        single_process_speed: 'Single process speed',
        single_process_saturation: 'Single process saturation',
        single_process_blending: 'Single process blending',
        single_process_clean_application: 'Clean application',
        single_process_application_method: 'Correct application method',
        single_process_timing_awareness: 'Timing awareness',
        understand_levels: 'Understand levels',
        foil_takedown: 'Foil takedown',
        rinsing_technique: 'Strong rinsing technique',
        shampoo_after_color: 'Shampoo correctly after color',
        glaze_prep: 'Prep for glaze properly',
        follow_direction: 'Follow direction',
        short_shadow: 'Short shadow work',
        long_shadow: 'Long shadow work',
        hairline_sectioning: 'Hairline sectioning',
        booked_model_blowdry: 'Booked model blowdries',
        consult_to_finish_blowdry: 'Consultation through finish',
        product_selection: 'Product selection',
        sectioning: 'Sectioning',
        timing: 'Timing',
        polish: 'Polish',
        guest_flow: 'Guest flow',
        finishing_standard: 'Hairstories finishing standard',
        beyond_blowdry_consistency: 'Consistency beyond blowdrys',
        haircut_standard: 'Haircut standard',
        single_process_standard: 'Single process standard',
        independent_service_standard: 'Independent service standard',
        all_assistant_days_traded_out: 'All assistant days traded out',
        retention_rebooking: 'Retention and rebooking',
        independent_operation: 'Independent operation',
        professionalism_timing_quality: 'Professionalism, timing, and quality',
        operational_value: 'Operational value',
        advanced_consistency: 'Advanced consistency',
        leadership_presence: 'Leadership presence',
        culture_support: 'Culture support',
        mentorship_visibility: 'Mentorship visibility',
        management_invitation: 'Management invitation',
        point_of_difference_confidence: 'Point of difference confidence',
        unique_client_experience: 'Unique client experience',
        articulate_value: 'Articulate value',
        staff_presentation_completed: 'Staff presentation completed',
        culture_fit: 'Culture fit'
      };

      var PROGRESSION_FOCUS_AREA_LABELS = {
        staff_page: 'Operations',
        clocking_in: 'Operations',
        station_reset: 'Operations',
        clean_cape_standard: 'Operations',
        towel_rollup_standard: 'Operations',
        chair_area_cleanliness: 'Operations',
        product_organization: 'Operations',
        towel_bin_management: 'Operations',
        laundry_procedures: 'Operations',
        clean_cape_storage: 'Operations',
        dish_station_organization: 'Operations',
        schedule_reading: 'Floor Awareness',
        appointment_status_awareness: 'Floor Awareness',
        service_finish_awareness: 'Floor Awareness',
        client_transfer_awareness: 'Floor Awareness',
        late_client_identification: 'Floor Awareness',
        running_behind_communication: 'Communication',
        front_desk_communication: 'Communication',
        understand_kp_vs_color_touch: 'Color Knowledge',
        glaze_formula_knowledge: 'Color Knowledge',
        color_formula_awareness: 'Color Knowledge',
        understand_service_being_applied: 'Color Knowledge',
        brush_from_ends: 'Prep and Detangling',
        detangle_around_ears: 'Prep and Detangling',
        extension_detangling: 'Prep and Detangling',
        proper_parting: 'Prep and Detangling',
        brushing_detangling: 'Prep and Detangling',
        foil_cutting: 'Foil Work',
        foil_separation: 'Foil Work',
        foil_stack_quality: 'Foil Work',
        foil_takedown: 'Foil Work',
        caping: 'Guest Setup',
        preguard: 'Guest Setup',
        client_prep: 'Guest Setup',
        greet_and_seat: 'Guest Setup',
        service_flow: 'Guest Experience',
        timing_handoffs: 'Guest Experience',
        guest_flow: 'Guest Experience',
        timer_management: 'Guest Experience',
        shampoo_products: 'Shampoo',
        shampoo_client_needs: 'Shampoo',
        shampoo_cleanse_rinse: 'Shampoo',
        shampoo_detangle: 'Shampoo',
        shampoo_remove_residue: 'Shampoo',
        shampoo_reset_sink: 'Shampoo',
        formula_retention: 'Color Formulation',
        bowl_labeling: 'Color Formulation',
        mixing_lightener: 'Color Formulation',
        mixing_glaze: 'Color Formulation',
        mixing_single_process: 'Color Formulation',
        understand_levels: 'Color Technique',
        rinsing_technique: 'Color Technique',
        shampoo_after_color: 'Color Technique',
        glaze_prep: 'Color Technique',
        follow_direction: 'Color Technique',
        short_shadow: 'Color Technique',
        long_shadow: 'Color Technique',
        hairline_sectioning: 'Color Technique',
        booked_model_blowdry: 'Blowdry',
        consult_to_finish_blowdry: 'Blowdry',
        product_selection: 'Blowdry',
        sectioning: 'Blowdry',
        timing: 'Blowdry',
        polish: 'Blowdry',
        finishing_standard: 'Blowdry',
        beyond_blowdry_consistency: 'Service Standards',
        haircut_standard: 'Service Standards',
        single_process_standard: 'Service Standards',
        independent_service_standard: 'Service Standards',
        hairstories_core_values: 'Leadership and Culture',
        all_assistant_days_traded_out: 'Business Readiness',
        retention_rebooking: 'Business Readiness',
        independent_operation: 'Business Readiness',
        professionalism_timing_quality: 'Leadership and Culture',
        operational_value: 'Leadership and Culture',
        advanced_consistency: 'Leadership and Culture',
        leadership_presence: 'Leadership and Culture',
        culture_support: 'Leadership and Culture',
        mentorship_visibility: 'Leadership and Culture',
        management_invitation: 'Leadership and Culture',
        point_of_difference_confidence: 'Brand and Positioning',
        unique_client_experience: 'Brand and Positioning',
        articulate_value: 'Brand and Positioning',
        staff_presentation_completed: 'Brand and Positioning',
        culture_fit: 'Leadership and Culture'
      };

      function normalizeTrainingBioKey(value){
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');
      }

      function isTrainingBioFocusMarkerKey(key){
        var normalized = normalizeTrainingBioKey(key);
        return normalized === 'focus_area' || normalized === 'group';
      }

      function parseTrainingBioChecklist(value){
        var flags = {};
        var sections = {};
        var itemFocusAreas = {};
        var currentSection = '';
        var currentFocusArea = '';
        var ignoredLegacyKeys = {
          blowdry_service_minimum_met: true,
          advanced_service_minimum_met: true
        };
        String(value || '').split(/\n+/).forEach(function(line){
          String(line || '').split(',').forEach(function(segment){
          var part = String(segment || '').trim();
          if (!part) return;
          var sectionMatch = part.match(/^(to_level_\d+|level_\d+_ongoing)\s*:\s*$/i);
          if (sectionMatch) {
            currentSection = normalizeTrainingBioKey(sectionMatch[1]);
            currentFocusArea = '';
            if (!sections[currentSection]) sections[currentSection] = [];
            return;
          }
          var matched = part.match(/^([^:=]+)\s*[:=]\s*(.+)$/);
          if (!matched) return;
          var key = normalizeTrainingBioKey(matched[1]);
          var rawValue = String(matched[2] || '').trim();
          if (!key || ignoredLegacyKeys[key]) return;
          if (isTrainingBioFocusMarkerKey(key)) {
            currentFocusArea = rawValue || '';
            return;
          }
          flags[key] = rawValue;
          if (currentFocusArea) {
            itemFocusAreas[key] = currentFocusArea;
          }
          if (currentSection) {
            if (!sections[currentSection]) sections[currentSection] = [];
            if (sections[currentSection].indexOf(key) === -1) sections[currentSection].push(key);
          }
          });
        });
        return {
          flags: flags,
          sections: sections,
          item_focus_areas: itemFocusAreas
        };
      }

      function bioFlagIsYes(flags, key){
        var value = String(flags && flags[key] || '').trim().toUpperCase();
        return value === 'YES' || value === 'Y' || value === 'TRUE' || value === 'PASS' || value === 'PASSED';
      }

      function parseProgressionDraftChecklist(draft){
        var sections = {};
        var flags = {};
        var itemFocusAreas = {};
        var itemDetails = {};
        var rawSections = Array.isArray(draft && draft.sections) ? draft.sections : [];

        rawSections.forEach(function(section){
          var sectionKey = normalizeTrainingBioKey(section && section.key);
          if (!sectionKey) return;
          if (!sections[sectionKey]) sections[sectionKey] = [];
          (Array.isArray(section && section.items) ? section.items : []).forEach(function(item){
            var key = normalizeTrainingBioKey(item && item.key);
            if (!key) return;
            flags[key] = String(item && item.value || '').trim();
            if (sections[sectionKey].indexOf(key) === -1) sections[sectionKey].push(key);
            var focusArea = String(item && item.focus_area || '').trim();
            if (focusArea) itemFocusAreas[key] = focusArea;
            itemDetails[sectionKey + ':' + key] = {
              requirement_id: String(item && item.requirement_id || '').trim(),
              signoff_required: item && item.signoff_required === true,
              checkpoint_description: String(item && item.checkpoint_description || '').trim(),
              staff_guidance: String(item && item.staff_guidance || '').trim(),
              manager_guidance: String(item && item.manager_guidance || '').trim(),
              training_status: String(item && item.training_status || '').trim(),
              audit_status: String(item && item.audit_status || '').trim(),
              signed_off_by: String(item && item.signed_off_by || '').trim(),
              signed_off_at: String(item && item.signed_off_at || '').trim(),
              audit_requested_at: String(item && item.audit_requested_at || '').trim(),
              audit_requested_by: String(item && item.audit_requested_by || '').trim(),
              audit_request_note: String(item && item.audit_request_note || '').trim(),
              audit_reviewed_at: String(item && item.audit_reviewed_at || '').trim(),
              audit_reviewed_by: String(item && item.audit_reviewed_by || '').trim(),
              audit_review_note: String(item && item.audit_review_note || '').trim()
            };
          });
        });

        return {
          flags: flags,
          sections: sections,
          item_focus_areas: itemFocusAreas,
          item_details: itemDetails
        };
      }

      function numericBioThreshold(flags, key, fallback){
        var value = Number(flags && flags[key]);
        return isFinite(value) ? value : fallback;
      }

      function numericBioThresholdFirst(flags, keys, fallback){
        var list = Array.isArray(keys) ? keys : [keys];
        for (var i = 0; i < list.length; i += 1) {
          var value = Number(flags && flags[list[i]]);
          if (isFinite(value)) return value;
        }
        return fallback;
      }

      function firstPresentBioThresholdKey(flags, keys){
        var list = Array.isArray(keys) ? keys : [keys];
        for (var i = 0; i < list.length; i += 1) {
          var key = String(list[i] || '').trim();
          if (!key) continue;
          var value = Number(flags && flags[key]);
          if (isFinite(value)) return key;
        }
        return '';
      }

      function isManualBioRequirementKey(key){
        var normalized = normalizeTrainingBioKey(key);
        return !!normalized
          && normalized.indexOf('_threshold') === -1
          && normalized !== 'blowdry_service_minimum_threshold'
          && normalized !== 'advanced_service_minimum_threshold'
          && normalized !== 'reliability_threshold_last_90_days'
          && normalized !== 'reliability_threshold_last_180_days'
          && normalized !== 'utilization_threshold_last_90_days'
          && normalized !== 'utilization_threshold_last_180_days'
          && normalized !== 'booked_hours_threshold_last_90_days'
          && normalized !== 'booked_hours_threshold_last_180_days';
      }

      function manualKeysForSection(parsedBio, sectionKey){
        var sections = parsedBio && parsedBio.sections && typeof parsedBio.sections === 'object'
          ? parsedBio.sections
          : {};
        return (sections[normalizeTrainingBioKey(sectionKey)] || []).filter(isManualBioRequirementKey);
      }

      function thresholdKeysForSection(parsedBio, sectionKey){
        var sections = parsedBio && parsedBio.sections && typeof parsedBio.sections === 'object'
          ? parsedBio.sections
          : {};
        return (sections[normalizeTrainingBioKey(sectionKey)] || []).filter(function(key){
          return String(key || '').indexOf('_threshold') >= 0;
        });
      }

      function firstPresentSectionThresholdKey(parsedBio, flags, sectionKey, keys){
        var allowed = thresholdKeysForSection(parsedBio, sectionKey);
        var list = Array.isArray(keys) ? keys : [keys];
        for (var i = 0; i < list.length; i += 1) {
          var key = normalizeTrainingBioKey(list[i]);
          if (!key || allowed.indexOf(key) === -1) continue;
          var value = Number(flags && flags[key]);
          if (isFinite(value)) return key;
        }
        return '';
      }

      function hasAnyProgressionBioContent(parsedBio){
        var sections = parsedBio && parsedBio.sections && typeof parsedBio.sections === 'object'
          ? parsedBio.sections
          : {};
        return Object.keys(sections).some(function(sectionKey){
          return manualKeysForSection(parsedBio, sectionKey).length > 0
            || thresholdKeysForSection(parsedBio, sectionKey).length > 0;
        });
      }

      function describeRequirementKey(key){
        return NEXT_MOVE_KEY_LABELS[key]
          || String(key || '').replace(/_/g, ' ').replace(/\b\w/g, function(match){ return match.toUpperCase(); });
      }

      function getProgressionFocusArea(key){
        var normalized = normalizeTrainingBioKey(key);
        if (!normalized) return 'General';
        if (PROGRESSION_FOCUS_AREA_LABELS[normalized]) {
          return PROGRESSION_FOCUS_AREA_LABELS[normalized];
        }
        if (/^(single_process_|mixing_|formula_|glaze_)/.test(normalized)) {
          return 'Color Formulation';
        }
        if (/^shampoo_/.test(normalized)) {
          return 'Shampoo';
        }
        if (/^foil_/.test(normalized)) {
          return 'Foil Work';
        }
        if (/_threshold(?:_|$)/.test(normalized)) {
          return 'Benchmarks';
        }
        return 'General';
      }

      function groupNextMoveItemsByFocusArea(items){
        var groups = [];
        (Array.isArray(items) ? items : []).forEach(function(item){
          if (!item) return;
          var focusArea = String(item.focus_area || '').trim() || 'General';
          var existing = groups.find(function(group){
            return group && group.label === focusArea;
          });
          if (!existing) {
            existing = {
              label: focusArea,
              items: []
            };
            groups.push(existing);
          }
          existing.items.push(item);
        });
        return groups;
      }

      function levelTitle(levelNumber){
        return LEVEL_TITLES[levelNumber] || ('Level ' + String(levelNumber || ''));
      }

      function formatCompactMetric(value, suffix){
        var numeric = Number(value);
        if (!isFinite(numeric)) return '—';
        if (Math.abs(numeric - Math.round(numeric)) < 0.05) {
          return String(Math.round(numeric)) + (suffix || '');
        }
        return numeric.toFixed(1) + (suffix || '');
      }

      function formatPercentMetricFromRatio(value){
        var numeric = Number(value);
        if (!isFinite(numeric)) return '—';
        return formatCompactMetric(numeric * 100, '%');
      }

      function normalizePercentThresholdForRatio(value){
        var numeric = Number(value);
        if (!isFinite(numeric)) return null;
        return numeric > 1 ? numeric / 100 : numeric;
      }

      function findServiceMixWindow(serviceMixWindows, preferredKey){
        var windows = Array.isArray(serviceMixWindows) ? serviceMixWindows : [];
        for (var i = 0; i < windows.length; i += 1) {
          if (windows[i] && windows[i].snapshot_key === preferredKey) return windows[i];
        }
        return windows[0] || null;
      }

      function sumServiceMixAppointments(serviceMixWindows, matcher, preferredSnapshotKey){
        var windowData = findServiceMixWindow(serviceMixWindows, preferredSnapshotKey || 'service_mix_last_90_days');
        var items = windowData && windowData.dataset && Array.isArray(windowData.dataset.items)
          ? windowData.dataset.items
          : [];
        return items.reduce(function(sum, item){
          var category = String(item && item.category || '').trim();
          if (!category) return sum;
          return matcher(category) ? sum + (Number(item.appointments) || 0) : sum;
        }, 0);
      }

      function isHaircutCategory(category){
        return String(category || '').trim().toLowerCase() === 'haircut';
      }

      function isSingleProcessCategory(category){
        var normalized = String(category || '').trim().toLowerCase();
        return normalized.indexOf('darker') >= 0 || normalized.indexOf('gray') >= 0;
      }

      function isKeratinCategory(category){
        return String(category || '').trim().toLowerCase() === 'treatments';
      }

      function isFoilCategory(category){
        var normalized = String(category || '').trim().toLowerCase();
        return normalized.indexOf('lighter') >= 0 || normalized.indexOf('highlight') >= 0;
      }

      function isBlowdryCategory(category){
        return String(category || '').trim().toLowerCase().indexOf('styling') >= 0;
      }

      function buildNextMoveRequirementItem(label, met, meta, tone, focusArea, details){
        return {
          label: label,
          met: !!met,
          meta: String(meta || '').trim(),
          tone: tone || (met ? 'done' : 'todo'),
          focus_area: String(focusArea || '').trim() || 'General',
          details: details && typeof details === 'object' ? {
            checkpoint_description: String(details.checkpoint_description || '').trim(),
            requirement_id: String(details.requirement_id || '').trim(),
            signoff_required: details.signoff_required === true,
            staff_guidance: String(details.staff_guidance || '').trim(),
            manager_guidance: String(details.manager_guidance || '').trim(),
            training_status: String(details.training_status || '').trim(),
            audit_status: String(details.audit_status || '').trim(),
            signed_off_by: String(details.signed_off_by || '').trim(),
            signed_off_at: String(details.signed_off_at || '').trim(),
            audit_requested_at: String(details.audit_requested_at || '').trim(),
            audit_requested_by: String(details.audit_requested_by || '').trim(),
            audit_request_note: String(details.audit_request_note || '').trim(),
            audit_reviewed_at: String(details.audit_reviewed_at || '').trim(),
            audit_reviewed_by: String(details.audit_reviewed_by || '').trim(),
            audit_review_note: String(details.audit_review_note || '').trim(),
            section_key: String(details.section_key || '').trim(),
            item_key: String(details.item_key || '').trim(),
            approvable: details.approvable === true,
            requestable: details.requestable === true
          } : null
        };
      }

      function getSectionRequirementDetails(parsedBio, sectionKey, itemKey){
        var allDetails = parsedBio && parsedBio.item_details && typeof parsedBio.item_details === 'object'
          ? parsedBio.item_details
          : {};
        var normalizedSectionKey = normalizeTrainingBioKey(sectionKey);
        var normalizedItemKey = normalizeTrainingBioKey(itemKey);
        if (!normalizedSectionKey || !normalizedItemKey) return null;
        var details = allDetails[normalizedSectionKey + ':' + normalizedItemKey];
        if (!details || typeof details !== 'object') return null;
        var checkpointDescription = String(details.checkpoint_description || '').trim();
        var staffGuidance = String(details.staff_guidance || '').trim();
        var managerGuidance = String(details.manager_guidance || '').trim();
        var requirementId = String(details.requirement_id || '').trim();
        var signoffRequired = details.signoff_required === true;
        var trainingStatus = String(details.training_status || '').trim();
        var auditStatus = String(details.audit_status || '').trim();
        var signedOffBy = String(details.signed_off_by || '').trim();
        var signedOffAt = String(details.signed_off_at || '').trim();
        var auditRequestedAt = String(details.audit_requested_at || '').trim();
        var auditRequestedBy = String(details.audit_requested_by || '').trim();
        var auditRequestNote = String(details.audit_request_note || '').trim();
        var auditReviewedAt = String(details.audit_reviewed_at || '').trim();
        var auditReviewedBy = String(details.audit_reviewed_by || '').trim();
        var auditReviewNote = String(details.audit_review_note || '').trim();
        var approvable = isManualBioRequirementKey(normalizedItemKey);
        var requestable = approvable && signoffRequired;
        if (!checkpointDescription && !staffGuidance && !managerGuidance && !signedOffBy && !signedOffAt && !requestable) return null;
        return {
          checkpoint_description: checkpointDescription,
          requirement_id: requirementId,
          signoff_required: signoffRequired,
          staff_guidance: staffGuidance,
          manager_guidance: managerGuidance,
          training_status: trainingStatus,
          audit_status: auditStatus,
          signed_off_by: signedOffBy,
          signed_off_at: signedOffAt,
          audit_requested_at: auditRequestedAt,
          audit_requested_by: auditRequestedBy,
          audit_request_note: auditRequestNote,
          audit_reviewed_at: auditReviewedAt,
          audit_reviewed_by: auditReviewedBy,
          audit_review_note: auditReviewNote,
          section_key: normalizedSectionKey,
          item_key: normalizedItemKey,
          approvable: approvable,
          requestable: requestable
        };
      }

      function formatSignedOffTimestamp(value){
        var parsed = new Date(value);
        if (isNaN(parsed.getTime())) return '';
        return parsed.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function getNextMoveApprovalDetailKey(sectionKey, itemKey){
        return String(sectionKey || '').trim() + ':' + String(itemKey || '').trim();
      }

      function isNextMoveItemQuickApprovable(item){
        var details = item && item.details && typeof item.details === 'object' ? item.details : null;
        return !!(details
          && details.approvable === true
          && item && item.met !== true
          && details.section_key
          && details.item_key);
      }

      function collectNextMoveQuickApprovalEntries(state){
        return (Array.isArray(state && state.todo) ? state.todo : []).map(function(item){
          if (!isNextMoveItemQuickApprovable(item)) return null;
          var details = item.details;
          return {
            detail_key: getNextMoveApprovalDetailKey(details.section_key, details.item_key),
            section_key: String(details.section_key || '').trim(),
            item_key: String(details.item_key || '').trim(),
            label: String(item && item.label || '').trim()
          };
        }).filter(Boolean);
      }

      function pruneSelectedNextMoveApprovalKeys(state){
        var allowed = {};
        collectNextMoveQuickApprovalEntries(state).forEach(function(entry){
          allowed[entry.detail_key] = true;
        });
        Object.keys(selectedNextMoveApprovalKeys).forEach(function(detailKey){
          if (!allowed[detailKey]) delete selectedNextMoveApprovalKeys[detailKey];
        });
      }

      function setNextMoveApprovalSelected(detailKey, isSelected){
        var normalizedKey = String(detailKey || '').trim();
        if (!normalizedKey) return;
        if (isSelected) {
          selectedNextMoveApprovalKeys[normalizedKey] = true;
        } else {
          delete selectedNextMoveApprovalKeys[normalizedKey];
        }
      }

      function getSelectedNextMoveApprovalEntries(state){
        return collectNextMoveQuickApprovalEntries(state).filter(function(entry){
          return selectedNextMoveApprovalKeys[entry.detail_key] === true;
        });
      }

      function syncNextMoveBulkSelectionUi(){
        if (!nextMoveMount) return;
        var toggles = Array.prototype.slice.call(nextMoveMount.querySelectorAll('[data-next-move-select-toggle]'));
        var total = toggles.length;
        var selected = 0;
        toggles.forEach(function(toggle){
          var detailKey = String(toggle.getAttribute('data-next-move-select-toggle') || '').trim();
          var isChecked = selectedNextMoveApprovalKeys[detailKey] === true;
          toggle.checked = isChecked;
          var itemNode = toggle.closest('.next-move-item');
          if (itemNode) itemNode.classList.toggle('is-bulk-selected', isChecked);
          if (isChecked) selected += 1;
        });
        Array.prototype.slice.call(nextMoveMount.querySelectorAll('[data-next-move-bulk-selected-count]')).forEach(function(node){
          node.textContent = String(selected);
        });
        Array.prototype.slice.call(nextMoveMount.querySelectorAll('[data-next-move-bulk-total-count]')).forEach(function(node){
          node.textContent = String(total);
        });
        Array.prototype.slice.call(nextMoveMount.querySelectorAll('[data-next-move-bulk-approve]')).forEach(function(node){
          if (node.getAttribute('data-bulk-loading') === 'true') return;
          node.disabled = selected === 0;
        });
        Array.prototype.slice.call(nextMoveMount.querySelectorAll('[data-next-move-clear-selected]')).forEach(function(node){
          node.disabled = selected === 0;
        });
        Array.prototype.slice.call(nextMoveMount.querySelectorAll('[data-next-move-select-all]')).forEach(function(node){
          node.disabled = total === 0 || selected === total;
        });
      }

      function applyLoggedInProgressionSave(saveData){
        currentLoggedInProgressionState = {
          staff: saveData.staff,
          profile: saveData.profile || null,
          draft: saveData.draft
        };
        currentLoggedInStaff = Object.assign({}, currentLoggedInStaff, saveData.staff || {});
        try {
          window.localStorage.setItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY, JSON.stringify(currentLoggedInStaff));
        } catch (_error) {
        }
        persistSharedStaffSession(currentLoggedInStaff);
      }

      function rerenderLoggedInNextMove(){
        var kpiSummary = currentSales90Summary || currentSalesYtdSummary || getPersonalKpiSummaryForBenchmarks() || null;
        currentRenderedNextMoveState = buildNextMoveState(
          String((currentLoggedInStaff && currentLoggedInStaff.role) || '').trim(),
          currentLoggedInStaff && currentLoggedInStaff.bio,
          currentAttendance90Row,
          kpiSummary,
          currentServiceMixWindows,
          currentLoggedInProgressionState
        );
        renderNextMove(currentRenderedNextMoveState);
      }

      async function authorizeProgressionEditorPin(pinValue){
        var trimmedPin = String(pinValue || '').trim();
        if (!trimmedPin) {
          throw new Error('Enter manager code.');
        }
        var authResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'progression-editor-auth',
            pin: trimmedPin
          })
        });
        var authRawText = await authResponse.text();
        var authData = null;
        try {
          authData = authRawText ? JSON.parse(authRawText) : null;
        } catch (_error) {
          authData = null;
        }
        if (!authResponse.ok || !authData || !authData.ok || !authData.editor) {
          throw new Error((authData && authData.error) || authRawText || 'Could not authorize manager code.');
        }
        return authData.editor;
      }

      async function saveLoggedInProgressionDraft(nextDraft, editorStaffId){
        var saveResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'progression-staff-save',
            staff_id: currentLoggedInStaff.id,
            role_id: currentLoggedInStaff.role_id || '',
            bio: nextDraft.raw,
            editor_staff_id: String(editorStaffId || '').trim()
          })
        });
        var saveRawText = await saveResponse.text();
        var saveData = null;
        try {
          saveData = saveRawText ? JSON.parse(saveRawText) : null;
        } catch (_error) {
          saveData = null;
        }
        if (!saveResponse.ok || !saveData || !saveData.ok || !saveData.staff || !saveData.draft) {
          throw new Error((saveData && saveData.error) || saveRawText || 'Could not save progression approval.');
        }
        applyLoggedInProgressionSave(saveData);
        return saveData;
      }

      function renderNextMoveItemDetails(item){
        var details = item && item.details && typeof item.details === 'object' ? item.details : null;
        if (!details) return '';
        var description = String(details.checkpoint_description || '').trim();
        var staffGuidance = String(details.staff_guidance || '').trim();
        var trainingStatus = String(details.training_status || '').trim().toLowerCase();
        var auditStatus = String(details.audit_status || '').trim().toLowerCase();
        var signedOffBy = String(details.signed_off_by || '').trim();
        var signedOffAt = formatSignedOffTimestamp(details.signed_off_at);
        var auditRequestedAt = formatSignedOffTimestamp(details.audit_requested_at);
        var auditRequestedBy = String(details.audit_requested_by || '').trim();
        var auditRequestNote = String(details.audit_request_note || '').trim();
        var auditReviewedAt = formatSignedOffTimestamp(details.audit_reviewed_at);
        var auditReviewedBy = String(details.audit_reviewed_by || '').trim();
        var auditReviewNote = String(details.audit_review_note || '').trim();
        var canQuickApprove = details.approvable === true
          && item && item.met !== true
          && details.section_key
          && details.item_key;
        var canRequestAudit = details.requestable === true
          && item && item.met !== true
          && details.section_key
          && details.item_key
          && auditStatus !== 'requested';
        var detailKey = String(details.section_key || '').trim() + ':' + String(details.item_key || '').trim();
        if (!description && !staffGuidance && !signedOffBy && !signedOffAt && !canQuickApprove && !canRequestAudit && auditStatus !== 'requested' && auditStatus !== 'denied') return '';
        return ''
          + '<details class="next-move-itemDetails">'
          +   '<summary class="next-move-itemDetailsToggle">View details</summary>'
          +   '<div class="next-move-itemDetailsBody">'
          +     (description
                ? '<div class="next-move-itemDetailBlock">'
                    + '<div class="next-move-itemDetailLabel">Checkpoint</div>'
                    + '<p class="next-move-itemDetailCopy">' + escapeHtml(description) + '</p>'
                  + '</div>'
                : '')
          +     (staffGuidance
                ? '<div class="next-move-itemDetailBlock">'
                    + '<div class="next-move-itemDetailLabel">How to nail it</div>'
                    + '<p class="next-move-itemDetailCopy">' + escapeHtml(staffGuidance) + '</p>'
                  + '</div>'
                : '')
          +     ((signedOffBy || signedOffAt)
                ? '<div class="next-move-itemDetailBlock">'
                    + '<div class="next-move-itemDetailLabel">Signed off</div>'
                    + '<p class="next-move-itemDetailCopy">' + escapeHtml([signedOffBy ? ('By ' + signedOffBy) : '', signedOffAt ? ('on ' + signedOffAt) : ''].filter(Boolean).join(' ')) + '</p>'
                  + '</div>'
                : '')
          +     (auditStatus === 'requested'
                ? '<div class="next-move-itemDetailBlock">'
                    + '<div class="next-move-itemDetailLabel">Audit requested</div>'
                    + '<p class="next-move-itemDetailCopy">' + escapeHtml([auditRequestedBy ? ('Requested by ' + auditRequestedBy) : '', auditRequestedAt ? ('on ' + auditRequestedAt) : ''].filter(Boolean).join(' ')) + '</p>'
                    + (auditRequestNote ? '<p class="next-move-itemDetailCopy">' + escapeHtml(auditRequestNote) + '</p>' : '')
                  + '</div>'
                : '')
          +     (auditStatus === 'denied'
                ? '<div class="next-move-itemDetailBlock">'
                    + '<div class="next-move-itemDetailLabel">Manager feedback</div>'
                    + '<p class="next-move-itemDetailCopy">' + escapeHtml([auditReviewedBy ? ('Reviewed by ' + auditReviewedBy) : '', auditReviewedAt ? ('on ' + auditReviewedAt) : ''].filter(Boolean).join(' ')) + '</p>'
                    + (auditReviewNote ? '<p class="next-move-itemDetailCopy">' + escapeHtml(auditReviewNote) + '</p>' : '')
                  + '</div>'
                : '')
          +     (canQuickApprove
                ? '<div class="next-move-itemApprove">'
                    + '<div class="next-move-itemDetailLabel">Quick manager sign off</div>'
                    + '<div class="next-move-itemApproveRow">'
                      + '<input class="next-move-itemApproveInput" type="password" inputmode="numeric" autocomplete="one-time-code" placeholder="Manager code" data-next-move-approve-pin="' + escapeHtml(detailKey) + '" />'
                      + '<button class="btn-primary next-move-itemApproveBtn" type="button" data-next-move-approve="' + escapeHtml(detailKey) + '" data-section-key="' + escapeHtml(details.section_key) + '" data-item-key="' + escapeHtml(details.item_key) + '">Sign Off</button>'
                    + '</div>'
                    + '<div class="next-move-itemApproveStatus" data-next-move-approve-status="' + escapeHtml(detailKey) + '">Use a manager code to sign this off right now.</div>'
                  + '</div>'
                : '')
          +     (canRequestAudit
                ? '<div class="next-move-itemApprove">'
                    + '<div class="next-move-itemDetailLabel">Request manager audit</div>'
                    + '<div class="next-move-itemApproveRow">'
                      + '<button class="btn-secondary next-move-itemApproveBtn" type="button" data-next-move-audit-request="' + escapeHtml(detailKey) + '" data-section-key="' + escapeHtml(details.section_key) + '" data-item-key="' + escapeHtml(details.item_key) + '">Request Audit</button>'
                    + '</div>'
                    + '<div class="next-move-itemApproveStatus" data-next-move-audit-status="' + escapeHtml(detailKey) + '">Send this checkpoint to the manager audit queue.</div>'
                  + '</div>'
                : '')
          +   '</div>'
          + '</details>';
      }

      function renderNextMoveAuditFeedbackSummary(item){
        var details = item && item.details && typeof item.details === 'object' ? item.details : null;
        if (!details) return '';
        var auditStatus = String(details.audit_status || '').trim().toLowerCase();
        var auditReviewNote = String(details.audit_review_note || '').trim();
        if (auditStatus !== 'denied' || !auditReviewNote) return '';
        return '<p class="next-move-itemMeta">Manager feedback: ' + escapeHtml(auditReviewNote) + '</p>';
      }

      function buildProgressionV2BioFromDraft(draft){
        var sections = Array.isArray(draft && draft.sections) ? draft.sections : [];
        return sections.map(function(section){
          var lines = [String(section && section.key || '').trim() + ':'];
          var lastFocusArea = '';
          (Array.isArray(section && section.items) ? section.items : []).forEach(function(item){
            var focusArea = String(item && item.focus_area || '').trim();
            if (focusArea && focusArea !== lastFocusArea) {
              lines.push('focus_area=' + focusArea + ',');
              lastFocusArea = focusArea;
            }
            lines.push(normalizeTrainingBioKey(item && item.key) + '=' + String(item && item.value || '').trim() + ',');
          });
          return lines.join('\n');
        }).join('\n\n').trim();
      }

      function cloneProgressionDraftWithCheckpointValue(draft, sectionKey, itemKey, nextValue){
        var found = false;
        var clonedSections = (Array.isArray(draft && draft.sections) ? draft.sections : []).map(function(section){
          var normalizedSectionKey = normalizeTrainingBioKey(section && section.key);
          var clonedItems = (Array.isArray(section && section.items) ? section.items : []).map(function(item){
            if (normalizedSectionKey === normalizeTrainingBioKey(sectionKey) && normalizeTrainingBioKey(item && item.key) === normalizeTrainingBioKey(itemKey)) {
              found = true;
              return Object.assign({}, item, { value: String(nextValue || '').trim() });
            }
            return Object.assign({}, item);
          });
          return Object.assign({}, section, { items: clonedItems });
        });
        return {
          found: found,
          draft: {
            raw: buildProgressionV2BioFromDraft({ sections: clonedSections }),
            sections: clonedSections
          }
        };
      }

      async function requestNextMoveCheckpointAudit(sectionKey, itemKey, statusNode, buttonNode){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) {
          throw new Error('No staff member is logged in.');
        }
        if (statusNode) {
          statusNode.textContent = 'Sending audit request...';
          statusNode.setAttribute('data-tone', '');
        }
        if (buttonNode) {
          buttonNode.disabled = true;
          buttonNode.textContent = 'Requesting';
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'progression-audit-request',
            staff_id: currentLoggedInStaff.id,
            section_key: sectionKey,
            item_key: itemKey
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.staff || !data.draft) {
          throw new Error((data && data.error) || rawText || 'Could not request checkpoint audit.');
        }
        applyLoggedInProgressionSave(data);
        if (statusNode) {
          statusNode.textContent = 'Audit request sent to managers.';
          statusNode.setAttribute('data-tone', 'success');
        }
        rerenderLoggedInNextMove();
      }

      async function approveNextMoveCheckpoint(sectionKey, itemKey, pinValue, statusNode, buttonNode){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) {
          throw new Error('No staff member is logged in.');
        }
        if (!currentLoggedInProgressionState || !currentLoggedInProgressionState.draft) {
          throw new Error('Progression state is not loaded yet.');
        }
        if (statusNode) {
          statusNode.textContent = 'Authorizing manager code...';
          statusNode.setAttribute('data-tone', '');
        }
        if (buttonNode) {
          buttonNode.disabled = true;
          buttonNode.textContent = 'Approving';
        }
        var editor = await authorizeProgressionEditorPin(pinValue);
        var nextDraftResult = cloneProgressionDraftWithCheckpointValue(currentLoggedInProgressionState.draft, sectionKey, itemKey, 'YES');
        if (!nextDraftResult.found) {
          throw new Error('Could not find that checkpoint in the current progression draft.');
        }
        if (statusNode) {
          statusNode.textContent = 'Saving approval...';
          statusNode.setAttribute('data-tone', '');
        }
        await saveLoggedInProgressionDraft(nextDraftResult.draft, editor && editor.staff_id);
        setNextMoveApprovalSelected(getNextMoveApprovalDetailKey(sectionKey, itemKey), false);
        if (statusNode) {
          statusNode.textContent = 'Approved and signed off.';
          statusNode.setAttribute('data-tone', 'success');
        }
        rerenderLoggedInNextMove();
      }

      async function approveSelectedNextMoveCheckpoints(selectedEntries, pinValue, statusNode, buttonNode){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) {
          throw new Error('No staff member is logged in.');
        }
        if (!currentLoggedInProgressionState || !currentLoggedInProgressionState.draft) {
          throw new Error('Progression state is not loaded yet.');
        }
        if (!Array.isArray(selectedEntries) || !selectedEntries.length) {
          throw new Error('Select at least one card.');
        }
        if (statusNode) {
          statusNode.textContent = 'Authorizing manager code...';
          statusNode.setAttribute('data-tone', '');
        }
        if (buttonNode) {
          buttonNode.disabled = true;
          buttonNode.textContent = 'Signing Off';
          buttonNode.setAttribute('data-bulk-loading', 'true');
        }
        var editor = await authorizeProgressionEditorPin(pinValue);
        var nextDraft = currentLoggedInProgressionState.draft;
        var appliedCount = 0;
        selectedEntries.forEach(function(entry){
          var draftResult = cloneProgressionDraftWithCheckpointValue(nextDraft, entry.section_key, entry.item_key, 'YES');
          if (draftResult.found) {
            nextDraft = draftResult.draft;
            appliedCount += 1;
          }
        });
        if (!appliedCount) {
          throw new Error('Could not find those checkpoints in the current progression draft.');
        }
        if (statusNode) {
          statusNode.textContent = appliedCount === 1
            ? 'Saving 1 sign off...'
            : 'Saving ' + String(appliedCount) + ' sign offs...';
          statusNode.setAttribute('data-tone', '');
        }
        await saveLoggedInProgressionDraft(nextDraft, editor && editor.staff_id);
        selectedEntries.forEach(function(entry){
          setNextMoveApprovalSelected(entry.detail_key, false);
        });
        if (statusNode) {
          statusNode.textContent = appliedCount === 1
            ? '1 checkpoint signed off.'
            : String(appliedCount) + ' checkpoints signed off.';
          statusNode.setAttribute('data-tone', 'success');
        }
        rerenderLoggedInNextMove();
      }

      function buildNextMoveState(role, bio, attendanceRow, kpiSummary, serviceMixWindows, progressionState){
        var progressionProfile = progressionState && progressionState.profile && typeof progressionState.profile === 'object'
          ? progressionState.profile
          : null;
        var progressionDraft = progressionState && progressionState.draft && typeof progressionState.draft === 'object'
          ? progressionState.draft
          : null;
        var levelNumber = progressionProfile && progressionProfile.current_level != null
          ? Number(progressionProfile.current_level)
          : parseRoleLevelNumber(role);
        if (levelNumber == null) return null;

        var parsedBio = progressionDraft
          ? parseProgressionDraftChecklist(progressionDraft)
          : parseTrainingBioChecklist(bio);
        var flags = parsedBio.flags || {};
        var itemFocusAreas = parsedBio.item_focus_areas || {};
        var isTopPublishedLevel = levelNumber >= 7;
        var nextLevelNumber = progressionProfile && progressionProfile.target_level != null
          ? Number(progressionProfile.target_level)
          : (isTopPublishedLevel ? null : levelNumber + 1);
        var nextLevelSectionKey = isTopPublishedLevel
          ? 'level_7_ongoing'
          : 'to_level_' + String(nextLevelNumber);
        if (!hasAnyProgressionBioContent(parsedBio)) {
          return {
            current_level: levelNumber,
            next_level: nextLevelNumber,
            next_label: nextLevelNumber != null ? levelTitle(nextLevelNumber) : 'Level 7 Ongoing',
            title: 'Next Move',
            subtitle: 'Your progression map has not been loaded yet.',
            empty_banner: progressionDraft
              ? 'Your progression profile is active, but no checklist has been loaded for this level yet.'
              : 'Manager needs to load your progression map in the Boulevard bio field.'
          };
        }
        var done = [];
        var todo = [];
        var seenTodoKeys = {};
        var reliabilityThresholdKey = firstPresentSectionThresholdKey(parsedBio, flags, nextLevelSectionKey, ['reliability_threshold_last_90_days', 'reliability_threshold_last_180_days']);
        var reliabilityThreshold = reliabilityThresholdKey ? Number(flags[reliabilityThresholdKey]) : null;
        var bookedHoursThresholdKey = firstPresentSectionThresholdKey(parsedBio, flags, nextLevelSectionKey, ['booked_hours_threshold_last_90_days', 'booked_hours_threshold_last_180_days']);
        var bookedHoursThreshold = bookedHoursThresholdKey ? Number(flags[bookedHoursThresholdKey]) : null;
        var utilizationThresholdKey = firstPresentSectionThresholdKey(parsedBio, flags, nextLevelSectionKey, ['utilization_threshold_last_90_days', 'utilization_threshold_last_180_days']);
        var utilizationThreshold = utilizationThresholdKey ? Number(flags[utilizationThresholdKey]) : null;
        var normalizedUtilizationThreshold = normalizePercentThresholdForRatio(utilizationThreshold);
        var normalizedAttendanceRow = normalizeAttendanceRowForBenchmarks(attendanceRow, currentAttendance90SnapshotDate || currentAttendanceYtdSnapshotDate);
        var reliabilityValue = normalizedAttendanceRow && normalizedAttendanceRow.reliability_score != null ? Number(normalizedAttendanceRow.reliability_score) : null;
        var resolvedKpiSummary = resolveCurrentStaffKpiSummaryForBenchmarks(kpiSummary);
        var hasKpiData = hasStaffKpiSummaryData(resolvedKpiSummary);
        var bookedHoursValue = hasKpiData ? getStaffKpiMetricNumber(resolvedKpiSummary, 'Hours Booked') : null;
        var utilizationValue = hasKpiData ? getStaffKpiMetricNumber(resolvedKpiSummary, 'Utilization %') : null;
        var hasReliabilityThreshold = Number.isFinite(reliabilityThreshold);
        var hasBookedHoursThreshold = Number.isFinite(bookedHoursThreshold);
        var hasUtilizationThreshold = Number.isFinite(utilizationThreshold);
        var hasReliabilityValue = Number.isFinite(reliabilityValue);
        var hasBookedHoursValue = Number.isFinite(bookedHoursValue);
        var hasUtilizationValue = Number.isFinite(utilizationValue);
        var hasServiceMix90DayWindow = !!findServiceMixWindow(serviceMixWindows, 'service_mix_last_90_days');
        var hasServiceMix180DayWindow = !!findServiceMixWindow(serviceMixWindows, 'service_mix_last_180_days');

        function pushNextLevelItem(item){
          if (!item) return;
          if (item.met) {
            done.push(item);
            return;
          }
          var todoKey = String(item.todo_key || item.label || '').trim().toLowerCase();
          if (todoKey && seenTodoKeys[todoKey]) return;
          if (todoKey) seenTodoKeys[todoKey] = true;
          todo.push(item);
        }

        function pushCarryoverTodo(item){
          if (!item || item.met) return;
          var todoKey = String(item.todo_key || item.label || '').trim().toLowerCase();
          if (todoKey && seenTodoKeys[todoKey]) return;
          if (todoKey) seenTodoKeys[todoKey] = true;
          todo.push(item);
        }

        manualKeysForSection(parsedBio, nextLevelSectionKey).forEach(function(key){
          var manualMet = bioFlagIsYes(flags, key);
          pushNextLevelItem(buildNextMoveRequirementItem(
            describeRequirementKey(key),
            manualMet,
            '',
            '',
            String(itemFocusAreas[key] || '').trim() || getProgressionFocusArea(key),
            getSectionRequirementDetails(parsedBio, nextLevelSectionKey, key)
          ));
        });

        for (var priorLevel = 1; priorLevel <= levelNumber; priorLevel += 1) {
          manualKeysForSection(parsedBio, 'to_level_' + String(priorLevel)).forEach(function(key){
            if (bioFlagIsYes(flags, key)) return;
            pushCarryoverTodo({
              label: describeRequirementKey(key),
              met: false,
              meta: 'Carryover from ' + levelTitle(priorLevel - 1) + '.',
              tone: 'todo',
              focus_area: String(itemFocusAreas[key] || '').trim() || getProgressionFocusArea(key),
              todo_key: 'carryover_' + key,
              details: getSectionRequirementDetails(parsedBio, 'to_level_' + String(priorLevel), key)
            });
          });
        }

        if (levelNumber === 2) {
          var blowdryThresholdKey = firstPresentSectionThresholdKey(parsedBio, flags, nextLevelSectionKey, 'blowdry_service_minimum_threshold');
          if (blowdryThresholdKey) {
            var blowdryThreshold = Number(flags[blowdryThresholdKey]);
            var blowdryCount = sumServiceMixAppointments(serviceMixWindows, isBlowdryCategory, 'service_mix_last_90_days');
            pushNextLevelItem(buildNextMoveRequirementItem(
              'Booked and checked-out blowdry services',
              hasServiceMix90DayWindow && isFinite(blowdryCount) && blowdryCount >= blowdryThreshold,
              hasServiceMix90DayWindow
                ? (formatCompactMetric(blowdryCount, '') + ' / ' + String(blowdryThreshold) + ' in the last 90 days.')
                : 'Awaiting the current 90-day service mix snapshot.',
              hasServiceMix90DayWindow && isFinite(blowdryCount) && blowdryCount >= blowdryThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, blowdryThresholdKey)
            ));
          }
        }

        if (levelNumber === 3) {
          var advancedThresholdKey = firstPresentSectionThresholdKey(parsedBio, flags, nextLevelSectionKey, 'advanced_service_minimum_threshold');
          if (advancedThresholdKey) {
            var advancedThreshold = 20;
            var haircutCount = sumServiceMixAppointments(serviceMixWindows, isHaircutCategory, 'service_mix_last_180_days');
            var singleProcessCount = sumServiceMixAppointments(serviceMixWindows, isSingleProcessCategory, 'service_mix_last_180_days');
            var keratinCount = sumServiceMixAppointments(serviceMixWindows, isKeratinCategory, 'service_mix_last_180_days');
            var foilCount = sumServiceMixAppointments(serviceMixWindows, isFoilCategory, 'service_mix_last_180_days');
            var combinedAdvancedCount = haircutCount + singleProcessCount + keratinCount + foilCount;
            pushNextLevelItem(buildNextMoveRequirementItem(
              '20 Non-Blowdry Services (180 Day Lookback)',
              hasServiceMix180DayWindow && combinedAdvancedCount >= advancedThreshold,
              hasServiceMix180DayWindow
                ? ('Haircut ' + formatCompactMetric(haircutCount, '')
                    + ' · Single process ' + formatCompactMetric(singleProcessCount, '')
                    + ' · Keratin ' + formatCompactMetric(keratinCount, '')
                    + ' · Foil ' + formatCompactMetric(foilCount, '')
                    + ' · Combined ' + formatCompactMetric(combinedAdvancedCount, '')
                    + ' in the last 180 days')
                : 'Awaiting the current 180-day service mix snapshot.',
              hasServiceMix180DayWindow && combinedAdvancedCount >= advancedThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, advancedThresholdKey)
            ));
          }
          if (hasReliabilityThreshold) {
            pushNextLevelItem(buildNextMoveRequirementItem(
              'Reliability target',
              hasReliabilityValue && reliabilityValue >= reliabilityThreshold,
              (hasReliabilityValue ? formatCompactMetric(reliabilityValue, '%') : 'No current score')
                + ' / ' + String(reliabilityThreshold) + '% target in the last 365 days',
              hasReliabilityValue && reliabilityValue >= reliabilityThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, reliabilityThresholdKey)
            ));
          }
          if (hasBookedHoursThreshold) {
            pushNextLevelItem(buildNextMoveRequirementItem(
              'Booked hours target',
              hasBookedHoursValue && bookedHoursValue >= bookedHoursThreshold,
              (hasBookedHoursValue ? formatCompactMetric(bookedHoursValue, '') : 'No current score')
                + ' / ' + String(bookedHoursThreshold) + ' booked hours target in the last 365 days',
              hasBookedHoursValue && bookedHoursValue >= bookedHoursThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, bookedHoursThresholdKey)
            ));
          }
          if (hasUtilizationThreshold) {
            pushNextLevelItem(buildNextMoveRequirementItem(
              'Utilization target',
              hasUtilizationValue && Number.isFinite(normalizedUtilizationThreshold) && utilizationValue >= normalizedUtilizationThreshold,
              (hasUtilizationValue ? formatPercentMetricFromRatio(utilizationValue) : 'No current score')
                + ' / ' + String(utilizationThreshold) + '% utilization target in the last 365 days',
              hasUtilizationValue && Number.isFinite(normalizedUtilizationThreshold) && utilizationValue >= normalizedUtilizationThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, utilizationThresholdKey)
            ));
          }
        }

        if (levelNumber >= 4) {
          if (hasReliabilityThreshold) {
            pushNextLevelItem(buildNextMoveRequirementItem(
              'Reliability target',
              hasReliabilityValue && reliabilityValue >= reliabilityThreshold,
              (hasReliabilityValue ? formatCompactMetric(reliabilityValue, '%') : 'No current score')
                + ' / ' + String(reliabilityThreshold) + '% target from the current 365-day attendance snapshot',
              hasReliabilityValue && reliabilityValue >= reliabilityThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, reliabilityThresholdKey)
            ));
          }
          if (hasBookedHoursThreshold) {
            pushNextLevelItem(buildNextMoveRequirementItem(
              'Booked hours target',
              hasBookedHoursValue && bookedHoursValue >= bookedHoursThreshold,
              (hasBookedHoursValue ? formatCompactMetric(bookedHoursValue, '') : 'No current score')
                + ' / ' + String(bookedHoursThreshold) + ' booked hours target from the current 90-day KPI snapshot',
              hasBookedHoursValue && bookedHoursValue >= bookedHoursThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, bookedHoursThresholdKey)
            ));
          }
          if (hasUtilizationThreshold) {
            pushNextLevelItem(buildNextMoveRequirementItem(
              'Utilization target',
              hasUtilizationValue && Number.isFinite(normalizedUtilizationThreshold) && utilizationValue >= normalizedUtilizationThreshold,
              (hasUtilizationValue ? formatPercentMetricFromRatio(utilizationValue) : 'No current score')
                + ' / ' + String(utilizationThreshold) + '% target from the current 90-day KPI snapshot',
              hasUtilizationValue && Number.isFinite(normalizedUtilizationThreshold) && utilizationValue >= normalizedUtilizationThreshold ? 'done' : 'todo',
              'Benchmarks',
              getSectionRequirementDetails(parsedBio, nextLevelSectionKey, utilizationThresholdKey)
            ));
          }
        }

        if (!done.length && !todo.length) {
          return {
            current_level: levelNumber,
            next_level: nextLevelNumber,
            next_label: nextLevelNumber != null ? levelTitle(nextLevelNumber) : 'Level 7 Ongoing',
            status_banner: nextLevelNumber == null
              ? {
                  label: 'Current status',
                  title: 'You are at the top published level',
                  copy: 'There is no active next move right now. Keep maintaining your current standards.',
                  status_text: 'No active next move right now.'
                }
              : {
                  label: 'Current status',
                  title: 'Nothing is currently in motion',
                  copy: 'There are no completed or active progression checkpoints showing for this step right now.',
                  status_text: 'No active next move right now.'
                }
          };
        }

        return {
          current_level: levelNumber,
          next_level: nextLevelNumber,
          next_label: nextLevelNumber != null ? levelTitle(nextLevelNumber) : 'Level 7 Ongoing',
          subtitle: nextLevelNumber != null
            ? 'Completed items shown here are only from your immediate next step. Older levels only appear if something is still missing.'
            : 'Ongoing standards for your current level.',
          done: done,
          todo: todo,
          total: done.length + todo.length
        };
      }

      function renderNextMove(state){
        if (!nextMoveMount || !nextMoveStatus) return;
        currentRenderedNextMoveState = state || null;
        if (!state) {
          selectedNextMoveApprovalKeys = {};
        } else {
          pruneSelectedNextMoveApprovalKeys(state);
        }
        if (!state) {
          if (nextMoveSection) nextMoveSection.hidden = true;
          nextMoveMount.hidden = true;
          nextMoveMount.innerHTML = '';
          return;
        }

        if (nextMoveSection) nextMoveSection.hidden = false;
        nextMoveMount.hidden = false;

        if (state.empty_banner) {
          nextMoveMount.innerHTML = ''
            + '<div class="next-move-shell">'
            +   '<div class="next-move-empty">' + escapeHtml(state.empty_banner) + '</div>'
            + '</div>';
          setDashboardSectionStatus(nextMoveStatus, 'Progression map not loaded yet.');
          return;
        }

        if (state.status_banner) {
          nextMoveMount.innerHTML = ''
            + '<div class="next-move-shell">'
            +   '<div class="next-move-statusBanner">'
            +     '<div class="next-move-statusEyebrow">' + escapeHtml(state.status_banner.label || 'Current status') + '</div>'
            +     '<div class="next-move-statusTitle">' + escapeHtml(state.status_banner.title || 'No active next move') + '</div>'
            +     '<div class="next-move-statusCopy">' + escapeHtml(state.status_banner.copy || '') + '</div>'
            +   '</div>'
            + '</div>';
          setDashboardSectionStatus(nextMoveStatus, state.status_banner.status_text || 'No active next move right now.');
          return;
        }

        var done = Array.isArray(state.done) ? state.done : [];
        var todo = Array.isArray(state.todo) ? state.todo : [];
        var total = Number(state.total || (done.length + todo.length)) || 0;
        var doneGroups = groupNextMoveItemsByFocusArea(done);
        var todoGroups = groupNextMoveItemsByFocusArea(todo);
        var quickApprovalEntries = collectNextMoveQuickApprovalEntries(state);
        var selectedQuickApprovalEntries = getSelectedNextMoveApprovalEntries(state);

        nextMoveMount.innerHTML = ''
          + '<div class="next-move-shell">'
          +   '<div class="next-move-hero">'
          +     '<div class="next-move-titleRow">'
          +       '<span class="next-move-badge">' + escapeHtml(state.next_level != null ? ('Toward Level ' + state.next_level) : 'Top Level') + '</span>'
          +     '</div>'
          +     '<p class="next-move-copy">' + escapeHtml(state.subtitle || '') + '</p>'
          +   '</div>'
          +   '<div class="next-move-summary">'
          +     '<div class="next-move-pill">'
          +       '<div class="next-move-pillLabel">Current</div>'
          +       '<div class="next-move-pillValue">' + escapeHtml(levelTitle(state.current_level)) + '</div>'
          +     '</div>'
          +     '<div class="next-move-pill">'
          +       '<div class="next-move-pillLabel">Next</div>'
          +       '<div class="next-move-pillValue">' + escapeHtml(state.next_label || 'At top level') + '</div>'
          +     '</div>'
          +     '<div class="next-move-pill">'
          +       '<div class="next-move-pillLabel">Progress</div>'
          +       '<div class="next-move-pillValue">' + escapeHtml(String(done.length) + ' / ' + String(total || done.length)) + '</div>'
          +     '</div>'
          +   '</div>'
          +   '<div class="next-move-columns">'
          +     '<div class="next-move-column next-move-column--done">'
          +       '<div class="next-move-columnHead">'
          +         '<h5 class="next-move-columnTitle">Already Landed</h5>'
          +         '<p class="next-move-columnCopy">Satisfied items from the very next level only.</p>'
          +       '</div>'
          +       '<div class="next-move-list">'
          +         (done.length ? doneGroups.map(function(group){
                return ''
                  + '<div class="next-move-group">'
                  +   '<div class="next-move-groupHead">'
                  +     '<h6 class="next-move-groupTitle">' + escapeHtml(group.label || 'General') + '</h6>'
                  +     '<span class="next-move-groupCount">' + escapeHtml(String((group.items || []).length)) + '</span>'
                  +   '</div>'
                  +   (group.items || []).map(function(item){
                        return ''
                          + '<div class="next-move-item">'
                          +   '<div class="next-move-itemTop">'
                          +     '<p class="next-move-itemName">' + escapeHtml(item.label || '') + '</p>'
                          +     '<span class="next-move-chip" data-tone="done">Done</span>'
                          +   '</div>'
                          +   (item.meta ? '<p class="next-move-itemMeta">' + escapeHtml(item.meta) + '</p>' : '')
                          +   renderNextMoveAuditFeedbackSummary(item)
                          +   renderNextMoveItemDetails(item)
                          + '</div>';
                      }).join('')
                  + '</div>';
              }).join('') : '<div class="next-move-empty">Nothing has been checked off yet.</div>')
          +       '</div>'
          +     '</div>'
          +     '<div class="next-move-column next-move-column--todo">'
          +       '<div class="next-move-columnHead">'
          +         '<h5 class="next-move-columnTitle">Still To Accomplish</h5>'
          +         '<p class="next-move-columnCopy">Any missing items from the next level down through the earliest unfinished level.</p>'
          +       '</div>'
          +       (quickApprovalEntries.length
                ? '<div class="next-move-bulk">'
                    + '<div class="next-move-bulkHead">'
                      + '<div class="next-move-bulkSummary">'
                        + '<div class="next-move-itemDetailLabel">Bulk manager sign off</div>'
                        + '<p class="next-move-bulkCopy"><span data-next-move-bulk-selected-count>' + escapeHtml(String(selectedQuickApprovalEntries.length)) + '</span> selected of <span data-next-move-bulk-total-count>' + escapeHtml(String(quickApprovalEntries.length)) + '</span> ready-now cards.</p>'
                      + '</div>'
                      + '<div class="next-move-bulkMiniActions">'
                        + '<button class="btn-secondary next-move-bulkMiniBtn" type="button" data-next-move-select-all>All ready</button>'
                        + '<button class="btn-secondary next-move-bulkMiniBtn" type="button" data-next-move-clear-selected' + (selectedQuickApprovalEntries.length ? '' : ' disabled') + '>Clear</button>'
                      + '</div>'
                    + '</div>'
                    + '<div class="next-move-itemApproveRow">'
                      + '<input class="next-move-itemApproveInput" type="password" inputmode="numeric" autocomplete="one-time-code" placeholder="Manager code" data-next-move-bulk-pin />'
                      + '<button class="btn-primary next-move-itemApproveBtn" type="button" data-next-move-bulk-approve' + (selectedQuickApprovalEntries.length ? '' : ' disabled') + '>Sign Off Selected</button>'
                    + '</div>'
                    + '<div class="next-move-itemApproveStatus" data-next-move-bulk-status>Select the cards you want to clear, then use one manager code.</div>'
                  + '</div>'
                : '')
          +       '<div class="next-move-list">'
          +         (todo.length ? todoGroups.map(function(group){
                return ''
                  + '<div class="next-move-group">'
                  +   '<div class="next-move-groupHead">'
                  +     '<h6 class="next-move-groupTitle">' + escapeHtml(group.label || 'General') + '</h6>'
                  +     '<span class="next-move-groupCount">' + escapeHtml(String((group.items || []).length)) + '</span>'
                  +   '</div>'
                  +   (group.items || []).map(function(item){
                        var quickApprovable = isNextMoveItemQuickApprovable(item);
                        var itemDetails = item && item.details && typeof item.details === 'object' ? item.details : null;
                        var itemDetailKey = quickApprovable && itemDetails
                          ? getNextMoveApprovalDetailKey(itemDetails.section_key, itemDetails.item_key)
                          : '';
                        return ''
                          + '<div class="next-move-item' + (itemDetailKey && selectedNextMoveApprovalKeys[itemDetailKey] === true ? ' is-bulk-selected' : '') + '">'
                          +   '<div class="next-move-itemTop">'
                          +     '<p class="next-move-itemName">' + escapeHtml(item.label || '') + '</p>'
                          +     '<div class="next-move-itemTopRight">'
                            + '<span class="next-move-chip" data-tone="todo">Needs Work</span>'
                            + (quickApprovable
                              ? '<label class="next-move-itemSelect">'
                                  + '<input type="checkbox" data-next-move-select-toggle="' + escapeHtml(itemDetailKey) + '"' + (selectedNextMoveApprovalKeys[itemDetailKey] === true ? ' checked' : '') + ' />'
                                  + '<span>Select</span>'
                                + '</label>'
                              : '')
                          +     '</div>'
                          +   '</div>'
                          +   (item.meta ? '<p class="next-move-itemMeta">' + escapeHtml(item.meta) + '</p>' : '')
                          +   renderNextMoveAuditFeedbackSummary(item)
                          +   renderNextMoveItemDetails(item)
                          + '</div>';
                      }).join('')
                  + '</div>';
              }).join('') : '<div class="next-move-empty">Everything for this next step is already completed.</div>')
          +       '</div>'
          +     '</div>'
          +   '</div>'
          + '</div>';

        syncNextMoveBulkSelectionUi();

        setDashboardSectionStatus(nextMoveStatus, todo.length
          ? String(done.length) + ' complete · ' + String(todo.length) + ' still to go'
          : 'Everything for the next step is complete.');
      }

      function renderStaffBonusPlans(plans){
        currentBonusPlans = Array.isArray(plans) ? plans.slice() : [];
        if (!bonusDashboardSection || !bonusDashboardMount || !bonusDashboardStatus) return;
        if (!currentBonusPlans.length) {
          setBonusSectionHidden(true);
          bonusDashboardMount.hidden = true;
          bonusDashboardMount.innerHTML = '';
          setDashboardSectionStatus(bonusDashboardStatus, 'No published bonus plans yet.');
          return;
        }

        setBonusSectionHidden(false);
        bonusDashboardMount.hidden = false;
        bonusDashboardMount.innerHTML = ''
          + '<div class="next-move-shell">'
          +   currentBonusPlans.map(function(entry){
                var plan = entry && entry.plan ? entry.plan : {};
                var allocation = entry && entry.allocation ? entry.allocation : {};
                var metrics = allocation && allocation.performance_metrics ? allocation.performance_metrics : {};
                return ''
                  + '<div class="next-move-statusBanner">'
                  +   '<div class="next-move-statusEyebrow">' + escapeHtml(String((plan && plan.title) || 'Bonus plan')) + '</div>'
                  +   '<div class="next-move-statusTitle">' + escapeHtml(formatMoney((allocation && allocation.allocation_amount) || 0)) + '</div>'
                  +   '<div class="next-move-statusCopy">' + escapeHtml(String((plan && plan.date_from) || '') + ' to ' + String((plan && plan.date_to) || '')) + '</div>'
                  +   '<div class="next-move-summary">'
                  +     '<div class="next-move-pill"><div class="next-move-pillLabel">Score</div><div class="next-move-pillValue">' + escapeHtml(formatPercent((allocation && allocation.normalized_score) || 0)) + '</div></div>'
                  +     '<div class="next-move-pill"><div class="next-move-pillLabel">Reliability</div><div class="next-move-pillValue">' + escapeHtml(formatPercent(metrics.reliability_score || 0)) + '</div></div>'
                  +     '<div class="next-move-pill"><div class="next-move-pillLabel">Progression</div><div class="next-move-pillValue">' + escapeHtml(metrics.progression_accomplishments != null ? formatPercent(metrics.progression_accomplishments) : '—') + '</div></div>'
                  +   '</div>'
                  +   ((plan && plan.notes) ? '<div class="next-move-itemMeta">' + escapeHtml(String(plan.notes || '')) + '</div>' : '')
                  + '</div>';
              }).join('')
          + '</div>';
        setDashboardSectionStatus(bonusDashboardStatus, 'Published bonus details are shown here.');
      }

      function startOfWeekMonday(date){
        var source = date instanceof Date ? date : new Date();
        var start = new Date(source.getFullYear(), source.getMonth(), source.getDate());
        var weekday = start.getDay();
        var offset = weekday === 0 ? 6 : weekday - 1;
        start.setDate(start.getDate() - offset);
        start.setHours(0, 0, 0, 0);
        return start;
      }

      function endOfWeekMonday(date){
        var start = startOfWeekMonday(date);
        var end = new Date(start);
        end.setDate(end.getDate() + 6);
        end.setHours(23, 59, 59, 999);
        return end;
      }

      function addDays(date, days){
        var next = new Date(date instanceof Date ? date.getTime() : Date.now());
        next.setDate(next.getDate() + (Number(days) || 0));
        return next;
      }

      function buildRetailGameWeekRange(weekOffset){
        var start = startOfWeekMonday(addDays(new Date(), (Number(weekOffset) || 0) * 7));
        var end = endOfWeekMonday(start);
        return {
          start: start,
          end: end,
          date_from: formatDateInputValue(start),
          date_to: formatDateInputValue(end)
        };
      }

      function formatPayrollPeriodLabel(dateFrom, dateTo){
        var start = parseLocalDateKey(dateFrom);
        var end = parseLocalDateKey(dateTo);
        if (!start || !end) return '';
        var sameYear = start.getFullYear() === end.getFullYear();
        var sameMonth = sameYear && start.getMonth() === end.getMonth();
        if (sameMonth) {
          return start.toLocaleDateString('en-US', { month: 'short' }) + ' ' + start.getDate() + '-' + end.getDate() + ', ' + end.getFullYear();
        }
        if (sameYear) {
          return start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' - ' + end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        }
        return start.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' - ' + end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      }

      function buildConcludedRetailGamePayrollOptions(limit){
        var maxCount = Math.max(1, Number(limit) || 1);
        var anchor = parseLocalDateKey(PAYROLL_PERIOD_ANCHOR_START);
        var today = startOfLocalDay(new Date());
        if (!anchor) return [];
        var daysSinceAnchor = Math.floor((today.getTime() - anchor.getTime()) / 86400000);
        var latestIndex = Math.floor((daysSinceAnchor - 14) / 14);
        if (!Number.isFinite(latestIndex) || latestIndex < 0) return [];
        var options = [];
        var earliestIndex = latestIndex - (maxCount - 1);
        for (var index = latestIndex; index >= earliestIndex && options.length < maxCount; index -= 1) {
          var start = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate() + (index * 14));
          var end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 13);
          if (!(end.getTime() < today.getTime())) continue;
          var dateFrom = formatDateInputValue(start);
          var dateTo = formatDateInputValue(end);
          options.push({
            value: dateFrom,
            label: formatPayrollPeriodLabel(dateFrom, dateTo),
            short_label: formatPayrollPeriodLabel(dateFrom, dateTo),
            start: start,
            end: end,
            date_from: dateFrom,
            date_to: dateTo,
            period_date_to: dateTo,
            live_through: '',
            is_live_current: false
          });
        }
        return options;
      }

      function buildCurrentRetailGamePayrollOption(){
        var anchor = parseLocalDateKey(PAYROLL_PERIOD_ANCHOR_START);
        var today = startOfLocalDay(new Date());
        if (!anchor) return null;
        var daysSinceAnchor = Math.floor((today.getTime() - anchor.getTime()) / 86400000);
        if (!Number.isFinite(daysSinceAnchor) || daysSinceAnchor < 0) return null;
        var currentIndex = Math.floor(daysSinceAnchor / 14);
        if (!Number.isFinite(currentIndex) || currentIndex < 0) return null;
        var start = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate() + (currentIndex * 14));
        var end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 13);
        var dateFrom = formatDateInputValue(start);
        var dateTo = formatDateInputValue(end);
        return {
          value: dateFrom,
          label: formatPayrollPeriodLabel(dateFrom, dateTo),
          short_label: 'Live current',
          start: start,
          end: end,
          date_from: dateFrom,
          date_to: formatDateInputValue(today),
          period_date_to: dateTo,
          live_through: formatDateInputValue(today),
          is_live_current: today.getTime() <= end.getTime()
        };
      }

      function buildRetailGamePayrollOptions(limit){
        var concluded = buildConcludedRetailGamePayrollOptions(limit);
        var current = buildCurrentRetailGamePayrollOption();
        if (!current || current.is_live_current !== true) return concluded;
        return [current].concat(concluded);
      }

      function buildRetailGamePayrollRange(periodStart){
        var periods = buildRetailGamePayrollOptions(26);
        var requestedStart = String(periodStart || '').trim();
        var target = periods.find(function(period){
          return String((period && period.value) || '') === requestedStart;
        }) || periods[0] || null;
        return target ? {
          start: target.start,
          end: target.end,
          date_from: target.date_from,
          date_to: target.date_to,
          period_date_to: target.period_date_to || target.date_to,
          label: target.label,
          short_label: target.short_label || '',
          live_through: target.live_through || '',
          payroll_start: String(target.value || ''),
          is_live_current: target.is_live_current === true
        } : {
          start: null,
          end: null,
          date_from: '',
          date_to: '',
          period_date_to: '',
          label: '',
          short_label: '',
          live_through: '',
          payroll_start: '',
          is_live_current: false
        };
      }

      function getRetailGameComparisonRange(selectedPayrollStart){
        var periods = buildRetailGamePayrollOptions(26);
        var selectedIndex = periods.findIndex(function(period){
          return String((period && period.value) || '') === String(selectedPayrollStart || '');
        });
        var fallbackIndex = selectedIndex >= 0 ? selectedIndex : 0;
        var comparisonPeriod = periods[fallbackIndex + 1] || null;
        return comparisonPeriod ? buildRetailGamePayrollRange(comparisonPeriod.value) : null;
      }

      function formatRetailGameRange(range){
        if (!range || !range.start || !range.end) return '';
        return range.start.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
          + ' - '
          + range.end.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      }

      function formatRetailGameAppointmentAt(value){
        var raw = String(value || '').trim();
        if (!raw) return '';
        var parsed = new Date(raw);
        if (isNaN(parsed.getTime())) return '';
        return parsed.toLocaleString(undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });
      }

      function retailGameRowsFromPayload(payload){
        return Array.isArray(payload && payload.rows) ? payload.rows.slice() : [];
      }

      function retailGameRowMatchesMode(row, mode){
        var expectedMode = String(mode || '').trim().toLowerCase() === 'assistant' ? 'assistant' : 'stylist';
        var staffName = String((row && row.staff_name) || '').trim();
        if (!staffName) return false;
        var matchedStaff = (Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : []).find(function(option){
          return sameStaffName(option && option.name, staffName);
        }) || null;
        var resolvedMode = resolveRetailTrackMode(
          (matchedStaff && (matchedStaff.level || matchedStaff.role)) || (row && (row.role_name || row.level)) || '',
          staffName
        );
        if (!resolvedMode) {
          var explicitMode = String((row && row.leaderboard_mode) || '').trim().toLowerCase();
          if (explicitMode === 'assistant' || explicitMode === 'stylist') {
            return explicitMode === expectedMode;
          }
          return true;
        }
        return resolvedMode === expectedMode;
      }

      function retailGameRowsForMode(payload, mode){
        return retailGameRowsFromPayload(payload).filter(function(row){
          return retailGameRowMatchesMode(row, mode);
        });
      }

      function sortRetailAttachRows(rows, mode){
        var isAssistantMode = String(mode || '').trim().toLowerCase() === 'assistant';
        return (Array.isArray(rows) ? rows.slice() : []).filter(function(row){
          return Number(row && row.closed_appointments) > 0;
        }).sort(function(left, right){
          if (isAssistantMode) {
            var supportWinDiff = Number((right && right.retail_visits) || 0) - Number((left && left.retail_visits) || 0);
            if (supportWinDiff) return supportWinDiff;
            var unitsDiff = Number((right && right.units_sold) || 0) - Number((left && left.units_sold) || 0);
            if (unitsDiff) return unitsDiff;
            var taggedDiff = Number((right && right.closed_appointments) || 0) - Number((left && left.closed_appointments) || 0);
            if (taggedDiff) return taggedDiff;
            return String((left && left.staff_name) || '').localeCompare(String((right && right.staff_name) || ''));
          }
          var attachDiff = Number((right && right.attach_rate) || 0) - Number((left && left.attach_rate) || 0);
          if (attachDiff) return attachDiff;
          var retailVisitDiff = Number((right && right.retail_visits) || 0) - Number((left && left.retail_visits) || 0);
          if (retailVisitDiff) return retailVisitDiff;
          var closedDiff = Number((right && right.closed_appointments) || 0) - Number((left && left.closed_appointments) || 0);
          if (closedDiff) return closedDiff;
          return String((left && left.staff_name) || '').localeCompare(String((right && right.staff_name) || ''));
        }).map(function(row, index){
          return Object.assign({}, row, {
            attach_rank: index + 1
          });
        });
      }

      function findRetailGameRow(rows, staffName){
        return (Array.isArray(rows) ? rows : []).find(function(row){
          return sameStaffName(row && row.staff_name, staffName);
        }) || null;
      }

      function retailGameTier(row){
        var supportWins = Number((row && row.retail_visits) || 0) || 0;
        if (String((row && row.leaderboard_mode) || '').trim().toLowerCase() === 'assistant') {
          if (supportWins >= 5) return 'Flame';
          if (supportWins >= 3) return 'Surging';
          if (supportWins >= 1) return 'On Board';
          return 'Opening';
        }
        var attachRate = Number((row && row.attach_rate) || 0) || 0;
        if (attachRate >= 40) return 'Flame';
        if (attachRate >= 25) return 'Surging';
        if (attachRate >= 10) return 'On Board';
        return 'Opening';
      }

      function retailGameAttachTone(row){
        var supportWins = Number((row && row.retail_visits) || 0) || 0;
        if (String((row && row.leaderboard_mode) || '').trim().toLowerCase() === 'assistant') {
          if (supportWins >= 5) return 'hot';
          if (supportWins >= 3) return 'surge';
          if (supportWins >= 1) return 'steady';
          return 'start';
        }
        var attachRate = Number((row && row.attach_rate) || 0) || 0;
        if (attachRate >= 40) return 'hot';
        if (attachRate >= 25) return 'surge';
        if (attachRate >= 10) return 'steady';
        return 'start';
      }

      function buildRetailGameNudge(currentRow, previousRow, leaderboardRows, mode){
        var currentClosed = Number((currentRow && currentRow.closed_appointments) || 0) || 0;
        var currentVisits = Number((currentRow && currentRow.retail_visits) || 0) || 0;
        var currentAttach = Number((currentRow && currentRow.attach_rate) || 0) || 0;
        var isAssistantMode = String(mode || '') === 'assistant';
        if (currentClosed <= 0) {
          return {
            title: isAssistantMode ? 'Fresh support period' : 'Fresh period',
            detail: isAssistantMode
              ? 'No tagged support appointments have closed yet in this payroll period. Start the board with your first retail-attached support appointment.'
              : 'No closed appointments yet in this payroll period. Start the board with your first retail attach.'
          };
        }
        var nextAttach = ((currentVisits + 1) / currentClosed) * 100;
        var ranked = sortRetailAttachRows(leaderboardRows, mode);
        var selfIndex = ranked.findIndex(function(row){
          return sameStaffName(row && row.staff_name, currentRow && currentRow.staff_name);
        });
        if (selfIndex > 0) {
          var rival = ranked[selfIndex - 1];
          var rivalWins = Number((rival && rival.retail_visits) || 0) || 0;
          var rivalAttach = Number((rival && rival.attach_rate) || 0) || 0;
          if ((isAssistantMode && (currentVisits + 1) >= rivalWins) || (!isAssistantMode && nextAttach >= rivalAttach)) {
            return {
              title: isAssistantMode ? 'One retail-attached support appt can move you up' : 'One attach can move you up',
              detail: isAssistantMode
                ? 'Support 1 more retail-closing appointment and you can jump ' + String((rival && rival.staff_name) || 'the next spot') + ' on this payroll board.'
                : 'Convert 1 more guest and you can jump ' + String((rival && rival.staff_name) || 'the next spot') + ' on this payroll board.'
            };
          }
        }
        if (previousRow) {
          var previousAttach = Number((previousRow && previousRow.attach_rate) || 0) || 0;
          var previousWins = Number((previousRow && previousRow.retail_visits) || 0) || 0;
          var winDelta = currentVisits - previousWins;
          if (isAssistantMode && winDelta > 0) {
            return {
              title: 'You are ahead of the last payroll',
              detail: 'You already have ' + String(winDelta) + ' more retail-attached support appointment' + (winDelta === 1 ? '' : 's') + ' than the last payroll at this point.'
            };
          }
          if (isAssistantMode && winDelta < 0) {
            return {
              title: 'Chase your last payroll support score',
              detail: String(Math.abs(winDelta)) + ' more retail-attached support appointment' + (Math.abs(winDelta) === 1 ? '' : 's') + ' gets you back to your last payroll pace.'
            };
          }
          if (!isAssistantMode && currentAttach > previousAttach) {
            return {
              title: 'You are ahead of the last payroll',
              detail: 'You are up ' + formatPercent(currentAttach - previousAttach) + ' versus the last payroll. Keep pressing the attach conversation.'
            };
          }
          if (!isAssistantMode && currentAttach < previousAttach) {
            return {
              title: 'Chase your last payroll score',
              detail: '1 more retail guest moves you toward your ' + formatPercent(previousAttach) + ' pace from the last payroll.'
            };
          }
        }
        return {
          title: 'Next unlock',
          detail: isAssistantMode
            ? '1 more retail-attached support appointment puts you at ' + String(currentVisits + 1) + ' this payroll period.'
            : '1 more retail guest would move you to ' + formatPercent(nextAttach) + ' attach this payroll period.'
        };
      }

      function renderRetailAttachLeaderboardList(rows, staffName, mode, limit){
        var maxRows = Math.max(1, Number(limit) || 5);
        var topRows = sortRetailAttachRows(rows, mode).slice(0, maxRows);
        var isAssistantMode = String(mode || '') === 'assistant';
        if (!topRows.length) {
          return '<div class="staff-retail-game-empty">' + (isAssistantMode
            ? 'No tagged support appointments are on the board yet.'
            : 'No closed appointments are on the board yet.') + '</div>';
        }
        return '<div class="staff-retail-boardList">' + topRows.map(function(row){
          var isSelf = sameStaffName(row && row.staff_name, staffName);
          return ''
            + '<article class="staff-retail-boardRow' + (isSelf ? ' staff-retail-boardRow--self' : '') + '">'
            +   '<div class="staff-retail-boardRank">#' + escapeHtml(String(row.attach_rank || '')) + '</div>'
            +   '<div class="staff-retail-boardIdentity">'
            +     '<div class="staff-retail-boardName">' + escapeHtml(String((row && row.staff_name) || 'Staff')) + '</div>'
            +     '<div class="staff-retail-boardMeta">' + escapeHtml(isAssistantMode
                  ? String((row && row.retail_visits) || 0) + ' retail-attached on ' + String((row && row.closed_appointments) || 0) + ' tagged'
                  : String((row && row.retail_visits) || 0) + ' attaches on ' + String((row && row.closed_appointments) || 0) + ' closed') + '</div>'
            +   '</div>'
            +   '<div class="staff-retail-boardValue">' + escapeHtml(isAssistantMode ? '' : formatPercent((row && row.attach_rate) || 0)) + '</div>'
            + '</article>';
        }).join('') + '</div>';
      }

      function colorDisciplineLevelName(reweighRate){
        var value = Number(reweighRate || 0) || 0;
        if (value >= 0.8) return 'Master';
        if (value >= 0.65) return 'Diamond';
        if (value >= 0.5) return 'Platinum';
        if (value >= 0.35) return 'Gold';
        if (value >= 0.2) return 'Silver';
        return 'Bronze';
      }

      function colorDisciplineRingProgress(reweighRate){
        var value = Math.max(0, Number(reweighRate || 0) || 0);
        return Math.max(10, Math.min(100, Math.round((value / 0.8) * 100)));
      }

      function colorDisciplineDispensedMeta(row){
        var ounces = Number((row && row.product_dispensed_ounces) || 0) || 0;
        var dispensed = Number((row && row.product_dispensed) || 0) || 0;
        if (ounces > 0) {
          return formatCompactNumber(ounces, 1) + ' oz dispensed';
        }
        if (dispensed > 0) {
          return formatCompactNumber(dispensed, 1) + ' product dispensed';
        }
        return 'Dispensed total unavailable';
      }

      function renderColorDisciplineLeaderboardList(rows, staffName){
        var ranked = Array.isArray(rows) ? rows.slice(0, 5) : [];
        if (!ranked.length) {
          return '<div class="staff-retail-game-empty">No reweigh data is on the board yet.</div>';
        }
        return '<div class="staff-retail-boardList">' + ranked.map(function(row){
          var isSelf = sameStaffName(row && row.staff_name, staffName);
          return ''
            + '<article class="staff-retail-boardRow' + (isSelf ? ' staff-retail-boardRow--self' : '') + '">'
            +   '<div class="staff-retail-boardRank">#' + escapeHtml(String((row && row.rank) || '')) + '</div>'
            +   '<div class="staff-retail-boardIdentity">'
            +     '<div class="staff-retail-boardName">' + escapeHtml(String((row && row.staff_name) || 'Stylist')) + '</div>'
            +     '<div class="staff-retail-boardMeta">' + escapeHtml(String((row && row.services) || 0) + ' services · ' + colorDisciplineDispensedMeta(row)) + '</div>'
            +   '</div>'
            +   '<div class="staff-retail-boardValue">' + escapeHtml(formatPercent(((row && row.reweigh_rate) || 0) * 100)) + '</div>'
            + '</article>';
        }).join('') + '</div>';
      }

      function renderColorDisciplineCard(currentSnapshot, previousSnapshot){
        if (getRetailGameMode() !== 'stylist') return '';
        var ownRow = currentSnapshot && currentSnapshot.own_row ? currentSnapshot.own_row : null;
        var previousOwnRow = previousSnapshot && previousSnapshot.own_row ? previousSnapshot.own_row : null;
        var reweighRate = Number((ownRow && ownRow.reweigh_rate) || 0) || 0;
        var previousRate = Number((previousOwnRow && previousOwnRow.reweigh_rate) || 0) || 0;
        var progress = colorDisciplineRingProgress(reweighRate);
        var trendLabel = previousOwnRow
          ? formatSignedPercentDelta((reweighRate - previousRate) * 100)
          : (ownRow ? 'New board' : 'No prior row');
        var teamAverage = Number((currentSnapshot && currentSnapshot.team_reweigh_rate) || 0) || 0;
        var versusAverage = formatSignedPercentDelta((reweighRate - teamAverage) * 100);
        var weekLabel = String((currentSnapshot && currentSnapshot.range_label) || 'Selected payroll').trim();
        var liveThrough = String((currentSnapshot && currentSnapshot.live_through) || '').trim();
        var periodMeta = currentSnapshot && currentSnapshot.is_live_current
          ? (weekLabel + ' · Live current payroll' + (liveThrough ? ' · Vish through ' + liveThrough : ''))
          : (weekLabel + ' · Closed payroll');
        var headlineValue = ownRow ? formatPercent(reweighRate * 100) : 'Not on board';
        var headlineMeta = ownRow
          ? (String((ownRow && ownRow.services) || 0) + ' services in this payroll view · #' + String((ownRow && ownRow.rank) || 0) + ' on the reweigh board')
          : ('No Vish reweigh row is linked to you in this payroll period. Team leaderboard still shown below.');
        return ''
          + '<section class="staff-retail-featureCard staff-retail-featureCard--color">'
          +   '<div class="staff-retail-game-kicker">Color Discipline</div>'
          +   '<div class="staff-retail-game-titleRow">'
          +     '<div>'
          +       '<div class="staff-retail-game-title staff-retail-colorValue">' + escapeHtml(headlineValue) + '</div>'
          +       '<p class="staff-retail-game-copy">' + escapeHtml(periodMeta) + '</p>'
          +       '<p class="staff-retail-cardMeta">' + escapeHtml(headlineMeta) + '</p>'
          +     '</div>'
          +     '<div class="staff-retail-game-ring" style="--ring-progress:' + escapeHtml(String(ownRow ? progress : Math.max(12, Math.round(teamAverage * 100)))) + '%;">'
          +       '<div class="staff-retail-game-ringInner"><span>' + escapeHtml(ownRow ? 'Level' : 'Team avg') + '</span><strong>' + escapeHtml(ownRow ? colorDisciplineLevelName(reweighRate) : formatPercent(teamAverage * 100)) + '</strong></div>'
          +     '</div>'
          +   '</div>'
          +   '<div class="staff-retail-game-track"><span style="width:' + escapeHtml(String(ownRow ? progress : Math.max(12, Math.round(teamAverage * 100)))) + '%"></span></div>'
          +   '<details class="staff-retail-expandable">'
          +     '<summary class="staff-retail-expandableSummary">'
          +       '<span>Show color details</span>'
          +       '<span class="staff-retail-expandableMeta">' + escapeHtml('Trend · avg · leaderboard') + '</span>'
          +     '</summary>'
          +     '<div class="staff-retail-expandableBody">'
          +       '<div class="staff-retail-game-metrics staff-retail-game-metrics--triple">'
          +         '<div class="staff-retail-game-metric"><span>' + escapeHtml(ownRow ? 'Vs previous payroll' : 'Your row') + '</span><strong>' + escapeHtml(ownRow ? trendLabel : 'Not found') + '</strong></div>'
          +         '<div class="staff-retail-game-metric"><span>Salon avg</span><strong>' + escapeHtml(formatPercent(teamAverage * 100)) + '</strong></div>'
          +         '<div class="staff-retail-game-metric"><span>' + escapeHtml(ownRow ? 'Vs avg' : 'Staff tracked') + '</span><strong>' + escapeHtml(ownRow ? versusAverage : String(Number((currentSnapshot && currentSnapshot.staff_count) || 0) || 0)) + '</strong></div>'
          +       '</div>'
          +       '<div class="staff-retail-cardHead">'
          +         '<h5 class="staff-retail-cardTitle">Reweigh leaderboard</h5>'
          +         '<div class="staff-retail-cardMeta">' + escapeHtml('Top 5 stylists for ' + weekLabel + (currentSnapshot && currentSnapshot.is_live_current ? ' · current payroll' : ' · closed payroll')) + '</div>'
          +       '</div>'
          +       renderColorDisciplineLeaderboardList(currentSnapshot && currentSnapshot.leaderboard, currentLoggedInStaff && currentLoggedInStaff.name)
          +     '</div>'
          +   '</details>'
          + '</section>';
      }

      function renderStaffColorDiscipline(currentSnapshot, previousSnapshot, periods){
        if (!staffColorDisciplineMount) return;
        var periodOptions = Array.isArray(periods) ? periods : [];
        var markup = renderColorDisciplineCard(currentSnapshot, previousSnapshot);
        staffColorDisciplineMount.hidden = false;
        staffColorDisciplineMount.innerHTML = '<div class="staff-retail-game-shell">'
          + (periodOptions.length
              ? ('<div class="request-queue-tabs retail-periodTabs staff-retail-periodTabs" role="tablist" aria-label="Color Discipline payroll periods">'
                  + periodOptions.map(function(period){
                    var value = String((period && (period.payroll_start || period.id)) || '').trim();
                    var isActive = value === String(activeStaffColorDisciplinePayrollStart || '');
                    var label = String((period && (period.short_label || period.label)) || '').trim();
                    return '<button class="request-queue-tab' + (isActive ? ' is-active' : '') + '" type="button" data-color-payroll-period="' + escapeHtml(value) + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">' + escapeHtml(label) + '</button>';
                  }).join('')
                + '</div>')
              : '')
          + (markup || '<div class="staff-retail-game-empty">No Color Discipline data is available for this payroll period yet.</div>')
          + '</div>';
        Array.prototype.slice.call(staffColorDisciplineMount.querySelectorAll('[data-color-payroll-period]')).forEach(function(button){
          button.addEventListener('click', function(){
            var nextValue = String(button.getAttribute('data-color-payroll-period') || '').trim();
            if (!nextValue || nextValue === String(activeStaffColorDisciplinePayrollStart || '')) return;
            activeStaffColorDisciplinePayrollStart = nextValue;
            loadRetailGameSection({ silent: false }).catch(function(error){
              if (staffColorDisciplineMount) {
                staffColorDisciplineMount.hidden = false;
                staffColorDisciplineMount.innerHTML = '<div class="staff-retail-game-shell"><div class="staff-retail-game-empty">' + escapeHtml(humanizeClientFetchErrorMessage(error, 'Color Discipline unavailable.')) + '</div></div>';
              }
              setDashboardSectionStatus(staffColorDisciplineStatus, humanizeClientFetchErrorMessage(error, 'Color Discipline unavailable.'), 'error');
            });
          });
        });
      }

      function retailGamePrimaryMetricLabel(mode){
        return String(mode || '') === 'assistant' ? 'Retail-attached support appts' : 'Retail Attach Rate';
      }

      function retailGamePrimaryMetricCopy(mode, currentRange, rankText){
        var bits = [];
        if (currentRange) bits.push(formatRetailGameRange(currentRange));
        if (currentRange && currentRange.is_live_current) bits.push('Live current payroll');
        else if (currentRange) bits.push('Closed payroll');
        bits.push(retailGamePrimaryMetricLabel(mode));
        if (rankText) bits.push(rankText);
        return bits.join(' · ');
      }

      function retailStrategyHasSignal(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var priorProducts = Array.isArray(safeItem.prior_purchased_products) ? safeItem.prior_purchased_products.filter(Boolean) : [];
        var concerns = Array.isArray(safeItem.tagged_concerns) ? safeItem.tagged_concerns.filter(Boolean) : [];
        var type = String((safeItem.strategy_type) || '').trim().toLowerCase();
        if (priorProducts.length || concerns.length) return true;
        return type === 'replenish' || type === 'restock' || type === 'revisit';
      }

      function retailStrategySummaryCopy(totalStrategies, visibleStrategies){
        var hiddenCount = Math.max(0, Number(totalStrategies || 0) - Number(visibleStrategies || 0));
        if (visibleStrategies > 0 && hiddenCount > 0) {
          return String(visibleStrategies) + ' strong retail cues · ' + String(hiddenCount) + ' guests need live discovery';
        }
        if (visibleStrategies > 0) {
          return String(visibleStrategies) + ' guests with real retail signal in this payroll period';
        }
        if (totalStrategies > 0) {
          return 'Nothing has enough history yet to cue a smart retail play.';
        }
        return 'No guest strategies available yet.';
      }

      function formatSignedPercentDelta(value){
        var numeric = Number(value || 0) || 0;
        if (!numeric) return '0.0%';
        return (numeric > 0 ? '+' : '') + formatPercent(numeric);
      }

      function formatSignedCountDelta(value){
        var numeric = Number(value || 0) || 0;
        if (!numeric) return '0';
        return (numeric > 0 ? '+' : '') + String(Math.round(numeric));
      }

      function buildRetailSuccessSquadSummary(){
        var options = Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : [];
        return options.reduce(function(summary, option){
          var role = String((option && option.role) || '').trim();
          if (!role) return summary;
          summary.total += 1;
          if (isAssistantSupportRole(role)) {
            summary.assistants += 1;
          } else if (!shouldHideSalesForRole(role)) {
            summary.stylists += 1;
          } else {
            summary.other += 1;
          }
          return summary;
        }, {
          total: 0,
          stylists: 0,
          assistants: 0,
          other: 0
        });
      }

      function retailSuccessLeaderboardLimit(count){
        var total = Math.max(0, Number(count) || 0);
        if (total && total <= 8) return 3;
        return 5;
      }

      function retailSuccessAverage(rows, mode){
        var isAssistantMode = String(mode || '') === 'assistant';
        var pool = (Array.isArray(rows) ? rows : []).filter(function(row){
          return Number((row && row.closed_appointments) || 0) > 0;
        });
        if (!pool.length) return 0;
        var total = pool.reduce(function(sum, row){
          return sum + Number(isAssistantMode ? ((row && row.retail_visits) || 0) : ((row && row.attach_rate) || 0));
        }, 0);
        return total / pool.length;
      }

      function retailSuccessLevelName(metricValue, mode){
        var value = Number(metricValue || 0) || 0;
        if (String(mode || '') === 'assistant') {
          if (value >= 8) return 'Master';
          if (value >= 6) return 'Diamond';
          if (value >= 4) return 'Platinum';
          if (value >= 3) return 'Gold';
          if (value >= 2) return 'Silver';
          return 'Bronze';
        }
        if (value >= 50) return 'Master';
        if (value >= 40) return 'Diamond';
        if (value >= 30) return 'Platinum';
        if (value >= 20) return 'Gold';
        if (value >= 10) return 'Silver';
        return 'Bronze';
      }

      function retailSuccessRingProgress(metricValue, mode){
        var value = Math.max(0, Number(metricValue || 0) || 0);
        if (String(mode || '') === 'assistant') {
          return Math.max(10, Math.min(100, Math.round((value / 8) * 100)));
        }
        return Math.max(10, Math.min(100, Math.round((value / 50) * 100)));
      }

      function buildRetailSuccessBadges(row, leaderboardRows, mode, baselineMetric){
        var badges = [];
        var isAssistantMode = String(mode || '') === 'assistant';
        var attachRate = Number((row && row.attach_rate) || 0) || 0;
        var visits = Number((row && row.retail_visits) || 0) || 0;
        var units = Number((row && row.units_sold) || 0) || 0;
        var rank = Number((row && row.attach_rank) || 0) || 0;
        if (visits >= 1) {
          badges.push({ icon: '🏅', label: isAssistantMode ? 'First Support Win' : 'First Product' });
        }
        if ((isAssistantMode ? visits : attachRate) >= baselineMetric && baselineMetric > 0) {
          badges.push({ icon: '🚀', label: 'Above Average' });
        }
        if (rank > 0 && rank <= 3 && (Array.isArray(leaderboardRows) ? leaderboardRows.length : 0) >= 3) {
          badges.push({ icon: rank === 1 ? '👑' : '🏆', label: rank === 1 ? '#1 Right Now' : 'Top 3' });
        }
        if (isAssistantMode) {
          if (Number((row && row.closed_appointments) || 0) >= 5) {
            badges.push({ icon: '🔥', label: 'Support 5+' });
          }
          if (visits >= 5) {
            badges.push({ icon: '💎', label: 'Retail Support 5+' });
          }
        } else {
          if (units >= 10) {
            badges.push({ icon: '⭐', label: '10 Products' });
          }
          if (attachRate >= 40) {
            badges.push({ icon: '💎', label: 'Routine Pro' });
          }
        }
        return badges.slice(0, 4);
      }

      function renderRetailSuccessBadges(badges){
        var items = Array.isArray(badges) ? badges.filter(Boolean) : [];
        if (!items.length) {
          return '';
        }
        return '<div class="staff-retail-badgeRow">' + items.map(function(item){
          return ''
            + '<div class="staff-retail-badgePill">'
            +   '<span class="staff-retail-badgeIcon">' + escapeHtml(String((item && item.icon) || '')) + '</span>'
            +   '<span class="staff-retail-badgeLabel">' + escapeHtml(String((item && item.label) || '')) + '</span>'
            + '</div>';
        }).join('') + '</div>';
      }

      function renderRetailGame(currentPayload, previousPayload, ownPayload){
        currentRetailGameCurrentWeek = currentPayload || null;
        currentRetailGameLastWeek = previousPayload || null;
        currentRetailGameOwnWeek = ownPayload || null;
        if (!retailGameMount) return;
        if (!currentPayload && !previousPayload && !ownPayload) {
          retailGameMount.hidden = false;
          retailGameMount.innerHTML = '<div class="staff-retail-game-shell"><div class="staff-retail-game-empty">Loading Retail Success...</div></div>';
          return;
        }

        var leaderboardMode = String((((ownPayload || {}).summary || {}).leaderboard_mode) || (((currentPayload || {}).summary || {}).leaderboard_mode) || getRetailGameMode() || 'stylist').trim().toLowerCase() === 'assistant'
          ? 'assistant'
          : 'stylist';
        var currentRows = retailGameRowsForMode(currentPayload, leaderboardMode);
        var previousRows = retailGameRowsForMode(previousPayload, leaderboardMode);
        var ownRows = retailGameRowsForMode(ownPayload, leaderboardMode);
        var isAssistantMode = leaderboardMode === 'assistant';
        var currentLeaderboard = sortRetailAttachRows(currentRows, leaderboardMode);
        var previousLeaderboard = sortRetailAttachRows(previousRows, leaderboardMode);
        var ownRow = findRetailGameRow(ownRows, currentLoggedInStaff && currentLoggedInStaff.name)
          || findRetailGameRow(currentRows, currentLoggedInStaff && currentLoggedInStaff.name);
        var previousOwnRow = findRetailGameRow(previousRows, currentLoggedInStaff && currentLoggedInStaff.name);
        var ownUpcoming = ownRow && ownRow.upcoming_book ? ownRow.upcoming_book : {};
        var allOwnStrategies = Array.isArray(ownUpcoming && ownUpcoming.client_strategies) ? ownUpcoming.client_strategies : [];
        var ownStrategies = allOwnStrategies.filter(retailStrategyHasSignal);
        var currentRange = currentPayload && currentPayload._range ? currentPayload._range : null;
        var previousRange = previousPayload && previousPayload._range ? previousPayload._range : null;
        var nudge = buildRetailGameNudge(ownRow, previousOwnRow, currentRows, leaderboardMode);
        var currentClosed = Number((ownRow && ownRow.closed_appointments) || 0) || 0;
        var currentVisits = Number((ownRow && ownRow.retail_visits) || 0) || 0;
        var currentAttach = Number((ownRow && ownRow.attach_rate) || 0) || 0;
        var currentUnits = Number((ownRow && ownRow.units_sold) || 0) || 0;
        var squadSummary = buildRetailSuccessSquadSummary();
        var teamSize = Math.max(0, Number(isAssistantMode ? squadSummary.assistants : squadSummary.stylists) || 0) || currentLeaderboard.length;
        var boardLimit = retailSuccessLeaderboardLimit(teamSize);
        var currentSummary = currentPayload && currentPayload.summary && typeof currentPayload.summary === 'object'
          ? currentPayload.summary
          : {};
        var salonAverage = retailSuccessAverage(currentRows, leaderboardMode);
        var salonAttach = Number(currentSummary.attach_rate || 0) || 0;
        var comparisonMetric = isAssistantMode ? salonAverage : salonAttach;
        var versusAverage = (isAssistantMode ? currentVisits : currentAttach) - comparisonMetric;
        var levelName = retailSuccessLevelName(isAssistantMode ? currentVisits : currentAttach, leaderboardMode);
        var ringProgress = retailSuccessRingProgress(isAssistantMode ? currentVisits : currentAttach, leaderboardMode);
        var achievementBadges = buildRetailSuccessBadges(ownRow, currentLeaderboard, leaderboardMode, comparisonMetric);
        var progressWidth = Math.max(8, Math.min(100, ringProgress));
        var rankText = ownRow && ownRow.attach_rank ? ('#' + String(ownRow.attach_rank) + ' this period') : 'Not ranked yet';
        var bookedGuests = Number((ownUpcoming && ownUpcoming.upcoming_appointments) || 0) || 0;
        var returningGuests = Number((ownUpcoming && ownUpcoming.returning_clients) || 0) || 0;
        var priorRetailGuests = Number((ownUpcoming && ownUpcoming.returning_clients_with_prior_retail) || 0) || 0;
        var boardRows = activeRetailGameBoardWindow === 'last' ? previousLeaderboard : currentLeaderboard;
        var boardRange = activeRetailGameBoardWindow === 'last' ? previousRange : currentRange;
        var boardTitle = activeRetailGameBoardWindow === 'last'
          ? 'Previous payroll leaderboard'
          : 'Selected payroll leaderboard';
        var heroKicker = isAssistantMode ? 'Retail Success · Assistant' : 'Retail Success · Stylist';
        var boardMeta = (boardRange ? formatRetailGameRange(boardRange) + ' · ' : '')
          + 'Top ' + String(Math.min(boardLimit, Math.max(1, boardRows.length || boardLimit))) + ' of ' + String(Math.max(teamSize, boardRows.length || 0))
          + (isAssistantMode ? ' assistants' : ' stylists');
        var heroMeta = retailGamePrimaryMetricCopy(leaderboardMode, currentRange, rankText);
        var salonAverageLabel = isAssistantMode
          ? String(Math.round(salonAverage * 10) / 10)
          : formatPercent(salonAttach);
        var versusAverageLabel = isAssistantMode
          ? formatSignedCountDelta(versusAverage)
          : formatSignedPercentDelta(versusAverage);
        var headlineValue = isAssistantMode
          ? String(currentVisits)
          : (ownRow ? formatPercent(currentAttach) : '0.0%');
        var strategyTitle = isAssistantMode ? 'Support Focus' : 'This Week\'s Best Plays';
        var strategyMeta = isAssistantMode
          ? 'Stay close to tagged appointments and help more supported guests leave with the right home care.'
          : (ownStrategies.length
            ? retailStrategySummaryCopy(allOwnStrategies.length, ownStrategies.length)
            : 'Only showing guest strategy when there is real retail or concern history behind it.');
        var badgesMarkup = renderRetailSuccessBadges(achievementBadges);
        var shouldRenderStrategySection = !isAssistantMode && ownStrategies.length > 0;
        var retailStatusMeta = currentRange
          ? ((currentRange.is_live_current
              ? (formatRetailGameRange(currentRange) + ' · Live current payroll' + (currentRange.live_through ? ' · through ' + currentRange.live_through : ''))
              : (formatRetailGameRange(currentRange) + ' · Closed payroll')))
          : 'Retail Success';
        var payrollOptions = buildRetailGamePayrollOptions(8);

        retailGameMount.hidden = false;
        retailGameMount.innerHTML = ''
          + '<div class="staff-retail-game-shell">'
          +   '<div class="request-queue-tabs retail-periodTabs staff-retail-periodTabs" role="tablist" aria-label="Retail Success payroll periods">'
          +     payrollOptions.map(function(period){
                  var value = String((period && period.value) || '');
                  var isActive = value === String(activeRetailGamePayrollStart || '');
                  var label = String((period && (period.short_label || period.label)) || '').trim();
                  return '<button class="request-queue-tab' + (isActive ? ' is-active' : '') + '" type="button" data-retail-payroll-period="' + escapeHtml(value) + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">' + escapeHtml(label) + '</button>';
                }).join('')
          +   '</div>'
          +   '<div class="staff-retail-game-grid staff-retail-game-grid--top">'
          +     '<section class="staff-retail-featureCard staff-retail-featureCard--' + escapeHtml(retailGameAttachTone(ownRow)) + '">'
          +       '<div class="staff-retail-game-kicker">' + escapeHtml(heroKicker) + '</div>'
          +       '<div class="staff-retail-game-titleRow">'
          +         '<div>'
          +           '<div class="staff-retail-game-title">' + escapeHtml(headlineValue) + '</div>'
          +           '<p class="staff-retail-game-copy">' + escapeHtml(retailStatusMeta) + '</p>'
          +           '<p class="staff-retail-cardMeta">' + escapeHtml(heroMeta) + '</p>'
          +         '</div>'
          +         '<div class="staff-retail-game-ring" style="--ring-progress:' + escapeHtml(String(progressWidth)) + '%;">'
          +           '<div class="staff-retail-game-ringInner"><span>Level</span><strong>' + escapeHtml(levelName) + '</strong></div>'
          +         '</div>'
          +       '</div>'
          +       '<div class="staff-retail-game-track"><span style="width:' + escapeHtml(String(progressWidth)) + '%"></span></div>'
          +       '<details class="staff-retail-expandable">'
          +         '<summary class="staff-retail-expandableSummary">'
          +           '<span>Show retail details</span>'
          +           '<span class="staff-retail-expandableMeta">' + escapeHtml('Stats · badges · next move · payroll board') + '</span>'
          +         '</summary>'
          +         '<div class="staff-retail-expandableBody">'
          +           '<div class="staff-retail-game-metrics">'
          +             '<div class="staff-retail-game-metric"><span>' + escapeHtml(isAssistantMode ? 'Tagged appts' : 'Products sold') + '</span><strong>' + escapeHtml(String(isAssistantMode ? currentClosed : currentUnits)) + '</strong></div>'
          +             '<div class="staff-retail-game-metric"><span>' + escapeHtml(isAssistantMode ? 'Support wins' : 'Retail-attached appts') + '</span><strong>' + escapeHtml(String(currentVisits)) + '</strong></div>'
          +             '<div class="staff-retail-game-metric"><span>' + escapeHtml(isAssistantMode ? 'Salon avg wins' : 'Salon attach') + '</span><strong>' + escapeHtml(salonAverageLabel) + '</strong></div>'
          +             '<div class="staff-retail-game-metric"><span>' + escapeHtml(isAssistantMode ? 'Vs avg' : 'Vs salon attach') + '</span><strong>' + escapeHtml(versusAverageLabel) + '</strong></div>'
          +           '</div>'
          +           (badgesMarkup ? '<div class="staff-retail-game-badges">' + badgesMarkup + '</div>' : '')
          +           '<div class="staff-retail-game-nudge">'
          +             '<div class="staff-retail-game-nudgeTitle">' + escapeHtml(nudge.title) + '</div>'
          +             '<div class="staff-retail-game-nudgeCopy">' + escapeHtml(nudge.detail) + '</div>'
          +           '</div>'
          +           '<div class="staff-retail-cardHead">'
          +             '<div>'
          +               '<h5 class="staff-retail-cardTitle">' + escapeHtml(boardTitle) + '</h5>'
          +               '<div class="staff-retail-cardMeta">' + escapeHtml(boardMeta + (activeRetailGameBoardWindow === 'current'
                              ? (boardRange && boardRange.is_live_current ? ' · live retail attribution' : ' · selected payroll snapshot')
                              : ' · previous payroll snapshot')) + '</div>'
          +             '</div>'
          +             '<div class="staff-retail-boardToggle" role="tablist" aria-label="Attach board window">'
          +               '<button class="staff-retail-boardToggleBtn' + (activeRetailGameBoardWindow === 'current' ? ' is-active' : '') + '" type="button" data-retail-board-window="current" aria-pressed="' + (activeRetailGameBoardWindow === 'current' ? 'true' : 'false') + '">Selected</button>'
          +               '<button class="staff-retail-boardToggleBtn' + (activeRetailGameBoardWindow === 'last' ? ' is-active' : '') + '" type="button" data-retail-board-window="last" aria-pressed="' + (activeRetailGameBoardWindow === 'last' ? 'true' : 'false') + '">Previous</button>'
          +             '</div>'
          +           '</div>'
          +           renderRetailAttachLeaderboardList(boardRows, currentLoggedInStaff && currentLoggedInStaff.name, leaderboardMode, boardLimit)
          +         '</div>'
          +       '</details>'
          +     '</section>'
          +   '</div>'
          +   (shouldRenderStrategySection
            ? '<section class="staff-retail-card">'
          +       '<div class="staff-retail-cardHead">'
          +         '<h5 class="staff-retail-cardTitle">' + escapeHtml(strategyTitle) + '</h5>'
          +         '<div class="staff-retail-cardMeta">' + escapeHtml(strategyMeta) + '</div>'
          +       '</div>'
          +       '<div class="staff-retail-strategyList">'
          +         ownStrategies.map(function(item){
                var appointmentAt = formatRetailGameAppointmentAt(item && item.appointment_at);
                var priorProducts = Array.isArray(item && item.prior_purchased_products) ? item.prior_purchased_products.filter(Boolean) : [];
                var concerns = Array.isArray(item && item.tagged_concerns) ? item.tagged_concerns.filter(Boolean) : [];
                return ''
                  + '<article class="staff-retail-strategyCard">'
                  +   '<div class="staff-retail-strategyHead">'
                  +     '<div>'
                  +       '<div class="staff-retail-strategyClient">' + escapeHtml(String((item && item.client_name) || 'Upcoming guest')) + '</div>'
                  +       (appointmentAt ? '<div class="staff-retail-strategyTime">' + escapeHtml(appointmentAt) + '</div>' : '')
                  +     '</div>'
                  +     '<span class="staff-retail-strategyBadge">' + escapeHtml(String((item && item.strategy_title) || 'Next move')) + '</span>'
                  +   '</div>'
                  +   (String((item && item.strategy_detail) || '').trim() ? '<p class="staff-retail-strategyDetail">' + escapeHtml(String((item && item.strategy_detail) || '')) + '</p>' : '')
                  +   ((priorProducts.length || concerns.length) ? '<div class="staff-retail-strategySignals">'
                    + (priorProducts.length ? '<div class="staff-retail-strategySignal"><span>Past retail</span><strong>' + escapeHtml(priorProducts.slice(0, 2).join(' · ')) + '</strong></div>' : '')
                    + (concerns.length ? '<div class="staff-retail-strategySignal"><span>Concerns</span><strong>' + escapeHtml(concerns.slice(0, 2).join(' · ')) + '</strong></div>' : '')
                    + '</div>' : '')
                  + '</article>';
              }).join('')
          +       '</div>'
          +     '</section>'
          : '')
          + '</div>';

        Array.prototype.slice.call(retailGameMount.querySelectorAll('[data-retail-board-window]')).forEach(function(button){
          button.addEventListener('click', function(){
            setRetailGameBoardWindow(button.getAttribute('data-retail-board-window') || 'current');
          });
        });
        Array.prototype.slice.call(retailGameMount.querySelectorAll('[data-retail-payroll-period]')).forEach(function(button){
          button.addEventListener('click', function(){
            var nextValue = String(button.getAttribute('data-retail-payroll-period') || '').trim();
            if (!nextValue || nextValue === String(activeRetailGamePayrollStart || '')) return;
            activeRetailGamePayrollStart = nextValue;
            activeRetailGameBoardWindow = 'current';
            loadRetailGameSection({ silent: false }).catch(function(error){
              if (retailGameMount) {
                retailGameMount.hidden = false;
                retailGameMount.innerHTML = '<div class="staff-retail-game-shell"><div class="staff-retail-game-empty">' + escapeHtml(humanizeClientFetchErrorMessage(error, 'Retail Success unavailable.')) + '</div></div>';
              }
              setDashboardSectionStatus(retailGameStatus, humanizeClientFetchErrorMessage(error, 'Retail Success unavailable.'), 'error');
            });
          });
        });
      }

      async function fetchRetailGameLeaderboard(range, staffName, mode){
        var leaderboardMode = String(mode || '').trim().toLowerCase() === 'assistant' ? 'assistant' : 'stylist';
        var body = {
          action: 'get-retail-sales-leaderboard',
          date_from: range && range.date_from ? range.date_from : '',
          date_to: range && range.date_to ? range.date_to : '',
          appointment_state: 'closed',
          leaderboard_mode: leaderboardMode
        };
        if (staffName && leaderboardMode !== 'assistant') body.staff_name = staffName;
        var response = await fetch(RETAIL_GAME_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || data.ok !== true || !data.sales_leaderboard) {
          throw new Error((data && data.error) || rawText || 'Could not load Retail Success.');
        }
        return Object.assign({}, data.sales_leaderboard, {
          _range: range || null
        });
      }

      async function fetchColorDisciplineStaffView(payrollStart){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) return null;
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'color-discipline-staff-view',
            staff_id: currentLoggedInStaff.id,
            payroll_start: payrollStart || ''
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || data.ok !== true) {
          throw new Error((data && data.error) || rawText || 'Could not load Color Discipline.');
        }
        return {
          periods: Array.isArray(data.periods) ? data.periods : [],
          selected_payroll_start: data.selected_payroll_start || '',
          current: data.current || null,
          previous: data.previous || null
        };
      }

      function stopRetailGameAutoRefresh(){
        if (retailGameRefreshTimer) {
          clearInterval(retailGameRefreshTimer);
          retailGameRefreshTimer = null;
        }
      }

      function startRetailGameAutoRefresh(){
        stopRetailGameAutoRefresh();
        if (!currentLoggedInStaff || !currentLoggedInStaff.name) return;
        retailGameRefreshTimer = setInterval(function(){
          if (appPage && appPage.hidden) return;
          loadRetailGameSection({ silent: true }).catch(function(){});
        }, RETAIL_GAME_REFRESH_MS);
      }

      function warmRetailGameSectionInBackground(options){
        var settings = options && typeof options === 'object' ? options : {};
        if (retailGameLoadPromise) return retailGameLoadPromise;
        retailGameLoadPromise = new Promise(function(resolve){
          window.setTimeout(resolve, 250);
        }).then(function(){
          return loadRetailGameSection({
            silent: settings.silent !== false
          });
        }).finally(function(){
          retailGameLoadPromise = null;
        });
        return retailGameLoadPromise;
      }

      async function loadRetailGameSection(options){
        var settings = options && typeof options === 'object' ? options : {};
        var leaderboardMode = getRetailGameMode();
        if (!currentLoggedInStaff || !currentLoggedInStaff.name) {
          renderRetailGame(null, null, null);
          renderStaffColorDiscipline(null, null);
          setDashboardSectionStatus(retailGameStatus, 'Retail Success unavailable.', 'error');
          setDashboardSectionStatus(staffColorDisciplineStatus, 'Color Discipline unavailable.', 'error');
          return;
        }
        if (!settings.silent) {
          setDashboardSectionStatus(retailGameStatus, 'Loading Retail Success...');
          setDashboardSectionStatus(staffColorDisciplineStatus, 'Loading Color Discipline...');
        }
        if (!activeRetailGamePayrollStart) {
          activeRetailGamePayrollStart = String(((buildRetailGamePayrollOptions(1)[0] || {}).value) || '');
        }
        if (!activeStaffColorDisciplinePayrollStart) {
          activeStaffColorDisciplinePayrollStart = activeRetailGamePayrollStart;
        }
        var currentRange = buildRetailGamePayrollRange(activeRetailGamePayrollStart);
        var previousRange = getRetailGameComparisonRange(activeRetailGamePayrollStart);
        var results = await withTimeout((async function(){
          var currentWeekPromise = fetchRetailGameLeaderboard(currentRange, '', leaderboardMode);
          var previousWeekPromise = previousRange
            ? fetchRetailGameLeaderboard(previousRange, '', leaderboardMode)
            : Promise.resolve(null);
          var colorDisciplinePromise = leaderboardMode === 'assistant'
            ? Promise.resolve(null)
            : fetchColorDisciplineStaffView(activeStaffColorDisciplinePayrollStart).catch(function(){ return null; });
          if (leaderboardMode === 'assistant') {
            var settled = await Promise.all([currentWeekPromise, previousWeekPromise]);
            currentColorDisciplineCurrentWeek = null;
            currentColorDisciplineLastWeek = null;
            currentColorDisciplinePeriods = [];
            return [settled[0], settled[1], settled[0]];
          }
          var settledResults = await Promise.all([
            currentWeekPromise,
            previousWeekPromise,
            fetchRetailGameLeaderboard(currentRange, currentLoggedInStaff.name, leaderboardMode),
            colorDisciplinePromise
          ]);
          currentColorDisciplinePeriods = settledResults[3] && Array.isArray(settledResults[3].periods) ? settledResults[3].periods : [];
          activeStaffColorDisciplinePayrollStart = String((settledResults[3] && settledResults[3].selected_payroll_start) || activeStaffColorDisciplinePayrollStart || '');
          currentColorDisciplineCurrentWeek = settledResults[3] && settledResults[3].current ? settledResults[3].current : null;
          currentColorDisciplineLastWeek = settledResults[3] && settledResults[3].previous ? settledResults[3].previous : null;
          return settledResults.slice(0, 3);
        })(), 45000, 'Retail Success took too long to load.');
        renderRetailGame(results[0], results[1], results[2]);
        renderStaffColorDiscipline(currentColorDisciplineCurrentWeek, currentColorDisciplineLastWeek, currentColorDisciplinePeriods);
        if (!shouldHideSalesForRole(String((currentLoggedInStaff && currentLoggedInStaff.role) || '').trim())) {
          renderSalesDashboardSection();
        }
        setDashboardSectionStatus(
          retailGameStatus,
          currentRange && currentRange.is_live_current
            ? ('Live retail attribution for the current payroll period through ' + String(currentRange.live_through || currentRange.date_to || '') + '.')
            : ('Closed payroll snapshot · ' + formatRetailGameRange(currentRange) + '.')
        );
        if (leaderboardMode === 'assistant') {
          setDashboardSectionStatus(staffColorDisciplineStatus, 'Color Discipline is shown for stylists with Vish reweigh data.');
        } else {
          setDashboardSectionStatus(
            staffColorDisciplineStatus,
            currentColorDisciplineCurrentWeek
              ? (currentColorDisciplineCurrentWeek.is_live_current
                  ? ('Current payroll Vish data through ' + String(currentColorDisciplineCurrentWeek.live_through || currentColorDisciplineCurrentWeek.report_end_date || '') + '.')
                  : ('Closed payroll snapshot · ' + String(currentColorDisciplineCurrentWeek.range_label || '') + '.'))
              : 'No Color Discipline snapshot is available yet.'
          );
        }
        startRetailGameAutoRefresh();
      }

      async function fetchStaffBonusPlans(){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id) return [];
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'bonus-staff-view',
            staff_id: currentLoggedInStaff.id
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load bonus details.');
        }
        return Array.isArray(data.plans) ? data.plans : [];
      }

      function buildServiceMixDataset(rows, staffName, config){
        var targetName = String(staffName || '').trim().toLowerCase();
        if (!targetName || !Array.isArray(rows)) {
          return { items: [], total_sales: 0, total_appointments: 0 };
        }

        var totals = {};
        var totalSalesFromAll = 0;
        var totalAppointmentsFromAll = 0;
        var groupingHeaders = detectServiceMixGroupingHeaders(rows);
        var candidateRows = [];

        rows.forEach(function(row){
          var rowStaff = getServiceMixStaffName(row).toLowerCase();
          var category = getServiceMixCategoryLabel(row);
          var locationName = String((row && row['Location name']) || '').trim().toLowerCase();
          var sales = parseNumericCell(row && (row['Service Sales'] || row.service_sales));
          var appointmentCount = parseNumericCell(row && (row['Appointment Count'] || row.appointment_count));
          var detailScore = 0;
          var hasAggregateGroupingValue = false;

          groupingHeaders.forEach(function(header){
            var headerValue = String((row && row[header]) || '').trim();
            if (!headerValue) return;
            if (isServiceMixAggregateValue(headerValue)) {
              hasAggregateGroupingValue = true;
              return;
            }
            detailScore += 1;
          });

          if (!rowStaff || rowStaff !== targetName) return;
          if (locationName === 'all') return;
          if (category && category.toLowerCase() === 'all') {
            totalSalesFromAll = sales;
            totalAppointmentsFromAll = appointmentCount;
            return;
          }
          if (!category) return;
          if (category.toLowerCase() === 'internal' || category.toLowerCase() === 'management') return;
          if (config && config.only_styling && !isStylingServiceMixCategory(category)) return;
          if (sales <= 0 && appointmentCount <= 0) return;
          candidateRows.push({
            category: category,
            sales: sales,
            appointments: appointmentCount,
            detail_score: detailScore,
            has_aggregate_grouping_value: hasAggregateGroupingValue
          });
        });

        var minimumDetailScore = null;
        candidateRows.forEach(function(item){
          if (minimumDetailScore == null || item.detail_score < minimumDetailScore) {
            minimumDetailScore = item.detail_score;
          }
        });

        candidateRows
          .filter(function(item){
            return minimumDetailScore == null || item.detail_score === minimumDetailScore;
          })
          .forEach(function(item){
            if (!totals[item.category]) {
              totals[item.category] = {
                sales: 0,
                appointments: 0
              };
            }
            totals[item.category].sales += item.sales;
            totals[item.category].appointments += item.appointments;
        });

        var items = Object.keys(totals).map(function(category){
          return {
            category: category,
            sales: totals[category].sales,
            appointments: totals[category].appointments
          };
        }).sort(function(a, b){
          var mode = config && config.mode ? config.mode : 'sales';
          if (mode === 'appointments') return b.appointments - a.appointments;
          if (b.sales !== a.sales) return b.sales - a.sales;
          return b.appointments - a.appointments;
        });

        var categorySalesTotal = items.reduce(function(sum, item){
          return sum + item.sales;
        }, 0);
        var categoryAppointmentsTotal = items.reduce(function(sum, item){
          return sum + item.appointments;
        }, 0);
        var totalSales = totalSalesFromAll > 0 ? totalSalesFromAll : categorySalesTotal;
        var totalAppointments = totalAppointmentsFromAll > 0 ? totalAppointmentsFromAll : categoryAppointmentsTotal;
        var mode = config && config.mode ? config.mode : 'sales';

        return {
          items: items.map(function(item){
            var sharePercent = mode === 'appointments'
              ? (totalAppointments > 0 ? (item.appointments / totalAppointments) * 100 : 0)
              : (totalSales > 0 ? (item.sales / totalSales) * 100 : 0);
            return {
              category: item.category,
              sales: item.sales,
              appointments: item.appointments,
              percent: totalSales > 0 ? (item.sales / totalSales) * 100 : 0,
              share_percent: sharePercent
            };
          }),
          total_sales: totalSales,
          total_appointments: totalAppointments
        };
      }

      function formatServiceMixSnapshotRange(windowData){
        if (!windowData) return '';
        var start = parseYmd(windowData.date_from);
        var end = parseYmd(windowData.date_to);
        if (!start || !end) return '';
        return start.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
          + ' - '
          + end.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
      }

      function buildServiceMixWindowLabel(snapshotKey){
        if (snapshotKey === 'service_mix_last_180_days') return 'Last 180 days';
        if (snapshotKey === 'service_mix_last_365_days') return 'Last 365 days';
        return 'Saved snapshot';
      }

      function getServiceMixPaletteColor(index){
        var palette = ['#E65A2C', '#F09A6D', '#E7B76E', '#9CBE79', '#5EA5A0', '#6D86C9', '#A882C9', '#D77AAE'];
        return palette[index % palette.length];
      }

      function renderServiceMix(windows, config){
        if (!serviceMixStatus || !serviceMix || !serviceMixPanels) return;

        var windowList = Array.isArray(windows) ? windows.filter(Boolean) : [];
        currentServiceMixWindows = windowList.slice();
        currentServiceMixConfig = config || null;
        if (!config || !windowList.length) {
          serviceMix.hidden = true;
          serviceMixPanels.innerHTML = '';
          setDashboardSectionStatus(serviceMixStatus, config ? 'No service mix yet.' : 'Not shown for this level.');
          return;
        }

        var activeWindowData = findServiceMixWindow(windowList, activeServiceMixWindow)
          || findServiceMixWindow(windowList, 'service_mix_last_180_days')
          || findServiceMixWindow(windowList, 'service_mix_last_365_days');
        if (activeWindowData) {
          activeServiceMixWindow = String(activeWindowData.snapshot_key || activeServiceMixWindow);
        }
        setDashboardToggleState(serviceMixTab180, serviceMixTab365, activeServiceMixWindow === 'service_mix_last_180_days' ? 'ytd' : '90d');
        serviceMix.hidden = false;
        serviceMixPanels.innerHTML = (activeWindowData ? [activeWindowData] : []).map(function(windowData){
          var dataset = windowData.dataset || { items: [], total_sales: 0, total_appointments: 0 };
          var items = Array.isArray(dataset.items) ? dataset.items.slice(0, 6) : [];
          return ''
            + '<article class="service-mix-panel">'
            +   '<div class="service-mix-panelHead">'
            +     '<h4 class="service-mix-panelTitle">' + escapeHtml(buildServiceMixWindowLabel(windowData.snapshot_key)) + '</h4>'
            +     '<div class="service-mix-panelMeta">' + escapeHtml(formatServiceMixSnapshotRange(windowData) || 'Most recent saved snapshot') + '</div>'
            +   '</div>'
            +   (items.length
                  ? '<div class="service-mix-strip">' + items.map(function(item, index){
                      var share = Math.max(0, Math.min(100, Number(item.share_percent) || 0));
                      return '<div class="service-mix-stripSegment" style="width:' + escapeHtml(String(share.toFixed(2))) + '%;background:' + escapeHtml(getServiceMixPaletteColor(index)) + '"></div>';
                    }).join('') + '</div>'
                  : '')
            +   (items.length
                  ? '<div class="service-mix-legend">' + items.map(function(item, index){
                      var metricBits = [];
                      if (config.mode === 'appointments') {
                        metricBits.push('<span class="service-mix-legendMetric"><strong>' + escapeHtml(formatNumericCell('Appointment Count', String(item.appointments || 0))) + '</strong> appts</span>');
                      } else if (config.mode === 'sales_and_appointments') {
                        metricBits.push('<span class="service-mix-legendMetric"><strong>' + escapeHtml(formatNumericCell('Service Sales', String(item.sales || 0))) + '</strong> sales</span>');
                        metricBits.push('<span class="service-mix-legendMetric"><strong>' + escapeHtml(formatNumericCell('Appointment Count', String(item.appointments || 0))) + '</strong> appts</span>');
                      } else {
                        metricBits.push('<span class="service-mix-legendMetric"><strong>' + escapeHtml(formatNumericCell('Service Sales', String(item.sales || 0))) + '</strong> sales</span>');
                      }
                      return ''
                        + '<div class="service-mix-legendItem">'
                        +   '<span class="service-mix-legendSwatch" style="background:' + escapeHtml(getServiceMixPaletteColor(index)) + '"></span>'
                        +   '<div class="service-mix-legendName">' + escapeHtml(getCompactServiceMixLabel(item.category)) + '</div>'
                        +   '<div class="service-mix-legendStats">'
                        +     '<span class="service-mix-legendShare">' + escapeHtml(formatPercentValue(item.share_percent || 0)) + '</span>'
                        +     metricBits.join('')
                        +   '</div>'
                        + '</div>';
                    }).join('') + '</div>'
                  : '<div class="service-mix-empty">' + escapeHtml(config.empty_copy || 'No service mix found in the latest saved snapshots.') + '</div>')
            + '</article>';
        }).join('');

        setDashboardSectionStatus(serviceMixStatus, formatSnapshotRefreshLabel(activeWindowData && activeWindowData.snapshot_date));
      }

      function shouldHideServiceMixForRole(role){
        var levelNumber = parseRoleLevelNumber(role);
        if (levelNumber == null) return false;
        return levelNumber === 0 || levelNumber === 1;
      }

      function shouldHideCoachingForRole(role){
        var normalized = String(role || '').trim().toLowerCase();
        if (!normalized) return false;
        return normalized.indexOf('manager') >= 0
          || normalized.indexOf('owner') >= 0;
      }

      function setSalesSectionHidden(hidden){
        if (!salesDashboardSection) return;
        salesDashboardSection.hidden = !!hidden;
        salesDashboardSection.style.display = hidden ? 'none' : '';
      }

      function setServiceMixSectionHidden(hidden){
        if (!serviceMixSection) return;
        serviceMixSection.hidden = !!hidden;
        serviceMixSection.style.display = hidden ? 'none' : '';
      }

      function setNextMoveSectionHidden(hidden){
        if (!nextMoveSection) return;
        nextMoveSection.hidden = !!hidden;
        nextMoveSection.style.display = hidden ? 'none' : '';
      }

      function setBonusSectionHidden(hidden){
        if (!bonusDashboardSection) return;
        bonusDashboardSection.hidden = !!hidden;
        bonusDashboardSection.style.display = hidden ? 'none' : '';
      }

      function setStaffCoachingSectionHidden(hidden){
        if (!staffCoachingSection) return;
        staffCoachingSection.hidden = !!hidden;
        staffCoachingSection.style.display = hidden ? 'none' : '';
      }

      function buildStaffRequestSummary(rows){
        var summary = {
          total_count: 0,
          pending_count: 0,
          approved_count: 0,
          denied_count: 0,
          future_approved_days: 0
        };
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var futureApproved = {};

        (Array.isArray(rows) ? rows : []).forEach(function(row){
          summary.total_count += 1;
          var status = String((row && row.status) || 'pending').trim().toLowerCase();
          if (status === 'approved') summary.approved_count += 1;
          else if (status === 'denied') summary.denied_count += 1;
          else summary.pending_count += 1;

          if (status !== 'approved') return;
          (Array.isArray(row && row.requested_dates) ? row.requested_dates : []).forEach(function(value){
            var parsed = parseYmd(value);
            if (!parsed) return;
            parsed.setHours(0, 0, 0, 0);
            if (parsed.getTime() < today.getTime()) return;
            futureApproved[formatDateInputValue(parsed)] = true;
          });
        });

        summary.future_approved_days = Object.keys(futureApproved).length;
        return summary;
      }

      function getStaffKpiMetricNumber(row, header){
        if (!row || !header) return 0;
        if (header === 'Utilization %' || header === 'Production Rate') {
          return parseNumericCell(getKpiDisplayValue(header, row) || 0);
        }
        return parseNumericCell(row[header] || 0);
      }

      function hasStaffKpiSummaryData(row){
        if (!row || typeof row !== 'object') return false;
        return parseNumericCell(row['Hours Booked']) > 0
          || parseNumericCell(row['Hours Scheduled']) > 0;
      }

      function buildStaffPerformanceAnalysisInput(context){
        var attendanceRow = context && context.attendanceRow ? context.attendanceRow : null;
        var kpiSummary = context && context.kpiSummary ? context.kpiSummary : null;
        var serviceMixRows = Array.isArray(context && context.serviceMixRows) ? context.serviceMixRows : [];
        var requestSummary = buildStaffRequestSummary(context && context.staffRequestRows);
        var staffName = String((context && context.staffName) || '').trim();
        var role = String((context && context.currentRole) || '').trim();
        var currentLevel = String((context && context.currentLevel) || getLevelLabel(staffName) || role).trim();

        return {
          staff_name: staffName,
          current_level: currentLevel,
          current_role: role,
          dashboard_window: 'ytd',
          attendance: {
            reliability_score: attendanceRow && attendanceRow.reliability_score != null ? Number(attendanceRow.reliability_score) : null,
            requests_off: attendanceRow ? Number(attendanceRow.requests_off || 0) : null,
            call_outs: attendanceRow ? Number(attendanceRow.call_outs || 0) : null,
            late_arrivals: attendanceRow ? Number(attendanceRow.late_arrivals || 0) : null
          },
          sales: {
            service_sales: kpiSummary ? getStaffKpiMetricNumber(kpiSummary, 'Service Sales') : null,
            appointments: kpiSummary ? getStaffKpiMetricNumber(kpiSummary, 'Appointment Count') : null,
            utilization: kpiSummary ? getStaffKpiMetricNumber(kpiSummary, 'Utilization %') : null,
            production: kpiSummary ? getStaffKpiMetricNumber(kpiSummary, 'Production Rate') : null
          },
          service_mix: serviceMixRows.slice(0, 6).map(function(item){
            return {
              category: item.category,
              sales: Number(item.sales) || 0,
              percent: Number(item.percent) || 0
            };
          }),
          requests: {
            total_count: Number(requestSummary.total_count || 0),
            approved_count: Number(requestSummary.approved_count || 0),
            pending_count: Number(requestSummary.pending_count || 0),
            denied_count: Number(requestSummary.denied_count || 0),
            future_approved_days: Number(requestSummary.future_approved_days || 0)
          }
        };
      }

      function formatCoachingMetricValue(value){
        var numeric = Number(value);
        if (!isFinite(numeric)) return '—';
        if (Math.abs(numeric - Math.round(numeric)) < 0.05) {
          return String(Math.round(numeric));
        }
        return numeric.toFixed(1);
      }

      function formatCoachingMetricGap(metric){
        if (!metric || typeof metric !== 'object') return '';
        var actual = Number(metric.actual);
        var target = Number(metric.target);
        var gap = Number(metric.gap);
        if (!target || !isFinite(actual)) return '';
        if (String(metric.status || '') === 'met') return 'Met';
        if (isFinite(gap) && gap > 0.05) {
          return formatCoachingMetricValue(actual) + ' / ' + formatCoachingMetricValue(target) + ' · ' + formatCoachingMetricValue(gap) + ' short';
        }
        return formatCoachingMetricValue(actual) + ' / ' + formatCoachingMetricValue(target);
      }

      function humanizeCoachingKey(value){
        return String(value || '')
          .replace(/[_-]+/g, ' ')
          .replace(/\b\w/g, function(match){ return match.toUpperCase(); })
          .trim();
      }

      function buildStaffCoachingSnapshot(context){
        if (!context || typeof context !== 'object') return '';
        var staffProfile = context.staff_profile && typeof context.staff_profile === 'object' ? context.staff_profile : {};
        var readiness = context.readiness_summary && typeof context.readiness_summary === 'object' ? context.readiness_summary : {};
        var benchmarks = context.benchmarks && typeof context.benchmarks === 'object' ? context.benchmarks : {};
        var promotionDelta = context.promotion_delta && typeof context.promotion_delta === 'object' ? context.promotion_delta : {};
        var pillHtml = [];
        var signalHtml = [];
        var benchmarkItems = [
          { label: 'Reliability', value: formatCoachingMetricGap(benchmarks.reliability) },
          { label: 'Utilization', value: formatCoachingMetricGap(benchmarks.utilization) },
          { label: 'Production', value: formatCoachingMetricGap(benchmarks.production) }
        ].filter(function(item){
          return item.value;
        });
        var blockers = Array.isArray(readiness.primary_blockers) ? readiness.primary_blockers.filter(Boolean) : [];
        var missedMetrics = Array.isArray(promotionDelta.missed_metrics) ? promotionDelta.missed_metrics.filter(function(item){
          return item && item.metric;
        }) : [];

        if (staffProfile.next_level) {
          pillHtml.push(
            '<div class="staff-coaching-pill">'
            + '<div class="staff-coaching-pillLabel">Next Level</div>'
            + '<div class="staff-coaching-pillValue">' + escapeHtml(String(staffProfile.next_level || '')) + '</div>'
            + '</div>'
          );
        }
        if (readiness.promotion_readiness) {
          pillHtml.push(
            '<div class="staff-coaching-pill">'
            + '<div class="staff-coaching-pillLabel">Readiness</div>'
            + '<div class="staff-coaching-pillValue">' + escapeHtml(humanizeCoachingKey(readiness.promotion_readiness)) + '</div>'
            + '</div>'
          );
        }
        if (readiness.track) {
          pillHtml.push(
            '<div class="staff-coaching-pill">'
            + '<div class="staff-coaching-pillLabel">Track</div>'
            + '<div class="staff-coaching-pillValue">' + escapeHtml(humanizeCoachingKey(readiness.track)) + '</div>'
            + '</div>'
          );
        }
        benchmarkItems.slice(0, 3).forEach(function(item){
          signalHtml.push(
            '<div class="staff-coaching-signal">'
            + '<div class="staff-coaching-signalLabel">' + escapeHtml(item.label) + '</div>'
            + '<div class="staff-coaching-signalValue">' + escapeHtml(item.value) + '</div>'
            + '</div>'
          );
        });
        if (missedMetrics.length) {
          missedMetrics.slice(0, 2).forEach(function(item){
            var metricLabel = humanizeCoachingKey(item.metric);
            signalHtml.push(
              '<div class="staff-coaching-signal">'
              + '<div class="staff-coaching-signalLabel">Main Gap</div>'
              + '<div class="staff-coaching-signalValue">' + escapeHtml(metricLabel + ': ' + formatCoachingMetricGap(item)) + '</div>'
              + '</div>'
            );
          });
        } else if (blockers.length) {
          signalHtml.push(
            '<div class="staff-coaching-signal">'
            + '<div class="staff-coaching-signalLabel">Primary Blockers</div>'
            + '<div class="staff-coaching-signalValue">' + escapeHtml(blockers.slice(0, 3).map(humanizeCoachingKey).join(', ')) + '</div>'
            + '</div>'
          );
        }

        if (!pillHtml.length && !signalHtml.length) return '';
        return ''
          + '<div class="staff-coaching-snapshot">'
          +   (pillHtml.length ? '<div class="staff-coaching-pills">' + pillHtml.join('') + '</div>' : '')
          +   (signalHtml.length ? '<div class="staff-coaching-signals">' + signalHtml.join('') + '</div>' : '')
          + '</div>';
      }

      function getLongWeekdayLabel(value){
        var text = value == null ? '' : String(value).trim();
        if (!text || text.toLowerCase() === 'all') return '';
        var parsed = new Date(text);
        if (isNaN(parsed.getTime())) return '';
        return parsed.toLocaleDateString(undefined, { weekday: 'long' });
      }

      function buildLevel4FloorInsight(headers, rows, snapshotLabel){
        var groupingHeader = detectKpiGroupingHeader(Array.isArray(headers) ? headers : [], Array.isArray(rows) ? rows : []);
        if (!groupingHeader) return null;

        var detailRows = selectKpiSummaryRows(headers, rows);
        if (!detailRows.length) return null;

        var weekdayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        var weekdayMap = {};

        detailRows.forEach(function(row){
          var longLabel = getLongWeekdayLabel(row && row[groupingHeader]);
          if (!longLabel) return;
          if (!weekdayMap[longLabel]) {
            weekdayMap[longLabel] = {
              weekday: longLabel,
              observed_days: 0,
              scheduled_days: 0,
              scheduled_floor_days: 0,
              active_floor_days: 0,
              low_util_days: 0,
              unscheduled_floor_days: 0,
              total_scheduled_hours: 0,
              total_scheduled_booked_hours: 0,
              total_booked_hours: 0,
              total_open_hours: 0,
              total_scheduled_appointments: 0,
              total_appointments: 0,
              total_scheduled_sales: 0,
              total_sales: 0,
              unscheduled_booked_hours: 0,
              unscheduled_appointments: 0
            };
          }
          var bucket = weekdayMap[longLabel];
          var hoursScheduled = parseNumericCell(row['Hours Scheduled']);
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          var appointmentCount = parseNumericCell(row['Appointment Count']);
          var serviceSales = parseNumericCell(row['Service Sales']);
          var isFloorDay = appointmentCount > 0 || hoursBooked > 0 || serviceSales > 0;
          var utilization = hoursScheduled > 0 ? (hoursBooked / hoursScheduled) : 0;

          bucket.observed_days += 1;
          bucket.total_appointments += appointmentCount;
          bucket.total_sales += serviceSales;
          bucket.total_booked_hours += hoursBooked;
          if (hoursScheduled > 0) {
            bucket.scheduled_days += 1;
            if (isFloorDay) {
              bucket.scheduled_floor_days += 1;
            }
            bucket.total_scheduled_hours += hoursScheduled;
            bucket.total_scheduled_booked_hours += hoursBooked;
            bucket.total_open_hours += Math.max(0, hoursScheduled - hoursBooked);
            bucket.total_scheduled_appointments += appointmentCount;
            bucket.total_scheduled_sales += serviceSales;
            if (utilization <= 0.55) bucket.low_util_days += 1;
          } else if (isFloorDay) {
            bucket.unscheduled_floor_days += 1;
            bucket.unscheduled_booked_hours += hoursBooked;
            bucket.unscheduled_appointments += appointmentCount;
          }
          if (isFloorDay) {
            bucket.active_floor_days += 1;
          }
        });

        var weekdayStats = weekdayOrder.map(function(label){
          return weekdayMap[label] || null;
        }).filter(Boolean);
        if (!weekdayStats.length) return null;

        weekdayStats.forEach(function(bucket){
          bucket.average_appointments = bucket.scheduled_floor_days > 0 ? (bucket.total_scheduled_appointments / bucket.scheduled_floor_days) : 0;
          bucket.average_booked_hours = bucket.scheduled_floor_days > 0 ? (bucket.total_scheduled_booked_hours / bucket.scheduled_floor_days) : 0;
          bucket.average_utilization = bucket.total_scheduled_hours > 0 ? (bucket.total_scheduled_booked_hours / bucket.total_scheduled_hours) : 0;
          bucket.floor_consistency = bucket.scheduled_days > 0 ? (bucket.scheduled_floor_days / bucket.scheduled_days) : 0;
          bucket.average_open_hours = bucket.scheduled_days > 0 ? (bucket.total_open_hours / bucket.scheduled_days) : 0;
          bucket.average_sales = bucket.scheduled_floor_days > 0 ? (bucket.total_scheduled_sales / bucket.scheduled_floor_days) : 0;
          bucket.average_minutes_per_appointment = bucket.total_scheduled_appointments > 0
            ? ((bucket.total_scheduled_booked_hours * 60) / bucket.total_scheduled_appointments)
            : 0;
        });

        var candidateDays = weekdayStats.filter(function(bucket){
          return bucket.scheduled_days > 0
            && bucket.scheduled_floor_days > 0
            && (bucket.scheduled_floor_days >= 2 || bucket.floor_consistency >= 0.45 || bucket.total_scheduled_booked_hours >= 6);
        }).sort(function(left, right){
          return right.scheduled_floor_days - left.scheduled_floor_days
            || right.floor_consistency - left.floor_consistency
            || right.total_scheduled_booked_hours - left.total_scheduled_booked_hours;
        });
        if (!candidateDays.length) {
          candidateDays = weekdayStats.filter(function(bucket){
            return bucket.scheduled_days > 0 && bucket.scheduled_floor_days > 0;
          }).sort(function(left, right){
            return right.scheduled_floor_days - left.scheduled_floor_days
              || right.total_scheduled_booked_hours - left.total_scheduled_booked_hours;
          });
        }
        var displayDays = candidateDays.slice(0, 3);
        if (!displayDays.length) return null;

        return {
          kicker: snapshotLabel || 'Recent KPI rows',
          headline: 'Likely building days',
          summary: '',
          overview: '',
          pills: [],
          signals: [],
          days: displayDays.map(function(bucket){
            return {
              weekday: bucket.weekday,
              floor_days: bucket.active_floor_days,
              scheduled_days: bucket.scheduled_days,
              utilization: bucket.total_scheduled_hours > 0 ? formatPercentValue(bucket.average_utilization * 100) : 'N/A',
              total_available_hours: bucket.total_scheduled_hours > 0 ? formatNumericCell('Hours Scheduled', String(bucket.total_scheduled_hours)) + ' total bookable hrs' : 'No scheduled hrs',
              free_time: bucket.total_scheduled_hours > 0 ? formatNumericCell('Hours Scheduled', String(bucket.average_open_hours)) + ' avg open hrs' : 'No scheduled hrs',
              appointments: formatNumericCell('Appointment Count', String(bucket.average_appointments)) + ' avg appts',
              average_time: bucket.average_minutes_per_appointment > 0 ? Math.round(bucket.average_minutes_per_appointment) + ' min per appt' : 'N/A'
            };
          })
        };
      }

      function renderLevel4FloorInsight(insight){
        if (!staffCoachingMount || !staffCoachingStatus) return;
        if (!insight || typeof insight !== 'object') {
          setStaffCoachingSectionHidden(true);
          staffCoachingMount.hidden = true;
          staffCoachingMount.innerHTML = '';
          setDashboardSectionStatus(staffCoachingStatus, '');
          return;
        }

        var signals = Array.isArray(insight.signals) ? insight.signals : [];
        var days = Array.isArray(insight.days) ? insight.days : [];

        setStaffCoachingSectionHidden(false);
        staffCoachingMount.hidden = false;
        staffCoachingMount.innerHTML = ''
          + '<div class="staff-coaching-shell">'
          +   '<div class="staff-coaching-hero">'
          +     '<div class="staff-coaching-kicker">' + escapeHtml(String(insight.kicker || 'Level 4 floor facts')) + '</div>'
          +     '<h4 class="staff-coaching-title">' + escapeHtml(String(insight.headline || 'Likely building days')) + '</h4>'
          +     '<p class="staff-coaching-copy">' + escapeHtml(String(insight.summary || '')) + '</p>'
          +     (insight.overview ? '<p class="staff-coaching-overview">' + escapeHtml(String(insight.overview || '')) + '</p>' : '')
          +     '<div class="staff-coaching-snapshot">'
          +       (signals.length ? '<div class="staff-coaching-signals">' + signals.map(function(item){
                return '<div class="staff-coaching-signal"><div class="staff-coaching-signalLabel">' + escapeHtml(String(item.label || '')) + '</div><div class="staff-coaching-signalValue">' + escapeHtml(String(item.value || '')) + '</div></div>';
                }).join('') + '</div>' : '')
          +     '</div>'
          +   '</div>'
          +   '<div class="staff-coaching-grid">'
          +     days.map(function(day){
                  return ''
                    + '<article class="staff-coaching-card">'
                    +   '<div class="staff-coaching-dayLabel">Likely floor day</div>'
                    +   '<h5 class="staff-coaching-dayTitle">' + escapeHtml(String(day.weekday || 'Weekday')) + '</h5>'
                    +   '<div class="staff-coaching-body">'
                    +     '<ul class="staff-coaching-list">'
                    +       '<li>Utilization: ' + escapeHtml(String(day.utilization || 'N/A')) + '</li>'
                    +       '<li>Total available: ' + escapeHtml(String(day.total_available_hours || 'N/A')) + '</li>'
                    +     '</ul>'
                    +   '</div>'
                    + '</article>';
                }).join('')
          +   '</div>'
          + '</div>';
        setDashboardSectionStatus(staffCoachingStatus, '');
      }

      function renderStaffCoaching(result, source, guideLinks, analysisContext){
        if (!staffCoachingMount) return;
        if (!result || typeof result !== 'object') {
          staffCoachingMount.hidden = true;
          staffCoachingMount.innerHTML = '';
          return;
        }

        var strengths = Array.isArray(result.strengths) ? result.strengths.filter(Boolean) : [];
        var nextSteps = Array.isArray(result.next_steps) ? result.next_steps.filter(Boolean) : [];
        var checkpoints = Array.isArray(result.training_checkpoints) ? result.training_checkpoints.filter(Boolean) : [];
        var focusAreas = Array.isArray(result.focus_areas) ? result.focus_areas.filter(function(item){
          return item && (item.title || item.reason);
        }) : [];
        var performanceOverview = String((result && result.performance_overview) || '').trim();
        var coachingSummary = String((result && result.coaching_summary) || '').trim();
        var coachingSnapshot = buildStaffCoachingSnapshot(analysisContext);
        var links = Array.isArray(guideLinks) ? guideLinks.filter(function(link){
          return link && link.href && link.label;
        }) : [];

        staffCoachingMount.hidden = false;
        staffCoachingMount.innerHTML = ''
          + '<div class="staff-coaching-shell">'
          +   '<div class="staff-coaching-hero">'
          +     '<div class="staff-coaching-kicker">' + escapeHtml(source === 'openai' ? 'OpenAI coaching read' : 'Progression guide read') + '</div>'
          +     '<h4 class="staff-coaching-title">' + escapeHtml(result.headline || 'Your next focus') + '</h4>'
          +     '<p class="staff-coaching-copy">' + escapeHtml(result.summary || '') + '</p>'
          +     (performanceOverview ? '<p class="staff-coaching-overview">' + escapeHtml(performanceOverview) + '</p>' : '')
          +     coachingSnapshot
          +   '</div>'
          +   '<div class="staff-coaching-grid">'
          +     '<article class="staff-coaching-card">'
          +       '<h5 class="staff-coaching-cardTitle">Strengths</h5>'
          +       '<div class="staff-coaching-body">'
          +         '<ul class="staff-coaching-list">' + strengths.map(function(item){
                      return '<li>' + escapeHtml(String(item || '')) + '</li>';
                    }).join('') + '</ul>'
          +       '</div>'
          +     '</article>'
          +     '<article class="staff-coaching-card">'
          +       '<h5 class="staff-coaching-cardTitle">Focus Now</h5>'
          +       '<div class="staff-coaching-focus">' + focusAreas.map(function(item){
                      return ''
                        + '<div class="staff-coaching-focusItem">'
                        +   '<div class="staff-coaching-focusTitle">' + escapeHtml(String(item.title || '')) + '</div>'
                        +   '<div class="staff-coaching-focusReason">' + escapeHtml(String(item.reason || '')) + '</div>'
                        + '</div>';
                    }).join('') + '</div>'
          +     '</article>'
          +     (checkpoints.length
                  ? '<article class="staff-coaching-card">'
                    + '<h5 class="staff-coaching-cardTitle">Checkpoints</h5>'
                    + '<div class="staff-coaching-body staff-coaching-body--tight">'
                    +   '<ul class="staff-coaching-list">' + checkpoints.map(function(item){
                          return '<li>' + escapeHtml(String(item || '')) + '</li>';
                        }).join('') + '</ul>'
                    + '</div>'
                    + '</article>'
                  : '')
          +     '<article class="staff-coaching-card staff-coaching-card--wide">'
          +       '<h5 class="staff-coaching-cardTitle">Next Steps</h5>'
          +       '<div class="staff-coaching-body">'
          +         '<ul class="staff-coaching-list">' + nextSteps.map(function(item){
                      return '<li>' + escapeHtml(String(item || '')) + '</li>';
                    }).join('') + '</ul>'
          +       '</div>'
          +     '</article>'
          +   '</div>'
          +   (coachingSummary
                ? '<div class="staff-coaching-progression">' + escapeHtml(coachingSummary) + '</div>'
                : '')
          +   (links.length
                ? '<div class="staff-coaching-links">' + links.map(function(link){
                    return '<a class="staff-coaching-link" href="' + escapeHtml(String(link.href || '')) + '" target="_blank" rel="noreferrer noopener">' + escapeHtml(String(link.label || 'Guide')) + '</a>';
                  }).join('') + '</div>'
                : '')
          + '</div>';
      }

      async function fetchStaffPerformanceAnalysis(input){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-performance-analysis',
            input: input
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.result) {
          throw new Error((data && data.error) || rawText || 'Could not build staff coaching guidance.');
        }
        return data;
      }

      async function fetchAttendanceSnapshot(snapshotKey){
        try {
          var snapshotResponse = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'attendance-totals-snapshot-get',
              snapshot_key: snapshotKey || 'attendance_ytd',
              refresh_if_missing: false
            })
          });
          var snapshotRawText = await snapshotResponse.text();
          var snapshotData = null;
          try {
            snapshotData = snapshotRawText ? JSON.parse(snapshotRawText) : null;
          } catch (_error) {
            snapshotData = null;
          }

          if (snapshotResponse.ok && snapshotData && snapshotData.ok && snapshotData.snapshot) {
            snapshotData.snapshot_source = 'saved';
            snapshotData.snapshot_date = snapshotData.snapshot.snapshot_date || '';
            return snapshotData;
          }
        } catch (_snapshotError) {
        }
        throw new Error('Could not load the latest saved attendance snapshot.');
      }

      async function fetchAttendanceYtdSnapshot(){
        return fetchAttendanceSnapshot('attendance_ytd');
      }

      async function fetchAttendance90DaySnapshot(){
        return fetchAttendanceSnapshot('attendance_last_90_days');
      }

      async function createKpiExportForRange(dateFromValue, dateToValue){
        var start = parseYmd(dateFromValue);
        var end = parseYmd(dateToValue);
        if (!start || !end) {
          throw new Error('Could not determine a valid YTD date range.');
        }

        var intervalDays = diffDaysInclusive(start, end);
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'create-report-export',
            report_id: KPI_REPORT_ID,
            file_content_type: 'CSV',
            frequency: 'ONCE',
            report_filters: [
              {
                attribute_name: 'Sale Date',
                relative_date_query: {
                  greater_equal: 'P' + String(intervalDays) + 'D'
                }
              }
            ]
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok || !data.report_export) {
          throw new Error((data && data.error) || 'Could not create KPI export.');
        }
        return data.report_export;
      }

      async function fetchKpiRowsForRange(dateFromValue, dateToValue){
        var createdExport = await createKpiExportForRange(dateFromValue, dateToValue);
        var readyExport = await waitForKpiExportReady(createdExport);
        var proxyResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'report-export-rows',
            file_url: readyExport.file_url
          })
        });
        var proxyData = await proxyResponse.json().catch(function(){ return null; });
        if (!proxyResponse.ok || !proxyData || !proxyData.ok) {
          throw new Error((proxyData && proxyData.error) || 'Could not load KPI rows.');
        }
        return {
          headers: Array.isArray(proxyData.headers) ? proxyData.headers : [],
          rows: Array.isArray(proxyData.rows) ? proxyData.rows : []
        };
      }

      async function fetchStaffKpiSnapshot(snapshotKey){
        var shouldRefreshIfMissing = String(snapshotKey || '').trim() === 'staff_kpi_last_7_days';
        try {
          var snapshotResponse = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'staff-kpi-snapshot-get',
              snapshot_key: snapshotKey || 'staff_kpi_ytd',
              refresh_if_missing: shouldRefreshIfMissing
            })
          });
          var snapshotRawText = await snapshotResponse.text();
          var snapshotData = null;
          try {
            snapshotData = snapshotRawText ? JSON.parse(snapshotRawText) : null;
          } catch (_error) {
            snapshotData = null;
          }

            if (snapshotResponse.ok && snapshotData && snapshotData.ok) {
              return {
                headers: Array.isArray(snapshotData.headers) ? snapshotData.headers : [],
                rows: Array.isArray(snapshotData.rows) ? snapshotData.rows : [],
                snapshot_source: 'saved',
                date_from: snapshotData.snapshot && snapshotData.snapshot.date_from
                  ? snapshotData.snapshot.date_from
                  : '',
                date_to: snapshotData.snapshot && snapshotData.snapshot.date_to
                  ? snapshotData.snapshot.date_to
                  : '',
                snapshot_date: snapshotData.snapshot && snapshotData.snapshot.snapshot_date
                  ? snapshotData.snapshot.snapshot_date
                  : ''
              };
            }
        } catch (_snapshotError) {
        }
        throw new Error('Could not load the latest saved staff KPI snapshot.');
      }

      async function fetchStaffKpiYtdSnapshot(){
        return fetchStaffKpiSnapshot('staff_kpi_ytd');
      }

      async function fetchGlobalKpiAnnualSnapshot(yearValue){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'global-kpi-annual-snapshot-get',
            year_value: String(yearValue || '').trim(),
            refresh_if_missing: true
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load annual KPI snapshot.');
        }
        return {
          snapshot: data.snapshot || null,
          headers: Array.isArray(data.headers) ? data.headers : [],
          rows: Array.isArray(data.rows) ? data.rows : []
        };
      }

      async function fetchStaffKpi90DaySnapshot(){
        return fetchStaffKpiSnapshot('staff_kpi_last_90_days');
      }

      async function fetchStaffKpi7DaySnapshot(){
        return fetchStaffKpiSnapshot('staff_kpi_last_7_days');
      }

      async function fetchStaffKpiSupplementalMetrics(dateFromValue, dateToValue){
        if (!currentLoggedInStaff || !currentLoggedInStaff.id || !dateFromValue || !dateToValue) return null;
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-kpi-supplemental-metrics',
            editor_staff_id: currentLoggedInStaff.id,
            date_from: dateFromValue,
            date_to: dateToValue
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load staff KPI supplemental metrics.');
        }
        var candidateNames = buildCurrentStaffCandidateNames();
        var targetStaffId = String((currentLoggedInStaff && currentLoggedInStaff.id) || '').trim();
        var rows = Array.isArray(data.rows) ? data.rows : [];
        var targetRow = findMatchingSupplementalRow(rows, targetStaffId, candidateNames);
        if (!targetRow) return null;
        return {
          attachRate: targetRow && targetRow.attach_rate != null ? ((Number(targetRow.attach_rate) || 0) / 100) : null,
          attachClosedAppointments: targetRow && targetRow.attach_closed_appointments != null ? Number(targetRow.attach_closed_appointments) || 0 : null,
          colorDisciplineReweighRate: targetRow && targetRow.color_discipline_reweigh_rate != null ? ((Number(targetRow.color_discipline_reweigh_rate) || 0) / 100) : null,
          colorDisciplineServices: targetRow && targetRow.color_discipline_services != null ? Number(targetRow.color_discipline_services) || 0 : null
        };
      }

      async function fetchServiceMixRows(dateFromValue, dateToValue){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'service-mix-report-rows',
            date_from: dateFromValue,
            date_to: dateToValue
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || 'Could not load Service Mix rows.');
        }
        return {
          headers: Array.isArray(data.headers) ? data.headers : [],
          rows: Array.isArray(data.rows) ? data.rows : [],
          export_filter_mode: String((data && data.export_filter_mode) || '').trim(),
          requested_report_filters: Array.isArray(data && data.requested_report_filters) ? data.requested_report_filters : []
        };
      }

      async function fetchServiceMixSnapshot(snapshotKey){
        var shouldRefreshIfMissing = String(snapshotKey || '').trim() === 'service_mix_last_90_days';
        try {
          var snapshotResponse = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'service-mix-snapshot-get',
              snapshot_key: snapshotKey || 'service_mix_ytd',
              refresh_if_missing: shouldRefreshIfMissing
            })
          });
          var snapshotRawText = await snapshotResponse.text();
          var snapshotData = null;
          try {
            snapshotData = snapshotRawText ? JSON.parse(snapshotRawText) : null;
          } catch (_error) {
            snapshotData = null;
          }

          if (snapshotResponse.ok && snapshotData && snapshotData.ok && snapshotData.snapshot) {
            return {
              headers: Array.isArray(snapshotData.headers) ? snapshotData.headers : [],
              rows: Array.isArray(snapshotData.rows) ? snapshotData.rows : [],
              snapshot_source: 'saved',
              snapshot_key: String(snapshotKey || 'service_mix_ytd'),
              date_from: snapshotData.snapshot && snapshotData.snapshot.date_from
                ? snapshotData.snapshot.date_from
                : '',
              date_to: snapshotData.snapshot && snapshotData.snapshot.date_to
                ? snapshotData.snapshot.date_to
                : '',
              snapshot_date: snapshotData.snapshot && snapshotData.snapshot.snapshot_date
                ? snapshotData.snapshot.snapshot_date
                : ''
            };
          }
        } catch (_snapshotError) {
        }
        throw new Error('Could not load the latest saved service mix snapshot.');
      }

      async function fetchServiceMixSnapshotBundle(){
        var snapshotKeys = ['service_mix_last_180_days', 'service_mix_last_365_days'];
        var settled = await Promise.allSettled(snapshotKeys.map(function(snapshotKey){
          return fetchServiceMixSnapshot(snapshotKey);
        }));
        var windows = {};
        var availableCount = 0;

        settled.forEach(function(result, index){
          var snapshotKey = snapshotKeys[index];
          if (result && result.status === 'fulfilled' && result.value) {
            windows[snapshotKey] = result.value;
            availableCount += 1;
          } else {
            windows[snapshotKey] = null;
          }
        });

        if (!availableCount) {
          throw new Error('Could not load the latest saved service mix snapshots.');
        }

        return {
          snapshot_source: 'saved',
          available_count: availableCount,
          windows: windows
        };
      }

      function canonicalStaffName(value){
        var raw = String(value || '').trim().toLowerCase();
        if (!raw) return '';
        var cleaned = raw.replace(/[^\w\s'-]+/g, ' ').replace(/\s+/g, ' ').trim();
        if (!cleaned) return '';
        var parts = cleaned.split(' ');
        if (!parts.length) return cleaned;

        var first = parts[0];
        var aliases = {
          jo: 'josephine',
          josie: 'josephine',
          joe: 'joseph',
          jen: 'jennifer',
          jenn: 'jennifer',
          jenna: 'jennifer',
          mike: 'michael',
          nikki: 'nicole',
          allie: 'allison',
          ally: 'allison',
          sam: 'samantha',
          gina: 'regina',
          regina: 'regina',
          allison: 'allison',
          alex: 'alexandra',
          six: 'six'
        };
        parts[0] = aliases[first] || first;
        return parts.join(' ');
      }

      function sameStaffName(left, right){
        var normalizedLeft = canonicalStaffName(left);
        var normalizedRight = canonicalStaffName(right);
        if (!normalizedLeft || !normalizedRight) return false;
        if (normalizedLeft === normalizedRight) return true;

        var leftParts = normalizedLeft.split(' ');
        var rightParts = normalizedRight.split(' ');
        var leftFirst = leftParts[0] || '';
        var rightFirst = rightParts[0] || '';
        if (leftParts.length === 1 || rightParts.length === 1) {
          return !!leftFirst && !!rightFirst && (
            leftFirst === rightFirst
            || leftFirst.indexOf(rightFirst) === 0
            || rightFirst.indexOf(leftFirst) === 0
          );
        }
        if (leftParts.length < 2 || rightParts.length < 2) return false;

        var leftLast = leftParts[leftParts.length - 1];
        var rightLast = rightParts[rightParts.length - 1];
        if (leftLast !== rightLast) return false;

        return leftFirst === rightFirst
          || leftFirst.indexOf(rightFirst) === 0
          || rightFirst.indexOf(leftFirst) === 0;
      }

      function withTimeout(promise, timeoutMs, message){
        return new Promise(function(resolve, reject){
          var settled = false;
          var timer = setTimeout(function(){
            if (settled) return;
            settled = true;
            reject(new Error(message || 'Request timed out.'));
          }, Math.max(1, Number(timeoutMs) || 1));

          promise.then(function(value){
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            resolve(value);
          }).catch(function(error){
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            reject(error);
          });
        });
      }

      async function loadPersonalDashboard(){
        if (!currentLoggedInStaff) return;
        var requestToken = ++personalDashboardRequestToken;
        var dashboardStaff = Object.assign({}, currentLoggedInStaff);
        function isStaleDashboardRequest(){
          if (requestToken !== personalDashboardRequestToken) return true;
          if (!currentLoggedInStaff) return true;
          var currentStaffId = String((currentLoggedInStaff && currentLoggedInStaff.id) || '').trim();
          var dashboardStaffId = String((dashboardStaff && dashboardStaff.id) || '').trim();
          if (currentStaffId && dashboardStaffId) {
            return currentStaffId !== dashboardStaffId;
          }
          return !sameStaffName(currentLoggedInStaff && currentLoggedInStaff.name, dashboardStaff && dashboardStaff.name);
        }

        if (personalDashboard) personalDashboard.hidden = false;
        var fullName = String((dashboardStaff && dashboardStaff.name) || '').trim() || 'Staff Member';
        var roleLabel = String((dashboardStaff && (dashboardStaff.level || dashboardStaff.role)) || '').trim();
        var levelNumber = currentLoggedInProgressionState && currentLoggedInProgressionState.profile && currentLoggedInProgressionState.profile.current_level != null
          ? Number(currentLoggedInProgressionState.profile.current_level)
          : resolveRequestOffLevelNumber(roleLabel, fullName);
        var showLevel4FloorInsight = levelNumber === 4;
        var hideSales = shouldHideSalesForRole(roleLabel);
        var serviceMixConfig = getServiceMixDisplayConfig(roleLabel);
        var hideServiceMix = !serviceMixConfig || shouldHideServiceMixForRole(roleLabel);
        var hideNextMove = false;
        var hideBonus = false;
        if (dashboardHeroTitle) dashboardHeroTitle.textContent = fullName;
        var salesDashboardTitleNode = document.getElementById('salesDashboardTitle');
        if (salesDashboardTitleNode) salesDashboardTitleNode.textContent = 'Staff Level KPI';
        if (personalDashboardLevelBadge) {
          personalDashboardLevelBadge.hidden = !roleLabel;
          personalDashboardLevelBadge.textContent = roleLabel || 'Level';
        }
        setSalesSectionHidden(hideSales);
        setServiceMixSectionHidden(hideServiceMix);
        setNextMoveSectionHidden(hideNextMove);
        setBonusSectionHidden(hideBonus);
        setStaffCoachingSectionHidden(true);
        if (staffCoachingMount) {
          staffCoachingMount.hidden = true;
          staffCoachingMount.innerHTML = '';
        }
        if (staffCoachingStatus) {
          setDashboardSectionStatus(staffCoachingStatus, '');
        }
        if (serviceMixTitle) {
          serviceMixTitle.textContent = serviceMixConfig && serviceMixConfig.title
            ? serviceMixConfig.title
            : 'Service Mix';
        }
        setPersonalDashboardStatus('Loading...');
        currentAttendanceYtdRow = null;
        currentAttendance90Row = null;
        currentAttendanceYtdSnapshotDate = '';
        currentAttendance90SnapshotDate = '';
        currentSalesYtdSummary = null;
        currentSales90Summary = null;
        currentSalesYtdSnapshotDate = '';
        currentSales90SnapshotDate = '';
        currentSalesYtdWindow = null;
        currentSales90Window = null;
        currentSalesYtdSupplemental = null;
        currentSales90Supplemental = null;
        currentSalesYtdHeaders = [];
        currentSales90Headers = [];
        currentSalesYtdDetailRows = [];
        currentSales90DetailRows = [];
        personalStaffGrowthDataset = null;
        personalLevel7ActivePeriod = '2026_ytd';
        personalLevel7AttendanceByPeriod = {};
        personalLevel7SupplementalByPeriod = {};
        personalLevel7SupplementalLoading = {};
        renderAttendanceDashboardSection();
        if (!hideSales) {
          renderPersonalLevel7LoadingState();
          setDashboardSectionStatus(salesDashboardStatus, 'Loading staff level KPI...');
        }
        setDashboardSectionStatus(retailGameStatus, 'Loading Retail Success...');
        if (!hideServiceMix) setDashboardSectionStatus(serviceMixStatus, 'Loading saved service mix snapshots...');
        if (!hideNextMove) setDashboardSectionStatus(nextMoveStatus, 'Loading next-step requirements...');
        if (!hideBonus) setDashboardSectionStatus(bonusDashboardStatus, 'Checking bonus visibility...');
        renderRetailGame(null, null, null);
        renderServiceMix([], serviceMixConfig);
        renderNextMove(null);
        renderStaffBonusPlans([]);
        requestOffQueue = [];
        todoItems = [];
        todoManagers = [];
        renderPersonalRequests([]);
        renderOpenShiftState([]);
        renderTodoManagerPicker([]);
        renderTodoItems([]);
        renderSupplyRequests([]);
        setOpenShiftsStatus('Loading open shifts...');
        setTodoStatus('Loading your to-do list...');
        setSupplyStatus('Loading your supply requests...');

        var attendancePromise = fetchAttendanceYtdSnapshot();
        var attendance90Promise = fetchAttendance90DaySnapshot();
        var requestQueuePromise = fetchRequestOffQueue();
        var shiftChangePromise = fetchShiftChangeQueue();
        var todoViewPromise = fetchTodoView();
        var supplyRequestsPromise = fetchSupplyRequests();
        var bonusPlansPromise = hideBonus ? Promise.resolve([]) : fetchStaffBonusPlans();
        var retailGamePromise = warmRetailGameSectionInBackground({ silent: false });
        var shouldLoadKpiBenchmarks = !hideNextMove;
        var salesPromise = shouldLoadKpiBenchmarks
          ? withTimeout(fetchStaffKpiYtdSnapshot(), 45000, 'Saved YTD KPI snapshot took too long to load.')
          : Promise.resolve(null);
        var kpi90Promise = shouldLoadKpiBenchmarks
          ? withTimeout(fetchStaffKpi90DaySnapshot(), 45000, 'Saved 90-day KPI snapshot took too long to load.')
          : Promise.resolve(null);
        var personalLevel7Promise = hideSales
          ? Promise.resolve(null)
          : withTimeout(fetchPersonalLevel7SnapshotBundle(), 45000, 'Staff level KPI snapshot took too long to load.');
        var serviceMixPromise = hideServiceMix
          ? Promise.resolve({
              windows: {},
              snapshot_source: 'hidden'
            })
          : withTimeout(
              fetchServiceMixSnapshotBundle(),
              45000,
              'Service mix snapshots took too long to load.'
            );

        var attendanceError = null;
        var kpiError = null;
        var requestQueueError = null;
        var serviceMixError = null;
        var bonusError = null;
        var retailGameError = null;
        var coachingError = null;
        var hasPartialData = false;
        var attendanceRow = null;
        var serviceMixWindows = [];
        var staffRequestRows = [];
        var todoRows = [];
        var supplyRequestRows = [];
        var publishedBonusPlans = [];
        var attendanceSnapshotDate = '';
        var attendance90Row = null;

        var attendanceHandled = attendancePromise.then(function(attendanceData){
          if (isStaleDashboardRequest()) return;
          attendanceSnapshotDate = String((attendanceData && attendanceData.snapshot_date) || '').trim();
          attendanceRow = Array.isArray(attendanceData && attendanceData.leaderboard)
            ? attendanceData.leaderboard.find(function(row){
                return sameStaffName(row && row.staff_name, dashboardStaff.name);
              }) || null
            : null;
          currentAttendanceYtdRow = normalizeAttendanceRowForBenchmarks(attendanceRow, attendanceSnapshotDate);
          currentAttendanceYtdSnapshotDate = attendanceSnapshotDate;
          renderAttendanceDashboardSection();
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          attendanceError = error;
          currentAttendanceYtdRow = null;
          currentAttendanceYtdSnapshotDate = '';
          renderDashboardLoadingCards(attendanceDashboardGrid, 4);
          setDashboardSectionStatus(attendanceDashboardStatus, 'Attendance unavailable.', 'error');
        });

        var requestsHandled = requestQueuePromise.then(function(requestQueueData){
          if (isStaleDashboardRequest()) return;
          staffRequestRows = Array.isArray(requestQueueData)
            ? requestQueueData.filter(function(row){
                return sameStaffName(row && row.staff_name, dashboardStaff.name);
              })
            : [];
          requestOffQueue = staffRequestRows.slice();
          renderPersonalRequests(staffRequestRows);
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          requestQueueError = error;
          requestOffQueue = [];
          renderPersonalRequests([]);
        });

        var shiftChangeHandled = shiftChangePromise.then(function(shiftChangeData){
          if (isStaleDashboardRequest()) return;
          shiftChangeQueue = Array.isArray(shiftChangeData) ? shiftChangeData : [];
          renderOpenShiftState(shiftChangeQueue);
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          renderOpenShiftState([]);
          setOpenShiftsStatus(humanizeClientFetchErrorMessage(error, 'Could not load open shifts.'), 'error');
        });

        var todoHandled = todoViewPromise.then(function(todoData){
          if (isStaleDashboardRequest()) return;
          todoRows = Array.isArray(todoData && todoData.rows) ? todoData.rows : [];
          todoManagers = Array.isArray(todoData && todoData.managers) ? todoData.managers : [];
          todoItems = todoRows.slice();
          renderTodoManagerPicker(todoManagers);
          renderTodoItems(todoRows);
          setTodoStatus(todoRows.length ? 'Open and completed to-dos are listed below.' : 'Nothing posted yet.');
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          todoManagers = [];
          todoItems = [];
          renderTodoManagerPicker([]);
          renderTodoItems([]);
          setTodoStatus(humanizeClientFetchErrorMessage(error, 'Could not load your to-do list.'), 'error');
        });

        var supplyHandled = supplyRequestsPromise.then(function(supplyRequestData){
          if (isStaleDashboardRequest()) return;
          supplyRequestRows = Array.isArray(supplyRequestData && supplyRequestData.rows) ? supplyRequestData.rows : [];
          renderSupplySuggestions(Array.isArray(supplyRequestData && supplyRequestData.suggestions) ? supplyRequestData.suggestions : []);
          supplyRequests = supplyRequestRows.slice();
          renderSupplyRequests(supplyRequestRows);
          var activeSupplyRows = supplyRequestRows.filter(function(row){
            var status = String((row && row.status) || '').trim().toLowerCase();
            return status !== 'ordered' && status !== 'dismissed' && status !== 'received';
          });
          setSupplyStatus(activeSupplyRows.length ? 'Only your active supply requests are shown below.' : 'No active supply requests right now.');
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          renderSupplySuggestions([]);
          renderSupplyRequests([]);
          setSupplyStatus(humanizeClientFetchErrorMessage(error, 'Could not load your supply requests.'), 'error');
        });

        var bonusHandled = bonusPlansPromise.then(function(plans){
          if (isStaleDashboardRequest()) return;
          publishedBonusPlans = Array.isArray(plans) ? plans : [];
          renderStaffBonusPlans(publishedBonusPlans);
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          bonusError = error;
          renderStaffBonusPlans([]);
        });

        var retailGameHandled = retailGamePromise.catch(function(error){
          if (isStaleDashboardRequest()) return;
          retailGameError = error;
          renderRetailGame(null, null, null);
          renderStaffColorDiscipline(null, null);
          if (retailGameMount) {
            retailGameMount.hidden = false;
            retailGameMount.innerHTML = '<div class="staff-retail-game-shell"><div class="staff-retail-game-empty">' + escapeHtml(humanizeClientFetchErrorMessage(error, 'Retail Success unavailable.')) + '</div></div>';
          }
          if (staffColorDisciplineMount) {
            staffColorDisciplineMount.hidden = false;
            staffColorDisciplineMount.innerHTML = '<div class="staff-retail-game-shell"><div class="staff-retail-game-empty">' + escapeHtml(humanizeClientFetchErrorMessage(error, 'Color Discipline unavailable.')) + '</div></div>';
          }
          setDashboardSectionStatus(retailGameStatus, humanizeClientFetchErrorMessage(error, 'Retail Success unavailable.'), 'error');
          setDashboardSectionStatus(staffColorDisciplineStatus, humanizeClientFetchErrorMessage(error, 'Color Discipline unavailable.'), 'error');
        });

        var personalLevel7Handled = personalLevel7Promise.then(function(payload){
          if (isStaleDashboardRequest() || hideSales || !payload) return;
          personalStaffGrowthDataset = buildPersonalStaffGrowthDataset(payload.headers, payload.rows, payload.snapshot, payload.directoryStaff);
          renderSalesDashboardSection();
          var attendanceDatesByPeriod = {
            '2021': '2021-12-31',
            '2022': '2022-12-31',
            '2023': '2023-12-31',
            '2024': '2024-12-31',
            '2025': '2025-12-31',
            '2026_ytd': formatDateInputValue(startOfLocalDay(new Date()))
          };
          Object.keys(attendanceDatesByPeriod).forEach(function(periodKey){
            fetchPersonalAttendanceCoverage(attendanceDatesByPeriod[periodKey]).then(function(coverage){
              if (isStaleDashboardRequest()) return;
              personalLevel7AttendanceByPeriod[periodKey] = coverage || {};
              if (periodKey === personalLevel7ActivePeriod) renderSalesDashboardSection();
            }).catch(function(){
              if (isStaleDashboardRequest()) return;
              personalLevel7AttendanceByPeriod[periodKey] = {};
              if (periodKey === personalLevel7ActivePeriod) renderSalesDashboardSection();
            });
          });
          ensurePersonalLevel7Supplemental(personalLevel7ActivePeriod);
        }).catch(function(error){
          if (isStaleDashboardRequest() || hideSales) return;
          salesDashboardGrid.className = 'empty';
          salesDashboardGrid.innerHTML = escapeHtml(humanizeClientFetchErrorMessage(error, 'Could not load staff level KPI.'));
          setDashboardSectionStatus(salesDashboardStatus, 'Staff level KPI unavailable.', 'error');
        });

        var attendance90Handled = attendance90Promise.then(function(attendanceData){
          if (isStaleDashboardRequest()) return;
          currentAttendance90SnapshotDate = String((attendanceData && attendanceData.snapshot_date) || '').trim();
          attendance90Row = Array.isArray(attendanceData && attendanceData.leaderboard)
            ? attendanceData.leaderboard.find(function(row){
                return sameStaffName(row && row.staff_name, dashboardStaff.name);
              }) || null
            : null;
          currentAttendance90Row = normalizeAttendanceRowForBenchmarks(attendance90Row, currentAttendance90SnapshotDate);
          renderAttendanceDashboardSection();
        }).catch(function(){
          if (isStaleDashboardRequest()) return;
          attendance90Row = null;
          currentAttendance90Row = null;
          currentAttendance90SnapshotDate = '';
        });

        var salesHandled = salesPromise.then(function(snapshotData){
          if (isStaleDashboardRequest() || !snapshotData) return;
          currentSalesYtdHeaders = Array.isArray(snapshotData.headers) ? snapshotData.headers.slice() : [];
          currentSalesYtdWindow = snapshotData || null;
          currentSalesYtdSnapshotDate = String((snapshotData && snapshotData.snapshot_date) || '').trim();
          var matchedYtd = buildCurrentStaffKpiSnapshotSummary(currentSalesYtdHeaders, snapshotData.rows);
          currentSalesYtdSummary = matchedYtd.summaryRow;
          currentSalesYtdDetailRows = matchedYtd.detailRows;
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          kpiError = error;
          currentSalesYtdSummary = null;
          currentSalesYtdHeaders = [];
          currentSalesYtdDetailRows = [];
          currentSalesYtdWindow = null;
          currentSalesYtdSnapshotDate = '';
        });
        var kpi90Handled = kpi90Promise.then(function(snapshotData){
          if (isStaleDashboardRequest() || !snapshotData) return;
          currentSales90Headers = Array.isArray(snapshotData.headers) ? snapshotData.headers.slice() : [];
          currentSales90Window = snapshotData || null;
          currentSales90SnapshotDate = String((snapshotData && snapshotData.snapshot_date) || '').trim();
          var matched90 = buildCurrentStaffKpiSnapshotSummary(currentSales90Headers, snapshotData.rows);
          currentSales90Summary = matched90.summaryRow;
          currentSales90DetailRows = matched90.detailRows;
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          kpiError = error;
          currentSales90Summary = null;
          currentSales90Headers = [];
          currentSales90DetailRows = [];
          currentSales90Window = null;
          currentSales90SnapshotDate = '';
        });

        var serviceMixHandled = serviceMixPromise.then(function(serviceMixData){
          if (isStaleDashboardRequest()) return;
          if (hideServiceMix) return;
          var windows = serviceMixData && serviceMixData.windows ? serviceMixData.windows : {};
          serviceMixWindows = ['service_mix_last_180_days', 'service_mix_last_365_days'].map(function(snapshotKey){
            var windowData = windows[snapshotKey];
            if (!windowData) return null;
            return {
              snapshot_key: snapshotKey,
              date_from: windowData.date_from,
              date_to: windowData.date_to,
              snapshot_date: windowData.snapshot_date,
              dataset: buildServiceMixDataset(windowData.rows, dashboardStaff && dashboardStaff.name, serviceMixConfig)
            };
          }).filter(Boolean);
          renderServiceMix(serviceMixWindows, serviceMixConfig);
        }).catch(function(error){
          if (isStaleDashboardRequest()) return;
          serviceMixError = error;
          if (!hideServiceMix) {
            renderServiceMix([], serviceMixConfig);
            setDashboardSectionStatus(serviceMixStatus, 'Service mix unavailable.', 'error');
          }
        });

        await Promise.allSettled([attendanceHandled, attendance90Handled, requestsHandled, shiftChangeHandled, todoHandled, supplyHandled, salesHandled, kpi90Handled, personalLevel7Handled, serviceMixHandled, bonusHandled]);
        if (isStaleDashboardRequest()) return;

        if (attendanceError && kpiError && requestQueueError && serviceMixError) {
          setPersonalDashboardStatus('Dashboard unavailable.', 'error');
          return;
        }
        if (attendanceError || (!hideSales && kpiError)) {
          setPersonalDashboardStatus('Partial data loaded.', 'error');
          return;
        }
        if (requestQueueError || serviceMixError || bonusError) {
          hasPartialData = true;
          setPersonalDashboardStatus('Partial data loaded.', 'error');
        }

        var kpiSummary = currentSalesYtdSummary || getPersonalKpiSummaryForBenchmarks() || null;
        var kpi90Summary = currentSales90Summary || null;
        var kpiSnapshotDate = currentSalesYtdSnapshotDate
          || currentSales90SnapshotDate
          || String((personalStaffGrowthDataset && personalStaffGrowthDataset.snapshot && personalStaffGrowthDataset.snapshot.updated_at) || '').trim();

        renderNextMove(buildNextMoveState(
          roleLabel,
          dashboardStaff && dashboardStaff.bio,
          attendance90Row,
          kpi90Summary || kpiSummary,
          serviceMixWindows,
          currentLoggedInProgressionState
        ));

        if (showLevel4FloorInsight) {
          var floorInsight = buildLevel4FloorInsight(
            currentSales90Headers.length ? currentSales90Headers : currentSalesYtdHeaders,
            currentSales90DetailRows.length ? currentSales90DetailRows : currentSalesYtdDetailRows,
            currentSales90DetailRows.length ? 'Last 90 days' : 'Year to date'
          );
          renderLevel4FloorInsight(floorInsight);
        } else {
          renderLevel4FloorInsight(null);
        }

        if (!hasPartialData) {
          var dashboardSnapshotDates = [
            attendanceSnapshotDate,
            kpiSnapshotDate
          ].concat(serviceMixWindows.map(function(item){
            return String((item && item.snapshot_date) || '').trim();
          })).filter(Boolean).sort();
          setPersonalDashboardStatus(formatSnapshotRefreshLabel(dashboardSnapshotDates[dashboardSnapshotDates.length - 1] || ''));
        }
      }

      async function applyLoggedInStaffContext(){
        if (!currentLoggedInStaff) return;
        var requestToken = ++loggedInStaffContextRequestToken;
        try {
          var latestEntries = await fetchStaffDirectoryEntries();
          if (requestToken !== loggedInStaffContextRequestToken) return;
          var refreshedStaff = Array.isArray(latestEntries) ? latestEntries.find(function(member){
            return String((member && member.id) || '').trim() === String((currentLoggedInStaff && currentLoggedInStaff.id) || '').trim()
              || sameStaffName(member && member.name, currentLoggedInStaff && currentLoggedInStaff.name);
          }) : null;
          if (refreshedStaff) {
            currentLoggedInStaff = Object.assign({}, currentLoggedInStaff, refreshedStaff);
            try {
              window.localStorage.setItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY, JSON.stringify(currentLoggedInStaff));
            } catch (_error) {
            }
            persistSharedStaffSession(currentLoggedInStaff);
          }
        } catch (_error) {
        }
        try {
          currentLoggedInProgressionState = null;
          if (currentLoggedInStaff && currentLoggedInStaff.id) {
            var progressionResponse = await fetch(REPORT_PROXY_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                action: 'progression-staff-get',
                staff_id: currentLoggedInStaff.id
              })
            });
            if (requestToken !== loggedInStaffContextRequestToken) return;
            var progressionRawText = await progressionResponse.text();
            if (requestToken !== loggedInStaffContextRequestToken) return;
            var progressionData = null;
            try {
              progressionData = progressionRawText ? JSON.parse(progressionRawText) : null;
            } catch (_error) {
              progressionData = null;
            }
            if (progressionResponse.ok && progressionData && progressionData.ok && progressionData.staff && progressionData.draft) {
              currentLoggedInProgressionState = {
                staff: progressionData.staff,
                profile: progressionData.profile || null,
                draft: progressionData.draft
              };
              currentLoggedInStaff = Object.assign({}, currentLoggedInStaff, progressionData.staff || {});
              try {
                window.localStorage.setItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY, JSON.stringify(currentLoggedInStaff));
              } catch (_error) {
              }
              persistSharedStaffSession(currentLoggedInStaff);
            }
          }
        } catch (_error) {
          currentLoggedInProgressionState = null;
        }
        if (requestToken !== loggedInStaffContextRequestToken) return;
        var requestOffInitPromise = initializeRequestOffForm();
        var dashboardPromise = loadPersonalDashboard();
        await requestOffInitPromise;
        if (requestToken !== loggedInStaffContextRequestToken) return;
        if (requestOffStaff) {
          var matchedOption = requestOffStaffOptions.find(function(option){
            return sameStaffName(option && option.name, currentLoggedInStaff.name)
              || String((option && option.id) || '').trim() === String(currentLoggedInStaff.id || '').trim();
          }) || null;
          if (matchedOption) {
            requestOffStaff.value = matchedOption.id || '';
          }
          requestOffStaff.disabled = true;
        }
        renderRequestOffSelectedStaff();
        await dashboardPromise;
      }

      function setStaffDirectoryStatus(text, tone){
        if (!staffDirectoryStatus) return;
        staffDirectoryStatus.textContent = String(text || '');
        staffDirectoryStatus.className = 'staff-directory-status' + (tone ? ' staff-directory-status--' + tone : '');
      }

      function formatDirectoryLink(type, value){
        var clean = String(value || '').trim();
        if (!clean) return '<span class="staff-directory-value is-empty">Not available</span>';

        if (type === 'phone') {
          return '<span class="staff-directory-value"><a href="tel:' + escapeHtml(clean.replace(/\s+/g, '')) + '">' + escapeHtml(clean) + '</a></span>';
        }

        if (type === 'email') {
          return '<span class="staff-directory-value"><a href="mailto:' + escapeHtml(clean) + '">' + escapeHtml(clean) + '</a></span>';
        }

        return '<span class="staff-directory-value">' + escapeHtml(clean) + '</span>';
      }

      function renderDirectoryField(label, value, type){
        return ''
          + '<div class="staff-directory-field">'
          +   '<div class="staff-directory-label">' + escapeHtml(label) + '</div>'
          +   (type ? formatDirectoryLink(type, value) : (String(value || '').trim()
              ? '<div class="staff-directory-value">' + escapeHtml(String(value || '').trim()) + '</div>'
              : '<div class="staff-directory-value is-empty">Not available</div>'))
          + '</div>';
      }

      function renderStaffDirectoryAvatar(member){
        var avatar = String((member && member.avatar) || '').trim();
        var name = String((member && member.name) || '').trim();
        if (avatar) {
          return '<div class="staff-directory-avatar"><img src="' + escapeHtml(avatar) + '" alt="' + escapeHtml(name) + '" loading="lazy" /></div>';
        }
        return '<div class="staff-directory-avatar">' + escapeHtml(getInitials(name)) + '</div>';
      }

      function renderStaffDirectory(entries){
        if (!staffDirectoryList) return;
        if (!entries.length) {
          staffDirectoryList.innerHTML = '<div class="staff-directory-empty">No staff directory entries are available yet.</div>';
          return;
        }

        staffDirectoryList.innerHTML = entries.map(function(member){
          return ''
            + '<article class="staff-directory-card">'
            +   '<div class="staff-directory-cardHead">'
            +     renderStaffDirectoryAvatar(member)
            +     '<div class="staff-directory-identity">'
            +       '<h2 class="staff-directory-name">' + escapeHtml(member.name || '') + '</h2>'
            +       '<p class="staff-directory-role">' + escapeHtml(member.role || 'Salon Team') + '</p>'
            +     '</div>'
            +   '</div>'
            +   '<div class="staff-directory-fields">'
            +     renderDirectoryField('Phone', member.mobile_phone, 'phone')
            +   '</div>'
            + '</article>';
        }).join('');
      }

      async function fetchStaffDirectoryEntries(){
        async function readStaffAction(action){
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: action })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !Array.isArray(data.staff)) {
            return [];
          }
          return data.staff;
        }

        var merged = {};
        var staff = (await readStaffAction('staff-directory')).concat(await readStaffAction('staff-directory-derived'));

        staff.forEach(function(member){
          var id = String((member && member.id) || '').trim();
          var name = String((member && member.name) || '').trim();
          if (!id && !name) return;
          var key = id || name;
          var existing = merged[key] || {
            id: id,
            name: name,
            first_name: '',
            last_name: '',
            role: '',
            level: '',
            mobile_phone: '',
            bio: '',
            pin: '',
            venmo: '',
            external_id: '',
            alternate_id: '',
            avatar: ''
          };

          existing.id = existing.id || id;
          existing.name = existing.name || name;
          existing.first_name = existing.first_name || String((member && (member.first_name || member.firstName)) || '').trim();
          existing.last_name = existing.last_name || String((member && (member.last_name || member.lastName)) || '').trim();
          existing.role = existing.role || String((member && member.role) || '').trim();
          existing.level = existing.level || getLevelLabel(name) || String((member && member.role) || '').trim();
          existing.mobile_phone = existing.mobile_phone || String((member && (member.mobile_phone || member.mobilePhone)) || '').trim();
          existing.bio = existing.bio || String((member && member.bio) || '').trim();
          existing.pin = existing.pin || String((member && member.pin) || '').trim();
          existing.venmo = existing.venmo || String((member && member.venmo) || '').trim();
          existing.external_id = existing.external_id || String((member && (member.external_id || member.externalId)) || '').trim();
          existing.alternate_id = existing.alternate_id || String((member && (member.alternate_id || member.alternateId)) || '').trim();
          existing.avatar = existing.avatar || String((member && member.avatar) || '').trim();

          merged[key] = existing;
        });

        return Object.keys(merged).map(function(key){
          return merged[key];
        }).sort(function(a, b){
          var levelA = String(a.level || a.role || '').trim();
          var levelB = String(b.level || b.role || '').trim();
          var levelCompare = levelA.localeCompare(levelB);
          if (levelCompare !== 0) return levelCompare;
          return String(a.name || '').localeCompare(String(b.name || ''));
        });
      }

      async function ensureStaffDirectoryLoaded(){
        if (hasLoadedStaffDirectory) return;
        try {
          setStaffDirectoryStatus('Loading staff directory...');
          renderStaffDirectory([]);
          var entries = await fetchStaffDirectoryEntries();
          renderStaffDirectory(entries);
          setStaffDirectoryStatus('Staff directory loaded.', 'success');
          hasLoadedStaffDirectory = true;
        } catch (error) {
          setStaffDirectoryStatus(humanizeClientFetchErrorMessage(error, 'Could not load staff directory.'), 'error');
          if (staffDirectoryList) {
            staffDirectoryList.innerHTML = '<div class="staff-directory-empty">Could not load staff directory right now.</div>';
          }
        }
      }

      function renderAvatarMarkup(staffName){
        var avatarUrl = getAvatarUrl(staffName);
        if (avatarUrl) {
          return '<span class="kpi-group-avatar"><img src="' + escapeHtml(avatarUrl) + '" alt="' + escapeHtml(staffName) + '" loading="lazy" /></span>';
        }
        return '<span class="kpi-group-avatar">' + escapeHtml(getInitials(staffName)) + '</span>';
      }

      function renderProductionShareMarkup(serviceSales, companyServiceSales){
        var stylistSales = parseNumericCell(serviceSales);
        var companySales = parseNumericCell(companyServiceSales);
        if (companySales <= 0 || stylistSales <= 0) return '';

        var percent = (stylistSales / companySales) * 100;
        var clampedPercent = Math.max(0, Math.min(100, percent));
        return ''
          + '<span class="kpi-share">'
          +   renderSummaryLine('Company share', percent.toFixed(1) + '%')
          +   '<span class="kpi-share-bar"><span class="kpi-share-fill" style="width:' + clampedPercent.toFixed(2) + '%"></span></span>'
          + '</span>';
      }

      async function waitForKpiExportReady(reportExport){
        if (reportExport && reportExport.current_export_at && reportExport.file_url) {
          return reportExport;
        }

        var exportId = reportExport && reportExport.id;
        var fileUrl = reportExport && reportExport.file_url;
        for (var attempt = 0; attempt < 30; attempt += 1) {
          await new Promise(function(resolve){ setTimeout(resolve, 2000); });
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'report-export-debug',
              report_export_id: exportId,
              file_url: fileUrl
            })
          });
          var data = await response.json().catch(function(){ return null; });
          var matched = data && data.matched_export;
          if (response.ok && data && data.ok && matched && matched.current_export_at && matched.file_url) {
            return matched;
          }
        }

        throw new Error('Raw KPI export is still processing. Please try again in a moment.');
      }

      async function fetchRawKpiRows(){
        var created = await createKpiExport();
        var readyExport = await waitForKpiExportReady(created.report_export);
        var proxyResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'report-export-rows',
            file_url: readyExport.file_url
          })
        });
        var proxyData = await proxyResponse.json().catch(function(){ return null; });
        if (!proxyResponse.ok || !proxyData || !proxyData.ok) {
          throw new Error((proxyData && proxyData.error) || 'Could not download raw KPI CSV.');
        }
        var parsed = {
          headers: Array.isArray(proxyData.headers) ? proxyData.headers : [],
          rows: Array.isArray(proxyData.rows) ? proxyData.rows : []
        };
        return {
          exportInfo: readyExport,
          filterConfig: created.filter_config,
          headers: parsed.headers,
          rows: parsed.rows,
          displayRows: buildDisplayKpiRows(parsed.headers, parsed.rows)
        };
      }

      async function createGlobalKpiExport(){
        var filterConfig = buildGlobalKpiReportFilters();
        if (!filterConfig.report_filters.length) {
          throw new Error(filterConfig.warning || 'Choose a quarter first.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'create-report-export',
            report_id: GLOBAL_KPI_REPORT_ID,
            file_content_type: 'CSV',
            frequency: 'ONCE',
            report_filters: filterConfig.report_filters
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok || !data.report_export) {
          throw new Error((data && data.error) || 'Could not create KPI Master export.');
        }
        return {
          report_export: data.report_export,
          filter_config: filterConfig
        };
      }

      async function fetchGlobalKpiRows(){
        var created = await createGlobalKpiExport();
        var readyExport = await waitForKpiExportReady(created.report_export);
        var proxyResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'report-export-rows',
            file_url: readyExport.file_url
          })
        });
        var proxyData = await proxyResponse.json().catch(function(){ return null; });
        if (!proxyResponse.ok || !proxyData || !proxyData.ok) {
          throw new Error((proxyData && proxyData.error) || 'Could not download KPI Master CSV.');
        }
        return {
          exportInfo: readyExport,
          filterConfig: created.filter_config,
          headers: Array.isArray(proxyData.headers) ? proxyData.headers : [],
          rows: Array.isArray(proxyData.rows) ? proxyData.rows : []
        };
      }

      async function fetchGlobalKpiSnapshotRows(){
        var selectedQuarter = getSelectedGlobalQuarter();
        if (!selectedQuarter) {
          throw new Error('Choose a period first.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'global-kpi-snapshot-get',
            quarter_value: selectedQuarter.value,
            refresh_if_missing: false
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load KPI Master snapshot.');
        }
        return {
          snapshot: data.snapshot || null,
          headers: Array.isArray(data.headers) ? data.headers : [],
          rows: Array.isArray(data.rows) ? data.rows : []
        };
      }

      async function fetchGlobalKpiLiveSalonMetrics(){
        var selectedQuarter = getSelectedGlobalQuarter();
        if (!selectedQuarter) {
          throw new Error('Choose a period first.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'global-kpi-live-salon-metrics',
            quarter_value: selectedQuarter.value
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load live salon metrics.');
        }
        return data || null;
      }

      function renderKpiTable(headers, rows){
        if (!headers.length || !rows.length) {
          kpiTableMount.className = 'empty';
          kpiTableMount.innerHTML = 'No staff KPI rows are available.';
          return;
        }

        var groupedView = buildKpiStaffGroups(headers, rows);
        if (groupedView && groupedView.totalRow && groupedView.groups.length) {
          var companyServiceSales = groupedView.companyServiceSales || 0;
          kpiTableMount.className = 'kpi-groups';
          kpiTableMount.innerHTML = ''
            + '<div class="table-wrap">'
            + renderKpiTableMarkup(headers, [groupedView.totalRow])
            + '</div>'
            + groupedView.groups.map(function(group){
                var summaryRow = group.summaryRow || {};
                var appointmentLabel = formatNumericCell('Appointment Count', summaryRow['Appointment Count'] || '');
                var serviceSalesLabel = formatNumericCell('Service Sales', summaryRow['Service Sales'] || '');
                var utilizationLabel = formatNumericCell('Utilization %', summaryRow['Utilization %'] || '');
                var weekdayUtilizationLines = group.weekdayUtilizationLines || [];
                var highestDayLabel = group.highestDayLabel || '';
                var lowestDayLabel = group.lowestDayLabel || '';
                var productionRateLabel = formatNumericCell('Production Rate', getKpiDisplayValue('Production Rate', summaryRow));
                var unscheduledOpportunityLabel = group.unscheduledOpportunityLabel || '';
                var supportPatternLabel = group.supportPatternLabel || '';
                var reliabilityScoreLabel = getReliabilityScoreLabel(group.staffName);
                var levelLabel = getLevelLabel(group.staffName);
                var productionShareMarkup = renderProductionShareMarkup(summaryRow['Service Sales'], companyServiceSales);
                var isNonProducingRole = !!supportPatternLabel;

                if (isNonProducingRole) {
                  return ''
                    + '<details class="kpi-group">'
                    +   '<summary>'
                    +     '<span class="kpi-group-identity">'
                    +       renderAvatarMarkup(group.staffName)
                    +       '<span class="kpi-group-identity-copy">'
                    +         '<span class="kpi-group-name">' + escapeHtml(group.staffName) + '</span>'
                    +         '<span class="kpi-group-level">'
                    +           renderSummaryLine('Level', levelLabel)
                    +           renderSummaryLine('Reliability', reliabilityScoreLabel)
                    +           renderReliabilityDetailLines(group.staffName)
                    +         '</span>'
                    +       '</span>'
                    +     '</span>'
                    +     '<span class="kpi-group-meta">'
                    +       productionShareMarkup
                    +       '<span class="kpi-group-note">'
                    +         renderSummaryLine('Role', supportPatternLabel, 'kpi-group-note--muted')
                    +       '</span>'
                    +     '</span>'
                    +   '</summary>'
                    +   '<div class="kpi-group-body table-wrap">'
                    +     renderKpiTableMarkup(headers, [summaryRow].concat(group.rows))
                    +   '</div>'
                    + '</details>';
                }

                return ''
                  + '<details class="kpi-group">'
                  +   '<summary>'
                  +     '<span class="kpi-group-identity">'
                  +       renderAvatarMarkup(group.staffName)
                  +       '<span class="kpi-group-identity-copy">'
                  +         '<span class="kpi-group-name">' + escapeHtml(group.staffName) + '</span>'
                  +         '<span class="kpi-group-level">'
                  +           renderSummaryLine('Level', levelLabel)
                  +           renderSummaryLine('Reliability', reliabilityScoreLabel)
                  +           renderReliabilityDetailLines(group.staffName)
                  +         '</span>'
                  +       '</span>'
                  +     '</span>'
                  +     '<span class="kpi-group-meta">'
                  +       '<span class="kpi-group-primary">'
                  +         renderSummaryLine('Volume', appointmentLabel + ' appts')
                  +         renderSummaryLine('Service', serviceSalesLabel)
                  +         renderSummaryLine('Utilization', utilizationLabel)
                  +         renderSummaryLine('Production', productionRateLabel)
                  +       '</span>'
                  +       '<span class="kpi-group-secondary">'
                  +         productionShareMarkup
                  +         weekdayUtilizationLines.map(function(line, index){
                              return renderSummaryLine(index === 0 ? 'Weekdays' : '', line);
                            }).join('')
                  +         renderSummaryLine('Highest day', highestDayLabel.replace(/^High:\s*/, ''))
                  +         renderSummaryLine('Lowest day', lowestDayLabel.replace(/^Low:\s*/, ''))
                  +       '</span>'
                  +       '<span class="kpi-group-note">'
                  +         renderSummaryLine('Recommendation', unscheduledOpportunityLabel.replace(/^Floor time recommendation:\s*/, ''))
                  +       '</span>'
                  +     '</span>'
                  +   '</summary>'
                  +   '<div class="kpi-group-body table-wrap">'
                  +     renderKpiTableMarkup(headers, [summaryRow].concat(group.rows))
                  +   '</div>'
                  + '</details>';
              }).join('');
          return;
        }

        kpiTableMount.className = 'table-wrap';
        kpiTableMount.innerHTML = renderKpiTableMarkup(headers, rows);
      }

      function buildDebugText(data){
        var payload = data || {};
        var sections = [];
        var rawKpiRows = payload.raw_rows && payload.raw_rows.kpi_for_stylists;
        var normalizedKpiRows = payload.normalized_rows && payload.normalized_rows.kpi_for_stylists;
        var kpiRenderedRows = payload.kpi_for_stylists && payload.kpi_for_stylists.rows;

        if (Array.isArray(rawKpiRows)) {
          sections.push('RAW KPI ROWS (' + rawKpiRows.length + ')');
          sections.push(JSON.stringify(rawKpiRows, null, 2));
        }

        if (Array.isArray(normalizedKpiRows)) {
          sections.push('NORMALIZED KPI ROWS (' + normalizedKpiRows.length + ')');
          sections.push(JSON.stringify(normalizedKpiRows, null, 2));
        }

        if (Array.isArray(kpiRenderedRows)) {
          sections.push('KPI REPORT ROWS (' + kpiRenderedRows.length + ')');
          sections.push(JSON.stringify(kpiRenderedRows, null, 2));
        }

        sections.push('FULL DEBUG JSON');
        sections.push(JSON.stringify(payload, null, 2));

        return sections.join('\n\n');
      }

      function renderDebug(data){
        lastDebugPayload = data || null;
        debugMount.textContent = buildDebugText(lastDebugPayload);
      }

      function formatGlobalKpiMetricValue(label, rawValue){
        return formatNumericCell(label, rawValue == null ? '' : String(rawValue));
      }

      function normalizeQuarterDisplay(value){
        var text = String(value == null ? '' : value).trim();
        if (!text || text.toLowerCase() === 'all') return 'All';
        return 'Q' + text;
      }

      function pickPrimaryGlobalKpiRow(rows){
        var quarter = getSelectedGlobalQuarter();
        var quarterNumber = quarter ? quarter.value.split('-Q')[1] : '';
        var candidates = Array.isArray(rows) ? rows.slice() : [];
        return candidates.find(function(row){
          return String((row && row['SaleDate Quarter']) || '').trim() === quarterNumber
            && String((row && row['Location name']) || '').trim().toLowerCase() !== 'all';
        }) || candidates.find(function(row){
          return String((row && row['SaleDate Quarter']) || '').trim() === quarterNumber;
        }) || candidates.find(function(row){
          return String((row && row['Location name']) || '').trim().toLowerCase() === 'all';
        }) || candidates[0] || null;
      }

      function renderGlobalKpiMetricCard(label, value, subvalue){
        return ''
          + '<div class="global-kpi-card">'
          +   '<div class="global-kpi-label">' + escapeHtml(label) + '</div>'
          +   '<div class="global-kpi-value">' + escapeHtml(formatGlobalKpiMetricValue(label, value)) + '</div>'
          +   (subvalue ? '<div class="global-kpi-subvalue">' + escapeHtml(subvalue) + '</div>' : '')
          + '</div>';
      }

      function normalizeGlobalKpiFieldKey(value){
        return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
      }

      function readGlobalKpiField(row, aliases){
        var safeRow = row && typeof row === 'object' ? row : {};
        var aliasList = Array.isArray(aliases) ? aliases : [aliases];
        var keys = Object.keys(safeRow);
        for (var aliasIndex = 0; aliasIndex < aliasList.length; aliasIndex += 1) {
          var alias = String(aliasList[aliasIndex] || '').trim();
          if (!alias) continue;
          if (Object.prototype.hasOwnProperty.call(safeRow, alias)) {
            return safeRow[alias];
          }
          var normalizedAlias = normalizeGlobalKpiFieldKey(alias);
          for (var keyIndex = 0; keyIndex < keys.length; keyIndex += 1) {
            var key = keys[keyIndex];
            if (normalizeGlobalKpiFieldKey(key) === normalizedAlias) {
              return safeRow[key];
            }
          }
        }
        return '';
      }

      function renderGlobalKpiTable(snapshotPayload, liveSalonMetrics){
        var headers = snapshotPayload && Array.isArray(snapshotPayload.headers) ? snapshotPayload.headers : [];
        var rows = snapshotPayload && Array.isArray(snapshotPayload.rows) ? snapshotPayload.rows : [];
        if (!globalKpiTableMount) return;
        if (!Array.isArray(headers) || !headers.length || !Array.isArray(rows) || !rows.length) {
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'No global KPI rows are available for that quarter.';
          return;
        }

        var primaryRow = pickPrimaryGlobalKpiRow(rows);
        if (!primaryRow) {
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'No global KPI rows are available for that quarter.';
          return;
        }

        var selectedQuarter = getSelectedGlobalQuarter();
        var quarterLabel = selectedQuarter ? selectedQuarter.label : normalizeQuarterDisplay(primaryRow['SaleDate Quarter']);
        var locationLabel = String((primaryRow['Location name']) || 'All Locations').trim() || 'All Locations';
        var derivedMetrics = snapshotPayload && snapshotPayload.derived_metrics && typeof snapshotPayload.derived_metrics === 'object'
          ? snapshotPayload.derived_metrics
          : {};
        var snapshotTagCapture = derivedMetrics && derivedMetrics.tag_capture && typeof derivedMetrics.tag_capture === 'object'
          ? derivedMetrics.tag_capture
          : null;
        var liveMetricsLoading = typeof liveSalonMetrics === 'undefined';
        var tagCapture = liveSalonMetrics && liveSalonMetrics.tag_capture && typeof liveSalonMetrics.tag_capture === 'object'
          ? liveSalonMetrics.tag_capture
          : snapshotTagCapture;
        var retailAttach = liveSalonMetrics && liveSalonMetrics.retail_attach && typeof liveSalonMetrics.retail_attach === 'object'
          ? liveSalonMetrics.retail_attach
          : null;
        var colorReweigh = liveSalonMetrics && liveSalonMetrics.color_reweigh && typeof liveSalonMetrics.color_reweigh === 'object'
          ? liveSalonMetrics.color_reweigh
          : null;
        var taggedAppointments = tagCapture ? Math.max(0, Number(tagCapture.tagged_appointment_count || 0) || 0) : 0;
        var totalTaggedAppointments = tagCapture ? Math.max(0, Number(tagCapture.total_appointment_count || 0) || 0) : 0;
        var tagCaptureRate = tagCapture ? Math.max(0, Number(tagCapture.tag_capture_rate || 0) || 0) : null;
        var tagCaptureSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (tagCapture && totalTaggedAppointments > 0
          ? formatNumericCell('Appointment Count', String(taggedAppointments)) + ' of ' + formatNumericCell('Appointment Count', String(totalTaggedAppointments)) + ' completed appts tagged'
          : (tagCapture ? 'No stored appointment history for this quarter' : 'Live metric unavailable'));
        var retailAttachRate = retailAttach ? Math.max(0, Number(retailAttach.attach_rate || 0) || 0) : null;
        var retailAttachClosed = retailAttach ? Math.max(0, Number(retailAttach.closed_appointments || 0) || 0) : 0;
        var retailAttachRetail = retailAttach ? Math.max(0, Number(retailAttach.retail_appointments || 0) || 0) : 0;
        var retailAttachSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (retailAttach && retailAttachClosed > 0
          ? formatNumericCell('Appointment Count', String(retailAttachRetail)) + ' of ' + formatNumericCell('Appointment Count', String(retailAttachClosed)) + ' closed appts attached'
          : (retailAttach ? 'No closed appointment retail history for this quarter' : 'Live metric unavailable'));
        var colorReweighRate = colorReweigh ? Math.max(0, Number(colorReweigh.reweigh_rate || 0) || 0) : null;
        var colorReweighServices = colorReweigh ? Math.max(0, Number(colorReweigh.services || 0) || 0) : 0;
        var colorReweighSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (colorReweigh && colorReweighServices > 0
          ? formatNumericCell('Service Count', String(colorReweighServices)) + ' services in Vish range'
          : (colorReweigh ? 'No Color Discipline coverage for this quarter' : 'Live metric unavailable'));
        var shopifySales = liveSalonMetrics && liveSalonMetrics.shopify_sales && typeof liveSalonMetrics.shopify_sales === 'object'
          ? liveSalonMetrics.shopify_sales
          : null;
        var shopifyNetSales = shopifySales ? Math.max(0, Number(shopifySales.net_sales || 0) || 0) : null;
        var shopifyOrderCount = shopifySales ? Math.max(0, Number(shopifySales.order_count || 0) || 0) : 0;
        var shopifyAov = shopifySales ? Math.max(0, Number(shopifySales.average_order_value || 0) || 0) : null;
        var shopifyRefunded = shopifySales ? Math.max(0, Number(shopifySales.refunded_sales || 0) || 0) : 0;
        var rawProductSales = parseNumericCell(readGlobalKpiField(primaryRow, ['Product Sales']));
        var grossPackageSales = Math.max(0, parseNumericCell(readGlobalKpiField(primaryRow, ['Gross Package Sales', 'Gross Packages Sales'])));
        var giftCardSales = Math.max(0, parseNumericCell(readGlobalKpiField(primaryRow, ['Giftcard Sales', 'Gift Card Sales'])));
        var adjustedProductSales = Math.max(0, rawProductSales - grossPackageSales);
        var hasGiftCardSales = normalizeGlobalKpiFieldKey(readGlobalKpiField(primaryRow, ['Giftcard Sales', 'Gift Card Sales'])) !== '' || giftCardSales > 0;
        var hasGrossPackageSales = normalizeGlobalKpiFieldKey(readGlobalKpiField(primaryRow, ['Gross Package Sales', 'Gross Packages Sales'])) !== '' || grossPackageSales > 0;
        var shopifySalesSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (shopifySales && shopifyOrderCount > 0
          ? formatNumericCell('Order Count', String(shopifyOrderCount)) + ' online orders • ' + formatNumericCell('Online Sales', String(shopifyRefunded)) + ' refunded'
          : (shopifySales ? 'No Shopify sales in this quarter' : 'Live metric unavailable'));
        var shopifyOrdersSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (shopifySales && shopifyOrderCount > 0
          ? 'Net online orders captured in Shopify'
          : (shopifySales ? 'No Shopify orders in this quarter' : 'Live metric unavailable'));
        var shopifyAovSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (shopifySales && shopifyOrderCount > 0
          ? 'Average net online order value'
          : (shopifySales ? 'No Shopify orders in this quarter' : 'Live metric unavailable'));

        globalKpiTableMount.className = 'global-kpi-dashboard';
        globalKpiTableMount.innerHTML = ''
          + '<div class="global-kpi-hero">'
          +   '<div class="global-kpi-hero-head">'
          +     '<div class="global-kpi-hero-title">'
          +       '<h2>' + escapeHtml(quarterLabel) + '</h2>'
          +       '<p class="global-kpi-hero-copy">' + escapeHtml(locationLabel) + ' overview from global KPIs.</p>'
          +     '</div>'
          +     '<span class="global-kpi-pill">' + escapeHtml(normalizeQuarterDisplay(primaryRow['SaleDate Quarter'])) + '</span>'
          +   '</div>'
          +   '<div class="global-kpi-metrics">'
          +     renderGlobalKpiMetricCard('Service Sales', primaryRow['Service Sales'], 'Core revenue')
          +     renderGlobalKpiMetricCard('Appointment Count', primaryRow['Appointment Count'], 'Completed appointments')
          +     renderGlobalKpiMetricCard('Tag Capture %', tagCaptureRate == null ? '' : String(tagCaptureRate), tagCaptureSubvalue)
          +     renderGlobalKpiMetricCard('Retail Attach %', retailAttachRate == null ? '' : String(retailAttachRate), retailAttachSubvalue)
          +     renderGlobalKpiMetricCard('Color Reweigh %', colorReweighRate == null ? '' : String(colorReweighRate), colorReweighSubvalue)
          +     renderGlobalKpiMetricCard('Online Sales', shopifyNetSales == null ? '' : String(shopifyNetSales), shopifySalesSubvalue)
          +     renderGlobalKpiMetricCard('Online Orders', shopifyOrderCount ? String(shopifyOrderCount) : (shopifySales ? '0' : ''), shopifyOrdersSubvalue)
          +     renderGlobalKpiMetricCard('Online AOV', shopifyAov == null ? '' : String(shopifyAov), shopifyAovSubvalue)
          +     renderGlobalKpiMetricCard('Utilization %', primaryRow['Utilization %'], 'Booked vs scheduled')
          +     renderGlobalKpiMetricCard('Prebooked %', primaryRow['Prebooked %'], 'Future retention')
          +     renderGlobalKpiMetricCard('New Client Count', primaryRow['New Client Count'], 'First-time guests')
          +     renderGlobalKpiMetricCard('Returning Client Count', primaryRow['Returning Client Count'], 'Repeat guests')
          +     renderGlobalKpiMetricCard('Product Sales', String(adjustedProductSales), grossPackageSales > 0 ? 'Net of gross package sales' : 'Retail revenue')
          +     (hasGrossPackageSales ? renderGlobalKpiMetricCard('Gross Package Sales', String(grossPackageSales), 'Included in raw product sales') : '')
          +     (hasGiftCardSales ? renderGlobalKpiMetricCard('Gift Card Sales', String(giftCardSales), 'Boulevard gift card revenue') : '')
          +     renderGlobalKpiMetricCard('Retail to Service %', primaryRow['Retail to Service %'], 'Retail mix')
          +     renderGlobalKpiMetricCard('Tip Sales', primaryRow['Tip Sales'], 'Tips captured')
          +     renderGlobalKpiMetricCard('Hours Booked', primaryRow['Hours Booked'], 'Booked hours')
          +     renderGlobalKpiMetricCard('Hours Scheduled', primaryRow['Hours Scheduled'], 'Scheduled hours')
          +     renderGlobalKpiMetricCard('Self-booked %', primaryRow['Self-booked %'], 'Online booking share')
          +   '</div>'
          + '</div>';
      }

      async function loadGlobalKpis(){
        if (!globalKpiTableMount) return;
        var selectedQuarter = getSelectedGlobalQuarter();
        if (!selectedQuarter) {
          setGlobalKpiStatus('Choose a quarter to load global KPIs.');
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'Choose a quarter to load global KPIs.';
          return;
        }

        try {
          setGlobalKpiStatus('Pulling global KPIs for ' + selectedQuarter.label + '...');
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'Pulling global KPIs for ' + escapeHtml(selectedQuarter.label) + '...';
          var result = null;
          try {
            result = await fetchGlobalKpiSnapshotRows();
          } catch (_error) {
            result = await fetchGlobalKpiRows();
          }
          renderGlobalKpiTable(result, undefined);
          setGlobalKpiStatus('Global KPIs updated for ' + selectedQuarter.label + '.', 'success');
          hasLoadedGlobalKpis = true;
          fetchGlobalKpiLiveSalonMetrics().then(function(metrics){
            if (!getSelectedGlobalQuarter() || getSelectedGlobalQuarter().value !== selectedQuarter.value) return;
            renderGlobalKpiTable(result, metrics);
          }).catch(function(){
            if (!getSelectedGlobalQuarter() || getSelectedGlobalQuarter().value !== selectedQuarter.value) return;
            renderGlobalKpiTable(result, null);
          });
        } catch (error) {
          var message = humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not load global KPIs.');
          setGlobalKpiStatus(message, 'error');
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = escapeHtml(message);
        }
      }

      function ensureGlobalKpiLoaded(){
        if (!hasLoadedGlobalKpis) {
          loadGlobalKpis();
        }
      }

      function setClientRecsStatus(message, tone){
        if (!clientRecsStatus) return;
        clientRecsStatus.textContent = String(message || '');
        clientRecsStatus.classList.toggle('is-error', tone === 'error');
        clientRecsStatus.classList.toggle('is-success', tone === 'success');
      }

      function clientRecsEditorId(){
        return String((currentLoggedInStaff && currentLoggedInStaff.id) || '').trim();
      }

      async function clientRecsRequest(action, payload){
        var editorStaffId = clientRecsEditorId();
        if (!editorStaffId) throw new Error('Your staff session could not be confirmed. Please sign in again.');
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.assign({}, payload || {}, {
            action: action,
            editor_staff_id: editorStaffId
          }))
        });
        var rawText = await response.text();
        var data = null;
        try { data = rawText ? JSON.parse(rawText) : null; } catch (_error) {}
        if (!response.ok || !data || data.ok !== true) {
          throw new Error((data && data.error) || rawText || 'Could not complete this request.');
        }
        return data;
      }

      function formatClientRecsDay(value){
        var date = new Date(value);
        if (!Number.isFinite(date.getTime())) return 'Upcoming';
        return date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
      }

      function formatClientRecsTime(value){
        var date = new Date(value);
        if (!Number.isFinite(date.getTime())) return '';
        return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      }

      function populateClientRecsStaff(){
        if (!clientRecsStaff || !clientRecsDashboard) return;
        var current = String(clientRecsStaff.value || '').trim();
        var ownId = clientRecsEditorId();
        var staff = Array.isArray(clientRecsDashboard.staff) ? clientRecsDashboard.staff : [];
        clientRecsStaff.innerHTML = '<option value="">All upcoming clients</option>' + staff.map(function(member){
          return '<option value="' + escapeHtml(member.id) + '">' + escapeHtml(member.name) + ' · ' + escapeHtml(String(member.appointment_count || 0)) + '</option>';
        }).join('');
        if (staff.some(function(member){ return member.id === current; })) clientRecsStaff.value = current;
        else if (staff.some(function(member){ return member.id === ownId; })) clientRecsStaff.value = ownId;
      }

      function filteredClientRecsAppointments(){
        var appointments = clientRecsDashboard && Array.isArray(clientRecsDashboard.appointments)
          ? clientRecsDashboard.appointments
          : [];
        var staffId = String((clientRecsStaff && clientRecsStaff.value) || '').trim();
        var query = String((clientRecsSearch && clientRecsSearch.value) || '').trim().toLowerCase();
        return appointments.filter(function(appointment){
          if (staffId && (!Array.isArray(appointment.staff_ids) || appointment.staff_ids.indexOf(staffId) < 0)) return false;
          if (!query) return true;
          return [
            appointment.client_name,
            (appointment.service_names || []).join(' '),
            (appointment.staff_names || []).join(' ')
          ].join(' ').toLowerCase().indexOf(query) >= 0;
        });
      }

      function clientRecsTagPresentation(tag){
        var rawName = String((tag && tag.name) || '').trim();
        var lowerName = rawName.toLowerCase();
        var group = { key: 'other', label: 'Other Profile Tags', order: 5 };
        var displayName = rawName;
        if (lowerName.indexOf('product:') === 0) {
          group = { key: 'products', label: 'Product Recommendations', order: 0 };
          displayName = rawName.replace(/^product:\s*/i, '').replace(/-/g, ' ')
            .replace(/^hs\s+/i, 'hs.').replace(/^root\s+/i, 'root. ')
            .replace(/^k18\s+/i, 'K18 ');
        } else if (lowerName.indexOf('concern:') === 0) {
          group = { key: 'concerns', label: 'Hair Concerns', order: 1 };
          displayName = rawName.replace(/^concern:\s*/i, '').replace(/-/g, ' ');
        } else if (lowerName.indexOf('routine:') === 0) {
          group = { key: 'routine', label: 'Routine', order: 2 };
          displayName = rawName.replace(/^routine:\s*/i, '').replace(/-/g, ' ');
        } else if (lowerName.indexOf('trait:') === 0) {
          group = { key: 'profile', label: 'Hair Profile', order: 3 };
          displayName = rawName.replace(/^trait:\s*/i, '').replace(/-/g, ' ');
        } else if (lowerName.indexOf('assistant:') === 0) {
          group = { key: 'assistants', label: 'Assistants', order: 4 };
        }
        if (group.key !== 'assistants' && displayName.indexOf('hs.') !== 0 && displayName.indexOf('root.') !== 0 && displayName.indexOf('K18 ') !== 0) {
          displayName = displayName.replace(/\b\w/g, function(letter){ return letter.toUpperCase(); });
        } else if (displayName.indexOf('hs.') === 0) {
          displayName = 'hs.' + displayName.slice(3).replace(/\b\w/g, function(letter){ return letter.toUpperCase(); });
        } else if (displayName.indexOf('root.') === 0) {
          displayName = 'root. ' + displayName.slice(6).replace(/\b\w/g, function(letter){ return letter.toUpperCase(); });
        } else if (displayName.indexOf('K18 ') === 0) {
          displayName = 'K18 ' + displayName.slice(4).replace(/\b\w/g, function(letter){ return letter.toUpperCase(); });
        }
        return { group: group, display_name: displayName || rawName };
      }

      function renderClientRecsTagGroups(tags, currentIds){
        var grouped = {};
        (Array.isArray(tags) ? tags : []).forEach(function(tag){
          var presentation = clientRecsTagPresentation(tag);
          if (!grouped[presentation.group.key]) {
            grouped[presentation.group.key] = { meta: presentation.group, tags: [] };
          }
          grouped[presentation.group.key].tags.push({ tag: tag, display_name: presentation.display_name });
        });
        return Object.keys(grouped).map(function(key){ return grouped[key]; })
          .sort(function(a, b){ return a.meta.order - b.meta.order; })
          .map(function(group){
            return '<section class="client-recs-tag-group" data-client-recs-tag-group="' + escapeHtml(group.meta.key) + '">' +
              '<div class="client-recs-tag-group-head"><h3>' + escapeHtml(group.meta.label) + '</h3><span>' + escapeHtml(String(group.tags.length)) + '</span></div>' +
              '<div class="client-recs-tag-group-options">' + group.tags.map(function(item){
                var active = currentIds[item.tag.id] === true;
                return '<button class="client-recs-tag' + (active ? ' is-active' : '') + '" type="button" data-client-recs-tag-id="' + escapeHtml(item.tag.id) + '" data-client-recs-tag-operation="' + (active ? 'remove' : 'add') + '" title="' + escapeHtml(item.tag.name) + '">' + escapeHtml(item.display_name) + '</button>';
              }).join('') + '</div></section>';
          }).join('');
      }

      function renderClientRecsList(){
        if (!clientRecsList) return;
        var appointments = filteredClientRecsAppointments();
        if (!appointments.length) {
          clientRecsList.innerHTML = '<div class="empty">No upcoming clients match these filters.</div>';
          setClientRecsStatus('No upcoming appointments found for this view.');
          return;
        }
        var currentDay = '';
        clientRecsList.innerHTML = appointments.map(function(appointment){
          var day = formatClientRecsDay(appointment.start_at);
          var dayHeading = day !== currentDay ? '<div class="client-recs-date">' + escapeHtml(day) + '</div>' : '';
          currentDay = day;
          var selected = appointment.appointment_id === clientRecsSelectedAppointmentId ? ' is-selected' : '';
          var services = Array.isArray(appointment.service_names) && appointment.service_names.length
            ? appointment.service_names.join(' · ')
            : 'Appointment';
          var staffNames = Array.isArray(appointment.staff_names) ? appointment.staff_names.join(' & ') : '';
          return dayHeading + '<article class="client-recs-card' + selected + '" data-client-recs-card="' + escapeHtml(appointment.appointment_id) + '">' +
            '<div class="client-recs-card-main"><strong>' + escapeHtml(appointment.client_name) + '</strong><span>' + escapeHtml(services) + '</span><span>' + escapeHtml(staffNames) + '</span></div>' +
            '<div class="client-recs-card-time">' + escapeHtml(formatClientRecsTime(appointment.start_at)) + '</div>' +
            '<button type="button" data-client-recs-open data-client-id="' + escapeHtml(appointment.client_id) + '" data-appointment-id="' + escapeHtml(appointment.appointment_id) + '">Edit recommendations</button>' +
          '</article>';
        }).join('');
        setClientRecsStatus(appointments.length + ' upcoming appointment' + (appointments.length === 1 ? '' : 's') + ' shown.', 'success');
      }

      function renderClientRecsDetail(tagQuery){
        if (!clientRecsDetail || !clientRecsClientProfile) return;
        var profile = clientRecsClientProfile;
        var currentTags = Array.isArray(profile.tags) ? profile.tags : [];
        var currentIds = {};
        currentTags.forEach(function(tag){ currentIds[tag.id] = true; });
        var searchValue = String(tagQuery || '').trim().toLowerCase();
        var catalog = clientRecsDashboard && Array.isArray(clientRecsDashboard.available_tags)
          ? clientRecsDashboard.available_tags
          : [];
        var visibleTags = catalog.filter(function(tag){
          return !searchValue || String(tag.name || '').toLowerCase().indexOf(searchValue) >= 0;
        });
        clientRecsDetail.innerHTML = '<div class="client-recs-detail-head">' +
          '<span class="client-recs-detail-kicker">Hairstories profile</span><h2>' + escapeHtml(profile.name || 'Hairstories client') + '</h2>' +
          '<p>Tap an approved Boulevard tag to add it. Tap a green tag to remove it.</p></div>' +
          '<div class="client-recs-current">' + currentTags.map(function(tag){
            return '<span class="client-recs-tag is-active">' + escapeHtml(clientRecsTagPresentation(tag).display_name) + '</span>';
          }).join('') + '</div>' +
          '<input class="client-recs-tag-search" type="search" data-client-recs-tag-search placeholder="Search Boulevard tags" value="' + escapeHtml(searchValue) + '">' +
          '<div class="client-recs-tag-library">' + (visibleTags.length ? renderClientRecsTagGroups(visibleTags, currentIds) : '<div class="empty">No Boulevard tags match this search.</div>') + '</div>' +
          '<p class="client-recs-save-status" data-client-recs-save-status></p>';
      }

      async function openClientRecsProfile(clientId, appointmentId){
        clientRecsSelectedClientId = String(clientId || '').trim();
        clientRecsSelectedAppointmentId = String(appointmentId || '').trim();
        renderClientRecsList();
        clientRecsDetail.innerHTML = '<div class="empty">Loading current Boulevard tags…</div>';
        try {
          var data = await clientRecsRequest('bfcm-client-tags-get', { client_id: clientRecsSelectedClientId });
          clientRecsClientProfile = data.client;
          renderClientRecsDetail('');
        } catch (error) {
          clientRecsDetail.innerHTML = '<div class="empty">' + escapeHtml(error && error.message ? error.message : 'Could not load this client.') + '</div>';
        }
      }

      async function updateClientRecsTag(button){
        if (!button || !clientRecsSelectedClientId) return;
        var tagId = String(button.getAttribute('data-client-recs-tag-id') || '').trim();
        var operation = String(button.getAttribute('data-client-recs-tag-operation') || '').trim();
        var statusNode = clientRecsDetail.querySelector('[data-client-recs-save-status]');
        button.disabled = true;
        if (statusNode) statusNode.textContent = operation === 'remove' ? 'Removing tag…' : 'Adding tag…';
        try {
          var data = await clientRecsRequest('bfcm-client-tag-update', {
            client_id: clientRecsSelectedClientId,
            tag_id: tagId,
            operation: operation
          });
          clientRecsClientProfile = data.client;
          renderClientRecsDetail('');
          var updatedStatus = clientRecsDetail.querySelector('[data-client-recs-save-status]');
          if (updatedStatus) {
            updatedStatus.className = 'client-recs-save-status is-success';
            updatedStatus.textContent = 'Saved to the client’s Hairstories profile.';
          }
        } catch (error) {
          button.disabled = false;
          if (statusNode) {
            statusNode.className = 'client-recs-save-status is-error';
            statusNode.textContent = error && error.message ? error.message : 'Could not update this tag.';
          }
        }
      }

      async function loadClientRecs(forceRefresh){
        if (!clientRecsList) return;
        setClientRecsStatus('Loading upcoming clients…');
        clientRecsList.innerHTML = '<div class="empty">Loading upcoming appointments…</div>';
        if (clientRecsRefresh) clientRecsRefresh.disabled = true;
        try {
          clientRecsDashboard = await clientRecsRequest('bfcm-client-tagging-dashboard', {
            days: Number((clientRecsWindow && clientRecsWindow.value) || 30),
            force_refresh: forceRefresh === true
          });
          hasLoadedClientRecs = true;
          populateClientRecsStaff();
          renderClientRecsList();
        } catch (error) {
          setClientRecsStatus(error && error.message ? error.message : 'Could not load upcoming clients.', 'error');
          clientRecsList.innerHTML = '<div class="empty">Could not load upcoming Boulevard clients.</div>';
        } finally {
          if (clientRecsRefresh) clientRecsRefresh.disabled = false;
        }
      }

      function ensureClientRecsLoaded(){
        if (!hasLoadedClientRecs) loadClientRecs(false);
      }

      function escapeHtml(value){
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function updateStats(dataset, leaderboard, mode){
        if (mode === 'call_outs') {
          renderCallOutsTable(Array.isArray(leaderboard) ? leaderboard : []);
          return;
        }

        renderMergedTable(Array.isArray(leaderboard) ? leaderboard : []);
      }

      async function run(){
        try {
          var kpiFilterConfig = buildKpiReportFilters();
          setStatus('Pulling attendance totals from Boulevard...');
          tableMount.className = 'empty';
          tableMount.innerHTML = 'Pulling attendance totals from Boulevard...';
          kpiTableMount.className = 'empty';
          kpiTableMount.innerHTML = canFetchKpiForSelectedRange(kpiFilterConfig)
            ? 'Pulling raw KPI report from Boulevard...'
            : 'KPI is only available for ranges ending today.';
          renderDebug({ loading: true });
          var attendancePromise = fetchAttendanceTotals();
          var staffDirectoryPromise = fetchStaffDirectoryInfo();
          var kpiPromise = canFetchKpiForSelectedRange(kpiFilterConfig)
            ? fetchRawKpiRows()
            : Promise.resolve(null);

          var baseResults = await Promise.all([
            attendancePromise,
            staffDirectoryPromise
          ]);
          var remote = baseResults[0];
          var staffDirectoryInfo = baseResults[1] || {};
          var rawKpi = null;
          var kpiError = null;

          if (canFetchKpiForSelectedRange(kpiFilterConfig)) {
            var kpiResult = await Promise.allSettled([kpiPromise]);
            if (kpiResult[0] && kpiResult[0].status === 'fulfilled') {
              rawKpi = kpiResult[0].value;
            } else if (kpiResult[0] && kpiResult[0].status === 'rejected') {
              kpiError = kpiResult[0].reason;
            }
          }

          reliabilityScoreByStaff = Array.isArray(remote && remote.leaderboard)
            ? remote.leaderboard.reduce(function(map, row){
                var staffName = String((row && row.staff_name) || '').trim();
                if (staffName && row && row.reliability_score != null) {
                  map[staffName] = row.reliability_score;
                }
                return map;
              }, {})
            : {};
          callOutsByStaff = Array.isArray(remote && remote.leaderboard)
            ? remote.leaderboard.reduce(function(map, row){
                var staffName = String((row && row.staff_name) || '').trim();
                if (staffName) {
                  map[staffName] = Number((row && row.call_outs) || 0) || 0;
                }
                return map;
              }, {})
            : Array.isArray(remote && remote.debug && remote.debug.leaderboards && remote.debug.leaderboards.call_outs && remote.debug.leaderboards.call_outs.leaderboard)
            ? remote.debug.leaderboards.call_outs.leaderboard.reduce(function(map, row){
                var staffName = String((row && row.staff_name) || '').trim();
                if (staffName) {
                  map[staffName] = Number((row && row.call_outs) || 0) || 0;
                }
                return map;
              }, {})
            : {};
          lateArrivalsByStaff = Array.isArray(remote && remote.leaderboard)
            ? remote.leaderboard.reduce(function(map, row){
                var staffName = String((row && row.staff_name) || '').trim();
                if (staffName) {
                  map[staffName] = Number((row && row.late_arrivals) || 0) || 0;
                }
                return map;
              }, {})
            : Array.isArray(remote && remote.debug && remote.debug.leaderboards && remote.debug.leaderboards.late_arrivals && remote.debug.leaderboards.late_arrivals.leaderboard)
            ? remote.debug.leaderboards.late_arrivals.leaderboard.reduce(function(map, row){
                var staffName = String((row && row.staff_name) || '').trim();
                if (staffName) {
                  map[staffName] = Number((row && row.late_arrivals) || 0) || 0;
                }
                return map;
              }, {})
            : {};
          requestsOffByStaff = Array.isArray(remote && remote.leaderboard)
            ? remote.leaderboard.reduce(function(map, row){
                var staffName = String((row && row.staff_name) || '').trim();
                if (staffName) {
                  map[staffName] = Number((row && row.requests_off) || 0) || 0;
                }
                return map;
              }, {})
            : Array.isArray(remote && remote.debug && remote.debug.leaderboards && remote.debug.leaderboards.requests_off && remote.debug.leaderboards.requests_off.leaderboard)
            ? remote.debug.leaderboards.requests_off.leaderboard.reduce(function(map, row){
                var staffName = String((row && row.staff_name) || '').trim();
                if (staffName) {
                  map[staffName] = Number((row && row.requests_off) || 0) || 0;
                }
                return map;
              }, {})
            : {};
          levelByStaff = {};
          avatarByStaff = {};
          Object.keys(staffDirectoryInfo).forEach(function(staffName){
            var item = staffDirectoryInfo[staffName] || {};
            if (item.role) {
              levelByStaff[staffName] = item.role;
            }
            if (item.avatar) {
              avatarByStaff[staffName] = item.avatar;
            }
          });
          if (Array.isArray(rawKpi && rawKpi.rows)) {
            rawKpi.rows.forEach(function(row){
              var staffName = String((row && row['Staff Name']) || '').trim();
              var roleName = extractLevelFromRecord(row);
              if (staffName && roleName && !levelByStaff[staffName]) {
                levelByStaff[staffName] = roleName;
              }
            });
          }
          if (remote && remote.debug && remote.debug.normalized_rows) {
            ['call_outs', 'late_arrivals', 'requests_off', 'kpi_for_stylists'].forEach(function(key){
              var rows = remote.debug.normalized_rows[key];
              if (!Array.isArray(rows)) return;
              rows.forEach(function(row){
                var staffName = String((row && row.staff_name) || '').trim();
                var roleName = extractLevelFromRecord(row);
                if (staffName && roleName && !levelByStaff[staffName]) {
                  levelByStaff[staffName] = roleName;
                }
              });
            });
          }
          if (remote && remote.debug && remote.debug.raw_rows) {
            ['call_outs', 'late_arrivals', 'requests_off', 'kpi_for_stylists'].forEach(function(key){
              var rows = remote.debug.raw_rows[key];
              if (!Array.isArray(rows)) return;
              rows.forEach(function(row){
                var staffName = String((row && (row.staff_name || row['Staff Name'] || row['staff name'])) || '').trim();
                var roleName = extractLevelFromRecord(row);
                if (staffName && roleName && !levelByStaff[staffName]) {
                  levelByStaff[staffName] = roleName;
                }
              });
            });
          }
          var callOutsData = remote && remote.debug && remote.debug.leaderboards
            ? remote.debug.leaderboards.call_outs
            : null;
          var hasMergedRows = Array.isArray(remote && remote.leaderboard) && remote.leaderboard.length > 0;
          var hasCallOutRows = !!(callOutsData && Array.isArray(callOutsData.leaderboard) && callOutsData.leaderboard.length > 0);
          var hasKpiRows = !!(rawKpi && Array.isArray(rawKpi.rows) && rawKpi.rows.length > 0);

          if (hasMergedRows) {
            updateStats(remote, remote.leaderboard, 'merged');
          } else if (hasCallOutRows) {
            updateStats(callOutsData, callOutsData.leaderboard, 'call_outs');
          } else {
            updateStats(remote, [], 'merged');
          }

          if (canFetchKpiForSelectedRange(kpiFilterConfig) && !kpiError) {
            renderKpiTable(hasKpiRows ? rawKpi.headers : [], hasKpiRows ? rawKpi.rows : []);
          } else if (canFetchKpiForSelectedRange(kpiFilterConfig) && kpiError) {
            kpiTableMount.className = 'empty';
            kpiTableMount.innerHTML = escapeHtml(humanizeDashboardErrorMessage(
              kpiError && kpiError.message
                ? kpiError.message
                : 'KPI export is still processing. Attendance totals are ready.'
            ));
          } else {
            kpiTableMount.className = 'empty';
            kpiTableMount.innerHTML = 'KPI is only available for ranges ending today. Attendance totals still loaded for this range.';
          }

          if (!canFetchKpiForSelectedRange(kpiFilterConfig)) {
            setStatus('Attendance totals updated. KPI is unavailable for this date range.');
          } else if (kpiError) {
            setStatus('Attendance totals updated. ' + humanizeDashboardErrorMessage(
              kpiError && kpiError.message ? kpiError.message : 'KPI export is still processing.'
            ));
          } else if (!hasMergedRows && hasCallOutRows) {
            setStatus(hasKpiRows ? 'Call-out totals and KPI updated.' : 'Call-out totals updated.');
          } else if (hasKpiRows) {
            setStatus('Attendance totals and KPI updated.');
          } else {
            setStatus('Attendance totals updated.');
          }
          renderDebug({
            filters: remote.filters || {},
            warning: remote.warning || '',
            filter_mode: remote.filter_mode || '',
            exports: remote.exports || {},
            merged_totals: {
              rows_analyzed: remote.rows_analyzed || 0,
              staff_ranked: remote.staff_ranked || 0,
              total_call_outs: remote.total_call_outs || 0,
              total_late_arrivals: remote.total_late_arrivals || 0,
              total_leaving_early: remote.total_leaving_early || 0,
              total_requests_off: remote.total_requests_off || 0,
              total_events: remote.total_events || 0,
              location_count: remote.location_count || 0
            },
            call_outs: remote.debug && remote.debug.leaderboards ? remote.debug.leaderboards.call_outs : null,
            requests_off: remote.debug && remote.debug.leaderboards ? remote.debug.leaderboards.requests_off : null,
            kpi_for_stylists: {
              period_mode: rawKpi && rawKpi.filterConfig ? rawKpi.filterConfig.mode : '',
              requested_report_filters: rawKpi && rawKpi.filterConfig ? rawKpi.filterConfig.report_filters : [],
              warning: rawKpi && rawKpi.filterConfig ? rawKpi.filterConfig.warning || '' : '',
              error: kpiError && kpiError.message ? kpiError.message : '',
              export: rawKpi ? rawKpi.exportInfo : null,
              headers: rawKpi ? rawKpi.headers : [],
              rows: rawKpi ? rawKpi.rows : [],
              raw_rows: rawKpi ? rawKpi.rows : []
            },
            normalized_rows: remote.debug ? remote.debug.normalized_rows : null,
            raw_rows: remote.debug ? remote.debug.raw_rows : null,
            merged_leaderboard: remote.leaderboard || []
          });
        } catch (error) {
          reliabilityScoreByStaff = {};
          requestsOffByStaff = {};
          callOutsByStaff = {};
          lateArrivalsByStaff = {};
          levelByStaff = {};
          avatarByStaff = {};
          var friendlyErrorMessage = humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not build totals.');
          setStatus(friendlyErrorMessage);
          tableMount.className = 'empty';
          tableMount.innerHTML = escapeHtml(friendlyErrorMessage);
          kpiTableMount.className = 'empty';
          kpiTableMount.innerHTML = escapeHtml(friendlyErrorMessage);
          renderDebug({
            error: friendlyErrorMessage
          });
        } finally {
        }
      }
      if (clientRecsStaff) clientRecsStaff.addEventListener('change', renderClientRecsList);
      if (clientRecsWindow) clientRecsWindow.addEventListener('change', function(){
        hasLoadedClientRecs = false;
        loadClientRecs(false);
      });
      if (clientRecsSearch) clientRecsSearch.addEventListener('input', renderClientRecsList);
      if (clientRecsRefresh) clientRecsRefresh.addEventListener('click', function(){ loadClientRecs(true); });
      if (clientRecsList) clientRecsList.addEventListener('click', function(event){
        var button = event.target && event.target.closest ? event.target.closest('[data-client-recs-open]') : null;
        if (button) openClientRecsProfile(button.getAttribute('data-client-id'), button.getAttribute('data-appointment-id'));
      });
      if (clientRecsDetail) {
        clientRecsDetail.addEventListener('click', function(event){
          var button = event.target && event.target.closest ? event.target.closest('[data-client-recs-tag-id]') : null;
          if (button) updateClientRecsTag(button);
        });
        clientRecsDetail.addEventListener('input', function(event){
          if (!event.target || !event.target.matches || !event.target.matches('[data-client-recs-tag-search]')) return;
          var query = String(event.target.value || '');
          renderClientRecsDetail(query);
          var nextInput = clientRecsDetail.querySelector('[data-client-recs-tag-search]');
          if (nextInput) {
            nextInput.focus();
            nextInput.setSelectionRange(query.length, query.length);
          }
        });
      }
      if (pinSubmitBtn) {
        pinSubmitBtn.addEventListener('click', unlockWithPin);
      }
      if (pinInput) {
        pinInput.addEventListener('keydown', function(event){
          if (event.key === 'Enter') {
            event.preventDefault();
            unlockWithPin();
          }
        });
      }
      if (nextMoveMount) {
        nextMoveMount.addEventListener('change', function(event){
          var selectTarget = event && event.target && event.target.matches && event.target.matches('[data-next-move-select-toggle]')
            ? event.target
            : null;
          if (!selectTarget) return;
          var detailKey = String(selectTarget.getAttribute('data-next-move-select-toggle') || '').trim();
          if (!detailKey) return;
          setNextMoveApprovalSelected(detailKey, !!selectTarget.checked);
          syncNextMoveBulkSelectionUi();
        });
        nextMoveMount.addEventListener('click', async function(event){
          var selectAllTarget = event && event.target && event.target.closest
            ? event.target.closest('[data-next-move-select-all]')
            : null;
          if (selectAllTarget) {
            collectNextMoveQuickApprovalEntries(currentRenderedNextMoveState).forEach(function(entry){
              setNextMoveApprovalSelected(entry.detail_key, true);
            });
            syncNextMoveBulkSelectionUi();
            return;
          }

          var clearSelectedTarget = event && event.target && event.target.closest
            ? event.target.closest('[data-next-move-clear-selected]')
            : null;
          if (clearSelectedTarget) {
            selectedNextMoveApprovalKeys = {};
            syncNextMoveBulkSelectionUi();
            return;
          }

          var bulkApproveTarget = event && event.target && event.target.closest
            ? event.target.closest('[data-next-move-bulk-approve]')
            : null;
          if (bulkApproveTarget) {
            var bulkRoot = bulkApproveTarget.closest('.next-move-bulk');
            var bulkStatusNode = bulkRoot ? bulkRoot.querySelector('[data-next-move-bulk-status]') : null;
            var bulkPinNode = bulkRoot ? bulkRoot.querySelector('[data-next-move-bulk-pin]') : null;
            try {
              await approveSelectedNextMoveCheckpoints(
                getSelectedNextMoveApprovalEntries(currentRenderedNextMoveState),
                bulkPinNode ? bulkPinNode.value : '',
                bulkStatusNode,
                bulkApproveTarget
              );
            } catch (error) {
              if (bulkStatusNode) {
                bulkStatusNode.textContent = humanizeClientFetchErrorMessage(error, 'Could not sign off selected checkpoints.');
                bulkStatusNode.setAttribute('data-tone', 'error');
              }
              bulkApproveTarget.removeAttribute('data-bulk-loading');
              bulkApproveTarget.disabled = false;
              bulkApproveTarget.textContent = 'Sign Off Selected';
            }
            return;
          }

          var approveTarget = event && event.target && event.target.closest
            ? event.target.closest('[data-next-move-approve]')
            : null;
          if (approveTarget && approveTarget.getAttribute) {
            var approveSectionKey = String(approveTarget.getAttribute('data-section-key') || '').trim();
            var approveItemKey = String(approveTarget.getAttribute('data-item-key') || '').trim();
            var approveDetailKey = String(approveTarget.getAttribute('data-next-move-approve') || '').trim();
            if (!approveSectionKey || !approveItemKey || !approveDetailKey) return;
            var approveRoot = approveTarget.closest('.next-move-itemApprove');
            var approveStatusNode = approveRoot ? approveRoot.querySelector('[data-next-move-approve-status="' + approveDetailKey + '"]') : null;
            var approvePinNode = approveRoot ? approveRoot.querySelector('[data-next-move-approve-pin="' + approveDetailKey + '"]') : null;
            try {
              await approveNextMoveCheckpoint(approveSectionKey, approveItemKey, approvePinNode ? approvePinNode.value : '', approveStatusNode, approveTarget);
            } catch (error) {
              if (approveStatusNode) {
                approveStatusNode.textContent = humanizeClientFetchErrorMessage(error, 'Could not sign off checkpoint.');
                approveStatusNode.setAttribute('data-tone', 'error');
              }
              approveTarget.disabled = false;
              approveTarget.textContent = 'Sign Off';
            }
            return;
          }

          var auditTarget = event && event.target && event.target.closest
            ? event.target.closest('[data-next-move-audit-request]')
            : null;
          if (!auditTarget || !auditTarget.getAttribute) return;
          var sectionKey = String(auditTarget.getAttribute('data-section-key') || '').trim();
          var itemKey = String(auditTarget.getAttribute('data-item-key') || '').trim();
          var detailKey = String(auditTarget.getAttribute('data-next-move-audit-request') || '').trim();
          if (!sectionKey || !itemKey || !detailKey) return;
          var detailsRoot = auditTarget.closest('.next-move-itemApprove');
          var statusNode = detailsRoot ? detailsRoot.querySelector('[data-next-move-audit-status="' + detailKey + '"]') : null;
          try {
            await requestNextMoveCheckpointAudit(sectionKey, itemKey, statusNode, auditTarget);
          } catch (error) {
            if (statusNode) {
              statusNode.textContent = humanizeClientFetchErrorMessage(error, 'Could not request checkpoint audit.');
              statusNode.setAttribute('data-tone', 'error');
            }
            auditTarget.disabled = false;
            auditTarget.textContent = 'Request Audit';
          }
        });
        nextMoveMount.addEventListener('keydown', function(event){
          var target = event && event.target;
          if (target && target.matches && target.matches('[data-next-move-bulk-pin]')) {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            var bulkRoot = target.closest('.next-move-bulk');
            var bulkButton = bulkRoot ? bulkRoot.querySelector('[data-next-move-bulk-approve]') : null;
            if (bulkButton && bulkButton.click) {
              bulkButton.click();
            }
            return;
          }
          if (!target || !target.matches || !target.matches('[data-next-move-approve-pin]')) return;
          if (event.key !== 'Enter') return;
          event.preventDefault();
          var detailKey = String(target.getAttribute('data-next-move-approve-pin') || '').trim();
          if (!detailKey) return;
          var approveRoot = target.closest('.next-move-itemApprove');
          var approveButton = approveRoot ? approveRoot.querySelector('[data-next-move-approve="' + detailKey + '"]') : null;
          if (approveButton && approveButton.click) {
            approveButton.click();
          }
        });
      }
      if (personalRequestsTabs) {
        personalRequestsTabs.addEventListener('click', function(event){
          var target = event && event.target && event.target.closest
            ? event.target.closest('[data-personal-requests-view]')
            : null;
          if (!target || !target.getAttribute) return;
          setActivePersonalRequestsView(String(target.getAttribute('data-personal-requests-view') || 'future'));
        });
      }
      if (personalRequestsList) {
        personalRequestsList.addEventListener('click', async function(event){
          var target = event && event.target && event.target.closest
            ? event.target.closest('[data-personal-request-delete]')
            : null;
          if (!target || !target.getAttribute) return;
          var requestId = String(target.getAttribute('data-personal-request-delete') || '').trim();
          var requestKind = String(target.getAttribute('data-personal-request-kind') || 'request_off').trim().toLowerCase();
          if (!requestId) return;

          try {
            var confirmMessage = requestKind === 'shift'
              ? 'Delete this shift request entry?'
              : 'Delete this request off entry?';
            if (typeof window !== 'undefined' && window.confirm && !window.confirm(confirmMessage)) {
              return;
            }
            target.disabled = true;
            setRequestOffStatus(requestKind === 'shift' ? 'Deleting shift request...' : 'Deleting request off...');
            var deleted = requestKind === 'shift'
              ? await deleteShiftChangeQueueRow(requestId)
              : await deleteRequestOffQueueRow(requestId);
            if (requestKind === 'shift') {
              renderPersonalRequests();
            }
            setRequestOffStatus(String((deleted && deleted.staff_name) || 'Request') + ' deleted.', 'success');
          } catch (error) {
            setRequestOffStatus(humanizeClientFetchErrorMessage(error, requestKind === 'shift' ? 'Could not delete shift request.' : 'Could not delete request off.'), 'error');
            target.disabled = false;
          }
        });
      }
      bindIdleTracking();
      try {
        var sharedAccessSession = restoreSharedAccessSession();
        if (window.localStorage.getItem(STAFF_OPERATIONS_PIN_STORAGE_KEY) === '1') {
          try {
            currentLoggedInStaff = JSON.parse(window.localStorage.getItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY) || 'null');
          } catch (_parseError) {
            currentLoggedInStaff = null;
          }
          if (!currentLoggedInStaff && sharedAccessSession && sharedAccessSession.mode === 'manager') {
            var sharedEditor = sharedAccessSession.editor || {};
            var sharedPermission = sharedAccessSession.permission || {};
            var sharedName = String(sharedEditor.staff_name || '').trim();
            var sharedStaffId = String(sharedPermission.boulevard_staff_id || sharedEditor.staff_id || '').trim();
            if (sharedName || sharedStaffId) {
              currentLoggedInStaff = {
                id: sharedStaffId,
                name: sharedName,
                role: String(sharedEditor.staff_role || 'Manager').trim()
              };
              try {
                window.localStorage.setItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY, JSON.stringify(currentLoggedInStaff));
              } catch (_storageError) {
              }
            }
          }
          if (!currentLoggedInStaff) {
            clearUnlockedSession({ preserveShared: !!(sharedAccessSession && sharedAccessSession.mode === 'manager') });
            showPinGate('Login code required.', '');
            return;
          }
          startApp();
          resetLoggedInStaffView('Restoring your dashboard...');
          showAppPage();
          setActiveTab('dashboard');
          applyLoggedInStaffContext().finally(function(){
            resetIdleTimer();
          });
        } else if (sharedAccessSession && sharedAccessSession.mode === 'manager') {
          var editor = sharedAccessSession.editor || {};
          var permission = sharedAccessSession.permission || {};
          var editorName = String(editor.staff_name || '').trim();
          var editorStaffId = String(permission.boulevard_staff_id || editor.staff_id || '').trim();
          if (editorName || editorStaffId) {
            currentLoggedInStaff = {
              id: editorStaffId,
              name: editorName,
              role: String(editor.staff_role || 'Manager').trim()
            };
            try {
              window.localStorage.setItem(STAFF_OPERATIONS_PIN_STORAGE_KEY, '1');
              window.localStorage.setItem(STAFF_OPERATIONS_STAFF_STORAGE_KEY, JSON.stringify(currentLoggedInStaff));
            } catch (_storageError) {
            }
            startApp();
            resetLoggedInStaffView('Restoring your dashboard...');
            showAppPage();
            setActiveTab('dashboard');
            applyLoggedInStaffContext().finally(function(){
              resetIdleTimer();
            });
          } else {
            showPinGate('Login code required.', '');
          }
        } else {
          showPinGate('Login code required.', '');
        }
      } catch (_error) {
        showPinGate('Login code required.', '');
      }
    })();
